/* ============================================
   CoreIQ â€” Core JavaScript
   Minimal, performance-first
   ============================================ */

(function () {
  'use strict';

  function ciqRoute(path) {
    var routesRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return routesRoot.replace(/\/?$/, '/') + String(path || '').replace(/^\/+/, '');
  }

  var ciqPendingInventoryAdds = Object.create(null);
  function ciqShowInventoryMessage(sourceEl, message) {
    if (!sourceEl || !message) return;
    var scope = sourceEl.closest && sourceEl.closest('.ciq-product-card, .ciq-mini-card, .ciq-main-product, .ciq-quick-view-modal, [data-coreiq-main-product], [data-coreiq-quick-view-modal]');
    scope = scope || sourceEl.parentElement;
    if (!scope) return;
    var status = scope.querySelector('[data-coreiq-inventory-message]');
    if (!status) {
      status = document.createElement('p');
      status.setAttribute('data-coreiq-inventory-message', '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.className = 'ciq-inventory-guard-message';
      scope.appendChild(status);
    }
    status.textContent = message;
    status.hidden = false;
  }

  function ciqFindInventoryLimit(variantId, sourceEl) {
    var source = sourceEl;
    while (source && source !== document) {
      var trackedAttr = source.getAttribute && source.getAttribute('data-inventory-tracked');
      var limitAttr = source.getAttribute && source.getAttribute('data-inventory-limit');
      if (trackedAttr === 'true' && limitAttr !== null && limitAttr !== '') {
        var sourceLimit = Number(limitAttr);
        if (Number.isFinite(sourceLimit)) return Math.max(0, sourceLimit);
      }
      source = source.parentElement;
    }

    var variantScripts = document.querySelectorAll('script[data-coreiq-product-variants], script[data-coreiq-main-product-variants], script[data-coreiq-qa-product-variants]');
    for (var scriptIndex = 0; scriptIndex < variantScripts.length; scriptIndex += 1) {
      try {
        var variants = JSON.parse(variantScripts[scriptIndex].textContent || '[]');
        if (!Array.isArray(variants)) continue;
        for (var variantIndex = 0; variantIndex < variants.length; variantIndex += 1) {
          var variant = variants[variantIndex];
          if (!variant || String(variant.id) !== String(variantId)) continue;
          // Shopify's continue policy intentionally allows sales past on-hand stock.
          var tracked = variant.inventory_tracked === true || Boolean(variant.inventory_management);
          var quantity = Number(variant.inventory_quantity);
          if (tracked && variant.inventory_policy !== 'continue' && variant.inventory_quantity != null && variant.inventory_quantity !== '' && Number.isFinite(quantity)) return Math.max(0, quantity);
        }
      } catch (error) {}
    }
    return null;
  }

  function ciqFetchInventoryLimit(variantId, sourceEl) {
    var productUrl = '';
    var productCard = sourceEl && sourceEl.closest
      ? sourceEl.closest('.ciq-product-card, .ciq-mini-card, .ciq-complementary-card, .ciq-quick-view-modal, [data-coreiq-quick-view-modal]')
      : null;
    if (productCard) {
      var productUrlNode = productCard.querySelector('[data-product-url]');
      productUrl = productUrlNode && productUrlNode.getAttribute('data-product-url') || '';
      if (!productUrl) {
        var productLink = productCard.querySelector('a[href*="/products/"]');
        productUrl = productLink && productLink.getAttribute('href') || '';
      }
    }
    if (!productUrl || productUrl === '#') return Promise.resolve(null);

    try {
      var productUrlObject = new URL(productUrl, window.location.origin);
      if (productUrlObject.origin !== window.location.origin) return Promise.resolve(null);
      productUrlObject.search = '';
      productUrlObject.hash = '';
      if (!/\.js$/i.test(productUrlObject.pathname)) productUrlObject.pathname = productUrlObject.pathname.replace(/\/$/, '') + '.js';
      return fetch(productUrlObject.toString(), { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (product) {
          var variants = product && Array.isArray(product.variants) ? product.variants : [];
          var variant = variants.find(function (item) { return item && String(item.id) === String(variantId); });
          var quantity = variant && Number(variant.inventory_quantity);
          return variant && variant.inventory_management && variant.inventory_policy !== 'continue' && variant.inventory_quantity != null && Number.isFinite(quantity)
            ? Math.max(0, quantity)
            : null;
        })
        .catch(function () { return null; });
    } catch (error) {
      return Promise.resolve(null);
    }
  }

  function ciqGuardedCartAdd(payload, sourceEl) {
    var variantId = payload && typeof payload.get === 'function' ? payload.get('id') : payload && payload.id;
    var requestedQuantity = payload && typeof payload.get === 'function' ? payload.get('quantity') : payload && payload.quantity;
    variantId = String(variantId || '');
    requestedQuantity = Math.max(1, parseInt(requestedQuantity || '1', 10) || 1);
    if (!variantId) return Promise.reject(new Error('Select an item option before adding it to your cart.'));

    var limit = ciqFindInventoryLimit(variantId, sourceEl);
    if (sourceEl && sourceEl.closest) {
      var oldScope = sourceEl.closest('.ciq-product-card, .ciq-mini-card, .ciq-main-product, .ciq-quick-view-modal, [data-coreiq-main-product], [data-coreiq-quick-view-modal]') || sourceEl.parentElement;
      var oldMessage = oldScope && oldScope.querySelector('[data-coreiq-inventory-message]');
      if (oldMessage) {
        oldMessage.textContent = '';
        oldMessage.hidden = true;
      }
    }
    var pendingBeforeThisAdd = Number(ciqPendingInventoryAdds[variantId] || 0);
    ciqPendingInventoryAdds[variantId] = pendingBeforeThisAdd + requestedQuantity;
    var reservationReleased = false;
    var releaseReservation = function () {
      if (reservationReleased) return;
      reservationReleased = true;
      ciqPendingInventoryAdds[variantId] = Math.max(0, Number(ciqPendingInventoryAdds[variantId] || 0) - requestedQuantity);
    };
    var addRequest = function () {
      return fetch(ciqRoute('cart/add.js'), payload && typeof payload.get === 'function' ? {
        method: 'POST', headers: { Accept: 'application/json' }, body: payload
      } : {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload)
      }).then(function (response) {
        if (response.ok) return response;
        return response.clone().json().catch(function () { return {}; }).then(function (body) {
          throw new Error(body.description || body.message || 'The requested quantity is no longer available.');
        });
      });
    };

    return (Number.isFinite(limit) ? Promise.resolve(limit) : ciqFetchInventoryLimit(variantId, sourceEl))
      .then(function (resolvedLimit) {
        if (!Number.isFinite(resolvedLimit)) {
          releaseReservation();
          return addRequest();
        }
        return fetch(ciqRoute('cart.js'), { headers: { Accept: 'application/json' } })
          .then(function (response) {
            if (!response.ok) throw new Error('Could not verify the available inventory. Please try again.');
            return response.json();
          })
          .then(function (cart) {
            var inCart = (cart.items || []).reduce(function (sum, item) {
              return String(item.variant_id || item.id) === variantId ? sum + Number(item.quantity || 0) : sum;
            }, 0);
            var remaining = Math.max(0, resolvedLimit - inCart - pendingBeforeThisAdd);
            if (requestedQuantity > remaining) {
              throw new Error(remaining > 0
                ? 'Only ' + remaining + ' more available; adjust the quantity to continue.'
                : 'No more units are available to add. This item is already at its stock limit in your cart.');
            }
            return addRequest();
          });
      })
      .catch(function (error) {
        ciqShowInventoryMessage(sourceEl, error && error.message || 'Unable to verify the available quantity. Please try again.');
        throw error;
      })
      .finally(releaseReservation);
  }
  window.CiqInventoryGuard = window.CiqInventoryGuard || { add: ciqGuardedCartAdd };

  function initScrollAnimations(root) {
    var scope = root && root.target ? root.target : root || document;
    var animEls = scope.querySelectorAll('.ciq-animate:not(.ciq-animate--visible)');
    if (!animEls.length) return;

    if ('IntersectionObserver' in window) {
      var animObs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var idx = entry.target.dataset.ciqIndex || 0;
              var isCollectionGridItem = Boolean(entry.target.closest('[data-coreiq-collection-grid]'));
              var animationScope = entry.target.closest('[data-coreiq-animation-stagger]');
              var scopeStagger = animationScope ? parseInt(animationScope.dataset.coreiqAnimationStagger || '', 10) : null;
              var baseStagger = parseInt(
                getComputedStyle(document.documentElement)
                  .getPropertyValue('--ciq-motion-stagger') || '60',
                10
              );
              var stagger = isCollectionGridItem ? 22 : (Number.isFinite(scopeStagger) ? scopeStagger : baseStagger);
              entry.target.style.animationDelay = idx * stagger + 'ms';
              if (isCollectionGridItem) {
                entry.target.style.animationDuration = '160ms';
              } else if (Number.isFinite(scopeStagger)) {
                entry.target.style.animationDuration = '180ms';
              }
              entry.target.classList.add('ciq-animate--visible');
              animObs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      animEls.forEach(function (el, i) {
        el.dataset.ciqIndex = el.dataset.ciqIndex || i;
        animObs.observe(el);
        if (el.closest('[data-coreiq-collection-grid]')) {
          window.requestAnimationFrame(function () {
            el.classList.add('ciq-animate--visible');
          });
        }
      });
    } else {
      animEls.forEach(function (el) {
        el.classList.add('ciq-animate--visible');
      });
    }
  }

  initScrollAnimations(document);

  /* â”€â”€ Mobile drawer toggle â”€â”€ */
  var drawerLockCount = 0;
  var lockedBodyScrollY = 0;
  var bodyScrollLockMode = '';

  function lockBodyScroll(options) {
    options = options || {};
    drawerLockCount += 1;
    if (drawerLockCount > 1) return;

    var docEl = document.documentElement;
    lockedBodyScrollY = window.pageYOffset || docEl.scrollTop || document.body.scrollTop || 0;
    var supportsStableGutter =
      window.CSS &&
      typeof window.CSS.supports === 'function' &&
      window.CSS.supports('scrollbar-gutter: stable');
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    var compensation = supportsStableGutter ? 0 : Math.max(scrollbarWidth, 0);

    docEl.style.setProperty('--ciq-scrollbar-compensation', compensation + 'px');
    docEl.classList.add('ciq-scroll-locked');
    document.body.classList.add('ciq-scroll-locked');
    docEl.style.overflow = 'hidden';
    docEl.style.overflowY = 'hidden';
    // A search panel is a fixed body child. Fixing body itself moves that
    // layer above the visual viewport on mobile browsers. For that case an
    // overflow-only lock is sufficient and keeps the drawer in view.
    if (options.preserveViewportLayer) {
      bodyScrollLockMode = 'overflow';
      document.body.style.overflow = 'hidden';
      return;
    }
    bodyScrollLockMode = 'fixed';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + lockedBodyScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    if (!supportsStableGutter && scrollbarWidth > 0) {
      document.body.style.paddingRight = scrollbarWidth + 'px';
    }
  }

  function unlockBodyScroll() {
    drawerLockCount = Math.max(0, drawerLockCount - 1);
    if (drawerLockCount > 0) return;
    document.documentElement.style.setProperty('--ciq-scrollbar-compensation', '0px');
    document.documentElement.classList.remove('ciq-scroll-locked');
    document.body.classList.remove('ciq-scroll-locked');
    document.documentElement.style.overflow = '';
    document.documentElement.style.overflowY = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    if (bodyScrollLockMode === 'fixed') {
      window.scrollTo(0, lockedBodyScrollY || 0);
    }
    lockedBodyScrollY = 0;
    bodyScrollLockMode = '';
  }

  function setDrawerInteractiveState(drawer, isOpen) {
    if (!drawer) return;
    if (!isOpen && drawer.contains(document.activeElement) && document.activeElement && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur();
    }
    drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    if ('inert' in drawer) {
      drawer.inert = !isOpen;
    }
  }

  function isModalDrawerInteraction(drawer) {
    if (!drawer) return false;
    if (drawer.getAttribute('aria-modal') === 'true') return true;
    return drawer.id === 'predictive-search-drawer' && isMobileSearchViewport();
  }

  function getPredictiveSearchPanelTransform(drawer) {
    if (!drawer || drawer.id !== 'predictive-search-drawer' || isMobileSearchViewport()) return 'translateX(0)';
    return 'translate(-50%, 0)';
  }

  function closeDrawer(drawer) {
    if (!drawer || !drawer.hasAttribute('open')) return;
    var shouldReturnFocus = isModalDrawerInteraction(drawer);
    var returnFocusTo = drawer.__ciqDrawerTrigger || null;
    drawer.removeAttribute('open');
    drawer.classList.remove('is-open');
    var closedPanel = drawer.querySelector('.ciq-mobile-drawer__panel');
    if (closedPanel) closedPanel.style.removeProperty('transform');
    if (drawer.__ciqDrawerPreviousAriaModal !== undefined) {
      drawer.setAttribute('aria-modal', drawer.__ciqDrawerPreviousAriaModal);
      delete drawer.__ciqDrawerPreviousAriaModal;
    }
    setDrawerInteractiveState(drawer, false);
    if (drawer.id) {
      document.querySelectorAll('[data-coreiq-drawer-toggle="' + drawer.id + '"]').forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      });
    }
    try {
      document.dispatchEvent(new CustomEvent('ciq:drawer-closed', {
        detail: { drawerId: drawer.id || '' }
      }));
    } catch (e) {
      // No-op when CustomEvent is unavailable.
    }
    if (drawer.__ciqScrollLocked) {
      drawer.__ciqScrollLocked = false;
      unlockBodyScroll();
    }
    // Predictive search is portaled out of the sticky header while open. This
    // matters on mobile too: keyboard viewport changes can otherwise leave
    // the fixed drawer clipped by the header's stacking context.
    if (drawer.id === 'predictive-search-drawer' && drawer.__coreiqInlineSearchOrigin) {
      restoreInlineSearchPanel(drawer);
    }
    if (shouldReturnFocus && returnFocusTo && document.contains(returnFocusTo) && typeof returnFocusTo.focus === 'function') {
      returnFocusTo.focus();
    }
  }

  function openDrawer(drawer, options) {
    if (!drawer) return;
    options = options || {};
    if (drawer.hasAttribute('open')) {
      drawer.removeAttribute('hidden');
      drawer.classList.add('is-open');
      var alreadyOpenPanel = drawer.querySelector('.ciq-mobile-drawer__panel');
      if (alreadyOpenPanel && !options.preservePanelTransform) {
        alreadyOpenPanel.style.setProperty(
          'transform',
          getPredictiveSearchPanelTransform(drawer),
          'important'
        );
      }
      return;
    }
    if (drawer.id === 'cart-drawer') {
      document.querySelectorAll('[data-coreiq-sticky-atc]').forEach(function (sticky) {
        sticky.classList.remove('is-visible');
      });
      document.body.classList.remove('ciq-has-sticky-atc', 'ciq-has-sticky-atc-pollheim');
    }
    drawer.__ciqDrawerTrigger = options.trigger || document.activeElement || null;
    drawer.__ciqDrawerPreviousAriaModal = drawer.getAttribute('aria-modal') || 'false';
    if (drawer.id === 'predictive-search-drawer' && isMobileSearchViewport()) {
      drawer.setAttribute('aria-modal', 'true');
    }

    var currentlyOpen = document.querySelectorAll('.ciq-mobile-drawer[open]');
    currentlyOpen.forEach(function (openDrawerEl) {
      if (openDrawerEl !== drawer) {
        closeDrawer(openDrawerEl);
      }
    });

    drawer.removeAttribute('hidden');
    drawer.classList.add('is-open');
    var panel = drawer.querySelector('.ciq-mobile-drawer__panel');
    if (panel && !options.preservePanelTransform) {
      panel.style.setProperty(
        'transform',
        getPredictiveSearchPanelTransform(drawer),
        'important'
      );
    }
    setDrawerInteractiveState(drawer, true);
    drawer.setAttribute('open', '');
    if (drawer.id) {
      document.querySelectorAll('[data-coreiq-drawer-toggle="' + drawer.id + '"]').forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
        if (!toggle.hasAttribute('aria-controls')) {
          toggle.setAttribute('aria-controls', drawer.id);
        }
      });
    }
    try {
      document.dispatchEvent(new CustomEvent('ciq:drawer-opened', {
        detail: {
          drawerId: drawer.id || '',
          suppressInitialFocusRing: options.suppressInitialFocusRing === true
        }
      }));
    } catch (e) {
      // No-op when CustomEvent is unavailable.
    }
    // Desktop side drawers must not freeze the underlying document. Search
    // remains modal only on mobile, where it covers the full interaction area.
    var shouldLockDrawerScroll = drawer.id !== 'cart-drawer' && !(drawer.id === 'predictive-search-drawer' && !isMobileSearchViewport());
    if (shouldLockDrawerScroll) {
      lockBodyScroll({
        preserveViewportLayer: drawer.id === 'predictive-search-drawer' && isMobileSearchViewport()
      });
      drawer.__ciqScrollLocked = true;
    }
  }

  document.querySelectorAll('.ciq-mobile-drawer').forEach(function (drawer) {
    setDrawerInteractiveState(drawer, drawer.hasAttribute('open'));
  });


  window.addEventListener('resize', function () {
    var searchDrawer = document.getElementById('predictive-search-drawer');
    if (!searchDrawer || !searchDrawer.hasAttribute('open')) return;
    var searchPanel = searchDrawer.querySelector('.ciq-mobile-drawer__panel');
    if (!searchPanel) return;
    var mobileSearch = isMobileSearchViewport();
    searchPanel.style.setProperty('transform', getPredictiveSearchPanelTransform(searchDrawer), 'important');

    if (mobileSearch && !searchDrawer.__ciqScrollLocked) {
      lockBodyScroll({ preserveViewportLayer: true });
      searchDrawer.__ciqScrollLocked = true;
    } else if (!mobileSearch && searchDrawer.__ciqScrollLocked) {
      searchDrawer.__ciqScrollLocked = false;
      unlockBodyScroll();
    }
  }, { passive: true });

  var latestCartState = null;
  var RECENTLY_VIEWED_KEY = 'ciq-recently-viewed-products';

  function ciqIdleInit(fn) {
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(function () { fn(); }, { timeout: 2000 });
    } else {
      setTimeout(function () { fn(); }, 200);
    }
  }

  function ciqHasDom(selector) {
    return Boolean(selector && document.querySelector(selector));
  }

  function ciqIdleInitWhenPresent(selector, fn) {
    if (!ciqHasDom(selector)) return;
    ciqIdleInit(fn);
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function isAvailabilityOnlyQuery(query) {
    var normalized = String(query || '')
      .toLowerCase()
      .replace(/[\u2018\u2019`]/g, "'")
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    return /^(in stock|instock|available|ready to ship|ships today)$/.test(normalized);
  }

  function buildAvailabilitySearchUrl() {
    var url = new URL(ciqRoute('collections/all'), window.location.origin);
    url.searchParams.set('filter.v.availability', '1');
    return url.pathname + '?' + url.searchParams.toString();
  }

  function normalizeAvailabilitySearchLocation() {
    if (!window.location || !/\/search\/?$/.test(window.location.pathname)) return;
    var params = new URLSearchParams(window.location.search || '');
    var rawQuery = params.get('q') || '';
    var normalizedQuery = rawQuery.trim();
    var hasAvailabilityFilter = params.get('filter.v.availability') === '1' || params.has('filter.v.availability');
    if (!isAvailabilityOnlyQuery(rawQuery) && !(hasAvailabilityFilter && (!normalizedQuery || normalizedQuery === '*'))) return;
    window.location.replace(buildAvailabilitySearchUrl());
  }

  normalizeAvailabilitySearchLocation();

  document.addEventListener('submit', function (event) {
    var target = event.target;
    var form = target && target.closest ? target.closest('form') : null;
    if (!form && target && target.tagName === 'FORM') form = target;
    if (!form) return;

    var queryInput = form.querySelector('input[name="q"]');
    if (!queryInput || !isAvailabilityOnlyQuery(queryInput.value)) return;

    var action = form.getAttribute('action') || '';
    var isSearchForm = form.getAttribute('role') === 'search' ||
      form.matches('[data-coreiq-recovery-search-form], .ciq-search-drawer__form') ||
      action.indexOf('/search') !== -1;
    if (!isSearchForm) return;

    event.preventDefault();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    window.location.assign(buildAvailabilitySearchUrl());
  }, true);

  window.coreiqAvailabilitySearch = {
    isAvailabilityOnlyQuery: isAvailabilityOnlyQuery,
    buildAvailabilitySearchUrl: buildAvailabilitySearchUrl
  };

  var activeSwatchTooltipTarget = null;

  function getSwatchTooltip() {
    var tooltip = document.getElementById('ciq-swatch-tooltip');
    if (tooltip || !document.body) return tooltip;
    tooltip = document.createElement('span');
    tooltip.id = 'ciq-swatch-tooltip';
    tooltip.className = 'ciq-swatch-tooltip';
    tooltip.setAttribute('role', 'tooltip');
    tooltip.hidden = true;
    document.body.appendChild(tooltip);
    return tooltip;
  }

  function positionSwatchTooltip(target, tooltip) {
    if (!target || !tooltip) return;
    var rect = target.getBoundingClientRect();
    var gap = 8;

    tooltip.style.left = '0px';
    tooltip.style.top = '0px';
    tooltip.hidden = false;
    tooltip.classList.add('is-visible');
    tooltip.classList.remove('is-below');

    var tooltipRect = tooltip.getBoundingClientRect();
    var left = rect.left + rect.width / 2;
    var top = rect.top - tooltipRect.height - gap;
    var minLeft = tooltipRect.width / 2 + 8;
    var maxLeft = window.innerWidth - tooltipRect.width / 2 - 8;

    if (top < 8) {
      top = rect.bottom + gap;
      tooltip.classList.add('is-below');
    }

    tooltip.style.left = Math.min(Math.max(left, minLeft), maxLeft) + 'px';
    tooltip.style.top = top + 'px';
  }

  function showSwatchTooltip(target) {
    if (!target) return;
    var label = target.getAttribute('data-coreiq-swatch-label') || target.getAttribute('aria-label') || target.getAttribute('title') || '';
    label = label.trim();
    if (!label) return;

    var tooltip = getSwatchTooltip();
    if (!tooltip) return;

    if (activeSwatchTooltipTarget && activeSwatchTooltipTarget !== target) {
      hideSwatchTooltip();
    }

    activeSwatchTooltipTarget = target;
    if (target.__ciqSwatchTooltipDescribedBy === undefined) {
      target.__ciqSwatchTooltipDescribedBy = target.getAttribute('aria-describedby') || '';
    }
    if (!target.getAttribute('aria-describedby') || target.getAttribute('aria-describedby').indexOf('ciq-swatch-tooltip') === -1) {
      target.setAttribute('aria-describedby', (target.__ciqSwatchTooltipDescribedBy ? target.__ciqSwatchTooltipDescribedBy + ' ' : '') + 'ciq-swatch-tooltip');
    }

    tooltip.textContent = label;
    positionSwatchTooltip(target, tooltip);
  }

  function hideSwatchTooltip() {
    var tooltip = document.getElementById('ciq-swatch-tooltip');
    if (activeSwatchTooltipTarget && activeSwatchTooltipTarget.__ciqSwatchTooltipDescribedBy !== undefined) {
      if (activeSwatchTooltipTarget.__ciqSwatchTooltipDescribedBy) {
        activeSwatchTooltipTarget.setAttribute('aria-describedby', activeSwatchTooltipTarget.__ciqSwatchTooltipDescribedBy);
      } else {
        activeSwatchTooltipTarget.removeAttribute('aria-describedby');
      }
      delete activeSwatchTooltipTarget.__ciqSwatchTooltipDescribedBy;
    }
    activeSwatchTooltipTarget = null;
    if (!tooltip) return;
    tooltip.classList.remove('is-visible', 'is-below');
    tooltip.hidden = true;
  }

  function formatCurrency(cents, currencyCode) {
    var amount = (Number(cents) || 0) / 100;
    var currency = currencyCode || 'USD';
    try {
      return amount.toLocaleString(undefined, { style: 'currency', currency: currency });
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function serializeJsonForScript(value) {
    return JSON.stringify(value || []).replace(/</g, '\\u003c');
  }

  document.addEventListener('mouseover', function (event) {
    var target = event.target.closest ? event.target.closest('[data-coreiq-swatch-label]') : null;
    if (target) showSwatchTooltip(target);
  });

  document.addEventListener('mouseout', function (event) {
    var target = event.target.closest ? event.target.closest('[data-coreiq-swatch-label]') : null;
    if (!target || target.contains(event.relatedTarget)) return;
    hideSwatchTooltip();
  });

  document.addEventListener('focusin', function (event) {
    var target = event.target.closest ? event.target.closest('[data-coreiq-swatch-label]') : null;
    if (target) showSwatchTooltip(target);
  });

  document.addEventListener('focusout', function (event) {
    var target = event.target.closest ? event.target.closest('[data-coreiq-swatch-label]') : null;
    if (target) hideSwatchTooltip();
  });

  window.addEventListener('resize', hideSwatchTooltip);
  window.addEventListener('scroll', hideSwatchTooltip, true);

  function getQuickLookIconMarkup() {
    return '<svg class="ciq-quick-look-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" width="16" height="16"><path d="M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/><path d="M2 10s3-6 8-6 8 6 8 6-3 6-8 6-8-6-8-6z"/></svg>';
  }

  function emitThemeAnalytics(eventName, payload) {
    var detail = Object.assign(
      {
        event: eventName,
        source: 'coreiq-theme'
      },
      payload || {}
    );

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(detail);
    }

    try {
      document.dispatchEvent(new CustomEvent('ciq:analytics', { detail: detail }));
    } catch (e) {
      // No-op when CustomEvent is unavailable.
    }
  }

  var ASSISTED_ATTRIBUTION_KEY = 'ciq-assisted-attribution';
  var ASSISTED_ATTRIBUTION_MAX_AGE_MS = 30 * 60 * 1000;

  function setAssistedAttributionContext(context) {
    if (!context) return;

    try {
      localStorage.setItem(
        ASSISTED_ATTRIBUTION_KEY,
        JSON.stringify(
          Object.assign({}, context, {
            timestamp: Date.now()
          })
        )
      );
    } catch (e) {
      // Ignore storage failures.
    }
  }

  function getAssistedAttributionContext() {
    try {
      var rawValue = localStorage.getItem(ASSISTED_ATTRIBUTION_KEY);
      if (!rawValue) return null;

      var parsed = JSON.parse(rawValue);
      if (!parsed || !parsed.timestamp) return null;
      if (Date.now() - parsed.timestamp > ASSISTED_ATTRIBUTION_MAX_AGE_MS) {
        localStorage.removeItem(ASSISTED_ATTRIBUTION_KEY);
        return null;
      }

      return parsed;
    } catch (e) {
      return null;
    }
  }

  function emitCartAddAnalytics(item, payload) {
    var quantity = Number((item && item.quantity) || (payload && payload.quantity) || 1) || 1;
    var priceCents = Number((item && item.final_line_price) || (item && item.line_price) || (item && item.final_price) || ((item && item.price) || 0) * quantity) || 0;
    var analyticsPayload = {
      actionSource: payload && payload.actionSource ? payload.actionSource : '',
      productId: item && item.product_id ? item.product_id : '',
      variantId: item && item.variant_id ? item.variant_id : ((item && item.id) || (payload && payload.variantId) || ''),
      itemTitle: item && (item.product_title || item.title) ? (item.product_title || item.title) : ((payload && payload.title) || ''),
      quantity: quantity,
      itemValue: priceCents / 100,
      itemValueCents: priceCents,
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || ''
    };

    emitThemeAnalytics('coreiq_add_to_cart', analyticsPayload);

    var assistedContext = getAssistedAttributionContext();
    if (assistedContext) {
      emitThemeAnalytics('coreiq_assisted_add_to_cart', Object.assign({}, analyticsPayload, assistedContext));
    }
  }

  function updateCartCountBadge(count) {
    var cartBadges = document.querySelectorAll('[data-coreiq-cart-count]');
    var parsedCount = Number(count) || 0;
    cartBadges.forEach(function (badge) {
      badge.textContent = String(parsedCount);
      badge.hidden = parsedCount <= 0;
    });

    var badge = document.querySelector('[data-ciq-cart-badge], .ciq-cart-badge, [data-cart-count], [data-coreiq-cart-count]');
    if (badge) {
      badge.classList.remove('ciq-badge--pulse');
      requestAnimationFrame(function () {
        if (!document.body.contains(badge)) return;
        badge.classList.add('ciq-badge--pulse');
      });
    }

    var cartButtons = document.querySelectorAll('[data-coreiq-cart-icon]');
    cartButtons.forEach(function (btn) {
      var cartLabel = btn.getAttribute('data-coreiq-cart-label') || 'Cart';
      btn.setAttribute('aria-label', cartLabel + ', ' + parsedCount + ' ' + (parsedCount === 1 ? 'item' : 'items'));
      btn.classList.add('is-updated');
      setTimeout(function () {
        btn.classList.remove('is-updated');
      }, 380);
    });
  }

  function announceCartUpdate(count) {
    var statusEls = document.querySelectorAll('[data-coreiq-cart-status]');
    if (!statusEls.length) return;

    var parsedCount = Number(count) || 0;
    var message = 'Added to cart. Cart now has ' + parsedCount + ' ' + (parsedCount === 1 ? 'item' : 'items') + '.';
    statusEls.forEach(function (statusEl) {
      statusEl.textContent = '';
      window.setTimeout(function () {
        statusEl.textContent = message;
      }, 30);
    });
  }

  function getAnimationImageUrl(sourceEl, item) {
    if (item && item.image) return item.image;

    var card = sourceEl.closest ? sourceEl.closest('.ciq-product-card, .ciq-mini-card, [data-coreiq-main-product]') : null;
    var cardImg = card ? card.querySelector('.ciq-product-card__media img, .ciq-mini-card__media img, .ciq-main-product__media-item:not([hidden]) img, .ciq-main-product__media-item.is-active img') : null;
    if (cardImg && cardImg.currentSrc) return cardImg.currentSrc;
    if (cardImg && cardImg.src) return cardImg.src;

    var activeProductImg = document.querySelector('.ciq-main-product__media-item:not([hidden]) img, .ciq-main-product__media-item.is-active img');
    if (activeProductImg && activeProductImg.currentSrc) return activeProductImg.currentSrc;
    return activeProductImg && activeProductImg.src ? activeProductImg.src : '';
  }

  function animateAddToCart(sourceEl, item) {
    var cartIcon = document.querySelector('[data-coreiq-cart-icon]');
    if (!cartIcon || !sourceEl) return;

    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    cartIcon.classList.add('is-receiving');
    window.setTimeout(function () {
      cartIcon.classList.remove('is-receiving');
    }, reducedMotion ? 520 : 820);
    if (reducedMotion) return;

    var sourceRect = sourceEl.getBoundingClientRect();
    var targetRect = cartIcon.getBoundingClientRect();
    if (!sourceRect || !targetRect) return;

    var token = document.createElement('span');
    token.className = 'ciq-cart-fly-token';
    token.setAttribute('aria-hidden', 'true');

    var imageUrl = getAnimationImageUrl(sourceEl, item);
    if (imageUrl) {
      var tokenImg = document.createElement('img');
      tokenImg.src = imageUrl;
      tokenImg.alt = '';
      token.appendChild(tokenImg);
    } else {
      token.classList.add('ciq-cart-fly-token--fallback');
    }

    token.style.left = sourceRect.left + sourceRect.width / 2 - 21 + 'px';
    token.style.top = sourceRect.top + sourceRect.height / 2 - 21 + 'px';
    document.body.appendChild(token);

    var deltaX = targetRect.left + targetRect.width / 2 - (sourceRect.left + sourceRect.width / 2);
    var deltaY = targetRect.top + targetRect.height / 2 - (sourceRect.top + sourceRect.height / 2);

    if (token.animate) {
      token.animate(
        [
          { transform: 'translate(0px, 0px) scale(1)', opacity: 1 },
          { transform: 'translate(' + (deltaX * 0.62) + 'px, ' + (deltaY * 0.58 - 22) + 'px) scale(0.9)', opacity: 0.95 },
          { transform: 'translate(' + deltaX + 'px, ' + deltaY + 'px) scale(0.34)', opacity: 0.08 }
        ],
        { duration: 760, easing: 'cubic-bezier(0.18, 0.78, 0.22, 1)', fill: 'forwards' }
      ).onfinish = function () {
        token.remove();
      };
      window.setTimeout(function () {
        token.remove();
      }, 950);
    } else {
      token.remove();
    }
  }

  function fetchCartState() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart fetch failed');
        return res.json();
      })
      .then(function (cart) {
        latestCartState = cart;
        updateCartCountBadge(cart.item_count || 0);
        return cart;
      });
  }

  function getCartLinePropertiesSignature(item) {
    var properties = item && item.properties ? item.properties : null;
    if (!properties) return '';
    var pairs = [];

    if (Array.isArray(properties)) {
      properties.forEach(function (property) {
        var name = property && (property.name || property[0]);
        var value = property && (property.value !== undefined ? property.value : property[1]);
        if (!name || String(name).charAt(0) === '_' || value === null || value === undefined || value === '') return;
        pairs.push(String(name) + ':' + String(value));
      });
    } else {
      Object.keys(properties).sort().forEach(function (name) {
        var value = properties[name];
        if (!name || String(name).charAt(0) === '_' || value === null || value === undefined || value === '') return;
        pairs.push(String(name) + ':' + String(value));
      });
    }

    return pairs.sort().join('||');
  }

  function getCartLineSignature(item) {
    if (!item) return '';
    var sellingPlanId = '';
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      sellingPlanId = item.selling_plan_allocation.selling_plan.id || item.selling_plan_allocation.selling_plan.name || '';
    }

    return [
      item.variant_id || item.id || item.key || '',
      item.product_id || '',
      item.product_title || '',
      item.variant_title || '',
      sellingPlanId,
      getCartLinePropertiesSignature(item)
    ].join('|');
  }

  function getRenderableCartItems(cart) {
    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    var buckets = Object.create(null);
    var renderedItems = [];

    items.forEach(function (item, index) {
      if (!item) return;
      var signature = getCartLineSignature(item) || String(item.key || index);
      var bucket = buckets[signature];
      if (!bucket) {
        bucket = Object.assign({}, item);
        bucket._ciqCartSignature = signature;
        bucket._ciqCartKeys = [];
        bucket._ciqCartLines = [];
        buckets[signature] = bucket;
        renderedItems.push(bucket);
      } else {
        bucket.quantity = Number(bucket.quantity || 0) + Number(item.quantity || 0);
        bucket.final_line_price = Number(bucket.final_line_price || 0) + Number(item.final_line_price || 0);
        bucket.original_line_price = Number(bucket.original_line_price || 0) + Number(item.original_line_price || 0);
        bucket.line_price = Number(bucket.line_price || 0) + Number(item.line_price || 0);
        bucket.total_discount = Number(bucket.total_discount || 0) + Number(item.total_discount || 0);
        if (!bucket.image && item.image) bucket.image = item.image;
      }

      if (item.key && bucket._ciqCartKeys.indexOf(item.key) === -1) {
        bucket._ciqCartKeys.push(item.key);
      }
      bucket._ciqCartLines.push(index + 1);
    });

    return renderedItems;
  }

  var cartProductTagLookups = Object.create(null);

  function getCollectorBadges(item, productTags) {
    var properties = item && item.properties && typeof item.properties === 'object' ? item.properties : {};
    var candidates = [];
    [item && item.product_tags, item && item.tags, productTags].forEach(function (tags) {
      if (Array.isArray(tags)) {
        tags.forEach(function (tag) { candidates.push(String(tag || '').trim()); });
      } else if (tags) {
        String(tags).split(',').forEach(function (tag) { candidates.push(tag.trim()); });
      }
    });
    candidates.push(String(item && item.product_title || ''));
    Object.keys(properties).forEach(function (key) {
      if (/^(condition|exclusive|vaulted|chase|signed|limited edition|grail|collector favorite)$/i.test(key)) {
        candidates.push(String(properties[key] || key).trim());
      }
    });

    var badgeMap = [
      { pattern: /\bchase\b/i, label: 'Chase' },
      { pattern: /vaulted/i, label: 'Vaulted' },
      { pattern: /signed|autograph/i, label: 'Signed' },
      { pattern: /convention exclusive/i, label: 'Convention exclusive' },
      { pattern: /funko exclusive|\bexclusive\b/i, label: 'Exclusive' },
      { pattern: /limited edition|limited/i, label: 'Limited edition' },
      { pattern: /\bgrail\b/i, label: 'Grail' },
      { pattern: /collector favorite|collector's favorite/i, label: 'Collector favorite' }
    ];
    var badges = [];
    candidates.forEach(function (candidate) {
      badgeMap.some(function (badge) {
        if (badge.pattern.test(candidate) && badges.indexOf(badge.label) === -1 && badges.length < 3) {
          badges.push(badge.label);
          return true;
        }
        return false;
      });
    });
    return badges;
  }

  function hydrateCartProductBadges(cartItems, itemsList) {
    if (!window.fetch || !itemsList) return;
    cartItems.forEach(function (item) {
      if (!item || !item.handle || getCollectorBadges(item).length) return;
      var cartUrl;
      try {
        cartUrl = new URL(item.url || ('/products/' + item.handle), window.location.origin);
      } catch (error) {
        return;
      }
      if (cartUrl.origin !== window.location.origin) return;
      cartUrl.pathname = cartUrl.pathname.replace(/\/$/, '') + '.js';
      cartUrl.search = '';
      var handle = String(item.handle);
      if (!cartProductTagLookups[handle]) {
        cartProductTagLookups[handle] = window.fetch(cartUrl.toString(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (response) { return response.ok ? response.json() : null; })
          .then(function (product) { return product && product.tags ? product.tags : []; })
          .catch(function () { return []; });
      }
      cartProductTagLookups[handle].then(function (tags) {
        var badges = getCollectorBadges(item, tags);
        if (!badges.length) return;
        var signature = String(item._ciqCartSignature || '');
        var itemElement = Array.prototype.find.call(itemsList.querySelectorAll('.ciq-cart-drawer__item'), function (element) {
          return element.getAttribute('data-cart-signature') === signature;
        });
        if (!itemElement) return;
        var badgesHtml = '<div class="ciq-cart-drawer__badges">' + badges.map(function (badge) {
          return '<span class="ciq-cart-drawer__badge">' + escapeHtml(badge) + '</span>';
        }).join('') + '</div>';
        var existing = itemElement.querySelector('.ciq-cart-drawer__badges');
        if (existing) existing.outerHTML = badgesHtml;
        else {
          var metadata = itemElement.querySelector('.ciq-cart-drawer__item-meta, .ciq-cart-drawer__item-variant, .ciq-cart-drawer__item-title');
          if (metadata) metadata.insertAdjacentHTML('afterend', badgesHtml);
        }
      });
    });
  }

  function renderCartDrawer(cart) {
    var drawer = document.getElementById('cart-drawer');
    var itemsWrap = drawer ? drawer.querySelector('[data-coreiq-cart-drawer-items]') : null;
    var itemsList = itemsWrap ? (itemsWrap.querySelector('[data-coreiq-cart-items-list]') || itemsWrap) : null;
    var footer = drawer ? drawer.querySelector('[data-coreiq-cart-drawer-footer]') : null;
    var orderSummary = drawer ? drawer.querySelector('[data-coreiq-cart-order-summary]') : null;
    var total = drawer ? drawer.querySelector('[data-coreiq-cart-drawer-total]') : null;
    var estimatedTotal = drawer ? drawer.querySelector('[data-coreiq-cart-estimated-total]') : null;
    var headTotal = drawer ? drawer.querySelector('[data-coreiq-cart-head-total]') : null;
    var count = drawer ? drawer.querySelector('[data-coreiq-cart-drawer-count]') : null;
    var subtitle = drawer ? drawer.querySelector('[data-coreiq-cart-drawer-subtitle]') : null;
    var summaryCount = drawer ? drawer.querySelector('[data-coreiq-cart-summary-count]') : null;
    var shippingWrap = drawer ? drawer.querySelector('[data-coreiq-cart-shipping-progress]') : null;
    var shippingCopyWrap = drawer ? drawer.querySelector('.ciq-cart-drawer__shipping-copy') : null;
    var shippingTitle = drawer ? drawer.querySelector('[data-coreiq-cart-shipping-title]') : null;
    var shippingText = drawer ? drawer.querySelector('[data-coreiq-cart-shipping-text]') : null;
    var shippingBarWrap = drawer ? drawer.querySelector('.ciq-cart-drawer__shipping-bar') : null;
    var shippingBar = drawer ? drawer.querySelector('[data-coreiq-cart-shipping-bar]') : null;
    var goalsWrap = drawer ? drawer.querySelector('[data-coreiq-cart-goals]') : null;
    var noteWrap = drawer ? drawer.querySelector('[data-coreiq-cart-note-wrap]') : null;
    var noteInput = drawer ? drawer.querySelector('[data-coreiq-cart-note-input]') : null;
    var giftWrap = drawer ? drawer.querySelector('[data-coreiq-cart-gift-wrap]') : null;
    var giftWrapInput = drawer ? drawer.querySelector('[data-coreiq-cart-gift-wrap-input]') : null;
    var giftNoteInput = drawer ? drawer.querySelector('[data-coreiq-cart-gift-note-input]') : null;
    var trustWrap = drawer ? drawer.querySelector('[data-coreiq-cart-trust]') : null;
    if (!itemsWrap || !itemsList) return;

    var inventoryLimits = drawer._ciqCartInventoryLimits;
    if (!inventoryLimits) {
      inventoryLimits = {};
      var inventoryLimitsNode = drawer.querySelector('[data-coreiq-cart-inventory-limits]');
      if (inventoryLimitsNode) {
        try {
          inventoryLimits = JSON.parse(inventoryLimitsNode.textContent || '{}') || {};
        } catch (error) {
          inventoryLimits = {};
        }
      }
      drawer._ciqCartInventoryLimits = inventoryLimits;
    }
    document.querySelectorAll('script[data-coreiq-product-variants]').forEach(function (variantsNode) {
      try {
        var variants = JSON.parse(variantsNode.textContent || '[]');
        if (!Array.isArray(variants)) return;
        variants.forEach(function (variant) {
          if (!variant || !variant.id) return;
          var tracked = variant.inventory_tracked === true || Boolean(variant.inventory_management);
          var quantity = Number(variant.inventory_quantity);
          if (tracked && Number.isFinite(quantity)) inventoryLimits[String(variant.id)] = Math.max(0, quantity);
        });
      } catch (error) {}
    });

    var itemCount = (cart && cart.item_count) || 0;
    if (count) count.textContent = itemCount + (itemCount === 1 ? ' collectible' : ' collectibles');
    if (headTotal) headTotal.textContent = formatCurrency((cart && cart.total_price) || 0, cart && cart.currency);
    if (summaryCount) summaryCount.textContent = 'Items (' + itemCount + ')';
    if (drawer) {
      drawer.classList.toggle('ciq-cart-drawer--compact', itemCount >= 4);
    }

    if (noteInput) {
      var savedNoteValue = (cart && cart.note) || '';
      noteInput.value = savedNoteValue;
      noteInput.setAttribute('data-coreiq-saved-note', savedNoteValue);
      var noteSaveBtnRef = noteWrap ? noteWrap.querySelector('[data-coreiq-cart-note-save]') : null;
      if (noteSaveBtnRef) noteSaveBtnRef.setAttribute('disabled', 'disabled');
    }

    if (giftWrap) {
      giftWrap.hidden = itemCount === 0;
      var cartAttributes = (cart && cart.attributes) || {};
      var savedGiftWrap = cartAttributes['Gift wrap'] === 'Yes';
      var savedGiftNote = cartAttributes['Gift note'] || '';
      if (giftWrapInput) {
        giftWrapInput.checked = savedGiftWrap;
        giftWrapInput.setAttribute('data-coreiq-saved-gift-wrap', savedGiftWrap ? 'true' : 'false');
      }
      if (giftNoteInput) {
        giftNoteInput.value = savedGiftNote;
        giftNoteInput.setAttribute('data-coreiq-saved-gift-note', savedGiftNote);
      }
      var giftSaveBtnRef = giftWrap.querySelector('[data-coreiq-cart-gift-save]');
      if (giftSaveBtnRef) giftSaveBtnRef.setAttribute('disabled', 'disabled');
    }

    renderCartUpsells(cart);

    if (drawer && trustWrap) {
      var trustEnabled = drawer.getAttribute('data-cart-trust-enabled') === 'true';
      var trustLines = [];
      if (trustEnabled) {
        trustLines = [
          drawer.getAttribute('data-cart-trust-1') || '',
          drawer.getAttribute('data-cart-trust-2') || '',
          drawer.getAttribute('data-cart-trust-3') || ''
        ].filter(function (line) { return String(line || '').trim(); });
      }
      var guaranteeDefaults = ['Authentic collectibles', 'Collector-grade packaging', 'Tracked delivery', 'Dedicated collector support'];
      var guaranteeSignals = [/authentic|verified/i, /packag/i, /track/i, /support/i];
      if (!trustLines.length) trustLines = guaranteeDefaults.slice();
      else guaranteeDefaults.forEach(function (line, index) {
        if (trustLines.length < 4 && !trustLines.some(function (current) { return guaranteeSignals[index].test(current); })) {
          trustLines.push(line);
        }
      });
      trustWrap.innerHTML = '<p class="ciq-cart-drawer__trust-title">The PopChaser Collector Promise</p>' + trustLines.slice(0, 4)
        .map(function (line) {
          return '<p class="ciq-cart-drawer__trust-item"><span aria-hidden="true">&#10003;</span><span>' + escapeHtml(line) + '</span></p>';
        })
        .join('');
      trustWrap.hidden = false;
    }

    function getCartGoalDisplayLabel(label, unlocked) {
      var normalizedLabel = String(label || '').trim();
      if (unlocked) return normalizedLabel;
      return normalizedLabel.replace(/\s+unlocked\s*$/i, '').trim() || normalizedLabel;
    }

    if (shippingWrap && drawer) {
      var threshold = parseInt(drawer.getAttribute('data-free-shipping-threshold') || '0', 10);
      var totalPrice = (cart && cart.total_price) || 0;
      var goalsEnabled = drawer.getAttribute('data-cart-goals-enabled') === 'true';
      var goals = [];

      if (goalsEnabled) {
        [1, 2, 3].forEach(function (index) {
          var goalThreshold = parseInt(drawer.getAttribute('data-cart-goal-' + index + '-threshold') || '0', 10);
          var goalLabel = (drawer.getAttribute('data-cart-goal-' + index + '-label') || '').trim();
          if (goalThreshold > 0 && goalLabel) {
            goals.push({ threshold: goalThreshold, label: goalLabel });
          }
        });

        goals.sort(function (a, b) {
          return a.threshold - b.threshold;
        });
      }

      if (threshold > 0 || goals.length) {
        var remaining = Math.max(0, threshold - totalPrice);
        var progress = threshold > 0 ? Math.min(100, Math.round((totalPrice / threshold) * 100)) : 0;
        var allGoalsUnlocked = goals.length > 0 && goals.every(function (goal) {
          return totalPrice >= goal.threshold;
        });
        var nextLockedGoal = goals.filter(function (goal) {
          return totalPrice < goal.threshold;
        })[0] || null;
        var nextTargetThreshold = threshold > 0 && remaining > 0
          ? threshold
          : (nextLockedGoal ? nextLockedGoal.threshold : threshold);
        var nextTargetRemaining = nextTargetThreshold > 0 ? Math.max(0, nextTargetThreshold - totalPrice) : 0;
        var nextTargetProgress = nextTargetThreshold > 0 ? Math.min(100, Math.round((totalPrice / nextTargetThreshold) * 100)) : 100;
        var hasActiveRewardTarget = nextTargetThreshold > 0 && nextTargetRemaining > 0;
        var hasUnlockedShipping = threshold > 0 && remaining <= 0;
        var copyMode = drawer.getAttribute('data-cart-message-copy-mode') || 'alternating';
        var copyVariant = 'motivational';
        if (copyMode === 'alternating') {
          copyVariant = itemCount % 2 === 0 ? 'factual' : 'motivational';
        } else if (copyMode === 'factual') {
          copyVariant = 'factual';
        }
        var previousUnlockedSignature = shippingWrap.getAttribute('data-coreiq-unlocked-signature') || '';
        shippingWrap.hidden = false;
        shippingWrap.classList.toggle('is-unlocked', hasUnlockedShipping && !hasActiveRewardTarget);
        shippingWrap.classList.toggle('is-next-reward', hasUnlockedShipping && Boolean(nextLockedGoal));
        shippingWrap.classList.toggle('is-complete', hasUnlockedShipping && goals.length > 0 && allGoalsUnlocked);
        shippingWrap.classList.toggle('ciq-cart-drawer__shipping--goals-only', false);

        if (shippingCopyWrap) {
          shippingCopyWrap.hidden = false;
        }
        if (shippingBarWrap) {
          shippingBarWrap.hidden = !hasActiveRewardTarget && !(threshold > 0 && hasUnlockedShipping);
        }
        if (shippingBar) {
          shippingBar.style.width = (hasActiveRewardTarget ? nextTargetProgress : progress) + '%';
        }

        if (hasActiveRewardTarget) {
          if (nextLockedGoal && hasUnlockedShipping) {
            if (shippingTitle) shippingTitle.textContent = 'Next reward: ' + getCartGoalDisplayLabel(nextLockedGoal.label, false);
            if (shippingText) shippingText.textContent = formatCurrency(nextTargetRemaining, cart && cart.currency) + ' to go.';
          } else if (threshold > 0 && remaining > 0) {
            if (shippingTitle) shippingTitle.textContent = formatCurrency(remaining, cart && cart.currency) + ' away from free shipping';
            if (shippingText) {
              shippingText.textContent = copyVariant === 'factual'
                ? 'Free shipping threshold is ' + formatCurrency(threshold, cart && cart.currency) + '. Current subtotal ' + formatCurrency(totalPrice, cart && cart.currency) + '.'
                : 'Add another collectible to reach your shipping threshold.';
            }
          } else if (shippingTitle) {
            shippingTitle.textContent = 'Rewards progress';
            if (shippingText) shippingText.textContent = formatCurrency(nextTargetRemaining, cart && cart.currency) + ' to go.';
          }
        } else if (hasUnlockedShipping) {
          if (shippingTitle) shippingTitle.textContent = goals.length > 0 && allGoalsUnlocked ? 'All rewards unlocked' : 'Free shipping unlocked';
          if (shippingText) {
            shippingText.textContent = goals.length > 0 && allGoalsUnlocked
              ? 'Every available cart reward is active for this order.'
              : 'Your order qualifies for complimentary shipping at checkout.';
          }
        }

        if (goalsWrap) {
          if (!goals.length) {
            goalsWrap.hidden = true;
            goalsWrap.innerHTML = '';
            shippingWrap.setAttribute('data-coreiq-unlocked-signature', '');
          } else {
            var hasLockedGoals = goals.some(function (goal) {
              return totalPrice < goal.threshold;
            });
            var displayGoals = goals.filter(function (goal) {
              var unlocked = totalPrice >= goal.threshold;
              var duplicatesShippingMilestone = threshold > 0 && goal.threshold <= threshold;
              var freeShippingLabel = /free\s*shipping/i.test(goal.label);
              return !(hasLockedGoals && unlocked && (duplicatesShippingMilestone || freeShippingLabel));
            });
            var nextLockedThreshold = null;
            displayGoals.forEach(function (goal) {
              if (nextLockedThreshold === null && totalPrice < goal.threshold) {
                nextLockedThreshold = goal.threshold;
              }
            });
            var unlockedSignature = displayGoals.map(function (goal) {
              return totalPrice >= goal.threshold ? '1' : '0';
            }).join('');

            if (!displayGoals.length) {
              goalsWrap.hidden = true;
              goalsWrap.innerHTML = '';
              shippingWrap.setAttribute('data-coreiq-unlocked-signature', unlockedSignature);
            } else {
              goalsWrap.innerHTML = displayGoals.map(function (goal) {
                var unlocked = totalPrice >= goal.threshold;
                var goalRemaining = Math.max(0, goal.threshold - totalPrice);
                var isCurrentTarget = !unlocked && nextLockedThreshold !== null && goal.threshold === nextLockedThreshold;
                var displayLabel = getCartGoalDisplayLabel(goal.label, unlocked);
                var status = unlocked
                  ? 'Unlocked'
                  : formatCurrency(goalRemaining, cart && cart.currency) + ' to go';

                return '<div class="ciq-cart-drawer__goal' +
                  (unlocked ? ' is-unlocked' : '') +
                  (isCurrentTarget ? ' is-current-target' : '') +
                  '">' +
                  '<div class="ciq-cart-drawer__goal-dot" aria-hidden="true"></div>' +
                  '<div class="ciq-cart-drawer__goal-copy">' +
                  '<strong>' + escapeHtml(displayLabel) + '</strong>' +
                  '<p>' + escapeHtml(status) + '</p>' +
                  '</div>' +
                '</div>';
              }).join('');
              goalsWrap.hidden = false;
            }

            if (unlockedSignature !== previousUnlockedSignature && unlockedSignature.indexOf('1') !== -1) {
              shippingWrap.classList.remove('is-pulsing');
              requestAnimationFrame(function () {
                if (!document.body.contains(shippingWrap)) return;
                shippingWrap.classList.add('is-pulsing');
              });
            }
            shippingWrap.setAttribute('data-coreiq-unlocked-signature', unlockedSignature);
          }
        }
      } else {
        shippingWrap.hidden = true;
        shippingWrap.setAttribute('data-coreiq-unlocked-signature', '');
      }
    }

    if (!cart || !cart.items || !cart.items.length) {
      var emptyHeading = drawer ? escapeHtml(drawer.getAttribute('data-empty-heading') || 'Your cart is empty') : 'Your cart is empty';
      var emptyText = drawer ? escapeHtml(drawer.getAttribute('data-empty-text') || '') : '';
      var emptyCta = drawer ? escapeHtml(drawer.getAttribute('data-empty-cta-label') || 'Continue shopping') : 'Continue shopping';
      var emptyCtaUrl = drawer ? (drawer.getAttribute('data-empty-cta-url') || '/collections/all') : '/collections/all';
      var emptyIconImage = drawer ? drawer.getAttribute('data-empty-icon-image') || '' : '';
      var emptyIconMarkup = emptyIconImage
        ? '<span class="ciq-cart-drawer__empty-icon ciq-cart-drawer__empty-icon--image" aria-hidden="true"><img class="ciq-cart-drawer__empty-image" src="' + escapeHtml(emptyIconImage) + '" alt="" loading="lazy"></span>'
        : '<span class="ciq-cart-drawer__empty-icon" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M7 8V7a5 5 0 0 1 10 0v1"></path><path d="M5.5 8h13l-1 12h-11l-1-12Z"></path></svg></span>';
      itemsList.innerHTML =
        '<div class="ciq-cart-drawer__empty">' +
        emptyIconMarkup +
        '<h4>' + emptyHeading + '</h4>' +
        '<p>' + emptyText + '</p>' +
        '<a href="' + escapeHtml(emptyCtaUrl) + '" class="ciq-btn ciq-btn--primary">' + emptyCta + '</a>' +
        '</div>';
      if (noteWrap) noteWrap.hidden = true;
      if (footer) footer.hidden = true;
      if (orderSummary) orderSummary.hidden = true;
      if (trustWrap) trustWrap.hidden = true;
      if (shippingWrap) shippingWrap.hidden = true;
      return;
    }

    if (noteWrap && drawer) {
      noteWrap.hidden = drawer.getAttribute('data-cart-note-enabled') !== 'true';
    }

    var renderedCartItems = getRenderableCartItems(cart);
    var variantCartQuantities = Object.create(null);
    (cart.items || []).forEach(function (cartItem) {
      var variantId = String(cartItem && (cartItem.variant_id || cartItem.id) || '');
      if (!variantId) return;
      variantCartQuantities[variantId] = (variantCartQuantities[variantId] || 0) + Number(cartItem.quantity || 0);
    });

    itemsList.innerHTML = renderedCartItems
      .map(function (item) {
        var itemKey = escapeHtml(item.key || '');
        var itemSignature = escapeHtml(item._ciqCartSignature || '');
        var itemLines = escapeHtml((item._ciqCartLines || []).join(','));
        var imageUrl = item.image || '';
        if (imageUrl) imageUrl = imageUrl.replace(/_(\d+x\d+|small|compact|medium|large|grande|master)(?=\.[a-z0-9]+(?:\?|$))/i, '_480x480');
        var imageHtml = imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(item.product_title || 'Collectible') + '" loading="lazy">' : '<div class="ciq-search-drawer__result-thumb"></div>';
        var productUrl = item.url || '/cart';
        var popNumberMatch = String(item.product_title || '').match(/#\s*(\d{1,5})\b/);
        var popNumberHtml = popNumberMatch ? '<span class="ciq-cart-drawer__pop-number">Pop #' + escapeHtml(popNumberMatch[1]) + '</span>' : '';
        var itemProperties = item.properties && typeof item.properties === 'object' ? item.properties : {};
        var badges = getCollectorBadges(item);
        var badgesHtml = badges.length
          ? '<div class="ciq-cart-drawer__badges">' + badges.map(function (badge) { return '<span class="ciq-cart-drawer__badge">' + escapeHtml(badge) + '</span>'; }).join('') + '</div>'
          : '';
        var condition = Object.keys(itemProperties).filter(function (key) { return /^condition$/i.test(key); }).map(function (key) { return itemProperties[key]; })[0];
        var productMeta = condition || '';
        var productMetaHtml = productMeta ? '<p class="ciq-cart-drawer__item-meta">' + escapeHtml(productMeta) + '</p>' : '';
        var variantId = String(item.variant_id || item.id || '');
        var rawInventoryLimit = Object.prototype.hasOwnProperty.call(inventoryLimits, variantId) ? inventoryLimits[variantId] : null;
        var inventoryLimit = rawInventoryLimit !== null && rawInventoryLimit !== '' ? Number(rawInventoryLimit) : NaN;
        var currentVariantQuantity = variantCartQuantities[variantId] || Number(item.quantity || 0);
        var atInventoryLimit = Number.isFinite(inventoryLimit) && currentVariantQuantity >= inventoryLimit;
        var plusButtonState = ' data-inventory-current-quantity="' + escapeHtml(currentVariantQuantity) + '"' +
          (Number.isFinite(inventoryLimit) ? ' data-inventory-limit="' + escapeHtml(inventoryLimit) + '"' : '') +
          (atInventoryLimit ? ' disabled title="Maximum available quantity is already in your cart" aria-label="Maximum available quantity reached"' : ' aria-label="Increase quantity"');
        var savingsHtml = Number(item.original_line_price || 0) > Number(item.final_line_price || 0)
          ? '<p class="ciq-cart-drawer__item-savings">You save ' + formatCurrency(Number(item.original_line_price || 0) - Number(item.final_line_price || 0), cart.currency) + '</p>'
          : '';
        return (
          '<article class="ciq-cart-drawer__item" data-cart-signature="' + itemSignature + '">' +
          '<a class="ciq-cart-drawer__item-media" href="' + escapeHtml(productUrl) + '">' + imageHtml + '</a>' +
          '<div class="ciq-cart-drawer__item-info">' +
          (item.product_type ? '<p class="ciq-cart-drawer__item-franchise">' + escapeHtml(item.product_type) + '</p>' : '') +
          '<p class="ciq-cart-drawer__item-title"><a href="' + escapeHtml(productUrl) + '">' + escapeHtml(item.product_title || 'Product') + '</a></p>' +
          popNumberHtml +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="ciq-cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
          productMetaHtml +
          badgesHtml +
          '<p class="ciq-cart-drawer__item-price">' + formatCurrency(item.final_line_price, cart.currency) + '</p>' +
          savingsHtml +
          '<div class="ciq-cart-drawer__item-actions"><div class="ciq-cart-drawer__qty">' +
          '<button type="button" data-coreiq-cart-qty data-key="' + itemKey + '" data-signature="' + itemSignature + '" data-lines="' + itemLines + '" data-delta="-1" aria-label="Decrease quantity"' + (Number(item.quantity || 0) <= 1 ? ' disabled' : '') + '>-</button>' +
          '<span data-coreiq-cart-qty-value>' + item.quantity + '</span>' +
          '<button type="button" data-coreiq-cart-qty data-key="' + itemKey + '" data-signature="' + itemSignature + '" data-lines="' + itemLines + '" data-delta="1"' + plusButtonState + '>+</button>' +
          '</div>' +
          '<button type="button" class="ciq-cart-drawer__remove" data-coreiq-cart-remove data-key="' + itemKey + '" data-signature="' + itemSignature + '" data-lines="' + itemLines + '">Remove</button></div>' +
          '</div>' +
          '</article>'
        );
      })
      .join('');

    hydrateCartProductBadges(renderedCartItems, itemsList);

    if (total) total.textContent = formatCurrency(cart.total_price, cart.currency);
    if (estimatedTotal) estimatedTotal.textContent = formatCurrency(cart.total_price, cart.currency);
    if (orderSummary) orderSummary.hidden = false;
    if (footer) footer.hidden = false;

    if (window.matchMedia('(min-width: 990px)').matches) {
      applyCartItemLimit();
    }
  }

  function applyCartItemLimit() {
    var container = document.querySelector('[data-ciq-cart-max-items]');
    if (!container) return;
    var max = parseInt(container.getAttribute('data-ciq-cart-max-items'), 10) || 5;
    var items = container.querySelectorAll('.ciq-cart-drawer__item');
    if (items.length <= max) return;

    // Remove any previously injected Show all button before re-applying
    var existingBtn = container.querySelector('[data-ciq-cart-show-all]');
    if (existingBtn) existingBtn.remove();
    // Ensure all items are visible before re-hiding
    items.forEach(function(item) { item.hidden = false; });

    items.forEach(function(item, i) {
      if (i >= max) item.hidden = true;
    });

    var showAllBtn = document.createElement('button');
    showAllBtn.type = 'button';
    showAllBtn.className = 'ciq-cart-drawer__show-all-btn';
    showAllBtn.setAttribute('data-ciq-cart-show-all', '');
    showAllBtn.textContent = 'Show all ' + items.length + ' items';
    showAllBtn.addEventListener('click', function() {
      items.forEach(function(item) { item.hidden = false; });
      showAllBtn.remove();
    });
    container.appendChild(showAllBtn);
  }

  // Re-apply or remove cart item limit on viewport resize
  var cartLimitResizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(cartLimitResizeTimer);
    cartLimitResizeTimer = setTimeout(function() {
      var container = document.querySelector('[data-ciq-cart-max-items]');
      if (!container) return;
      var items = container.querySelectorAll('.ciq-cart-drawer__item');
      if (!items.length) return;
      if (window.matchMedia('(min-width: 990px)').matches) {
        applyCartItemLimit();
      } else {
        // Remove the limit on mobile — show all items
        items.forEach(function(item) { item.hidden = false; });
        var btn = container.querySelector('[data-ciq-cart-show-all]');
        if (btn) btn.remove();
      }
    }, 120);
  }, { passive: true });

  function isProductOnSale(product) {
    if (!product) return false;

    var directCompare = Number(product.compare_at_price || 0);
    var directPrice = Number(product.price || 0);
    if (directCompare > directPrice && directPrice > 0) return true;

    var minCompare = Number(product.compare_at_price_min || 0);
    var minPrice = Number(product.price_min || product.price || 0);
    if (minCompare > minPrice && minPrice > 0) return true;

    if (Array.isArray(product.variants)) {
      return product.variants.some(function (variant) {
        return Number(variant && variant.compare_at_price) > Number(variant && variant.price);
      });
    }

    return false;
  }

  function hasAvailableUpsellVariant(product) {
    if (!product) return false;
    if (typeof product.available === 'boolean') return product.available;
    if (Array.isArray(product.variants) && product.variants.length) {
      return product.variants.some(function (variant) {
        return Boolean(variant && variant.available);
      });
    }
    return true;
  }

  function getCartUpsellFallbackMarkup(drawer) {
    if (!drawer) return '';
    var template = drawer.querySelector('[data-coreiq-cart-upsell-fallback-template]');
    return template ? String(template.innerHTML || '').trim() : '';
  }

  function getVisibleMiniCardCount(container) {
    if (!container) return 0;
    return Array.prototype.slice.call(container.querySelectorAll('.ciq-mini-card')).filter(function (card) {
      return !card.hidden;
    }).length;
  }

  function buildUpsellCardMarkup(product) {
    if (!product) return '';

    var featuredImage = '';
    if (product.featured_image) {
      featuredImage = product.featured_image;
    } else if (product.images && product.images.length) {
      featuredImage = product.images[0];
    } else if (product.image) {
      featuredImage = product.image;
    }

    var priceText = product.price;
    if (typeof product.price === 'number') {
      priceText = formatCurrency(product.price, window.Shopify && Shopify.currency ? Shopify.currency.active : undefined);
    }

    var variants = (product.variants || []).map(function (variant) {
      return {
        id: variant.id,
        title: variant.title || 'Default Title',
        available: typeof variant.available === 'boolean' ? variant.available : true,
        price: typeof variant.price === 'number'
          ? formatCurrency(variant.price, window.Shopify && Shopify.currency ? Shopify.currency.active : undefined)
          : (variant.price || priceText || '')
      };
    });

    var productUrl = product.url || '#';
    var collectorBadges = getCollectorBadges(product);
    var collectorBadgesHtml = collectorBadges.length
      ? '<div class="ciq-cart-drawer__badges">' + collectorBadges.map(function (badge) { return '<span class="ciq-cart-drawer__badge">' + escapeHtml(badge) + '</span>'; }).join('') + '</div>'
      : '';
    var quickViewAttrs =
      ' data-coreiq-quick-view' +
      ' data-product-context="cart-upsell"' +
      ' data-product-url="' + escapeHtml(productUrl) + '"' +
      ' data-product-title="' + escapeHtml(product.title || 'Product') + '"' +
      ' data-product-price="' + escapeHtml(priceText || '') + '"' +
      ' data-product-vendor="' + escapeHtml(product.vendor || '') + '"' +
      ' data-product-image="' + escapeHtml(featuredImage || '') + '"' +
      ' aria-haspopup="dialog" aria-controls="ciq-quick-view-modal" aria-expanded="false"';

    var mediaHtml =
      '<a href="' + escapeHtml(productUrl) + '" class="ciq-mini-card__media" aria-label="View ' + escapeHtml(product.title || 'Product') + '">' +
      (featuredImage ? '<img src="' + escapeHtml(featuredImage) + '" alt="" loading="lazy">' : '<div class="ciq-search-drawer__result-thumb"></div>') +
      '</a>';

    var titleHtml =
      '<h3 class="ciq-mini-card__title">' +
      '<button type="button" class="ciq-mini-card__title-button"' + quickViewAttrs + '>' + escapeHtml(product.title || 'Product') + '</button>' +
      '</h3>';

    var actionHtml =
      '<button type="button" class="ciq-btn ciq-btn--secondary ciq-mini-card__cta ciq-mini-card__cta--options"' + quickViewAttrs + '><span aria-hidden="true">＋</span><span>Add to cart</span></button>';

    if (variants.length === 1 && variants[0].available) {
      actionHtml =
        '<form method="post" action="/cart/add" data-coreiq-quick-add-form>' +
        '<input type="hidden" name="id" value="' + escapeHtml(String(variants[0].id || '')) + '">' +
        '<input type="hidden" name="quantity" value="1">' +
        '<button type="submit" class="ciq-btn ciq-btn--secondary ciq-mini-card__cta ciq-mini-card__cta--compact" data-coreiq-quick-add-btn><span aria-hidden="true">＋</span><span data-coreiq-quick-add-label>Add to cart</span></button>' +
        '</form>';
    }

    return (
      '<article class="ciq-mini-card">' +
      mediaHtml +
      '<div class="ciq-mini-card__body">' +
      collectorBadgesHtml +
      (product.vendor ? '<p class="ciq-mini-card__vendor"><a href="/search?q=' + encodeURIComponent(product.vendor) + '&type=product%2Cpage%2Carticle&options%5Bprefix%5D=last" class="ciq-mini-card__vendor-link">' + escapeHtml(product.vendor) + '</a></p>' : '') +
      titleHtml +
      (priceText ? '<p class="ciq-mini-card__price">' + escapeHtml(priceText) + '</p>' : '') +
      actionHtml +
      '<script type="application/json" data-coreiq-product-variants">' + serializeJsonForScript(variants) + '</script>' +
      '</div>' +
      '</article>'
    );
  }

  function renderCartUpsells(cart) {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    var upsellWrap = drawer.querySelector('[data-coreiq-cart-upsell-wrap]');
    var upsellList = drawer.querySelector('[data-coreiq-cart-upsell-list]');
    var upsellHead = drawer.querySelector('.ciq-cart-drawer__upsell-head h4');
    var intentEnabled = drawer.getAttribute('data-cart-intent-enabled') === 'true';
    var intentTitleTemplate = drawer.getAttribute('data-cart-intent-title-template') || 'Complete your {intent} setup';
    if (!upsellWrap || !upsellList) return;
    if (drawer.getAttribute('data-cart-upsell-enabled') === 'false') {
      upsellWrap.hidden = true;
      upsellList.innerHTML = '';
      return;
    }
    var defaultUpsellHeading = '';
    if (upsellHead) {
      defaultUpsellHeading = upsellHead.getAttribute('data-coreiq-default-heading') || upsellHead.textContent || '';
      if (!upsellHead.hasAttribute('data-coreiq-default-heading')) {
        upsellHead.setAttribute('data-coreiq-default-heading', defaultUpsellHeading);
      }
    }

    if (!cart || !cart.items || !cart.items.length) {
      upsellWrap.hidden = true;
      upsellList.innerHTML = '';
      return;
    }

    var inCartIds = {};
    var inCartHandles = {};
    var cartTypes = {};
    cart.items.forEach(function (item) {
      if (item.product_id) inCartIds[String(item.product_id)] = true;
      if (item.handle) inCartHandles[String(item.handle)] = true;
      if (item.product_type) {
        var normalizedType = String(item.product_type).trim();
        if (normalizedType) {
          cartTypes[normalizedType] = (cartTypes[normalizedType] || 0) + Number(item.quantity || 1);
        }
      }
    });

    var source = drawer.getAttribute('data-cart-upsell-source') || 'recommendations';
    var recommendationIntent = drawer.getAttribute('data-cart-upsell-intent') || 'complementary';
    if (recommendationIntent !== 'related' && recommendationIntent !== 'complementary') {
      recommendationIntent = 'complementary';
    }
    var configuredLimit = parseInt(drawer.getAttribute('data-cart-upsell-limit') || '2', 10);
    configuredLimit = Math.max(1, configuredLimit || 2);
    var limit = configuredLimit;
    limit = Math.min(2, limit);
    var recentlyViewedLimit = parseInt(drawer.getAttribute('data-cart-recently-viewed-limit') || String(configuredLimit || 4), 10);
    recentlyViewedLimit = Math.min(2, Math.max(1, recentlyViewedLimit || 2));
    var excludeSale = drawer.getAttribute('data-cart-upsell-exclude-sale') === 'true';
    var excludeStock = drawer.getAttribute('data-cart-upsell-exclude-stock') === 'true';
    var fallbackMarkup = getCartUpsellFallbackMarkup(drawer);
    var resetUpsellMode = function () {
      upsellWrap.classList.remove('ciq-cart-drawer__upsell--recently-viewed');
      upsellList.classList.remove('ciq-cart-drawer__upsell-list--carousel');
    };
    resetUpsellMode();
    var setIntentHeading = function () {
      if (!intentEnabled || !upsellHead) return;
      var topType = Object.keys(cartTypes).sort(function (a, b) {
        return cartTypes[b] - cartTypes[a];
      })[0];
      if (topType) {
        upsellHead.textContent = intentTitleTemplate.replace('{intent}', topType.toLowerCase());
      } else if (defaultUpsellHeading) {
        upsellHead.textContent = defaultUpsellHeading;
      }
    };
    var showFallbackUpsells = function () {
      if (!fallbackMarkup) return false;
      resetUpsellMode();
      upsellList.innerHTML = fallbackMarkup;
      upsellList.querySelectorAll('.ciq-mini-card').forEach(function (card) {
        var productId = card.getAttribute('data-product-id') || '';
        card.hidden = Boolean(productId && inCartIds[String(productId)]);
      });
      var visibleFallbackCards = getVisibleMiniCardCount(upsellList);
      if (!visibleFallbackCards) {
        upsellWrap.hidden = true;
        upsellList.innerHTML = '';
        return false;
      }
      setIntentHeading();
      upsellWrap.hidden = false;
      return true;
    };
    var showRecentlyViewedUpsells = function () {
      var storedRecentItems = getRecentlyViewedProducts().filter(function (item) {
        return item && item.handle;
      }).slice(0, recentlyViewedLimit);
      var recentItems = storedRecentItems.filter(function (item) {
        return item && item.handle && !inCartHandles[String(item.handle)];
      });
      if (!recentItems.length) {
        recentItems = storedRecentItems;
      }
      var recentMarkup = recentItems.map(buildCartDrawerRecentlyViewedCard).filter(Boolean).join('');
      if (!recentMarkup && cart && cart.items && cart.items.length) {
        recentMarkup = cart.items.slice(0, recentlyViewedLimit).map(function (item) {
          return buildCartDrawerRecentlyViewedCard({
            handle: item.handle || '',
            url: item.url || '/cart',
            title: item.product_title || item.title || 'Product',
            price: formatCurrency(Number(item.final_price || item.price || 0), cart.currency),
            image: item.image || '',
            available: true,
            purchasable: false
          });
        }).filter(Boolean).join('');
      }
      if (!recentMarkup) return false;
      upsellWrap.classList.add('ciq-cart-drawer__upsell--recently-viewed');
      upsellList.classList.add('ciq-cart-drawer__upsell-list--carousel');
      upsellList.innerHTML = recentMarkup;
      if (!getVisibleMiniCardCount(upsellList)) {
        upsellWrap.hidden = true;
        upsellList.innerHTML = '';
        return false;
      }
      if (upsellHead) {
        upsellHead.textContent = 'Complete Your Collection';
      }
      upsellWrap.hidden = false;
      return true;
    };

    if (source === 'manual_collection') {
      resetUpsellMode();
      var visibleManualCards = 0;
      upsellList.querySelectorAll('.ciq-mini-card').forEach(function (card) {
        var productId = card.getAttribute('data-product-id') || '';
        var showCard = !productId || !inCartIds[String(productId)];
        card.hidden = !showCard;
        if (showCard) visibleManualCards += 1;
      });
      if (visibleManualCards > 0) setIntentHeading();
      if (visibleManualCards === 0 && showFallbackUpsells()) return;
      if (visibleManualCards === 0 && showRecentlyViewedUpsells()) return;
      upsellWrap.hidden = visibleManualCards === 0;
      return;
    }

    var primaryItem = cart.items[0];
    if (!primaryItem || !primaryItem.product_id) {
      if (showRecentlyViewedUpsells()) return;
      upsellWrap.hidden = true;
      return;
    }

    var topIntentType = Object.keys(cartTypes).sort(function (a, b) {
      return cartTypes[b] - cartTypes[a];
    })[0] || '';

    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(primaryItem.product_id) + '&limit=' + encodeURIComponent(String(Math.max(limit + 2, 4))) + '&intent=' + encodeURIComponent(recommendationIntent), {
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Upsell recommendations failed');
        return res.json();
      })
      .then(function (payload) {
        if (!latestCartState || !latestCartState.items || !latestCartState.items.length) {
          upsellWrap.hidden = true;
          upsellList.innerHTML = '';
          return;
        }

        var products = (payload && payload.products) || [];
        var filtered = products.filter(function (product) {
          if (!product || inCartIds[String(product.id)]) return false;
          if (excludeSale && isProductOnSale(product)) return false;
          if (excludeStock && !hasAvailableUpsellVariant(product)) return false;
          return true;
        });

        if (intentEnabled && topIntentType) {
          filtered.sort(function (a, b) {
            var aType = String(a && a.type || '').toLowerCase();
            var bType = String(b && b.type || '').toLowerCase();
            var intent = String(topIntentType || '').toLowerCase();
            var aScore = aType === intent ? 2 : (aType.indexOf(intent) > -1 ? 1 : 0);
            var bScore = bType === intent ? 2 : (bType.indexOf(intent) > -1 ? 1 : 0);
            return bScore - aScore;
          });
        }

        filtered = filtered.slice(0, Math.max(1, limit));

        if (!filtered.length) {
          if (showFallbackUpsells()) return;
          if (showRecentlyViewedUpsells()) return;
          upsellWrap.hidden = true;
          upsellList.innerHTML = '';
          return;
        }

        resetUpsellMode();
        upsellList.innerHTML = filtered.map(buildUpsellCardMarkup).join('');
        if (!getVisibleMiniCardCount(upsellList)) {
          upsellWrap.hidden = true;
          upsellList.innerHTML = '';
          return;
        }
        setIntentHeading();
        upsellWrap.hidden = false;
      })
      .catch(function () {
        if (!latestCartState || !latestCartState.items || !latestCartState.items.length) {
          upsellWrap.hidden = true;
          upsellList.innerHTML = '';
          return;
        }

        if (showFallbackUpsells()) return;
        if (showRecentlyViewedUpsells()) return;
        upsellWrap.hidden = true;
      });
  }

  function getRecentlyViewedProducts() {
    try {
      return JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveRecentlyViewedProduct(productData) {
    if (!productData || !productData.handle) return;

    productData = Object.assign({}, productData, { viewedAt: Date.now() });

    var existing = getRecentlyViewedProducts().filter(function (item) {
      return item && item.handle && item.handle !== productData.handle;
    });

    existing.unshift(productData);

    try {
      localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(existing.slice(0, 12)));
    } catch (e) {}
  }

  function saveRecentlyViewedProducts(items) {
    try {
      localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify((items || []).slice(0, 12)));
    } catch (e) {}
  }

  function getAvailableRecentlyViewedVariant(product, storedVariantId) {
    var variants = Array.isArray(product && product.variants) ? product.variants : [];
    if (!variants.length) return null;

    var storedId = storedVariantId ? String(storedVariantId) : '';
    var selectedVariant = storedId
      ? variants.filter(function (variant) {
        return variant && String(variant.id) === storedId && variant.available !== false;
      })[0]
      : null;

    return selectedVariant || variants.filter(function (variant) {
      return variant && variant.available !== false;
    })[0] || null;
  }

  function normalizeRecentlyViewedProduct(item, product) {
    if (!item || !product || product.available === false) return null;

    var selectedVariant = getAvailableRecentlyViewedVariant(product, item.variantId);
    if (!selectedVariant) return null;

    var handle = product.handle || item.handle || '';
    var productUrl = product.url || (handle ? '/products/' + handle : item.url || '');
    var image = product.featured_image || (Array.isArray(product.images) && product.images.length ? product.images[0] : item.image || '');
    var priceText = typeof selectedVariant.price === 'number'
      ? formatCurrency(selectedVariant.price, window.Shopify && Shopify.currency ? Shopify.currency.active : undefined)
      : (item.price || '');

    return {
      id: product.id || item.id || '',
      handle: handle,
      url: productUrl,
      title: product.title || item.title || '',
      price: priceText,
      image: image,
      vendor: product.vendor || item.vendor || '',
      tags: product.tags || item.tags || '',
      variantId: selectedVariant.id || item.variantId || '',
      variantTitle: selectedVariant.title || item.variantTitle || 'Default Title',
      viewedAt: Number(item.viewedAt) || Date.now(),
      available: true,
      purchasable: true
    };
  }

  function validateRecentlyViewedProduct(item) {
    if (!item || !item.handle) return Promise.resolve(null);

    return fetch('/products/' + encodeURIComponent(item.handle) + '.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (res.status === 404) return null;
        if (!res.ok) throw new Error('Recently viewed validation failed');
        return res.json();
      })
      .then(function (product) {
        return normalizeRecentlyViewedProduct(item, product);
      })
      .catch(function () {
        var storedPurchasable = item.purchasable === true || item.purchasable === 'true' || item.available === true;
        return storedPurchasable ? item : null;
      });
  }

  function validateRecentlyViewedProducts(items, limit) {
    var requestedLimit = parseInt(limit, 10);
    var validationLimit = Number.isFinite(requestedLimit) ? requestedLimit : 4;
    validationLimit = Math.min(12, Math.max(1, validationLimit));
    var candidates = (items || []).filter(function (item) {
      return item && item.handle;
    }).slice(0, validationLimit);

    if (!candidates.length) return Promise.resolve([]);

    return Promise.all(candidates.map(validateRecentlyViewedProduct)).then(function (results) {
      var validated = results.filter(function (item) {
        return Boolean(item && item.handle && item.purchasable !== false && item.available !== false);
      });
      return validated;
    });
  }

  function buildRecentlyViewedCard(item, showWishlist) {
    if (!item || !item.url || !item.title) return '';

    var isPurchasable = item.purchasable === true || item.purchasable === 'true' || item.available === true;
    var variantTitle = item.variantTitle || 'Default Title';
    var variants = item.variantId
      ? [{
        id: item.variantId,
        title: variantTitle,
        available: Boolean(isPurchasable),
        price: item.price || ''
      }]
      : [];
    var quickViewAttrs =
      ' data-coreiq-quick-view' +
      ' data-product-context="recently-viewed"' +
      ' data-product-url="' + escapeHtml(item.url) + '"' +
      ' data-product-title="' + escapeHtml(item.title) + '"' +
      ' data-product-price="' + escapeHtml(item.price || '') + '"' +
      ' data-product-vendor="' + escapeHtml(item.vendor || '') + '"' +
      ' data-product-image="' + escapeHtml(item.image || '') + '"' +
      ' aria-haspopup="dialog" aria-controls="ciq-quick-view-modal" aria-expanded="false"' +
      ' aria-label="Quick look ' + escapeHtml(item.title) + '"';

    var quickLookHtml = isPurchasable
      ? '<button type="button" class="ciq-mini-card__quick-view ciq-mini-card__quick-view--overlay"' + quickViewAttrs + '>' + getQuickLookIconMarkup() + '<span class="visually-hidden">Quick look</span></button>'
      : '';
    var imageLabel = 'View ' + escapeHtml(item.title || 'product');
    var imageHtml = item.image
      ? '<div class="ciq-mini-card__media-wrap"><a href="' + escapeHtml(item.url) + '" class="ciq-mini-card__media" aria-label="' + imageLabel + '"><img src="' + escapeHtml(item.image) + '" alt="" loading="lazy"></a>' + quickLookHtml + '</div>'
      : '<div class="ciq-mini-card__media-wrap"><a href="' + escapeHtml(item.url) + '" class="ciq-mini-card__media" aria-label="' + imageLabel + '"><div class="ciq-search-drawer__result-thumb"></div></a>' + quickLookHtml + '</div>';

    var actionHtml = '<a href="' + escapeHtml(item.url) + '" class="ciq-btn ciq-btn--secondary ciq-mini-card__cta">View product</a>';
    if (item.variantId && isPurchasable) {
      actionHtml =
        '<form method="post" action="/cart/add" data-coreiq-quick-add-form>' +
        '<input type="hidden" name="id" value="' + escapeHtml(item.variantId) + '">' +
        '<input type="hidden" name="quantity" value="1">' +
        '<button type="submit" class="ciq-btn ciq-btn--secondary ciq-mini-card__cta" data-coreiq-quick-add-btn><span data-coreiq-quick-add-label>Add to cart</span></button>' +
        '</form>';
    }

    var wishlistHtml = showWishlist && item.id
      ? '<button type="button" class="ciq-mini-card__wishlist" data-coreiq-wishlist-btn data-product-id="' + escapeHtml(item.id) + '" data-product-handle="' + escapeHtml(item.handle || '') + '" data-product-title="' + escapeHtml(item.title) + '" data-product-image="' + escapeHtml(item.image || '') + '" data-product-price="' + escapeHtml(item.price || '') + '" data-product-variant-id="' + escapeHtml(item.variantId || '') + '" data-product-available="' + (isPurchasable ? 'true' : 'false') + '" data-product-edition="' + escapeHtml(item.edition || '') + '" aria-pressed="false" aria-label="Add to wishlist: ' + escapeHtml(item.title) + '">♡</button>'
      : '';
    var recentTags = Array.isArray(item.tags) ? item.tags.join('|') : String(item.tags || '');
    var recentBadge = '';
    if (showWishlist) {
      if (/\bchase\b/i.test(recentTags)) recentBadge = 'Chase';
      else if (/\bvaulted\b/i.test(recentTags)) recentBadge = 'Vaulted';
      else if (/\bexclusive\b/i.test(recentTags)) recentBadge = 'Exclusive';
      else if (/\bsigned\b/i.test(recentTags)) recentBadge = 'Signed';
    }

    return (
      '<article class="ciq-mini-card">' +
      imageHtml +
      '<div class="ciq-mini-card__body">' +
      (recentBadge ? '<span class="pc-cart-recent-badge">' + recentBadge + '</span>' : '') +
      wishlistHtml +
      (item.vendor ? '<p class="ciq-mini-card__vendor"><a href="/search?q=' + encodeURIComponent(item.vendor) + '&type=product%2Cpage%2Carticle&options%5Bprefix%5D=last" class="ciq-mini-card__vendor-link">' + escapeHtml(item.vendor) + '</a></p>' : '') +
      '<h3 class="ciq-mini-card__title"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a></h3>' +
      (item.price ? '<p class="ciq-mini-card__price">' + escapeHtml(item.price) + '</p>' : '') +
      actionHtml +
      '<script type="application/json" data-coreiq-product-variants>' + serializeJsonForScript(variants) + '</script>' +
      '</div>' +
      '</article>'
    );
  }

  function buildCartDrawerRecentlyViewedCard(item) {
    if (!item || !item.url || !item.title) return '';

    var isPurchasable = item.purchasable === true || item.purchasable === 'true' || item.available === true;
    var variantTitle = item.variantTitle || 'Default Title';
    var variants = item.variantId
      ? [{
        id: item.variantId,
        title: variantTitle,
        available: Boolean(isPurchasable),
        price: item.price || ''
      }]
      : [];
    var quickViewAttrs =
      ' data-coreiq-quick-view' +
      ' data-product-context="cart-recently-viewed"' +
      ' data-product-url="' + escapeHtml(item.url) + '"' +
      ' data-product-title="' + escapeHtml(item.title) + '"' +
      ' data-product-price="' + escapeHtml(item.price || '') + '"' +
      ' data-product-vendor="' + escapeHtml(item.vendor || '') + '"' +
      ' data-product-image="' + escapeHtml(item.image || '') + '"' +
      ' aria-haspopup="dialog" aria-controls="ciq-quick-view-modal" aria-expanded="false"' +
      ' aria-label="Quick look ' + escapeHtml(item.title) + '"';
    var quickLookHtml = isPurchasable
      ? '<button type="button" class="ciq-mini-card__quick-view ciq-mini-card__quick-view--overlay"' + quickViewAttrs + '>' + getQuickLookIconMarkup() + '<span class="visually-hidden">Quick look</span></button>'
      : '';
    var imageLabel = 'View ' + escapeHtml(item.title || 'product');
    var imageHtml = item.image
      ? '<a href="' + escapeHtml(item.url) + '" class="ciq-mini-card__media" aria-label="' + imageLabel + '"><img src="' + escapeHtml(item.image) + '" alt="" loading="lazy"></a>'
      : '<a href="' + escapeHtml(item.url) + '" class="ciq-mini-card__media" aria-label="' + imageLabel + '"><div class="ciq-search-drawer__result-thumb"></div></a>';

    var actionHtml = '<a href="' + escapeHtml(item.url) + '" class="ciq-btn ciq-btn--secondary ciq-mini-card__cta">View product</a>';
    if (item.variantId && isPurchasable) {
      actionHtml =
        '<form method="post" action="/cart/add" data-coreiq-quick-add-form>' +
        '<input type="hidden" name="id" value="' + escapeHtml(item.variantId) + '">' +
        '<input type="hidden" name="quantity" value="1">' +
        '<button type="submit" class="ciq-btn ciq-btn--secondary ciq-mini-card__cta" data-coreiq-quick-add-btn><span data-coreiq-quick-add-label>Add to cart</span></button>' +
        '</form>';
    }

    return (
      '<article class="ciq-mini-card ciq-mini-card--cart-recent">' +
      '<div class="ciq-mini-card__media-wrap">' +
      imageHtml +
      quickLookHtml +
      '</div>' +
      '<div class="ciq-mini-card__body">' +
      '<h3 class="ciq-mini-card__title"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a></h3>' +
      (item.price ? '<p class="ciq-mini-card__price">' + escapeHtml(item.price) + '</p>' : '') +
      actionHtml +
      '<script type="application/json" data-coreiq-product-variants>' + serializeJsonForScript(variants) + '</script>' +
      '</div>' +
      '</article>'
    );
  }

  function getCollectionGridImageSizes(cols, mobileTwoColumn) {
    var mobileSize = mobileTwoColumn ? 'calc((100vw - 48px) / 2)' : 'calc(100vw - 36px)';
    if (cols === '2') {
      return '(min-width: 1440px) 670px, (min-width: 1200px) calc((100vw - 92px) / 2), (min-width: 990px) calc((100vw - 92px) / 2), (min-width: 750px) 50vw, ' + mobileSize;
    }
    if (cols === '3') {
      return '(min-width: 1440px) 480px, (min-width: 1200px) calc((100vw - 120px) / 3), (min-width: 990px) calc((100vw - 120px) / 3), (min-width: 750px) 50vw, ' + mobileSize;
    }
    return '(min-width: 1440px) 353px, (min-width: 1200px) calc((100vw - 148px) / 4), (min-width: 990px) calc((100vw - 148px) / 4), (min-width: 750px) 50vw, ' + mobileSize;
  }

  function updateCollectionGridImageSizes(grid, cols) {
    if (!grid || !cols) return;
    var sizes = getCollectionGridImageSizes(cols, grid.classList.contains('ciq-grid--mobile-2'));
    grid.querySelectorAll('[data-coreiq-card-primary-image], .ciq-product-card__secondary-image img').forEach(function (img) {
      img.setAttribute('sizes', sizes);
      if (img.dataset && img.dataset.ciqOriginalImageReady === 'true') {
        img.dataset.ciqOriginalSizes = sizes;
      }
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-coreiq-drawer-toggle]');
    if (toggle) {
      var targetId = toggle.getAttribute('data-coreiq-drawer-toggle');
      var drawer = document.getElementById(targetId);
      if (drawer) {
        var isDesktopNonModalSearchClose = targetId === 'predictive-search-drawer' &&
          !isMobileSearchViewport() &&
          isNonModalSearchMode(drawer) &&
          toggle.hasAttribute('data-coreiq-inline-search-close');
        if (isDesktopNonModalSearchClose) {
          e.preventDefault();
          e.stopPropagation();
          closeInlineSearchPanel();
          return;
        }
        var isOpen = drawer.hasAttribute('open');
        if (isOpen) {
          closeDrawer(drawer);
          if (targetId === 'mobile-drawer' && typeof window.coreiqResetMobileNavPanels === 'function') {
            window.coreiqResetMobileNavPanels();
          }
        } else {
          openDrawer(drawer, {
            trigger: toggle,
            suppressInitialFocusRing: shouldSuppressFocusRingFromClick(e)
          });

          if (targetId === 'mobile-drawer' && typeof window.coreiqResetMobileNavPanels === 'function') {
            window.coreiqResetMobileNavPanels();
          }

          if (targetId === 'cart-drawer') {
            fetchCartState()
              .then(function (cart) {
                renderCartDrawer(cart);
              })
              .catch(function () {
                renderCartDrawer(null);
              });
          }
        }
      }
    }

    /* Close on overlay click */
    if (e.target.classList.contains('ciq-mobile-drawer__overlay')) {
      var drawerEl = e.target.closest('.ciq-mobile-drawer');
      if (drawerEl) {
        closeDrawer(drawerEl);
      }
    }
  });

  /* â”€â”€ Keyboard: close drawer on Escape â”€â”€ */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var openDrawer = document.querySelector('.ciq-mobile-drawer[open]');
      if (openDrawer) {
        closeDrawer(openDrawer);
      }
    }

    if (e.key === 'Tab') {
      var modalDrawer = Array.prototype.slice.call(document.querySelectorAll('.ciq-mobile-drawer[open]')).find(isModalDrawerInteraction);
      if (!modalDrawer) return;

      if (modalDrawer.id === 'predictive-search-drawer') {
        if (!isMobileSearchViewport()) {
          return;
        }
      }

      var a11y = window.CoreIQA11y || null;
      if (a11y && typeof a11y.trapTabKey === 'function') {
        a11y.trapTabKey(e, modalDrawer);
      }
    }
  });

  /* â”€â”€ Header nav enhancements: mega menu and analytics â”€â”€ */
  (function initHeaderNavEnhancements() {
    var header = document.querySelector('.ciq-header');
    if (!header) return;

    var nav = header.querySelector('[data-coreiq-nav], [data-coreiq-nav]');
    var megaToggles = header.querySelectorAll('[data-coreiq-mega-toggle]');
    var megaCloseTimer = null;
    var seriesCountRequests = Object.create(null);

    function hydrateSeriesCounts(panel) {
      if (!panel) return;
      panel.querySelectorAll('a[data-coreiq-nav-level="collector-series"]').forEach(function (seriesLink) {
        var countNode = seriesLink.querySelector('[data-coreiq-series-count]');
        if (!countNode || countNode.getAttribute('data-count-loaded') === 'true') return;

        var href = seriesLink.getAttribute('href') || '';
        var target;
        try {
          target = new URL(href, window.location.href);
        } catch (error) {
          return;
        }
        if (target.origin !== window.location.origin || !/^\/collections\//.test(target.pathname)) return;

        var cacheKey = 'pc-mega-series-count:' + target.href;
        var cached = null;
        try {
          cached = JSON.parse(window.sessionStorage.getItem(cacheKey) || 'null');
        } catch (error) {}

        function applyCount(value) {
          if (!Number.isFinite(value) || value < 0) return;
          countNode.textContent = String(value);
          countNode.setAttribute('aria-label', value + ' collectible' + (value === 1 ? '' : 's'));
          countNode.hidden = false;
          countNode.setAttribute('data-count-loaded', 'true');
          var arrow = seriesLink.querySelector('.pc-mega-series-arrow');
          if (arrow) arrow.hidden = true;
        }

        if (cached && Number.isFinite(cached.count) && Date.now() - cached.savedAt < 15 * 60 * 1000) {
          applyCount(cached.count);
          return;
        }

        if (seriesCountRequests[target.href]) {
          seriesCountRequests[target.href].then(applyCount);
          return;
        }

        seriesCountRequests[target.href] = fetch(target.href, { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Unable to load collection count');
            return response.text();
          })
          .then(function (html) {
            var documentFromResponse = new DOMParser().parseFromString(html, 'text/html');
            var collectionPanel = documentFromResponse.querySelector('[data-coreiq-collection-results]');
            var count = collectionPanel ? Number(collectionPanel.getAttribute('data-coreiq-collection-results')) : NaN;
            if (!Number.isFinite(count)) throw new Error('Collection result count is unavailable');
            try {
              window.sessionStorage.setItem(cacheKey, JSON.stringify({ count: count, savedAt: Date.now() }));
            } catch (error) {}
            return count;
          })
          .catch(function () { return NaN; })
          .finally(function () { delete seriesCountRequests[target.href]; });

        seriesCountRequests[target.href].then(applyCount);
      });
    }

    function clearMegaCloseTimer() {
      if (!megaCloseTimer) return;
      window.clearTimeout(megaCloseTimer);
      megaCloseTimer = null;
    }

    function scheduleMegaClose(event) {
      var nextTarget = event && event.relatedTarget;
      if (nextTarget && (nav.contains(nextTarget) || nextTarget.closest && nextTarget.closest('[data-coreiq-mega-panel]'))) return;

      clearMegaCloseTimer();
      megaCloseTimer = window.setTimeout(function () {
        closeAllMegaPanels();
      }, 180);
    }

    function closeAllMegaPanels() {
      clearMegaCloseTimer();
      header.querySelectorAll('[data-coreiq-mega-panel]').forEach(function (panel) {
        panel.hidden = true;
        panel.classList.remove('is-open');
      });
      megaToggles.forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.classList.remove('is-open');
      });
      document.body.classList.remove('ciq-mega-open');
    }

    function isPlainTopLevelNavLink(el) {
      if (!el || !nav || !nav.contains(el)) return false;
      if (el.closest('[data-coreiq-mega-item]')) return false;
      if (el.hasAttribute('data-coreiq-mega-toggle')) return false;
      return el.classList && el.classList.contains('ciq-header__nav-link');
    }

    function openMegaPanel(toggle) {
      if (!toggle) return;
      closePredictiveSearchForNavigation();
      clearMegaCloseTimer();
      var panelId = toggle.getAttribute('aria-controls');
      if (!panelId) return;
      var panel = document.getElementById(panelId);
      if (!panel) return;

      closeAllMegaPanels();
      panel.hidden = false;
      panel.classList.add('is-open');
      hydrateSeriesCounts(panel);
      toggle.setAttribute('aria-expanded', 'true');
      toggle.classList.add('is-open');
      document.body.classList.add('ciq-mega-open');

      emitThemeAnalytics('coreiq_nav_mega_opened', {
        menuStyle: nav ? nav.getAttribute('data-coreiq-menu-style') || nav.getAttribute('data-coreiq-menu-style') || '' : '',
        navLabel: toggle.textContent ? toggle.textContent.trim() : ''
      });
    }

    if (megaToggles.length && nav) {
      megaToggles.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          var panelId = toggle.getAttribute('aria-controls');
          var panel = panelId ? document.getElementById(panelId) : null;
          var isOpen = !!(panel && !panel.hidden);
          if (isOpen) {
            closeAllMegaPanels();
          } else {
            openMegaPanel(toggle);
          }
        });

        var megaItem = toggle.closest('[data-coreiq-mega-item]');
        if (megaItem) {
          megaItem.addEventListener('mouseenter', function () {
            openMegaPanel(toggle);
          });
          megaItem.addEventListener('mouseleave', scheduleMegaClose);
        }

        toggle.addEventListener('focusin', function () {
          openMegaPanel(toggle);
        });
      });

      header.querySelectorAll('[data-coreiq-mega-panel]').forEach(function (panel) {
        panel.addEventListener('mouseenter', clearMegaCloseTimer);
        panel.addEventListener('mouseleave', scheduleMegaClose);
        panel.addEventListener('focusin', clearMegaCloseTimer);
        panel.addEventListener('focusout', scheduleMegaClose);
      });

      nav.addEventListener('mouseenter', clearMegaCloseTimer);
      nav.addEventListener('mouseleave', scheduleMegaClose);
      nav.addEventListener('pointerover', function (event) {
        var supportsHoverNav = !window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        if (!supportsHoverNav) return;
        var topLink = event.target.closest('.ciq-header__nav-link');
        if (topLink && nav.contains(topLink)) {
          closePredictiveSearchForNavigation();
        }
        if (isPlainTopLevelNavLink(topLink)) {
          closeAllMegaPanels();
        }
      });
      nav.addEventListener('focusin', function (event) {
        var topLink = event.target.closest('.ciq-header__nav-link');
        if (topLink && nav.contains(topLink)) {
          closePredictiveSearchForNavigation();
        }
        if (isPlainTopLevelNavLink(topLink)) {
          closeAllMegaPanels();
        }
      });
      nav.addEventListener('focusout', scheduleMegaClose);

      nav.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeAllMegaPanels();
      });

      document.addEventListener('click', function (event) {
        if (!event.target.closest('.ciq-header__nav') && !event.target.closest('[data-coreiq-mega-panel]')) {
          closeAllMegaPanels();
        }
      });
    }

    document.addEventListener('click', function (event) {
      var navLink = event.target.closest('[data-coreiq-nav-link], [data-coreiq-nav-link]');
      if (!navLink) return;

      var navLabel = navLink.getAttribute('data-coreiq-nav-label') || navLink.getAttribute('data-coreiq-nav-label') || navLink.textContent || '';
      var navLevel = navLink.getAttribute('data-coreiq-nav-level') || navLink.getAttribute('data-coreiq-nav-level') || 'unknown';
      var navUrl = navLink.getAttribute('href') || '';

      setAssistedAttributionContext({
        assistSurface: 'navigation',
        assistTargetType: navLevel,
        assistRuleId: '',
        assistRuleName: navLabel,
        assistQuery: '',
        assistUrl: navUrl
      });

      emitThemeAnalytics('coreiq_nav_click', {
        navLabel: String(navLabel || '').replace(/\s+/g, ' ').trim(),
        navLevel: navLevel,
        navUrl: navUrl
      });
    });
  })();

  /* Header icon contrast: keep action icons readable against merchant-picked icon surfaces. */
  (function initHeaderIconContrast() {
    var contrastFrame = null;

    function parseCssColor(value) {
      value = String(value || '').trim().toLowerCase();
      if (!value || value === 'transparent') return null;

      var parts = value.match(/[\d.]+%?/g);
      if (!parts || parts.length < 3) return null;

      function toChannel(part) {
        if (String(part).indexOf('%') !== -1) {
          return Math.round((parseFloat(part) / 100) * 255);
        }
        return Math.max(0, Math.min(255, parseFloat(part)));
      }

      return {
        r: toChannel(parts[0]),
        g: toChannel(parts[1]),
        b: toChannel(parts[2]),
        a: parts.length > 3 ? Math.max(0, Math.min(1, parseFloat(parts[3]))) : 1
      };
    }

    function blendColor(top, base) {
      var alpha = top && typeof top.a === 'number' ? top.a : 1;
      if (alpha >= 1) return top;
      base = base || { r: 255, g: 255, b: 255, a: 1 };
      return {
        r: Math.round((top.r * alpha) + (base.r * (1 - alpha))),
        g: Math.round((top.g * alpha) + (base.g * (1 - alpha))),
        b: Math.round((top.b * alpha) + (base.b * (1 - alpha))),
        a: 1
      };
    }

    function getBackdropColor(element) {
      var current = element && element.parentElement ? element.parentElement : null;
      while (current && current !== document.documentElement) {
        var currentStyle = window.getComputedStyle ? window.getComputedStyle(current) : null;
        var currentColor = currentStyle ? parseCssColor(currentStyle.backgroundColor) : null;
        if (currentColor && currentColor.a > 0.02) {
          if (currentColor.a >= 0.98) return currentColor;
          return blendColor(currentColor, getBackdropColor(current));
        }
        current = current.parentElement;
      }

      var bodyStyle = document.body && window.getComputedStyle ? window.getComputedStyle(document.body) : null;
      var bodyColor = bodyStyle ? parseCssColor(bodyStyle.backgroundColor) : null;
      return bodyColor ? blendColor(bodyColor, { r: 255, g: 255, b: 255, a: 1 }) : { r: 255, g: 255, b: 255, a: 1 };
    }

    function getButtonSurfaceColor(button) {
      var computed = window.getComputedStyle ? window.getComputedStyle(button) : null;
      var color = computed ? parseCssColor(computed.backgroundColor) : null;
      var backdrop = getBackdropColor(button);
      if (!color || color.a === 0) {
        color = backdrop;
      }
      return color ? blendColor(color, backdrop) : null;
    }

    function relativeLuminance(color) {
      function channel(value) {
        value = value / 255;
        return value <= 0.03928 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
      }

      return (0.2126 * channel(color.r)) + (0.7152 * channel(color.g)) + (0.0722 * channel(color.b));
    }

    function syncHeaderIconContrast(root) {
      root = root && root.querySelectorAll ? root : document;
      var buttons = root.querySelectorAll('.ciq-header__actions .ciq-header__icon-btn:not(.ciq-search-drawer__close-btn)');
      buttons.forEach(function (button) {
        var surface = getButtonSurfaceColor(button);
        if (!surface) {
          button.removeAttribute('data-coreiq-contrast-icon');
          return;
        }
        button.setAttribute('data-coreiq-contrast-icon', relativeLuminance(surface) > 0.46 ? 'dark' : 'light');
      });
    }

    function scheduleHeaderIconContrast(root) {
      if (contrastFrame) window.cancelAnimationFrame(contrastFrame);
      contrastFrame = window.requestAnimationFrame(function () {
        contrastFrame = null;
        syncHeaderIconContrast(root || document);
      });
    }

    window.CoreIQSyncHeaderIconContrast = scheduleHeaderIconContrast;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scheduleHeaderIconContrast(document); });
    } else {
      scheduleHeaderIconContrast(document);
    }

    window.addEventListener('load', function () { scheduleHeaderIconContrast(document); });
    window.addEventListener('resize', function () { scheduleHeaderIconContrast(document); }, { passive: true });
    window.addEventListener('scroll', function () { scheduleHeaderIconContrast(document); }, { passive: true });
    document.addEventListener('shopify:section:load', function (event) { scheduleHeaderIconContrast(event.target || document); });
    document.addEventListener('shopify:section:select', function (event) { scheduleHeaderIconContrast(event.target || document); });
  })();

  /* ── Mobile drawer accordion nav ── */
  (function initMobileDrawerAccordion() {
    var drawer = document.getElementById('mobile-drawer');
    if (!drawer) return;

    function closeAllAccordions() {
      drawer.querySelectorAll('.ciq-mobile-drawer__accordion[open]').forEach(function (el) {
        el.removeAttribute('open');
      });
    }

    window.coreiqResetMobileNavPanels = closeAllAccordions;
  })();

  function applyAnnouncementSlideStyle(bar, slide) {
    if (!bar) return;

    var defaultBg = bar.getAttribute('data-coreiq-default-bg') || '';
    var defaultText = bar.getAttribute('data-coreiq-default-text') || '';
    var defaultHeight = bar.getAttribute('data-coreiq-default-height') || '32px';
    var defaultFontSize = bar.getAttribute('data-coreiq-default-font-size') || '13px';
    var defaultPosition = (bar.getAttribute('data-coreiq-default-position') || 'center').toLowerCase();
    var defaultFontFamily = bar.getAttribute('data-coreiq-default-font-family') || 'inherit';
    var defaultPillRadius = bar.getAttribute('data-coreiq-default-pill-radius') || '999px';
    var defaultPillText = bar.getAttribute('data-coreiq-default-pill-text') || defaultText;
    var defaultPillBg = bar.getAttribute('data-coreiq-default-pill-bg') || 'color-mix(in srgb, var(--ciq-announcement-text) 16%, transparent)';
    var defaultPillStroke = bar.getAttribute('data-coreiq-default-pill-stroke') || 'transparent';
    var isEditorMode = !!(bar && bar.classList.contains('ciq-announcement--editor-preview'));

    var bg = slide ? (slide.getAttribute('data-coreiq-style-bg') || defaultBg) : defaultBg;
    var text = slide ? (slide.getAttribute('data-coreiq-style-text') || defaultText) : defaultText;
    var height = slide ? (slide.getAttribute('data-coreiq-style-height') || defaultHeight) : defaultHeight;
    var fontSize = slide ? (slide.getAttribute('data-coreiq-style-font-size') || defaultFontSize) : defaultFontSize;
    var position = slide ? (slide.getAttribute('data-coreiq-style-position') || defaultPosition).toLowerCase() : defaultPosition;
    var fontFamily = slide ? (slide.getAttribute('data-coreiq-style-font-family') || defaultFontFamily) : defaultFontFamily;
    var pillRadius = slide ? (slide.getAttribute('data-coreiq-style-pill-radius') || defaultPillRadius) : defaultPillRadius;
    var pillText = slide ? (slide.getAttribute('data-coreiq-style-pill-text') || defaultPillText) : defaultPillText;
    var pillBg = slide ? (slide.getAttribute('data-coreiq-style-pill-bg') || defaultPillBg) : defaultPillBg;
    var pillStroke = slide ? (slide.getAttribute('data-coreiq-style-pill-stroke') || defaultPillStroke) : defaultPillStroke;

    if (isEditorMode) {
      bar.style.setProperty('--ciq-announcement-bg', defaultBg);
      bar.style.setProperty('--ciq-announcement-text', defaultText);
      bar.style.setProperty('--ciq-announcement-height', height || defaultHeight);
      bar.style.setProperty('--ciq-announcement-font-size', fontSize || defaultFontSize);
      bar.style.setProperty('--ciq-announcement-font-family', fontFamily || defaultFontFamily);
      bar.style.setProperty('--ciq-announcement-pill-radius', pillRadius || defaultPillRadius);
      bar.style.setProperty('--ciq-announcement-pill-text', pillText || defaultPillText || defaultText);
      bar.style.setProperty('--ciq-announcement-pill-bg', pillBg || defaultPillBg);
      bar.style.setProperty('--ciq-announcement-pill-stroke', pillStroke || defaultPillStroke);
    } else {
      bar.style.setProperty('--ciq-announcement-bg', defaultBg);
      bar.style.setProperty('--ciq-announcement-text', defaultText);
      bar.style.setProperty('--ciq-announcement-height', height || defaultHeight);
      bar.style.setProperty('--ciq-announcement-font-size', defaultFontSize);
      bar.style.setProperty('--ciq-announcement-font-family', defaultFontFamily);
      bar.style.setProperty('--ciq-announcement-pill-radius', defaultPillRadius);
      bar.style.setProperty('--ciq-announcement-pill-text', defaultPillText || defaultText);
      bar.style.setProperty('--ciq-announcement-pill-bg', defaultPillBg);
      bar.style.setProperty('--ciq-announcement-pill-stroke', defaultPillStroke);
    }

    var inner = bar.querySelector('.ciq-announcement__inner');
    if (!inner) return;
    inner.classList.remove('ciq-placement--left', 'ciq-placement--center', 'ciq-placement--right');
    if (position !== 'left' && position !== 'right') {
      position = 'center';
    }
    inner.classList.add('ciq-placement--' + position);
  }

  function getAnnouncementSlideVariant(slide) {
    return String(slide && slide.getAttribute('data-coreiq-promo-variant') || 'a').toLowerCase();
  }

  function getAnnouncementSlideSlot(slide) {
    return String(slide && slide.getAttribute('data-coreiq-promo-slot') || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();
  }

  function isAnnouncementBVariantAllowed(slide) {
    return String(slide && slide.getAttribute('data-coreiq-b-variant-allowed') || 'true') === 'true';
  }

  function getAnnouncementDesignModeSlides(bar) {
    var slides = Array.prototype.slice.call(bar.querySelectorAll('[data-coreiq-promo-variant][data-coreiq-promo-slot]'));
    return slides.filter(function (slide) {
      return getAnnouncementSlideVariant(slide) === 'a' || (getAnnouncementSlideVariant(slide) === 'b' && isAnnouncementBVariantAllowed(slide));
    });
  }

  function getAnnouncementPairedFrames(slides) {
    var aSlidesBySlot = {};
    var bSlidesBySlot = {};
    var standaloneASlides = [];
    var standaloneBSlides = [];
    var frames = [];

    slides.forEach(function (slide) {
      var slot = getAnnouncementSlideSlot(slide);
      if (getAnnouncementSlideVariant(slide) === 'b') {
        if (!isAnnouncementBVariantAllowed(slide)) return;
        if (!slot) {
          standaloneBSlides.push(slide);
          return;
        }
        if (bSlidesBySlot[slot]) {
          standaloneBSlides.push(slide);
          return;
        }
        bSlidesBySlot[slot] = slide;
        return;
      }

      if (slot && !aSlidesBySlot[slot]) {
        aSlidesBySlot[slot] = slide;
        return;
      }

      standaloneASlides.push(slide);
    });

    Object.keys(aSlidesBySlot).forEach(function (slot) {
      var frame = [aSlidesBySlot[slot]];
      if (bSlidesBySlot[slot]) {
        frame.push(bSlidesBySlot[slot]);
      }
      frames.push(frame);
      delete bSlidesBySlot[slot];
    });

    standaloneASlides.forEach(function (slide) {
      frames.push([slide]);
    });

    Object.keys(bSlidesBySlot).forEach(function (slot) {
      frames.push([bSlidesBySlot[slot]]);
    });

    standaloneBSlides.forEach(function (slide) {
      frames.push([slide]);
    });

    return frames;
  }

  /* â”€â”€ Announcement promo experiment (A/B) â”€â”€ */
  function initAnnouncementPromoExperiment(root) {
    var bars = (root || document).querySelectorAll('.ciq-announcement[data-coreiq-promo-experiment-enabled]');
    if (!bars.length) return;

    bars.forEach(function (bar, index) {
      var slides = Array.prototype.slice.call(bar.querySelectorAll('[data-coreiq-promo-variant][data-coreiq-promo-slot]'));
      if (!slides.length) return;
      var keyedASlots = {};

      slides.forEach(function (slide) {
        if (getAnnouncementSlideVariant(slide) !== 'a') return;
        var aSlot = getAnnouncementSlideSlot(slide);
        if (!aSlot) return;
        keyedASlots[aSlot] = true;
      });

      var isDesignMode = !!(window.Shopify && Shopify.designMode);
      if (isDesignMode) {
        bar.classList.add('ciq-announcement--editor-preview');
        var editorSlides = getAnnouncementDesignModeSlides(bar);
        slides.forEach(function (slide) {
          var visible = editorSlides.indexOf(slide) !== -1;
          slide.setAttribute('data-coreiq-promo-visible', visible ? 'true' : 'false');
          slide.hidden = !visible;
          slide.classList.toggle('is-active', false);
          slide.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });
        applyAnnouncementSlideStyle(bar, editorSlides[0] || null);
        return;
      }

      bar.classList.remove('ciq-announcement--editor-preview');

      var enabled = String(bar.getAttribute('data-coreiq-promo-experiment-enabled') || 'false') === 'true';
      if (!enabled) {
        slides.forEach(function (slide) {
          slide.setAttribute('data-coreiq-promo-visible', 'true');
        });
        applyAnnouncementSlideStyle(bar, null);
        return;
      }

      var forcedVariant = String(bar.getAttribute('data-coreiq-promo-experiment-force-variant') || 'random').toLowerCase();
      var aWeight = Math.min(90, Math.max(10, parseInt(bar.getAttribute('data-coreiq-promo-experiment-a-weight') || '50', 10)));
      var storageKey = 'coreiq-announcement-promo-experiment-variant::' + index;
      var variant = 'a';

      if (forcedVariant === 'a' || forcedVariant === 'b') {
        variant = forcedVariant;
      } else {
        try {
          var existing = localStorage.getItem(storageKey);
          if (existing === 'a' || existing === 'b') {
            variant = existing;
          } else {
            variant = Math.random() * 100 < aWeight ? 'a' : 'b';
            localStorage.setItem(storageKey, variant);
          }
        } catch (e) {
          variant = Math.random() * 100 < aWeight ? 'a' : 'b';
        }
      }

      emitThemeAnalytics('coreiq_announcement_promo_experiment_assigned', {
        experimentName: 'announcement-bar-promo-slot',
        experimentVariant: variant,
        forcedVariant: forcedVariant
      });

      var trackedImpressions = {};
      var visibleSlides = [];

      slides.forEach(function (slide) {
        var slideVariant = String(slide.getAttribute('data-coreiq-promo-variant') || 'both').toLowerCase();
        var slot = getAnnouncementSlideSlot(slide);
        if (slideVariant === 'b' && (!isAnnouncementBVariantAllowed(slide) || !slot || !keyedASlots[slot])) {
          slide.setAttribute('data-coreiq-promo-visible', 'false');
          slide.hidden = true;
          slide.classList.toggle('is-active', false);
          slide.setAttribute('aria-hidden', 'true');
          return;
        }
        var visible = false;
        if (!slot) {
          visible = true;
        } else {
          visible = slideVariant === 'both' || slideVariant === variant;
        }

        slide.setAttribute('data-coreiq-promo-visible', visible ? 'true' : 'false');
        slide.hidden = !visible;
        slide.classList.toggle('is-active', false);
        slide.setAttribute('aria-hidden', visible ? 'false' : 'true');

        if (visible) {
          visibleSlides.push(slide);
          var impressionKey = slot + '::' + slideVariant;
          if (slot && !trackedImpressions[impressionKey]) {
            trackedImpressions[impressionKey] = true;
            emitThemeAnalytics('coreiq_announcement_promo_impression', {
              promoSlotId: slot,
              promoVariant: slideVariant,
              experimentVariant: variant
            });
          }
        }
      });

      if (visibleSlides.length) {
        visibleSlides[0].hidden = false;
        visibleSlides[0].classList.add('is-active');
      }

      applyAnnouncementSlideStyle(bar, null);
    });
  }

  initAnnouncementPromoExperiment(document);

  /* â”€â”€ Sticky stack offsets for announcement/header/hero underlap â”€â”€ */
  function normalizeStickyAncestors(el) {
    if (!el) return;

    var current = el.parentElement;
    while (current && current !== document.body) {
      var hasHeaderGroupRef =
        (current.id && current.id.indexOf('shopify-section-group-header-group') !== -1) ||
        (current.className && String(current.className).indexOf('shopify-section-group-header-group') !== -1) ||
        (current.className && String(current.className).indexOf('shopify-section') !== -1);

      if (hasHeaderGroupRef) {
        current.style.overflow = 'visible';
        current.style.transform = 'none';
      }

      // Sticky positioning is disabled by any scrolling/ clipped ancestor.
      // Shopify wrappers can receive these styles from apps or editor chrome,
      // so normalize only ancestors that are actually constraining the header.
      if (window.getComputedStyle) {
        var computed = window.getComputedStyle(current);
        if (computed.overflow === 'hidden' || computed.overflow === 'clip' || computed.overflowY === 'auto' || computed.overflowY === 'scroll') {
          current.style.overflow = 'visible';
          current.style.overflowY = 'visible';
        }
      }

      current = current.parentElement;
    }
  }

  function syncHeaderStackHeight() {
    var announcementBar = document.querySelector('.ciq-announcement');
    var headerBar = document.querySelector('.ciq-header');
    var announcementGroup = announcementBar && announcementBar.closest('[id^="shopify-section-group-header-group"], .shopify-section-group-header-group');
    var headerGroup = headerBar && headerBar.closest('[id^="shopify-section-group-header-group"], .shopify-section-group-header-group');

    normalizeStickyAncestors(announcementBar);
    normalizeStickyAncestors(headerBar);

    var announcementStickyEnabled = false;
    var headerStickyEnabled = false;

    if (announcementBar) {
      announcementStickyEnabled = announcementBar.getAttribute('data-sticky-enabled') === 'true';
      announcementBar.classList.toggle('ciq-announcement--sticky', announcementStickyEnabled);
      announcementBar.classList.remove('ciq-announcement--fixed');
    }

    if (headerBar) {
      if (typeof headerBar.__coreiqStickyCompactSetting === 'undefined') {
        headerBar.__coreiqStickyCompactSetting = headerBar.getAttribute('data-sticky-compact-enabled') === 'true';
      }
      var explicitHeaderStickyEnabled = headerBar.getAttribute('data-sticky-enabled') === 'true';
      headerStickyEnabled = announcementStickyEnabled || explicitHeaderStickyEnabled;
      headerBar.classList.toggle('ciq-header--sticky', headerStickyEnabled);
      headerBar.classList.remove('ciq-header--fixed');

      var compactLogoWidth = headerBar.style.getPropertyValue('--ciq-sticky-logo-width') || '92px';
      var compactHeight = headerBar.style.getPropertyValue('--ciq-header-compact-height') || '56px';
      headerBar.style.setProperty('--ciq-sticky-logo-width', compactLogoWidth);
      headerBar.style.setProperty('--ciq-header-compact-height', compactHeight);
    }

    var stickyAnnouncement = announcementStickyEnabled ? announcementBar : null;
    var stickyHeader = headerStickyEnabled ? headerBar : null;

    var announcementHeight = announcementBar ? announcementBar.offsetHeight || 0 : 0;
    var stickyAnnouncementHeight = stickyAnnouncement ? stickyAnnouncement.offsetHeight || 0 : 0;
    var headerHeight = headerBar ? headerBar.offsetHeight || 0 : 0;

    if (headerBar && !headerBar.classList.contains('ciq-header--compact')) {
      headerBar.__coreiqReservedHeaderHeight = headerHeight;
    }

    var reservedHeaderHeight = headerBar ? Math.max(headerBar.__coreiqReservedHeaderHeight || 0, headerHeight) : 0;
    var stableHeaderHeight = stickyHeader ? reservedHeaderHeight : headerHeight;
    var stackHeight = announcementHeight + stableHeaderHeight;
    var stickyStackHeight = stickyAnnouncementHeight + (stickyHeader ? stableHeaderHeight : 0);
    var fixedOverlayHeight = 0;

    document.documentElement.style.setProperty('--ciq-header-stack-height', stackHeight + 'px');
    document.documentElement.style.setProperty('--ciq-sticky-stack-height', stickyStackHeight + 'px');
    document.documentElement.style.setProperty('--ciq-stable-header-stack-height', stickyStackHeight > 0 ? stickyStackHeight + 'px' : stackHeight + 'px');
    document.documentElement.style.setProperty('--ciq-announcement-fixed-height', stickyAnnouncement ? stickyAnnouncementHeight + 'px' : '0px');
    document.documentElement.style.setProperty('--ciq-fixed-stack-height', fixedOverlayHeight + 'px');
    document.documentElement.classList.toggle('ciq-has-fixed-stack', fixedOverlayHeight > 0);

    // Shopify renders announcement and header as sibling, short section-group
    // wrappers. Make those wrappers the sticky rails: a sticky child alone is
    // constrained by its own wrapper and scrolls away immediately.
    if (announcementGroup) {
      announcementGroup.classList.toggle('ciq-announcement-group--sticky', announcementStickyEnabled);
      if (announcementStickyEnabled) {
        announcementGroup.style.setProperty('position', 'sticky', 'important');
        announcementGroup.style.setProperty('top', '0px', 'important');
        announcementGroup.style.setProperty('z-index', '141', 'important');
        announcementBar.style.setProperty('position', 'static', 'important');
        announcementBar.style.removeProperty('top');
      } else {
        announcementGroup.style.removeProperty('position');
        announcementGroup.style.removeProperty('top');
        announcementGroup.style.removeProperty('z-index');
        announcementBar.style.removeProperty('position');
        announcementBar.style.removeProperty('top');
      }
    }

    if (headerGroup) {
      headerGroup.classList.toggle('ciq-header-group--sticky', headerStickyEnabled);
      if (headerStickyEnabled) {
        headerGroup.style.setProperty('position', 'sticky', 'important');
        // Sibling section wrappers need an explicit offset beneath the
        // announcement. A shared wrapper naturally lays out the bars, so it
        // stays at zero to avoid applying that offset twice.
        headerGroup.style.setProperty('top', announcementGroup && announcementGroup !== headerGroup && stickyAnnouncement ? stickyAnnouncementHeight + 'px' : '0px', 'important');
        headerGroup.style.setProperty('z-index', '140', 'important');
        headerBar.style.setProperty('position', 'static', 'important');
        headerBar.style.setProperty('top', '0px', 'important');
        headerBar.style.marginTop = '0px';
      } else {
        headerGroup.style.removeProperty('position');
        headerGroup.style.removeProperty('top');
        headerGroup.style.removeProperty('z-index');
        headerBar.style.removeProperty('position');
        headerBar.style.removeProperty('top');
        headerBar.style.removeProperty('margin-top');
      }
    } else if (stickyHeader) {
      stickyHeader.style.setProperty('position', 'sticky', 'important');
      stickyHeader.style.setProperty('top', stickyAnnouncement ? stickyAnnouncementHeight + 'px' : '0px', 'important');
      stickyHeader.style.marginTop = '0px';
    } else if (headerBar) {
      headerBar.style.removeProperty('position');
      headerBar.style.removeProperty('top');
      headerBar.style.removeProperty('margin-top');
    }

    // Header measurements are reliable only after this synchronizer has
    // committed a compact/full state. Re-anchor an already open inline search
    // here rather than during every scroll event.
    var openInlineSearch = document.getElementById('predictive-search-drawer');
    if (openInlineSearch && openInlineSearch.hasAttribute('open') && openInlineSearch.getAttribute('data-search-mode') === 'inline_panel' && !isMobileSearchViewport()) {
      updateInlineSearchPanelPosition();
    }

  }

  function syncUnderlapHeaderMode() {
    var headerBar = document.querySelector('.ciq-header');
    var underlapEnabled = headerBar && headerBar.getAttribute('data-underlap-hero-enabled') === 'true';
    document.documentElement.classList.toggle('ciq-underlap-header-enabled', !!underlapEnabled);
    var heroCandidates = document.querySelectorAll('#MainContent > .shopify-section.ciq-section-centered-hero .ciq-hero');
    if (!heroCandidates.length) {
      heroCandidates = document.querySelectorAll('.ciq-section-centered-hero .ciq-hero');
    }

    if (!underlapEnabled) {
      document.documentElement.classList.remove('ciq-underlap-header-active');
      heroCandidates.forEach(function (heroEl) {
        heroEl.classList.remove('ciq-hero--under-header');
      });
      return;
    }

    var primaryHero = document.querySelector('#MainContent > .shopify-section.ciq-section-centered-hero:first-of-type .ciq-hero');
    if (!primaryHero && heroCandidates.length) {
      primaryHero = heroCandidates[0];
    }

    heroCandidates.forEach(function (heroEl) {
      var shouldUnderlapThisHero = Boolean(underlapEnabled && primaryHero && heroEl === primaryHero);
      heroEl.classList.toggle('ciq-hero--under-header', shouldUnderlapThisHero);
    });

    var underlapHero = primaryHero && primaryHero.classList.contains('ciq-hero--under-header') ? primaryHero : null;
    if (!underlapHero) {
      document.documentElement.classList.remove('ciq-underlap-header-active');
      return;
    }

    var heroRect = underlapHero.getBoundingClientRect();
    var stickyStackHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ciq-sticky-stack-height')) || 0;
    var shouldEnableTransparentStack = heroRect.bottom > stickyStackHeight + 24;

    document.documentElement.classList.toggle('ciq-underlap-header-active', shouldEnableTransparentStack);
  }

  function syncCenteredHeaderSpacing() {
    var centeredHeaders = document.querySelectorAll('.ciq-header[data-logo-placement="center"]');
    centeredHeaders.forEach(function (headerEl) {
      var logoEl = headerEl.querySelector('.ciq-header__logo');
      var navEl = headerEl.querySelector('.ciq-header__nav');
      var logoHeight = logoEl ? logoEl.offsetHeight || 40 : 40;
      var navHeight = navEl ? navEl.offsetHeight || 24 : 24;

      headerEl.style.setProperty('--ciq-center-logo-height', Math.max(logoHeight, 24) + 'px');
      headerEl.style.setProperty('--ciq-center-nav-height', Math.max(navHeight, 20) + 'px');
    });
  }

  syncHeaderStackHeight();
  syncCenteredHeaderSpacing();
  syncUnderlapHeaderMode();
  initAnnouncementPromoExperiment(document);
  initAnnouncementRotator(document);
  initAnnouncementCountdown();
  syncCompactHeaderState();
  window.addEventListener('resize', syncHeaderStackHeight, { passive: true });
  window.addEventListener('resize', syncCenteredHeaderSpacing, { passive: true });
  window.addEventListener('resize', syncUnderlapHeaderMode, { passive: true });
  window.addEventListener('scroll', syncUnderlapHeaderMode, { passive: true });
  window.addEventListener('load', syncHeaderStackHeight);
  window.addEventListener('load', syncCenteredHeaderSpacing);
  window.addEventListener('load', syncUnderlapHeaderMode);

  document.addEventListener('shopify:section:load', function () {
    setTimeout(function () {
      syncHeaderStackHeight();
      syncCenteredHeaderSpacing();
      syncUnderlapHeaderMode();
      initAnnouncementPromoExperiment(document);
      initAnnouncementRotator(document);
      initAnnouncementCountdown();
      syncCompactHeaderState();
    }, 40);
  });

  document.addEventListener('shopify:section:reorder', function () {
    setTimeout(function () {
      syncHeaderStackHeight();
      syncCenteredHeaderSpacing();
      syncUnderlapHeaderMode();
      initAnnouncementPromoExperiment(document);
      initAnnouncementRotator(document);
      initAnnouncementCountdown();
      syncCompactHeaderState();
    }, 40);
  });

  document.addEventListener('shopify:section:select', function () {
    setTimeout(function () {
      syncHeaderStackHeight();
      syncCenteredHeaderSpacing();
      syncUnderlapHeaderMode();
      initAnnouncementPromoExperiment(document);
      initAnnouncementRotator(document);
      initAnnouncementCountdown();
      syncCompactHeaderState();
    }, 40);
  });

  document.addEventListener('shopify:block:select', function () {
    setTimeout(function () {
      initAnnouncementPromoExperiment(document);
      initAnnouncementRotator(document);
      initAnnouncementCountdown();
      syncCompactHeaderState();
    }, 40);
  });

  /* â”€â”€ Product-grid filter view toggles (chips <-> sidebar) â”€â”€ */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-coreiq-open-filters]');
    var closeBtn = e.target.closest('[data-coreiq-close-filters]');
    if (!openBtn && !closeBtn) return;

    e.preventDefault();

    var mobileFilters = window.matchMedia('(max-width: 989px)').matches;
    var drawerId = openBtn ? openBtn.getAttribute('data-coreiq-filter-drawer-id') : '';
    var drawer = drawerId ? document.getElementById(drawerId) : e.target.closest('.ciq-collection-filter-drawer');

    function syncFilterDrawerTriggers(isOpen) {
      if (!drawer || !drawer.id) return;
      document.querySelectorAll('[data-coreiq-open-filters][data-coreiq-filter-drawer-id="' + drawer.id + '"]').forEach(function (button) {
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    if (mobileFilters && drawer) {
      if (openBtn) {
        openDrawer(drawer, { trigger: openBtn });
        syncFilterDrawerTriggers(true);
      } else {
        closeDrawer(drawer);
        syncFilterDrawerTriggers(false);
      }
      return;
    }

    var host = e.target.closest('.ciq-section-product-grid, .ciq-section');
    if (!host) return;

    var layout = host.querySelector('.ciq-collection-layout');
    var aside = host.querySelector('.ciq-collection-filters');
    if (!layout || !aside) return;

    var openSidebar = Boolean(openBtn);
    function syncFilterButtons(isOpen) {
      host.querySelectorAll('[data-coreiq-open-filters]').forEach(function (button) {
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        button.classList.toggle('ciq-collection-toolbar__filter-button--sidebar', isOpen);
      });
    }

    window.clearTimeout(aside.__ciqFilterTimer);
    if (openSidebar) {
      layout.classList.add('ciq-collection-layout--with-sidebar');
      aside.classList.remove('is-hidden', 'is-hiding');
      requestAnimationFrame(function () {
        aside.classList.add('is-visible');
        initFilterScrollAffordances(aside);
      });
    } else {
      aside.classList.remove('is-visible');
      aside.classList.add('is-hiding');
      aside.__ciqFilterTimer = window.setTimeout(function () {
        aside.classList.remove('is-hiding');
        aside.classList.add('is-hidden');
        layout.classList.remove('ciq-collection-layout--with-sidebar');
      }, 180);
    }
    syncFilterButtons(openSidebar);
  });

  document.addEventListener('ciq:drawer-closed', function (event) {
    var drawerId = event && event.detail ? event.detail.drawerId : '';
    if (!drawerId) return;
    document.querySelectorAll('[data-coreiq-open-filters][data-coreiq-filter-drawer-id="' + drawerId + '"]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
  });

  function syncInitialFilterTriggerStates() {
    var mobileFilters = window.matchMedia('(max-width: 989px)').matches;
    document.querySelectorAll('[data-coreiq-open-filters][data-coreiq-filter-drawer-id]').forEach(function (button) {
      if (mobileFilters) {
        button.setAttribute('aria-expanded', 'false');
        return;
      }

      var host = button.closest('.ciq-section-product-grid, .ciq-section');
      var layout = host ? host.querySelector('.ciq-collection-layout') : null;
      var aside = host ? host.querySelector('.ciq-collection-filters') : null;
      var isOpen = !!(layout && aside && layout.classList.contains('ciq-collection-layout--with-sidebar') && !aside.classList.contains('is-hidden'));
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function initFilterScrollAffordances(root) {
    var scope = root && root.target ? root.target : root || document;
    var areas = scope.querySelectorAll('[data-coreiq-filter-scroll-area]');
    if (!areas.length) return;

    areas.forEach(function (area) {
      var frame = area.parentElement;
      if (!frame) return;
      frame.classList.add('ciq-filter-scroll-affordance');

      function syncAffordance() {
        var hasMore = area.scrollHeight > area.clientHeight + 2;
        var atEnd = area.scrollTop + area.clientHeight >= area.scrollHeight - 2;
        frame.classList.toggle('is-active', hasMore && !atEnd);
      }

      if (area.__ciqFilterScrollAffordanceInitialized) {
        syncAffordance();
        return;
      }

      area.__ciqFilterScrollAffordanceInitialized = true;
      area.addEventListener('scroll', syncAffordance, { passive: true });
      window.addEventListener('resize', syncAffordance, { passive: true });
      if ('ResizeObserver' in window) {
        var resizeObserver = new ResizeObserver(syncAffordance);
        resizeObserver.observe(area);
        area.__ciqFilterScrollResizeObserver = resizeObserver;
      }
      if ('MutationObserver' in window) {
        var mutationObserver = new MutationObserver(syncAffordance);
        mutationObserver.observe(area, { attributes: true, childList: true, subtree: true });
        area.__ciqFilterScrollMutationObserver = mutationObserver;
      }
      window.requestAnimationFrame(syncAffordance);
    });
  }

  initFilterScrollAffordances(document);
  syncInitialFilterTriggerStates();
  window.addEventListener('resize', syncInitialFilterTriggerStates, { passive: true });
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(syncInitialFilterTriggerStates, 40);
  });

  function getFilterSurface(element) {
    return element ? element.closest('[data-coreiq-filter-surface][data-coreiq-section-id]') : null;
  }

  function getFilterSurfaceBySectionId(sectionId) {
    if (!sectionId) return null;
    var selector = '[data-coreiq-filter-surface][data-coreiq-section-id="' + String(sectionId).replace(/"/g, '\\"') + '"]';
    return document.querySelector(selector);
  }

  function setFilterSurfacePending(surface, isPending) {
    if (!surface) return;
    surface.classList.toggle('is-filtering-pending', Boolean(isPending));
  }

  function setFilterSurfaceLoading(surface, isLoading) {
    if (!surface) return;
    surface.classList.toggle('is-filtering', Boolean(isLoading));
    surface.classList.remove('is-filtering-pending');
    surface.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function buildFilterFormUrl(form) {
    var nextUrl = new URL(form.getAttribute('action') || window.location.href, window.location.origin);
    nextUrl.search = '';
    var formData = new FormData(form);
    formData.forEach(function (value, key) {
      if (String(value || '').trim() !== '') nextUrl.searchParams.append(key, value);
    });
    return nextUrl;
  }

  function replaceFilterSurfaceFromHtml(currentSurface, html, sectionId) {
    var parser = new DOMParser();
    var nextDoc = parser.parseFromString(html, 'text/html');
    var nextSurface = nextDoc.querySelector('[data-coreiq-filter-surface][data-coreiq-section-id="' + String(sectionId).replace(/"/g, '\\"') + '"]') || nextDoc.querySelector('[data-coreiq-filter-surface]');
    if (!nextSurface) throw new Error('CoreIQ filter surface was not found in section response.');

    currentSurface.outerHTML = nextSurface.outerHTML;
    var insertedSurface = getFilterSurfaceBySectionId(sectionId) || document.querySelector('[data-coreiq-filter-surface]');
    if (insertedSurface) {
      initPriceRangeSliders(insertedSurface);
      initPriceFilterAutoSubmit(insertedSurface);
      syncInitialFilterTriggerStates();
      initFilterScrollAffordances(insertedSurface);
      syncCollectionGridToggles(insertedSurface);
      initScrollAnimations(insertedSurface);
      document.dispatchEvent(new CustomEvent('coreiq:filters-updated', { detail: { surface: insertedSurface } }));
    }
    return insertedSurface;
  }

  function filterSurfaceHasMissingProducts(surface) {
    if (!surface) return false;
    if (surface.querySelector('.ciq-product-card')) return false;
    if (surface.querySelector('.ciq-collection-page__empty, .ciq-recovery-state')) return false;

    var countEl = surface.querySelector('.ciq-collection-page__count, .ciq-collection-toolbar__results');
    var countText = countEl ? countEl.textContent || '' : '';
    var match = countText.match(/\d+/);
    return Boolean(match && Number(match[0]) > 0);
  }

  function navigateFilterSurface(nextUrl, surface, options) {
    if (!nextUrl || !surface) return false;
    var sectionId = surface.getAttribute('data-coreiq-section-id');
    if (!sectionId || !window.fetch || !window.DOMParser) return false;
    closeFilterDrawersInSurface(surface);
    window.__coreiqFilterRequestSerial = window.__coreiqFilterRequestSerial || {};
    var requestSerial = (window.__coreiqFilterRequestSerial[sectionId] || 0) + 1;
    window.__coreiqFilterRequestSerial[sectionId] = requestSerial;

    var displayUrl = new URL(nextUrl.toString(), window.location.origin);
    displayUrl.searchParams.delete('section_id');
    var fetchUrl = new URL(displayUrl.toString(), window.location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);

    window.clearTimeout(surface.__ciqFilterLoadingTimer);
    surface.__ciqFilterLoadingTimer = window.setTimeout(function () {
      setFilterSurfaceLoading(surface, true);
    }, 80);

    if (surface.__ciqFilterAbortController) {
      surface.__ciqFilterAbortController.abort();
    }
    var abortController = window.AbortController ? new AbortController() : null;
    surface.__ciqFilterAbortController = abortController;

    fetch(fetchUrl.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: abortController ? abortController.signal : undefined
    })
      .then(function (response) {
        if (!response.ok) throw new Error('CoreIQ filter request failed.');
        return response.text();
      })
      .then(function (html) {
        if (window.__coreiqFilterRequestSerial[sectionId] !== requestSerial) return;
        window.clearTimeout(surface.__ciqFilterLoadingTimer);
        var insertedSurface = replaceFilterSurfaceFromHtml(surface, html, sectionId);
        if (filterSurfaceHasMissingProducts(insertedSurface)) {
          window.location.href = displayUrl.toString();
          return;
        }
        if (!options || options.updateHistory !== false) {
          window.history.pushState({ coreiqFilterSectionId: sectionId }, '', displayUrl.pathname + displayUrl.search + displayUrl.hash);
        }
      })
      .catch(function () {
        if (window.__coreiqFilterRequestSerial[sectionId] !== requestSerial) return;
        if (abortController && abortController.signal.aborted) return;
        window.location.href = displayUrl.toString();
      });

    return true;
  }

  function closeFilterDrawersInSurface(surface) {
    if (!surface) return;
    surface.querySelectorAll('.ciq-collection-filter-drawer[open]').forEach(function (drawer) {
      closeDrawer(drawer);
      if (!drawer.id) return;
      document.querySelectorAll('[data-coreiq-open-filters][data-coreiq-filter-drawer-id="' + drawer.id + '"]').forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
    });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.ciq-collection-filters__value[href], .ciq-filter-chip--clear[href], .ciq-filter-chip--active[href]');
    if (!link || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || link.target === '_blank') return;

    var surface = getFilterSurface(link);
    if (!surface) return;

    var href = link.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return;

    var nextUrl;
    try {
      nextUrl = new URL(href, window.location.origin);
    } catch (err) {
      return;
    }

    if (navigateFilterSurface(nextUrl, surface)) {
      e.preventDefault();
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-coreiq-price-filter-form]');
    if (!form) return;

    var surface = getFilterSurface(form);
    if (!surface) return;

    var nextUrl = buildFilterFormUrl(form);
    if (navigateFilterSurface(nextUrl, surface)) {
      e.preventDefault();
    }
  });

  window.addEventListener('popstate', function () {
    var surface = document.querySelector('[data-coreiq-filter-surface][data-coreiq-section-id]');
    if (!surface) return;
    navigateFilterSurface(new URL(window.location.href), surface, { updateHistory: false });
  });

  document.addEventListener('click', function (e) {
    var filterLink = e.target.closest('.ciq-collection-filters__value[href]');
    if (!filterLink) return;

    var sidebar = filterLink.closest('.ciq-collection-filters[data-coreiq-using-native-filters]');
    if (!sidebar) return;

    var usingNativeFilters = String(sidebar.getAttribute('data-coreiq-using-native-filters') || 'false') === 'true';
    if (usingNativeFilters) return;

    var layout = sidebar.closest('.ciq-collection-layout');
    if (!layout) return;

    var grid = layout.querySelector('[data-coreiq-collection-grid]');
    if (!grid) return;

    var href = filterLink.getAttribute('href') || '';
    if (!href) return;

    var nextUrl;
    try {
      nextUrl = new URL(href, window.location.origin);
    } catch (err) {
      return;
    }

    e.preventDefault();

    var params = nextUrl.searchParams;
    var vendorValues = [];
    var optionValues = [];

    params.forEach(function (value, key) {
      var normalized = String(value || '').trim().toLowerCase().replace(/\s+/g, '-');
      if (!normalized) return;

      if (key === 'filter.p.vendor') {
        vendorValues.push(normalized);
      }

      if (key.indexOf('filter.v.option.') === 0) {
        optionValues.push(normalized);
      }
    });

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.ciq-collection-card-shell'));
    var visibleCount = 0;

    cards.forEach(function (card) {
      var vendorTokens = String(card.getAttribute('data-coreiq-filter-vendor') || '');
      var optionTokens = String(card.getAttribute('data-coreiq-filter-options') || '');

      var vendorPass = !vendorValues.length || vendorValues.some(function (vendor) {
        return vendorTokens.indexOf('|' + vendor + '|') !== -1;
      });

      var optionPass = !optionValues.length || optionValues.every(function (optionValue) {
        return optionTokens.indexOf('|' + optionValue + '|') !== -1;
      });

      var shouldShow = vendorPass && optionPass;
      card.hidden = !shouldShow;
      if (shouldShow) visibleCount += 1;
    });

    var resultsLabel = layout.querySelector('.ciq-collection-toolbar__results');
    if (resultsLabel) {
      resultsLabel.textContent = visibleCount + ' result' + (visibleCount === 1 ? '' : 's');
    }

    window.history.replaceState({}, '', nextUrl.pathname + nextUrl.search);
  });

  function captureCollectionGridPositions(grid) {
    return Array.prototype.map.call(grid.children, function (item) {
      if (item.hidden || !item.getClientRects().length) return null;
      var rect = item.getBoundingClientRect();
      return { item: item, left: rect.left, top: rect.top };
    }).filter(Boolean);
  }

  function animateCollectionGridReflow(grid, previousPositions) {
    if (!previousPositions || !previousPositions.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var staggerIndex = 0;
    previousPositions.forEach(function (previous) {
      var item = previous.item;
      if (!item.isConnected || item.hidden || !item.getClientRects().length || typeof item.animate !== 'function') return;

      var next = item.getBoundingClientRect();
      var deltaX = previous.left - next.left;
      var deltaY = previous.top - next.top;
      if (Math.abs(deltaX) < 1 && Math.abs(deltaY) < 1) return;

      item.animate([
        { transform: 'translate3d(' + deltaX + 'px, ' + deltaY + 'px, 0) scale(.985)', opacity: 0.78 },
        { transform: 'translate3d(0, 0, 0) scale(1)', opacity: 1 }
      ], {
        duration: 360,
        delay: Math.min(staggerIndex * 14, 180),
        easing: 'cubic-bezier(.2,.75,.25,1)'
      });
      staggerIndex += 1;
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-coreiq-grid-cols]');
    if (!toggle) return;

    e.preventDefault();

    var host = e.target.closest('.ciq-section-product-grid, .ciq-section');
    if (!host) return;

    var grid = host.querySelector('[data-coreiq-collection-grid]');
    if (!grid) return;

    var nextCols = toggle.getAttribute('data-coreiq-grid-cols');
    if (!nextCols) return;

    if (grid.classList.contains('ciq-grid--' + nextCols)) return;
    var previousPositions = captureCollectionGridPositions(grid);

    ['2', '3', '4'].forEach(function (cols) {
      grid.classList.remove('ciq-grid--' + cols);
    });
    grid.classList.add('ciq-grid--' + nextCols);
    updateCollectionGridImageSizes(grid, nextCols);
    animateCollectionGridReflow(grid, previousPositions);
    try {
      localStorage.setItem('ciq_collection_grid_columns', nextCols);
    } catch (_) {}

    host.querySelectorAll('[data-coreiq-grid-cols]').forEach(function (button) {
      var isActive = button.getAttribute('data-coreiq-grid-cols') === nextCols;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  });

  function syncCollectionGridToggles(root) {
    var scope = root && root.target ? root.target : root || document;
    scope.querySelectorAll('[data-coreiq-collection-grid]').forEach(function (grid) {
      var host = grid.closest('.ciq-section-product-grid, .ciq-section');
      if (!host) return;
      var activeCols = grid.getAttribute('data-default-grid') || '';
      ['2', '3', '4', '5'].some(function (cols) {
        if (grid.classList.contains('ciq-grid--' + cols)) {
          activeCols = cols;
          return true;
        }
        return false;
      });
      if (!activeCols) return;
      var storedCols = null;
      try { storedCols = localStorage.getItem('ciq_collection_grid_columns'); } catch (_) {}
      if (storedCols && ['2', '3', '4', '5'].indexOf(storedCols) !== -1) {
        ['2', '3', '4', '5'].forEach(function (cols) {
          grid.classList.toggle('ciq-grid--' + cols, cols === storedCols);
        });
        activeCols = storedCols;
        updateCollectionGridImageSizes(grid, activeCols);
      }
      host.querySelectorAll('[data-coreiq-grid-cols]').forEach(function (button) {
        var isActive = button.getAttribute('data-coreiq-grid-cols') === activeCols;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncCollectionGridToggles(document); });
  } else {
    syncCollectionGridToggles(document);
  }
  document.addEventListener('shopify:section:load', syncCollectionGridToggles);
  document.addEventListener('shopify:section:load', initScrollAnimations);

  function initPriceRangeSliders(root) {
    var scope = root && root.target ? root.target : root || document;
    var ranges = scope.querySelectorAll('[data-coreiq-price-range]');
    if (!ranges.length) return;

    ranges.forEach(function (range) {
      if (range.dataset.coreiqPriceRangeReady === 'true') return;
      var minInput = range.querySelector('[data-coreiq-price-min]');
      var maxInput = range.querySelector('[data-coreiq-price-max]');
      var control = range.querySelector('.ciq-price-filter-form__range-control');
      var minOutput = range.querySelector('[data-coreiq-price-min-output]');
      var maxOutput = range.querySelector('[data-coreiq-price-max-output]');
      if (!minInput || !maxInput || !control) return;

      var currency = range.dataset.coreiqCurrency || (window.Shopify && Shopify.currency ? Shopify.currency.active : undefined);
      var minAttr = Number(minInput.getAttribute('min') || 0);
      var maxAttr = Number(maxInput.getAttribute('max') || 0);
      var isSingleValueRange = maxAttr <= minAttr;
      var valueSpan = Math.max(maxAttr - minAttr, 1);
      range.classList.toggle('is-single-value', isSingleValueRange);

      function moneyFromUnits(value) {
        var amount = Math.round(Number(value || 0));
        var resolvedCurrency = currency || 'USD';
        try {
          return amount.toLocaleString(undefined, {
            style: 'currency',
            currency: resolvedCurrency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          });
        } catch (e) {
          return '$' + amount;
        }
      }

      function update(activeInput) {
        var minValue = Number(minInput.value || minAttr);
        var maxValue = Number(maxInput.value || maxAttr);

        if (isSingleValueRange) {
          minValue = minAttr;
          maxValue = maxAttr;
          minInput.value = String(minAttr);
          maxInput.value = String(maxAttr);
        }

        if (minValue > maxValue) {
          if (activeInput === minInput) {
            minValue = maxValue;
            minInput.value = String(minValue);
          } else {
            maxValue = minValue;
            maxInput.value = String(maxValue);
          }
        }

        var minPercent = ((minValue - minAttr) / valueSpan) * 100;
        var maxPercent = ((maxValue - minAttr) / valueSpan) * 100;
        control.style.setProperty('--ciq-price-min-percent', isSingleValueRange ? '0%' : Math.max(0, Math.min(100, minPercent)) + '%');
        control.style.setProperty('--ciq-price-max-percent', isSingleValueRange ? '100%' : Math.max(0, Math.min(100, maxPercent)) + '%');
        maxInput.style.zIndex = maxValue - minValue <= 1 ? '3' : '';

        var minMoney = moneyFromUnits(minValue);
        var maxMoney = moneyFromUnits(maxValue);
        if (minOutput) minOutput.textContent = minMoney;
        if (maxOutput) maxOutput.textContent = maxMoney;
      }

      minInput.addEventListener('input', function () { update(minInput); });
      maxInput.addEventListener('input', function () { update(maxInput); });
      update(maxInput);
      range.dataset.coreiqPriceRangeReady = 'true';
    });
  }

  function initPriceFilterAutoSubmit(root) {
    var scope = root && root.target ? root.target : root || document;
    var forms = scope.querySelectorAll('[data-coreiq-price-filter-form]');
    if (!forms.length) return;

    forms.forEach(function (form) {
      if (form.dataset.coreiqPriceAutoSubmitReady === 'true') return;

      function preparePriceInputs() {
        form.querySelectorAll('[data-coreiq-price-min], [data-coreiq-price-max], [data-coreiq-price-input]').forEach(function (input) {
          input.disabled = false;
          var rawValue = String(input.value || '').trim();

          if (input.hasAttribute('data-coreiq-price-input') && !rawValue) {
            input.disabled = true;
            return;
          }

          if (input.hasAttribute('data-coreiq-price-min')) {
            var minDefault = String(input.getAttribute('min') || '').trim();
            if (rawValue === minDefault) input.disabled = true;
          }

          if (input.hasAttribute('data-coreiq-price-max')) {
            var maxDefault = String(input.getAttribute('max') || '').trim();
            if (rawValue === maxDefault) input.disabled = true;
          }
        });
      }

      function submitPriceForm(delay) {
        setFilterSurfacePending(getFilterSurface(form), true);
        window.clearTimeout(form.__ciqPriceSubmitTimer);
        form.__ciqPriceSubmitTimer = window.setTimeout(function () {
          preparePriceInputs();
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        }, delay);
      }

      form.addEventListener('submit', preparePriceInputs);
      form.querySelectorAll('[data-coreiq-price-min], [data-coreiq-price-max], [data-coreiq-price-input]').forEach(function (input) {
        if (input.type === 'range') {
          input.addEventListener('change', function () { submitPriceForm(40); });
          input.addEventListener('pointerup', function () { submitPriceForm(60); });
          input.addEventListener('keyup', function (event) {
            if (event.key === 'Enter' || event.key === ' ') submitPriceForm(60);
          });
        } else {
          input.addEventListener('input', function () { submitPriceForm(520); });
          input.addEventListener('change', function () { submitPriceForm(80); });
        }
      });

      form.dataset.coreiqPriceAutoSubmitReady = 'true';
    });
  }

  function initPriceFilters(root) {
    initPriceRangeSliders(root || document);
    initPriceFilterAutoSubmit(root || document);
  }

  function queuePriceFilters() {
    ciqIdleInitWhenPresent('[data-coreiq-price-filter-form]', function () {
      initPriceFilters(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queuePriceFilters);
  } else {
    queuePriceFilters();
  }
  document.addEventListener('shopify:section:load', function (event) {
    var scope = event && event.target ? event.target : document;
    if (!scope.querySelector || !scope.querySelector('[data-coreiq-price-filter-form]')) return;
    initPriceFilters(scope);
  });

  /* â”€â”€ Main product details accordion (exclusive open) â”€â”€ */
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('[data-coreiq-exclusive-details] > details > summary');
    if (!summary) return;

    var details = summary.parentElement;
    if (!details) return;

    var group = details.parentElement;
    if (!group || !group.hasAttribute('data-coreiq-exclusive-details')) return;

    // Let native details toggle happen first, then close siblings.
    setTimeout(function () {
      if (!details.open) return;
      group.querySelectorAll('details').forEach(function (panel) {
        if (panel !== details) panel.open = false;
      });
    }, 0);
  });

  document.addEventListener('toggle', function (e) {
    var panel = e.target;
    if (!panel || !panel.classList || !panel.classList.contains('ciq-main-product__detail-panel')) return;

    var content = panel.querySelector('.ciq-main-product__detail-content');
    if (!content || !content.animate) return;

    var startHeight = panel.open ? 0 : content.scrollHeight;
    var endHeight = panel.open ? content.scrollHeight : 0;

    content.animate(
      [
        { maxHeight: startHeight + 'px', opacity: panel.open ? 0 : 1, transform: panel.open ? 'translateY(-3px)' : 'translateY(0)' },
        { maxHeight: endHeight + 'px', opacity: panel.open ? 1 : 0, transform: panel.open ? 'translateY(0)' : 'translateY(-3px)' }
      ],
      {
        duration: 190,
        easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)'
      }
    );
  }, true);

  /* -- Inline search panel toggle -- */
  var inlineSearchTrigger = null;

  function isMobileSearchViewport() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function isNonModalSearchMode(panel) {
    return Boolean(panel && panel.id === 'predictive-search-drawer');
  }

  // Search is rendered inside Shopify's header section. That section can
  // become a transformed or clipped sticky stacking context, making a fixed
  // search panel disappear even though it remains open in the DOM. Portal it
  // to body for both desktop and mobile so sticky-header and keyboard viewport
  // changes cannot clip the modal surface.
  function portalInlineSearchPanel(panel) {
    if (!panel || panel.parentNode === document.body) return;
    var marker = document.createComment('coreiq-inline-search-origin');
    panel.parentNode.insertBefore(marker, panel);
    panel.__coreiqInlineSearchOrigin = marker;
    panel.__coreiqInlineSearchOwner = panel.closest('.shopify-section');
    document.body.appendChild(panel);
  }

  function restoreInlineSearchPanel(panel) {
    if (!panel || !panel.__coreiqInlineSearchOrigin) return;
    var marker = panel.__coreiqInlineSearchOrigin;
    if (marker.parentNode && marker.isConnected) {
      marker.parentNode.insertBefore(panel, marker);
    } else {
      // A Shopify editor section replacement detached the original header.
      // Do not leave a duplicate predictive-search id in document.body.
      panel.remove();
    }
    marker.remove();
    panel.__coreiqInlineSearchOrigin = null;
    panel.__coreiqInlineSearchOwner = null;
  }

  function updateInlineSearchPanelPosition(trigger) {
    var panel = document.getElementById('predictive-search-drawer');
    if (!isNonModalSearchMode(panel)) return;

    trigger = trigger || inlineSearchTrigger || document.querySelector('[data-coreiq-inline-search-toggle]');
    var headerStackHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ciq-header-stack-height')) || 65;
    var maxPanelHeight = Math.max(260, Math.min(Math.round(window.innerHeight * 0.66), Math.round(window.innerHeight - headerStackHeight - 12)));
    panel.style.setProperty('--ciq-search-panel-max-height', maxPanelHeight + 'px');

    if (panel.getAttribute('data-search-mode') === 'inline_panel') {
      var headerBar = document.querySelector('.ciq-header');
      var announcementBar = document.querySelector('.ciq-announcement');
      // Shopify can report transient/offscreen descendant rects while moving
      // its sticky wrappers. offsetHeight is layout-stable and reflects the
      // current compact/full header size after syncHeaderStackHeight commits.
      var announcementHeight = announcementBar ? announcementBar.offsetHeight || 0 : 0;
      var visibleHeaderHeight = headerBar ? headerBar.offsetHeight || 0 : 0;
      var announcementSticky = announcementBar && announcementBar.getAttribute('data-sticky-enabled') === 'true';
      var headerSticky = headerBar && (headerBar.getAttribute('data-sticky-enabled') === 'true' || announcementSticky);
      var headerBottom = 0;
      var hasHeaderMeasurement = !!headerBar;
      var visibleAnnouncementHeight = 0;

      if (announcementSticky) {
        visibleAnnouncementHeight = announcementHeight;
      } else if (announcementBar) {
        var announcementRect = announcementBar.getBoundingClientRect();
        visibleAnnouncementHeight = Math.max(0, Math.min(announcementHeight, announcementRect.bottom));
      }

      if (headerSticky) {
        // Count the pinned announcement, or the still-visible portion of a
        // non-sticky announcement while the document is at the page top.
        headerBottom = visibleAnnouncementHeight + visibleHeaderHeight;
      } else if (headerBar) {
        // A non-sticky header is anchored only while it is actually on-screen.
        var headerRect = headerBar.getBoundingClientRect();
        headerBottom = Math.max(0, Math.min(window.innerHeight, headerRect.bottom));
      }
      if (!hasHeaderMeasurement && headerBottom <= 0) headerBottom = headerStackHeight;

      panel.style.setProperty('--ciq-search-panel-top', Math.max(0, Math.round(headerBottom)) + 'px');
    }

    if (trigger) {
      var triggerRect = trigger.getBoundingClientRect();
      var triggerCenter = triggerRect.left + (triggerRect.width / 2);
      panel.style.setProperty('--ciq-search-caret-left', Math.round(triggerCenter) + 'px');
    }
  }

  function syncSearchPanelPosition() {
    var panel = document.getElementById('predictive-search-drawer');
    if (!panel || !panel.hasAttribute('open') || isMobileSearchViewport()) return;
    updateInlineSearchPanelPosition();
  }

  /* Kept as a compatibility shim for existing result-refresh hooks. Search no
     longer has a push-down mode; each refresh only realigns the inline panel. */
  function syncSearchPushdownOffset() {
    syncSearchPanelPosition();
  }

  function refreshCartPageSection() {
    var cartPage = document.querySelector('.ciq-cart-page');
    if (!cartPage) return Promise.resolve();

    return fetch(window.location.pathname + '?section_id=main-cart', {
      headers: { Accept: 'text/html' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart page refresh failed');
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var freshCartPage = doc.querySelector('.ciq-cart-page');
        if (!freshCartPage) return;
        cartPage.replaceWith(freshCartPage);
        renderRecentlyViewedRails();
      });
  }

  function focusPredictiveSearchInput(input, shouldSuppressFocusRing) {
    if (!input) return;
    if (shouldSuppressFocusRing) {
      input.setAttribute('data-coreiq-programmatic-focus', 'true');
    }
    try {
      input.focus({ preventScroll: true });
    } catch (e) {
      input.focus();
    }
  }

  function shouldSuppressFocusRingFromClick(event) {
    return !!(event && typeof event.detail === 'number' && event.detail > 0);
  }

  function closeInlineSearchPanel() {
    var panel = document.getElementById('predictive-search-drawer');
    if (!panel || !panel.hasAttribute('open') || !isNonModalSearchMode(panel)) return;
    var hadPanelFocus = !!(document.activeElement && panel.contains(document.activeElement));
    closeDrawer(panel);
    document.documentElement.classList.remove('ciq-nonmodal-search-open');
    var toggleBtn = inlineSearchTrigger || document.querySelector('[data-coreiq-inline-search-toggle]');
    if (toggleBtn) {
      toggleBtn.setAttribute('aria-expanded', 'false');
      if (hadPanelFocus && toggleBtn.isConnected) {
        toggleBtn.focus();
      }
    }
  }

  function closePredictiveSearchForNavigation() {
    var panel = document.getElementById('predictive-search-drawer');
    if (!panel || !panel.hasAttribute('open')) return;
    if (isNonModalSearchMode(panel) && !isMobileSearchViewport()) {
      closeInlineSearchPanel();
      return;
    }
    closeDrawer(panel);
  }

  if (document.getElementById('predictive-search-drawer')) {
    document.addEventListener('shopify:section:unload', function (event) {
      var panel = document.getElementById('predictive-search-drawer');
      if (!panel || !panel.__coreiqInlineSearchOrigin) return;
      var owner = panel.__coreiqInlineSearchOwner;
      if (!owner || (event.target !== owner && !event.target.contains(owner))) return;
      panel.removeAttribute('open');
      setDrawerInteractiveState(panel, false);
      document.documentElement.classList.remove('ciq-nonmodal-search-open');
      restoreInlineSearchPanel(panel);
    });

    document.addEventListener('click', function (e) {
      var toggleBtn = e.target.closest('[data-coreiq-inline-search-toggle]');
      if (!toggleBtn) return;
      // Header and navigation enhancements also delegate click events. Handle
      // this dedicated trigger before bubble-phase handlers can consume it.
      e.preventDefault();
      e.stopPropagation();
      var panel = document.getElementById('predictive-search-drawer');
      if (!panel) return;
      inlineSearchTrigger = toggleBtn;

      if (isMobileSearchViewport()) {
        if (panel.hasAttribute('open')) {
          closeDrawer(panel);
          toggleBtn.setAttribute('aria-expanded', 'false');
        } else {
          portalInlineSearchPanel(panel);
          openDrawer(panel, {
            trigger: toggleBtn,
            suppressInitialFocusRing: shouldSuppressFocusRingFromClick(e)
          });
          toggleBtn.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      var isOpen = panel.hasAttribute('open');
      if (isOpen) {
        closeInlineSearchPanel();
      } else {
        portalInlineSearchPanel(panel);
        updateInlineSearchPanelPosition(toggleBtn);
        openDrawer(panel, {
          trigger: toggleBtn,
          suppressInitialFocusRing: shouldSuppressFocusRingFromClick(e),
          // Inline CSS owns the translateY entrance animation. The generic
          // drawer transform is for side drawers and would hide this panel.
          preservePanelTransform: true
        });
        document.documentElement.classList.add('ciq-nonmodal-search-open');
        var searchInput = panel.querySelector('[data-coreiq-predictive-input]');
        var suppressInitialFocusRing = shouldSuppressFocusRingFromClick(e);
        if (searchInput) setTimeout(function () { focusPredictiveSearchInput(searchInput, suppressInitialFocusRing); }, 60);
      }
    }, true);

    document.addEventListener('click', function (e) {
      var panel = document.getElementById('predictive-search-drawer');
      if (!panel || !panel.hasAttribute('open') || !isNonModalSearchMode(panel)) return;
      if (isMobileSearchViewport()) return;
      if (e.target.closest('[data-coreiq-inline-search-toggle]')) return;
      if (e.target.closest('[data-coreiq-inline-search-close]')) {
        closeInlineSearchPanel();
        return;
      }

      var panelContent = panel.querySelector('.ciq-mobile-drawer__panel');
      if (panelContent && !panelContent.contains(e.target)) {
        closeInlineSearchPanel();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var panel = document.getElementById('predictive-search-drawer');
      if (!panel || !panel.hasAttribute('open') || !isNonModalSearchMode(panel)) return;
      closeInlineSearchPanel();
    });

    window.addEventListener('resize', function () {
      var panel = document.getElementById('predictive-search-drawer');
      if (!panel || !panel.hasAttribute('open') || !isNonModalSearchMode(panel)) return;
      if (isMobileSearchViewport()) return;
      updateInlineSearchPanelPosition();
    }, { passive: true });

  }

  /* â”€â”€ Predictive search drawer â”€â”€ */
  function initPredictiveSearch() {
    var drawer = document.getElementById('predictive-search-drawer');
    if (!drawer) return;
    if (drawer.getAttribute('data-coreiq-predictive-ready') === 'true') return;
    drawer.setAttribute('data-coreiq-predictive-ready', 'true');

    var input = drawer.querySelector('[data-coreiq-predictive-input]');
    var resultsEl = drawer.querySelector('[data-coreiq-predictive-results]');
    var statusEl = drawer.querySelector('[data-coreiq-predictive-status]');
    var tabs = drawer.querySelectorAll('[data-coreiq-search-tab]');
    var recentWrap = drawer.querySelector('[data-coreiq-recent-searches-wrap]');
    var recentEl = drawer.querySelector('[data-coreiq-recent-searches]');
    var menuBridge = drawer.querySelector('[data-coreiq-search-menu-bridge]');
    var stickyViewAllWrap = drawer.querySelector('[data-coreiq-predictive-sticky-view-all]');
    var stickyViewAllLink = drawer.querySelector('[data-coreiq-predictive-sticky-view-all-link]');
    var activeTab = 'all';
    var lastResults = [];
    var lastQueries = [];
    var searchTimer;
    var recentKey = 'ciq-recent-searches';
    var lastMeaningfulKeywordQuery = '';
    var lastMatchedPredictiveRule = null;
    var predictiveRuleImpressions = {};
    var predictiveRequestNonce = 0;
    var showTitle = drawer.getAttribute('data-show-title') !== 'false';
    var showPrice = drawer.getAttribute('data-show-price') !== 'false';
    var showPriceRange = drawer.getAttribute('data-show-price-range') === 'true';
    var showSizeModifier = drawer.getAttribute('data-show-size-modifier') !== 'false';
    var predictiveRuleConfigEl = drawer.querySelector('[data-coreiq-predictive-rules]');
    var synonymConfigEl = drawer.querySelector('[data-coreiq-synonym-groups]');
    var synonymPreset = String(drawer.getAttribute('data-coreiq-synonym-preset') || '')
      .trim()
      .toLowerCase();
    var typoExpansionEnabled = drawer.getAttribute('data-coreiq-typo-expansion') !== 'false';
    var PURCHASE_INTENT_PATTERN = /\b(buy|purchase|shop|order|get|need|looking for|find|add to cart)\b/i;
    var vendorBoostEnabled = drawer.getAttribute('data-vendor-boost') !== 'false';
    var codeBoostEnabled = drawer.getAttribute('data-code-boost') !== 'false';
    var barcodeBoostEnabled = drawer.getAttribute('data-barcode-boost') !== 'false';
    var predictiveRules = [];

    if (predictiveRuleConfigEl) {
      try {
        predictiveRules = JSON.parse(predictiveRuleConfigEl.textContent || '[]');
      } catch (e) {
        predictiveRules = [];
      }
    }

    var LOW_SIGNAL_DISCOVERY_PATTERN = /^(?:yes|yeah|yep|yup|ok|okay|sure|thanks|thank you)$/i;
    var BETWEEN_PRICE_PATTERN = /between\s+\$?(\d+(?:\.\d+)?)\s+(?:and|to)\s+\$?(\d+(?:\.\d+)?)/i;
    var MAX_PRICE_PATTERN = /(?:under|below|less than|up to|max(?:imum)?(?:\s+price)?)\s+\$?(\d+(?:\.\d+)?)/i;
    var MIN_PRICE_PATTERN = /(?:over|above|more than|at least|min(?:imum)?(?:\s+price)?|starting at)\s+\$?(\d+(?:\.\d+)?)/i;
    var AROUND_PRICE_PATTERN = /(?:around|about|roughly|close to|near)\s+\$?(\d+(?:\.\d+)?)/i;
    var PLAIN_PRICE_PATTERN = /\$\s?(\d+(?:\.\d+)?)/i;
    var AVAILABILITY_PATTERN = /\b(in stock|available|ready to ship|ships today)\b/i;
    var CONTEXTUAL_REFINEMENT_PATTERN = /\b(what about|how about|one that'?s|one thats|something|anything|around|about|roughly|close to|near|but)\b/i;
    var DISCOVERY_FILLER_PATTERN = /\b(i need(?: to)?|i(?:'| a)?m looking for|im looking for|looking for|can you|could you|would you|show me|find me|suggest(?: me)?|recommend(?: me)?|gift|present|someone|person|friend|coworker|employee|staff|team|works?|working|product|products|item|items|option|options|please|maybe|wth|with|for|the|a|an|to|buy|purchase|need|want|that|who|is|at|and|budget|cheap|cheapest|affordable|most affordable|low cost|lowest price|lowest priced|best price)\b/gi;
    var DISCOVERY_TYPO_CORRECTIONS = [
      [/\bpruple\b/gi, 'purple'],
      [/\bpurpel\b/gi, 'purple'],
      [/\bprducts\b/gi, 'products'],
      [/\bprodutcs\b/gi, 'products'],
      [/\bporoducts\b/gi, 'products'],
      [/\bcheep\b/gi, 'cheap'],
      [/\bafforadble\b/gi, 'affordable'],
      [/\bundre\b/gi, 'under'],
      [/\bovre\b/gi, 'over'],
      [/\bbluue\b/gi, 'blue'],
      [/\bredd\b/gi, 'red'],
      [/\bgren\b/gi, 'green'],
      [/\bsnwoboard\b/gi, 'snowboard'],
      [/\bsnowbaord\b/gi, 'snowboard'],
      [/\bsweatshirtt\b/gi, 'sweatshirt'],
      [/\bhoodiee\b/gi, 'hoodie'],
      [/\bshrt\b/gi, 'shirt'],
      [/\bjckt\b/gi, 'jacket']
    ];

    var SIZE_LANGUAGE_EXPANSIONS = [
      [/\b(?:triple extra large|triple xl|3xl|3x large|3x-large)\b/gi, 'xxxl'],
      [/\b(?:double extra large|double xl|2xl|2x large|2x-large)\b/gi, 'xxl'],
      [/\b(?:extra extra large|xx large|xx-large)\b/gi, 'xxl'],
      [/\b(?:extra large|x large|x-large)\b/gi, 'xl'],
      [/\b(?:extra extra small|xx small|xx-small)\b/gi, 'xxs'],
      [/\b(?:extra small|x small|x-small)\b/gi, 'xs'],
      [/\bmedium\b/gi, 'm'],
      [/\bsmall\b/gi, 's'],
      [/\blarge\b/gi, 'l']
    ];

    function parseSynonymGroups(rawValue) {
      return String(rawValue || '')
        .split(/\r?\n/)
        .map(function (line) { return line.trim(); })
        .filter(Boolean)
        .map(function (line) {
          var separatorIndex = line.indexOf(':') !== -1 ? line.indexOf(':') : line.indexOf('=');
          if (separatorIndex === -1) return null;

          var canonical = normalizeDiscoveryText(line.slice(0, separatorIndex)).toLowerCase();
          var aliases = line
            .slice(separatorIndex + 1)
            .split(',')
            .map(function (value) { return normalizeDiscoveryText(value).toLowerCase(); })
            .filter(Boolean);

          if (!canonical || !aliases.length) return null;
          return { canonical: canonical, aliases: aliases };
        })
        .filter(Boolean);
    }

    var INDUSTRY_SYNONYMS = {
      'apparel': [
        'hoodie: sweatshirt, pullover',
        'shoes: sneakers, trainers, tennis shoes',
        't-shirt: tee, t shirt',
        'pants: trousers, slacks'
      ],
      'beauty': [
        'moisturizer: face cream, hydrating cream, lotion',
        'sunscreen: spf, sun block',
        'perfume: fragrance, cologne, scent'
      ],
      'furniture': [
        'sofa: couch, sectional, settee',
        'table: desk'
      ]
    };
    var synonymGroups = [];
    if (synonymConfigEl) {
      try {
        var rawText = JSON.parse(synonymConfigEl.textContent || '""');
        if (synonymPreset && INDUSTRY_SYNONYMS[synonymPreset]) {
          // If rawText is just a string, we concatenate
          rawText += '\n' + INDUSTRY_SYNONYMS[synonymPreset].join('\n');
        }
        synonymGroups = parseSynonymGroups(rawText);
      } catch (e) {
        synonymGroups = [];
      }
    }

    function escapeHtml(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function formatMoney(value) {
      if (value == null || value === '') return '';
      if (typeof value === 'string') {
        if (value.indexOf('$') !== -1) return value;
        var parsed = parseFloat(value);
        if (isNaN(parsed)) return value;
        return '$' + parsed.toFixed(2);
      }
      if (typeof value === 'number') {
        var normalized = value > 999 ? value / 100 : value;
        return '$' + normalized.toFixed(2);
      }
      return '';
    }

    function normalizeDiscoveryText(value) {
      var normalized = String(value || '');
      DISCOVERY_TYPO_CORRECTIONS.forEach(function (entry) {
        normalized = normalized.replace(entry[0], entry[1]);
      });
      SIZE_LANGUAGE_EXPANSIONS.forEach(function (entry) {
        normalized = normalized.replace(entry[0], entry[1]);
      });
      return normalized.replace(/\s+/g, ' ').trim();
    }

    function escapeRegExp(value) {
      return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function getActiveTabLabel() {
      if (activeTab === 'product') return 'products';
      if (activeTab === 'collection') return 'collections';
      if (activeTab === 'page') return 'pages';
      if (activeTab === 'article') return 'articles';
      return 'all results';
    }

    function setPredictiveStatus(message, busy) {
      if (resultsEl) {
        resultsEl.setAttribute('aria-busy', busy ? 'true' : 'false');
      }
      if (statusEl) {
        statusEl.textContent = message || '';
      }
    }

    function setActiveSearchTab(tab, shouldFocusPanel) {
      if (!tab) return;
      activeTab = tab.getAttribute('data-coreiq-search-tab') || 'all';
      tabs.forEach(function (btn) {
        var isActive = btn === tab;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.setAttribute('tabindex', isActive ? '0' : '-1');
      });
      if (resultsEl && tab.id) {
        resultsEl.setAttribute('aria-labelledby', tab.id);
      }
      renderResults();
      if (shouldFocusPanel && resultsEl) {
        resultsEl.focus();
      }
    }

    function applySynonymGroups(value) {
      var normalized = normalizeDiscoveryText(value || '');
      if (!synonymGroups.length || !normalized) return normalized;

      var nextValue = normalized;
      synonymGroups.forEach(function (group) {
        var matched = false;
        var canonicalPattern = new RegExp('\\b' + escapeRegExp(group.canonical) + '\\b', 'i');
        if (canonicalPattern.test(nextValue)) {
          matched = true;
        }

        group.aliases.forEach(function (alias) {
          var aliasPattern = new RegExp('\\b' + escapeRegExp(alias) + '\\b', 'ig');
          if (aliasPattern.test(nextValue)) {
            matched = true;
            nextValue = nextValue.replace(aliasPattern, group.canonical);
          }
        });

        if (matched && !canonicalPattern.test(nextValue)) {
          nextValue += ' ' + group.canonical;
        }
      });

      return normalizeDiscoveryText(nextValue);
    }

    function parsePricePreferences(query) {
      var normalized = normalizeDiscoveryText(query || '');
      var betweenMatch = normalized.match(BETWEEN_PRICE_PATTERN);
      if (betweenMatch) {
        return { minPrice: Number(betweenMatch[1]), maxPrice: Number(betweenMatch[2]) };
      }

      var aroundMatch = normalized.match(AROUND_PRICE_PATTERN);
      if (aroundMatch) {
        var targetPrice = Number(aroundMatch[1]);
        var tolerance = Math.max(15, Math.round(targetPrice * 0.15));
        return {
          minPrice: Math.max(0, targetPrice - tolerance),
          maxPrice: targetPrice + tolerance
        };
      }

      var maxMatch = normalized.match(MAX_PRICE_PATTERN);
      var minMatch = normalized.match(MIN_PRICE_PATTERN);
      if (maxMatch || minMatch) {
        return {
          minPrice: minMatch ? Number(minMatch[1]) : undefined,
          maxPrice: maxMatch ? Number(maxMatch[1]) : undefined
        };
      }

      var plainPriceMatch = normalized.match(PLAIN_PRICE_PATTERN);
      if (plainPriceMatch) {
        var plainTarget = Number(plainPriceMatch[1]);
        var plainTolerance = Math.max(15, Math.round(plainTarget * 0.15));
        return {
          minPrice: Math.max(0, plainTarget - plainTolerance),
          maxPrice: plainTarget + plainTolerance
        };
      }

      return { minPrice: undefined, maxPrice: undefined };
    }

    function extractKeywordQuery(query) {
      var normalized = normalizeDiscoveryText(query || '');
      var tokens = normalized
        .replace(BETWEEN_PRICE_PATTERN, ' ')
        .replace(MAX_PRICE_PATTERN, ' ')
        .replace(MIN_PRICE_PATTERN, ' ')
        .replace(AROUND_PRICE_PATTERN, ' ')
        .replace(PLAIN_PRICE_PATTERN, ' ')
        .replace(AVAILABILITY_PATTERN, ' ')
        .replace(/\b(how about|what about|yes|yeah|yep|yup|sure|okay|ok|correct|exactly|one|ones|around|about|roughly|close|near|but)\b/gi, ' ')
        .replace(/\$\d+(?:\.\d+)?/g, ' ')
        .replace(DISCOVERY_FILLER_PATTERN, ' ')
        .toLowerCase()
        .replace(/[^a-z0-9\s-]+/g, ' ')
        .split(/\s+/)
        .filter(function (term) {
          return term && (term.length >= 2 || /^[sml]$/.test(term)) && !/^\d+$/.test(term);
        });

      return Array.from(new Set(tokens)).join(' ').trim();
    }

    function parseSearchIntent(query) {
      var normalized = normalizeDiscoveryText(query || '');
      var synonymExpandedQuery = applySynonymGroups(normalized);
      var pricePrefs = parsePricePreferences(synonymExpandedQuery);
      var keywordQuery = extractKeywordQuery(synonymExpandedQuery);
      var availableOnly = AVAILABILITY_PATTERN.test(synonymExpandedQuery);
      return {
        normalizedQuery: synonymExpandedQuery,
        keywordQuery: keywordQuery,
        minPrice: pricePrefs.minPrice,
        maxPrice: pricePrefs.maxPrice,
        availableOnly: availableOnly,
        hasRefinementSignal: Boolean(
          keywordQuery ||
          availableOnly ||
          pricePrefs.minPrice !== undefined ||
          pricePrefs.maxPrice !== undefined ||
          CONTEXTUAL_REFINEMENT_PATTERN.test(normalized)
        )
      };
    }

    function isCodeLikeQuery(rawQuery) {
      var compact = normalizeDiscoveryText(rawQuery || '').replace(/\s+/g, '');
      if (!compact || compact.length < 3) return false;
      return /\d/.test(compact) || compact.indexOf('-') !== -1;
    }

    function toNumericPrice(value) {
      if (value == null || value === '') return NaN;
      if (typeof value === 'number') {
        return value > 999 ? value / 100 : value;
      }
      var parsed = parseFloat(String(value).replace(/[^\d.]/g, ''));
      if (isNaN(parsed)) return NaN;
      return parsed > 999 ? parsed / 100 : parsed;
    }

    function applySearchIntentFilters(items, intent) {
      if (!intent) return items;
      var hasPriceFilter = intent.minPrice !== undefined || intent.maxPrice !== undefined;
      if (!hasPriceFilter && !intent.availableOnly) return items;

      return items.filter(function (item) {
        if (item.type !== 'product') return false;
        var itemPrice = toNumericPrice(item.priceMin || item.price);
        if (intent.minPrice !== undefined && (isNaN(itemPrice) || itemPrice < intent.minPrice)) return false;
        if (intent.maxPrice !== undefined && (isNaN(itemPrice) || itemPrice > intent.maxPrice)) return false;
        if (intent.availableOnly && item.available === false) return false;
        return true;
      });
    }

    function getSearchTerms(intent, rawQuery) {
      var keywordQuery = intent && intent.keywordQuery ? intent.keywordQuery : normalizeDiscoveryText(rawQuery || '');
      return keywordQuery
        .toLowerCase()
        .split(/\s+/)
        .filter(function (term) { return term && (term.length >= 2 || /^[sml]$/.test(term)); });
    }

    function rankPredictiveResults(items, intent, rawQuery) {
      var rawQueryLower = (rawQuery || '').toLowerCase().trim();

      // Partition: exact raw-query title matches are pinned to the top unconditionally.
      // This ensures a product whose title exactly equals the search string always
      // appears first, regardless of intent processing or SKU/barcode boost scores.
      var exactTitleItems = [];
      var scorableItems = [];
      (items || []).forEach(function(item) {
        if (rawQueryLower && item.title && item.title.toLowerCase() === rawQueryLower) {
          exactTitleItems.push(item);
        } else {
          scorableItems.push(item);
        }
      });

      var searchTerms = getSearchTerms(intent, rawQuery);
      var compactQuery = searchTerms.join(' ').trim();
      var purchaseIntent = PURCHASE_INTENT_PATTERN.test(rawQuery || '');
      var codeLikeQuery = (codeBoostEnabled || barcodeBoostEnabled) && isCodeLikeQuery(rawQuery);
      var rawNormalizedQuery = normalizeDiscoveryText(rawQuery || '').toLowerCase();

      var sorted = (scorableItems).slice().sort(function (a, b) {
        function score(item) {
          var itemTitle = normalizeDiscoveryText(item.title || '').toLowerCase();
          var itemVendor = normalizeDiscoveryText(item.vendor || '').toLowerCase();
          var itemType = normalizeDiscoveryText(item.type || '').toLowerCase();
          var itemHandle = normalizeDiscoveryText(item.handle || '').toLowerCase();
          var variantTitles = (item.variantTitles || []).map(function (value) {
            return normalizeDiscoveryText(value).toLowerCase();
          });
          var variantCodes = (item.variantSkus || []).map(function (value) {
              return normalizeDiscoveryText(value).toLowerCase();
            });
            var variantBarcodes = (item.variantBarcodes || []).map(function (value) {
              return normalizeDiscoveryText(value).toLowerCase();
            });
          var tags = (item.tags || []).map(function (value) {
            return normalizeDiscoveryText(value).toLowerCase();
          });
          var scoreValue = 0;

          if (item.type === 'product') scoreValue += 4;
          if (purchaseIntent && item.type === 'product') scoreValue += 2;
          if (item.available !== false) scoreValue += 1;
          if (compactQuery && itemTitle === compactQuery) scoreValue += 20;
          if (compactQuery && itemTitle.indexOf(compactQuery) === 0) scoreValue += 5;
          if (compactQuery && itemTitle.indexOf(compactQuery) !== -1) scoreValue += 3;
          if (vendorBoostEnabled && compactQuery && itemVendor === compactQuery) scoreValue += 5;
          if (vendorBoostEnabled && compactQuery && itemVendor.indexOf(compactQuery) !== -1) scoreValue += 2.5;

          if (codeLikeQuery) {
            if (itemHandle === rawNormalizedQuery) scoreValue += 8;
            if (variantCodes.indexOf(rawNormalizedQuery) !== -1) scoreValue += 10;
              if (barcodeBoostEnabled && variantBarcodes.indexOf(rawNormalizedQuery) !== -1) scoreValue += 12;
            if (variantTitles.indexOf(rawNormalizedQuery) !== -1) scoreValue += 6;
            if (tags.indexOf(rawNormalizedQuery) !== -1) scoreValue += 6;
          }

          searchTerms.forEach(function (term) {
            if (itemTitle.indexOf(term) !== -1) scoreValue += 1.4;
            if (vendorBoostEnabled && itemVendor.indexOf(term) !== -1) scoreValue += 0.8;
            if (itemType.indexOf(term) !== -1) scoreValue += 0.3;
            if (codeBoostEnabled && variantCodes.some(function (code) { return code.indexOf(term) !== -1; })) scoreValue += 1.5;
              if (barcodeBoostEnabled && variantBarcodes.some(function (code) { return code.indexOf(term) !== -1; })) scoreValue += 2.0;
            if (codeBoostEnabled && variantTitles.some(function (title) { return title.indexOf(term) !== -1; })) scoreValue += 0.8;
            if (codeBoostEnabled && tags.some(function (tag) { return tag.indexOf(term) !== -1; })) scoreValue += 0.6;
          });

          return scoreValue;
        }

        return score(b) - score(a);
      });

      return exactTitleItems.concat(sorted);
    }

    function sanitizePredictiveSearchFields(fields) {
      var allowedFields = {
        author: true,
        body: true,
        product_type: true,
        tag: true,
        title: true,
        'variants.barcode': true,
        'variants.sku': true,
        'variants.title': true,
        vendor: true
      };
      var normalized = String(fields || '')
        .replace(/body_html/g, 'body')
        .split(',')
        .map(function (field) { return field.trim(); })
        .filter(function (field, index, list) {
          return field && allowedFields[field] && list.indexOf(field) === index;
        });
      if (normalized.indexOf('title') === -1) normalized.unshift('title');
      return normalized.join(',');
    }

    function buildPredictiveSearchUrl(queryValue, searchFields) {
      var routesRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      var params = new URLSearchParams();
      params.set('q', queryValue);
      params.set('resources[type]', 'product,collection,page,article,query');
      params.set('resources[limit]', '8');
      params.set('resources[options][fields]', searchFields);
      params.set('resources[options][unavailable_products]', 'last');
      return routesRoot.replace(/\/?$/, '/') + 'search/suggest.json?' + params.toString();
    }

    function requestPredictivePayload(queryValue, useSafeFallback) {
      var searchForm = drawer ? drawer.querySelector('[data-coreiq-search-fields]') : null;
      var rawSearchFields = (searchForm && searchForm.getAttribute('data-coreiq-search-fields')) || 'title,product_type,variants.title,variants.sku,variants.barcode,vendor,tag';
      var safeFallbackFields = 'title,product_type,vendor,tag,variants.title,variants.sku,variants.barcode';
      var searchFields = useSafeFallback ? safeFallbackFields : sanitizePredictiveSearchFields(rawSearchFields);
      var suggestUrl = buildPredictiveSearchUrl(queryValue, searchFields);
      return fetch(suggestUrl)
        .then(function (response) {
          if (!response.ok) {
            var error = new Error('Predictive search request failed');
            error.status = response.status;
            error.searchFields = searchFields;
            throw error;
          }
          return response.json();
        })
        .catch(function (error) {
          if (!useSafeFallback && searchFields !== safeFallbackFields) {
            return requestPredictivePayload(queryValue, true);
          }
          throw error;
        });
    }

    function getPredictiveQueryFallbacks(rawQuery, requestQuery) {
      if (!typoExpansionEnabled) return [];
      var normalized = normalizeDiscoveryText(rawQuery || requestQuery || '').toLowerCase();
      var terms = normalized.split(/\s+/).filter(Boolean);
      var suggestions = [];

      function addSuggestion(value) {
        var clean = normalizeDiscoveryText(value || '').trim();
        if (!clean) return;
        if (clean === requestQuery || clean === normalized) return;
        if (suggestions.indexOf(clean) === -1) suggestions.push(clean);
      }

      addSuggestion(applySynonymGroups(normalized));

      var sizeExpanded = normalizeDiscoveryText(normalized);
      addSuggestion(sizeExpanded);

      if (terms.length > 1) {
        addSuggestion(terms.join(''));
        for (var i = 0; i < terms.length - 1; i += 1) {
          var compoundTerms = terms.slice();
          compoundTerms.splice(i, 2, terms[i] + terms[i + 1]);
          addSuggestion(compoundTerms.join(' '));
        }
      }

      terms.forEach(function (term, index) {
        if (term.length < 3) return;
        if (term.slice(-1) === 's') {
          var singularTerms = terms.slice();
          singularTerms[index] = term.slice(0, -1);
          addSuggestion(singularTerms.join(' '));
        } else {
          var pluralTerms = terms.slice();
          pluralTerms[index] = term + 's';
          addSuggestion(pluralTerms.join(' '));
        }

        if (term.indexOf('-') !== -1) {
          var dehyphenatedTerms = terms.slice();
          dehyphenatedTerms[index] = term.replace(/-/g, '');
          addSuggestion(dehyphenatedTerms.join(' '));
          dehyphenatedTerms[index] = term.replace(/-/g, ' ');
          addSuggestion(dehyphenatedTerms.join(' '));
        }

        // Recover common live-search typos such as "shortsss". Predictive
        // search treats the extra trailing letters literally, while shoppers
        // generally mean the single trailing-character version ("shorts").
        var collapsedTerm = term.replace(/(.)\1{2,}$/i, '$1');
        if (collapsedTerm !== term && collapsedTerm.length >= 2) {
          var collapsedTerms = terms.slice();
          collapsedTerms[index] = collapsedTerm;
          addSuggestion(collapsedTerms.join(' '));
        }
      });

      return suggestions.slice(0, 4);
    }

    function requestPredictiveFallbackResults(fallbackQueries, intent, originalQuery) {
      var chain = Promise.resolve(null);

      fallbackQueries.forEach(function (fallbackQuery) {
        chain = chain.then(function (found) {
          if (found && found.results && found.results.length) return found;
          return requestPredictivePayload(fallbackQuery)
            .then(function (payload) {
              var fallbackResults = rankPredictiveResults(applySearchIntentFilters(normalizeResults(payload), intent), intent, originalQuery || fallbackQuery);
              if (!fallbackResults.length) return null;
              return {
                query: fallbackQuery,
                results: fallbackResults,
                queries: ((((payload || {}).resources || {}).results || {}).queries || []).map(function (q) { return q.text; })
              };
            })
            .catch(function () {
              return null;
            });
        });
      });

      return chain;
    }

    function getRecentSearches() {
      try {
        var parsed = JSON.parse(localStorage.getItem(recentKey) || '[]');
        return Array.isArray(parsed) ? parsed.slice(0, 6) : [];
      } catch (e) {
        return [];
      }
    }

    function saveRecentSearch(query) {
      if (!query) return;
      var prev = getRecentSearches().filter(function (item) {
        return item !== query;
      });
      prev.unshift(query);
      localStorage.setItem(recentKey, JSON.stringify(prev.slice(0, 6)));
    }

    function getQueryIcon(query) {
      var q = String(query || '').toLowerCase();
      if (/sale|deal|discount|offer/.test(q)) return '🏷️ ';
      if (/new|latest|just in/.test(q)) return '✨ ';
      if (/gift|present/.test(q)) return '🎁 ';
      if (/top|best|popular|trending/.test(q)) return '🔥 ';
      if (/shoe|trainer|boot|sneaker/.test(q)) return '👟 ';
      if (/bag|handbag|tote/.test(q)) return '👜 ';
      return '';
    }

    function renderRecentSearches() {
      var items = getRecentSearches();
      if (!items.length) {
        recentWrap.hidden = false;
        recentEl.innerHTML = '<p class="ciq-search-empty-recent">No recent searches yet.</p>';
        setPredictiveStatus('Type to search products, collections, pages, or articles.', false);
        window.requestAnimationFrame(syncSearchPushdownOffset);
        return;
      }

      recentWrap.hidden = false;
      recentEl.innerHTML = items
        .map(function (item) {
          return '<button type="button" class="ciq-search-drawer__chip" data-coreiq-recent-item="' + escapeHtml(item) + '">' + getQueryIcon(item) + escapeHtml(item) + '</button>';
        })
        .join('');
    }

    function getRuleKeywords(rawValue) {
      return String(rawValue || '')
        .toLowerCase()
        .replace(/[;|]/g, ',')
        .split(',')
        .map(function (value) {
          return normalizeDiscoveryText(value || '').trim();
        })
        .filter(Boolean);
    }

    function matchPredictiveRule(query) {
      var normalizedQuery = normalizeDiscoveryText(query || '');
      if (!normalizedQuery) return null;

      for (var index = 0; index < predictiveRules.length; index += 1) {
        var rule = predictiveRules[index];
        var keywords = getRuleKeywords(rule && rule.keywords);
        for (var keywordIndex = 0; keywordIndex < keywords.length; keywordIndex += 1) {
          if (normalizedQuery.indexOf(keywords[keywordIndex]) !== -1) {
            return rule;
          }
        }
      }

      return null;
    }

    function buildPredictiveRouteHtml(rule, query) {
      if (!rule || !rule.collectionUrl) return '';

      var title = rule.collectionTitle || rule.name || 'Collection';
      var helperText = rule.helperText || 'Jump straight into the best matching collection.';
      var ctaLabel = rule.ctaLabel || 'Shop collection';

      return (
        '<a class="ciq-search-drawer__route" href="' + escapeHtml(rule.collectionUrl) + '" data-coreiq-predictive-route data-coreiq-rule-id="' + escapeHtml(rule.id || '') + '" data-coreiq-rule-name="' + escapeHtml(rule.name || title) + '" data-coreiq-query="' + escapeHtml(query || '') + '">' +
        '<div class="ciq-search-drawer__route-copy">' +
        '<p class="ciq-search-drawer__route-eyebrow">Recommended collection</p>' +
        '<p class="ciq-search-drawer__route-title">' + escapeHtml(title) + '</p>' +
        '<p class="ciq-search-drawer__route-text">' + escapeHtml(helperText) + '</p>' +
        '</div>' +
        '<span class="ciq-btn ciq-btn--secondary ciq-search-drawer__route-cta">' + escapeHtml(ctaLabel) + '</span>' +
        '</a>'
      );
    }

    function trackPredictiveRuleImpression(rule, query) {
      if (!rule || !rule.id) return;

      var impressionKey = String(rule.id) + '::' + normalizeDiscoveryText(query || '');
      if (predictiveRuleImpressions[impressionKey]) return;
      predictiveRuleImpressions[impressionKey] = true;

      emitThemeAnalytics('coreiq_predictive_rule_impression', {
        predictiveRuleId: rule.id || '',
        predictiveRuleName: rule.name || '',
        predictiveQuery: (query || '').trim(),
        predictiveCollectionUrl: rule.collectionUrl || ''
      });
    }

    function renderResults() {
      var filtered = lastResults.filter(function (item) {
        return activeTab === 'all' || item.type === activeTab;
      });
      var searchPreset = drawer.getAttribute('data-search-preset') || 'conversion';
      var isConversionSearch = searchPreset === 'conversion';

      var routeHtml = '';
      if (lastMatchedPredictiveRule && (activeTab === 'all' || activeTab === 'collection')) {
        routeHtml = buildPredictiveRouteHtml(lastMatchedPredictiveRule, input ? input.value.trim() : '');
        if (routeHtml) {
          trackPredictiveRuleImpression(lastMatchedPredictiveRule, input ? input.value.trim() : '');
        }
      }

      var queryValue = input ? input.value.trim() : '';
      function formatResultPrice(item) {
        if (!showPrice) return '';
        var minPrice = formatMoney(item.priceMin || item.price);
        var maxPrice = formatMoney(item.priceMax || item.price);
        return showPriceRange && minPrice && maxPrice && minPrice !== maxPrice
          ? minPrice + ' - ' + maxPrice
          : (minPrice || '');
      }
      var routesRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      var isAvailabilityQuery = isAvailabilityOnlyQuery(queryValue);
      var searchUrl = isAvailabilityQuery
        ? buildAvailabilitySearchUrl()
        : routesRoot.replace(/\/?$/, '/') + 'search?q=' + encodeURIComponent(queryValue) + '&type=product%2Cpage%2Carticle&options%5Bprefix%5D=last';
      var useStickyEditorialViewAll = searchPreset === 'editorial' &&
        drawer.getAttribute('data-search-mode') === 'drawer';
      if (stickyViewAllWrap && stickyViewAllLink) {
        var showStickyViewAll = useStickyEditorialViewAll && Boolean(queryValue && filtered.length);
        stickyViewAllWrap.hidden = !showStickyViewAll;
        if (showStickyViewAll) {
          stickyViewAllLink.href = searchUrl;
          stickyViewAllLink.textContent = isAvailabilityQuery
            ? 'View in-stock products'
            : 'View all results for "' + queryValue + '"';
        }
      }
      var viewAllHtml = (queryValue && filtered.length && !useStickyEditorialViewAll)
        ? '<a class="ciq-search-drawer__view-all" href="' + escapeHtml(searchUrl) + '">' + (isAvailabilityQuery ? 'View in-stock products' : 'View all results for "' + escapeHtml(queryValue) + '"') + '</a>'
        : '';

      // Update the hint/status element
      var hintStatusEl = drawer.querySelector('[data-ciq-search-status]');

      if (!filtered.length) {
        var currentQuery = input ? input.value.trim() : '';
        if (currentQuery) {
          // Only show the empty state after a real completed fetch with a non-empty query
          if (hintStatusEl) {
            hintStatusEl.textContent = '';
            hintStatusEl.style.color = '';
          }
          var emptyStateHtml = '<div class="ciq-search-empty-state" role="status" aria-live="polite">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="ciq-search-empty-state__icon" aria-hidden="true" width="32" height="32">' +
              '<circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>' +
            '</svg>' +
            '<p class="ciq-search-empty-state__heading">No results found</p>' +
            '<p class="ciq-search-empty-state__body">Try checking your spelling or searching with fewer words.</p>' +
          '</div>';
          resultsEl.innerHTML = routeHtml + emptyStateHtml;
          setPredictiveStatus('No matching ' + getActiveTabLabel() + ' for "' + currentQuery + '".', false);
          trySpellCheckFallback(currentQuery, resultsEl);
        } else {
          // Input is empty or cleared — show nothing, do not flash empty state
          resultsEl.innerHTML = '';
          if (hintStatusEl) {
            hintStatusEl.textContent = '';
            hintStatusEl.style.color = '';
          }
          window.requestAnimationFrame(syncSearchPushdownOffset);
        }
        window.requestAnimationFrame(syncSearchPushdownOffset);
        return;
      }

      // Results exist — restore the hint text
      if (hintStatusEl) {
        hintStatusEl.textContent = '';
        hintStatusEl.style.color = '';
      }

      if (isConversionSearch) {
        var conversionProducts = filtered.filter(function (item) {
          return item.type === 'product';
        }).slice(0, 5);

        if (conversionProducts.length) {
          var conversionCards = conversionProducts.map(function (item) {
            var variants = (item.variants || []).filter(function (variant) {
              return variant && variant.title && variant.title.toLowerCase() !== 'default title';
            }).slice(0, 5);
            var sizeChoices = variants.length ? variants.map(function (variant, index) {
              return '<span class="ciq-search-conversion-card__size' + (index === 0 ? ' is-selected' : '') + '">' + escapeHtml(variant.title) + '</span>';
            }).join('') : '<span class="ciq-search-conversion-card__size ciq-search-conversion-card__size--options">View options</span>';
            var firstVariant = variants[0] || ((item.variants || [])[0]) || null;
            var predictiveInventoryTracked = firstVariant && firstVariant.inventory_management && firstVariant.inventory_quantity != null && Number.isFinite(Number(firstVariant.inventory_quantity));
            var predictiveInventoryAttrs = predictiveInventoryTracked
              ? ' data-inventory-tracked="true" data-inventory-limit="' + Math.max(0, Number(firstVariant.inventory_quantity)) + '"'
              : '';
            var quickAdd = firstVariant && firstVariant.id && item.available !== false
              ? '<button type="button" class="ciq-search-conversion-card__quick-add" data-coreiq-predictive-quick-add data-variant-id="' + escapeHtml(firstVariant.id) + '"' + predictiveInventoryAttrs + '>Quick add <span aria-hidden="true">＋</span></button>'
              : '<a class="ciq-search-conversion-card__quick-add" href="' + escapeHtml(item.url || '#') + '">View product <span aria-hidden="true">→</span></a>';
            var stock = item.available === false
              ? '<p class="ciq-search-conversion-card__stock is-sold-out">Sold out</p>'
              : '<p class="ciq-search-conversion-card__stock">In stock</p>';
            return '<article class="ciq-search-conversion-card" data-coreiq-predictive-result data-coreiq-predictive-type="product" data-coreiq-predictive-title="' + escapeHtml(item.title || '') + '" data-coreiq-predictive-url="' + escapeHtml(item.url || '') + '">' +
              '<a class="ciq-search-conversion-card__media" href="' + escapeHtml(item.url || '#') + '">' +
              (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy">' : '<span class="ciq-search-result__thumb ciq-search-result__thumb--placeholder"></span>') +
              '</a>' +
              '<a class="ciq-search-conversion-card__title" href="' + escapeHtml(item.url || '#') + '">' + escapeHtml(item.title || '') + '</a>' +
              (showPrice ? '<p class="ciq-search-conversion-card__price">' + escapeHtml(formatResultPrice(item)) + '</p>' : '') +
              '<div class="ciq-search-conversion-card__sizes" aria-label="Available options">' + sizeChoices + '</div>' +
              stock + quickAdd +
              '</article>';
          }).join('');

          resultsEl.innerHTML = routeHtml +
            '<section class="ciq-search-conversion-results" aria-label="Top picks">' +
            '<div class="ciq-search-conversion-results__bar"><p>Showing results for <strong>“' + escapeHtml(queryValue) + '”</strong></p><a href="' + escapeHtml(searchUrl) + '">View all results for “' + escapeHtml(queryValue) + '” <span aria-hidden="true">→</span></a></div>' +
            '<div class="ciq-search-conversion-results__heading"><h2>Top picks</h2><a href="' + escapeHtml(searchUrl) + '">See more top picks <span aria-hidden="true">→</span></a></div>' +
            '<div class="ciq-search-conversion-results__grid">' + conversionCards + '</div>' +
            '</section>';

          if (menuBridge) menuBridge.hidden = false;
          if (recentWrap) {
            renderRecentSearches();
            recentWrap.hidden = false;
          }
          setPredictiveStatus(conversionProducts.length + ' top picks shown for "' + queryValue + '".', false);
          window.requestAnimationFrame(syncSearchPushdownOffset);
          return;
        }

        if (menuBridge) menuBridge.hidden = true;
        if (recentWrap) recentWrap.hidden = true;
      }

      if (searchPreset === 'editorial') {
        var editorialProducts = filtered.filter(function (item) { return item.type === 'product'; }).slice(0, 5);
        if (editorialProducts.length) {
          var editorialLead = editorialProducts[0];
          var editorialCards = editorialProducts.slice(1).map(function (item) {
            var editorialCardTitle = showTitle ? '<strong>' + escapeHtml(item.title || '') + '</strong>' : '';
            var editorialCardPrice = showPrice ? '<em>' + escapeHtml(formatResultPrice(item)) + '</em>' : '';
            return '<a class="ciq-search-editorial-card" href="' + escapeHtml(item.url || '#') + '" aria-label="' + escapeHtml(item.title || 'View product') + '" data-coreiq-predictive-result data-coreiq-predictive-type="product" data-coreiq-predictive-title="' + escapeHtml(item.title || '') + '" data-coreiq-predictive-url="' + escapeHtml(item.url || '') + '">' +
              (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy">' : '<span class="ciq-search-editorial-card__placeholder"></span>') +
              '<span><small>' + escapeHtml(item.vendor || 'Performance edit') + '</small>' + editorialCardTitle + editorialCardPrice + '</span></a>';
          }).join('');
          resultsEl.innerHTML = routeHtml +
            '<section class="ciq-search-editorial-results" aria-label="Editorial picks">' +
              '<a class="ciq-search-editorial-lead" href="' + escapeHtml(editorialLead.url || '#') + '" aria-label="' + escapeHtml(editorialLead.title || 'View product') + '" data-coreiq-predictive-result data-coreiq-predictive-type="product" data-coreiq-predictive-title="' + escapeHtml(editorialLead.title || '') + '" data-coreiq-predictive-url="' + escapeHtml(editorialLead.url || '') + '">' +
                (editorialLead.image ? '<img src="' + escapeHtml(editorialLead.image) + '" alt="" loading="lazy">' : '<span class="ciq-search-editorial-lead__placeholder"></span>') +
                '<span><small>Editorial pick</small>' + (showTitle ? '<strong>' + escapeHtml(editorialLead.title || '') + '</strong>' : '') + (showPrice ? '<em>' + escapeHtml(formatResultPrice(editorialLead)) + '</em>' : '') + '<b>View product →</b></span>' +
              '</a>' +
              '<div class="ciq-search-editorial-side"><div class="ciq-search-editorial-side__heading"><h2>Suggested pieces</h2>' + viewAllHtml + '</div>' + editorialCards + '</div>' +
            '</section>';
          if (menuBridge) menuBridge.hidden = false;
          if (recentWrap) { renderRecentSearches(); recentWrap.hidden = false; }
          setPredictiveStatus(editorialProducts.length + ' editorial picks shown for "' + queryValue + '".', false);
          window.requestAnimationFrame(syncSearchPushdownOffset);
          return;
        }
      }

      if (searchPreset === 'impact') {
        // Predictive search can return a parent product alongside its material
        // or construction variants. Impact gives the first product the feature
        // position, so keep that family out of the match rail as well.
        var impactProductFamilies = {};
        var impactProducts = filtered.filter(function (item) {
          if (item.type !== 'product') return false;
          var familyKey = String(item.handle || item.title || '')
            .toLowerCase()
            .replace(/[-_]/g, ' ')
            .replace(/\b(?:link|chain|cuff|gold|silver|rose|plated|metal)\b/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
          familyKey = familyKey || String(item.url || item.title || '');
          if (impactProductFamilies[familyKey]) return false;
          impactProductFamilies[familyKey] = true;
          return true;
        }).slice(0, 4);
        if (impactProducts.length) {
          var impactLead = impactProducts[0];
          var impactMatches = impactProducts.slice(1).map(function (item) {
            var impactAvailability = item.available === false ? 'Sold out' : 'Available';
            var impactAvailabilityClass = item.available === false ? ' is-sold-out' : ' is-available';
            return '<a class="ciq-search-impact-match" href="' + escapeHtml(item.url || '#') + '" aria-label="' + escapeHtml(item.title || 'View product') + '" data-coreiq-predictive-result data-coreiq-predictive-type="product" data-coreiq-predictive-title="' + escapeHtml(item.title || '') + '" data-coreiq-predictive-url="' + escapeHtml(item.url || '') + '">' +
              (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy">' : '<span class="ciq-search-impact-match__placeholder" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" focusable="false"><path d="M7.5 8.5 9 5h6l1.5 3.5M6 9h12l-1 10H7L6 9Z"/><path d="M9 9c0 1.7 1.3 3 3 3s3-1.3 3-3"/></svg></span>') +
              '<span><small class="ciq-search-impact-match__availability' + impactAvailabilityClass + '">' + escapeHtml(impactAvailability) + '</small>' + (showTitle ? '<strong>' + escapeHtml(item.title || '') + '</strong>' : '') + (showPrice ? '<em>' + escapeHtml(formatResultPrice(item)) + '</em>' : '') + '</span><b aria-hidden="true">→</b></a>';
          }).join('');
          resultsEl.innerHTML = routeHtml +
            '<section class="ciq-search-impact-results" aria-label="Impact search matches">' +
              '<div class="ciq-search-impact-results__lead">' +
                (impactLead.image ? '<img src="' + escapeHtml(impactLead.image) + '" alt="" loading="lazy">' : '<span></span>') +
                '<div><small>Featured match</small>' + (showTitle ? '<h2>' + escapeHtml(impactLead.title || '') + '</h2>' : '') + '<p>' + escapeHtml(impactLead.vendor || 'Built to move. Made to perform.') + '</p><a href="' + escapeHtml(impactLead.url || '#') + '" aria-label="' + escapeHtml(impactLead.title || 'View product') + '" data-coreiq-predictive-result data-coreiq-predictive-type="product" data-coreiq-predictive-title="' + escapeHtml(impactLead.title || '') + '" data-coreiq-predictive-url="' + escapeHtml(impactLead.url || '') + '">View product</a></div>' +
              '</div>' +
              '<div class="ciq-search-impact-results__matches"><div class="ciq-search-impact-results__matches-heading"><h2>Top matches</h2><span>' + impactProducts.length + ' curated results</span></div>' + impactMatches + '</div>' +
              '<a class="ciq-search-impact-results__all" href="' + escapeHtml(searchUrl) + '"><span>View all results for</span> <strong>“' + escapeHtml(queryValue) + '”</strong> <b aria-hidden="true">→</b></a>' +
            '</section>';
          if (menuBridge) menuBridge.hidden = false;
          if (recentWrap) { renderRecentSearches(); recentWrap.hidden = false; }
          setPredictiveStatus(impactProducts.length + ' impact matches shown for "' + queryValue + '".', false);
          window.requestAnimationFrame(syncSearchPushdownOffset);
          return;
        }
      }

      resultsEl.innerHTML = routeHtml + filtered
        .map(function (item) {
          var imageHtml = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy" class="ciq-search-result__thumb">' : '<div class="ciq-search-result__thumb ciq-search-result__thumb--placeholder"></div>';
          var titleHtml = showTitle ? '<p class="ciq-search-drawer__result-title">' + escapeHtml(item.title) + '</p>' : '';
          var resultMetaLabel = item.type === 'product' ? (item.vendor || '') : (item.typeLabel || '');
          var vendorHtml = resultMetaLabel ? '<p class="ciq-search-drawer__result-vendor">' + escapeHtml(resultMetaLabel) + '</p>' : '';
          var sizeHtml = showSizeModifier && item.sizeModifier ? '<p class="ciq-search-drawer__result-size">' + escapeHtml(item.sizeModifier) + '</p>' : '';
          var priceHtml = '';
          if (item.type === 'product' && showPrice) {
            var minPrice = formatMoney(item.priceMin || item.price);
            var maxPrice = formatMoney(item.priceMax || item.price);
            if (showPriceRange && minPrice && maxPrice && minPrice !== maxPrice) {
              priceHtml = '<p class="ciq-search-drawer__result-price">' + minPrice + ' - ' + maxPrice + '</p>';
            } else if (minPrice) {
              priceHtml = '<p class="ciq-search-drawer__result-price">' + minPrice + '</p>';
            }
          }
          return (
            '<a class="ciq-search-drawer__result ciq-search-drawer__result--' + escapeHtml(item.type || 'result') + (item.available === false ? ' is-sold-out' : '') + '" href="' + escapeHtml(item.url || '#') + '" data-coreiq-predictive-result data-coreiq-predictive-type="' + escapeHtml(item.type || '') + '" data-coreiq-predictive-title="' + escapeHtml(item.title || '') + '" data-coreiq-predictive-url="' + escapeHtml(item.url || '') + '">' +
            imageHtml +
            '<div class="ciq-search-drawer__result-main">' +
            vendorHtml +
            titleHtml +
            sizeHtml +
            priceHtml +
            '</div>' +
            '</a>'
          );
        })
        .join('') + viewAllHtml;
      setPredictiveStatus(filtered.length + ' ' + (filtered.length === 1 ? 'result' : 'results') + ' shown in ' + getActiveTabLabel() + ' for "' + (input ? input.value.trim() : '') + '".', false);
      window.requestAnimationFrame(syncSearchPushdownOffset);
    }

    function normalizeResults(data) {
      var all = [];
      var products = (((data || {}).resources || {}).results || {}).products || [];
      var collections = (((data || {}).resources || {}).results || {}).collections || [];
      var pages = (((data || {}).resources || {}).results || {}).pages || [];
      var articles = (((data || {}).resources || {}).results || {}).articles || [];

      products.forEach(function (item) {
        var variantModifier = '';
        if (item.variants && item.variants.length) {
          var firstVariant = item.variants[0] || {};
          if (firstVariant && firstVariant.title && firstVariant.title.toLowerCase() !== 'default title') {
            variantModifier = firstVariant.title;
          }
        }
        all.push({
          type: 'product',
          title: item.title,
          url: item.url,
          handle: item.handle || (item.url ? item.url.split('/').pop().split('?')[0] : ''),
          image: item.featured_image ? item.featured_image.url : '',
          vendor: item.vendor || '',
          tags: item.tags || [],
          variantTitles: (item.variants || []).map(function (variant) { return variant && variant.title ? variant.title : ''; }).filter(Boolean),
          variantSkus: (item.variants || []).map(function (variant) { return variant && variant.sku ? variant.sku : ''; }).filter(Boolean),
          variantBarcodes: (item.variants || []).map(function (variant) { return variant && variant.barcode ? variant.barcode : ''; }).filter(Boolean),
          variants: (item.variants || []).map(function (variant) {
            return { id: variant && variant.id ? variant.id : '', title: variant && variant.title ? variant.title : '' };
          }),
          price: item.price,
          priceMin: item.price_min,
          priceMax: item.price_max,
          available: item.available,
          sizeModifier: variantModifier
        });
      });
      collections.forEach(function (item) {
        all.push({
          type: 'collection',
          typeLabel: 'Collection',
          title: item.title,
          url: item.url,
          image: item.featured_image ? item.featured_image.url : ''
        });
      });
      pages.forEach(function (item) {
        all.push({
          type: 'page',
          typeLabel: 'Page',
          title: item.title,
          url: item.url,
          image: item.image ? item.image.url : ''
        });
      });
      articles.forEach(function (item) {
        all.push({
          type: 'article',
          typeLabel: 'Article',
          title: item.title,
          url: item.url,
          image: item.image ? item.image.url : ''
        });
      });

      return all;
    }

    function trySpellCheckFallback(originalQuery, resultsContainer) {
      var routesRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      fetch(routesRoot.replace(/\/?$/, '/') + 'search/suggest.json?q=' + encodeURIComponent(originalQuery) + '&resources[type]=query&resources[limit]=3')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var queries = (((data.resources || {}).results || {}).queries || [])
            .map(function (q) { return q.text; })
            .filter(function (t) { return t.toLowerCase() !== originalQuery.toLowerCase(); });
          if (!queries.length) {
            // No-results message is now shown in the hint/status element — skip inline fallback.
            return;
          }
          var notice = '<div class="ciq-search-spellcheck" role="status">' +
            'Did you mean: ' + queries.map(function (q) {
              return '<button type="button" class="ciq-search-spellcheck__btn" data-ciq-spell-query="' + escapeHtml(q) + '">' + escapeHtml(q) + '</button>';
            }).join(', ') + '</div>';
          resultsContainer.insertAdjacentHTML('afterbegin', notice);
          resultsContainer.querySelectorAll('[data-ciq-spell-query]').forEach(function (btn) {
            btn.addEventListener('click', function () {
              if (input) {
                input.value = btn.getAttribute('data-ciq-spell-query');
                input.dispatchEvent(new Event('input', { bubbles: true }));
              }
            });
          });
        })
        .catch(function () {});
    }

    function renderRecentlyViewed() {
      var section = drawer.querySelector('[data-ciq-recent-viewed-section]');
      var list = drawer.querySelector('[data-ciq-recent-viewed-list]');
      if (!section || !list) return;
      var items = [];
      try { items = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY) || '[]'); } catch (e) {}
      if (!items.length) { section.hidden = true; return; }
      section.hidden = false;
      list.innerHTML = items.slice(0, 4).map(function (item) {
        var title = String(item && item.title || '').trim();
        if (!title) return '';
        var price = item.price != null ? String(item.price).trim() : '';
        var collectionContext = item.franchise || item.collectionTitle || item.collection || '';
        if (collectionContext && typeof collectionContext === 'object') collectionContext = collectionContext.title || '';
        collectionContext = String(collectionContext).trim();
        var hasAvailability = item.available === true || item.available === false || item.available === 'true' || item.available === 'false';
        var isAvailable = item.available === true || item.available === 'true';
        var statusText = hasAvailability ? (isAvailable ? 'In stock' : 'Sold out') : '';
        var ariaLabel = [title, collectionContext, price, statusText].filter(Boolean).join(', ');
        return '<a href="' + escapeHtml(item.url || '#') + '" class="ciq-search-rv-item" aria-label="' + escapeHtml(ariaLabel) + '">' +
          (item.image ? '<span class="ciq-search-rv-item__media"><img src="' + escapeHtml(item.image) + '" alt="" width="64" height="76" loading="lazy"></span>' : '<span class="ciq-search-rv-item__media ciq-search-rv-item__media--empty" aria-hidden="true"></span>') +
          '<span class="ciq-search-rv-item__copy"><strong class="ciq-search-rv-item__title">' + escapeHtml(title) + '</strong>' +
          (collectionContext ? '<span class="ciq-search-rv-item__context">' + escapeHtml(collectionContext) + '</span>' : '') +
          (price ? '<span class="ciq-search-rv-item__price">' + escapeHtml(price) + '</span>' : '') +
          (statusText ? '<span class="ciq-search-rv-item__availability' + (isAvailable ? ' is-available' : ' is-sold-out') + '"><span aria-hidden="true"></span>' + escapeHtml(statusText) + '</span>' : '') +
          '</span></a>';
      }).join('');
    }

    function renderAvailabilitySearchShortcut(query) {
      var availabilityUrl = buildAvailabilitySearchUrl();
      lastResults = [];
      lastQueries = [];
      lastMatchedPredictiveRule = null;
      var isConversionSearch = (drawer.getAttribute('data-search-preset') || 'conversion') === 'conversion';
      if (menuBridge) menuBridge.hidden = !isConversionSearch;
      if (recentWrap) recentWrap.hidden = !isConversionSearch;
      var recentlyViewedSection = drawer.querySelector('[data-ciq-recent-viewed-section]');
      if (recentlyViewedSection) recentlyViewedSection.hidden = true;
      resultsEl.innerHTML =
        '<a class="ciq-search-drawer__route ciq-search-drawer__route--availability" href="' + escapeHtml(availabilityUrl) + '" data-coreiq-predictive-route data-coreiq-rule-id="" data-coreiq-rule-name="Availability" data-coreiq-query="' + escapeHtml(query || '') + '">' +
          '<div class="ciq-search-drawer__route-copy">' +
            '<p class="ciq-search-drawer__route-eyebrow">Availability</p>' +
            '<p class="ciq-search-drawer__route-title">View in-stock products</p>' +
            '<p class="ciq-search-drawer__route-text">Browse products that Shopify currently marks available for purchase.</p>' +
          '</div>' +
          '<span class="ciq-btn ciq-btn--secondary ciq-search-drawer__route-cta">View in-stock products</span>' +
        '</a>';
      setPredictiveStatus('Open in-stock product results.', false);
      window.requestAnimationFrame(syncSearchPushdownOffset);
    }

    function fetchPredictiveResults(query) {
      var requestNonce = ++predictiveRequestNonce;
      var intent = parseSearchIntent(query);
      var matchedPredictiveRule = matchPredictiveRule(query);
      lastMatchedPredictiveRule = matchedPredictiveRule;

      if (!query) {
        resultsEl.innerHTML = '';
        lastResults = [];
        if (menuBridge) menuBridge.hidden = false;
        renderRecentSearches();
        renderRecentlyViewed();
        // Restore hint text when input is cleared
        var hintStatusElClear = drawer.querySelector('[data-ciq-search-status]');
        if (hintStatusElClear) {
          hintStatusElClear.textContent = '';
          hintStatusElClear.style.color = '';
        }
        window.requestAnimationFrame(syncSearchPushdownOffset);
        return;
      }

      if (isAvailabilityOnlyQuery(query)) {
        renderAvailabilitySearchShortcut(query);
        saveRecentSearch(query);
        emitThemeAnalytics('coreiq_predictive_query_evaluated', {
          predictiveQuery: (query || '').trim(),
          predictiveRequestQuery: '*',
          predictiveFallbackQuery: '',
          predictiveRuleId: '',
          predictiveRuleName: 'Availability',
          predictiveMatchedRule: 'false',
          predictiveResultCount: 0,
          predictiveTopResultType: 'availability'
        });
        return;
      }

      if (LOW_SIGNAL_DISCOVERY_PATTERN.test(intent.normalizedQuery) && !intent.hasRefinementSignal) {
        resultsEl.innerHTML = '';
        lastResults = [];
        if (menuBridge) menuBridge.hidden = false;
        renderRecentSearches();
        renderRecentlyViewed();
        window.requestAnimationFrame(syncSearchPushdownOffset);
        return;
      }

      if (menuBridge) menuBridge.hidden = true;
      recentWrap.hidden = true;
      var recentlyViewedSection = drawer.querySelector('[data-ciq-recent-viewed-section]');
      if (recentlyViewedSection) recentlyViewedSection.hidden = true;
      resultsEl.innerHTML = '<p class="ciq-search-drawer__meta">Searching...</p>';
      setPredictiveStatus('Searching...', true);
      window.requestAnimationFrame(syncSearchPushdownOffset);

      var requestQuery = intent.keywordQuery || '';
      if (matchedPredictiveRule && matchedPredictiveRule.querySeed) {
        requestQuery = matchedPredictiveRule.querySeed;
      }
      if (!requestQuery && intent.hasRefinementSignal && lastMeaningfulKeywordQuery) {
        requestQuery = lastMeaningfulKeywordQuery;
      }
      if (!requestQuery) {
        requestQuery = intent.normalizedQuery || query;
      }
      if (!requestQuery) requestQuery = 'products';

      if (intent.keywordQuery) {
        lastMeaningfulKeywordQuery = intent.keywordQuery;
      }

      requestPredictivePayload(requestQuery)
        .then(function (payload) {
          if (requestNonce !== predictiveRequestNonce) return;
          lastResults = rankPredictiveResults(applySearchIntentFilters(normalizeResults(payload), intent), intent, query);
          var queryResults = (((payload || {}).resources || {}).results || {}).queries || [];
          lastQueries = queryResults.map(function (q) {
            return q.text;
          });

          if (!lastResults.length && lastQueries.length && lastQueries[0] && lastQueries[0] !== requestQuery) {
            return requestPredictivePayload(lastQueries[0]).then(function (suggestedPayload) {
              if (requestNonce !== predictiveRequestNonce) return;
              lastResults = rankPredictiveResults(applySearchIntentFilters(normalizeResults(suggestedPayload), intent), intent, lastQueries[0]);
              if (!lastResults.length) {
                var suggestedFallbackQueries = getPredictiveQueryFallbacks(query, requestQuery);
                return requestPredictiveFallbackResults(suggestedFallbackQueries, intent, query).then(function (fallback) {
                  if (requestNonce !== predictiveRequestNonce) return;
                  if (fallback && fallback.results && fallback.results.length) {
                    lastResults = fallback.results;
                    lastQueries = fallback.queries || lastQueries;
                  }
                  renderResults();
                  saveRecentSearch(query);
                  emitThemeAnalytics('coreiq_predictive_query_evaluated', {
                    predictiveQuery: (query || '').trim(),
                    predictiveRequestQuery: requestQuery,
                    predictiveFallbackQuery: fallback && fallback.query ? fallback.query : '',
                    predictiveRuleId: matchedPredictiveRule && matchedPredictiveRule.id ? matchedPredictiveRule.id : '',
                    predictiveRuleName: matchedPredictiveRule && matchedPredictiveRule.name ? matchedPredictiveRule.name : '',
                    predictiveMatchedRule: matchedPredictiveRule ? 'true' : 'false',
                    predictiveResultCount: lastResults.length,
                    predictiveTopResultType: lastResults[0] && lastResults[0].type ? lastResults[0].type : ''
                  });
                });
              }
              renderResults();
              saveRecentSearch(query);
              emitThemeAnalytics('coreiq_predictive_query_evaluated', {
                predictiveQuery: (query || '').trim(),
                predictiveRequestQuery: requestQuery,
                predictiveRuleId: matchedPredictiveRule && matchedPredictiveRule.id ? matchedPredictiveRule.id : '',
                predictiveRuleName: matchedPredictiveRule && matchedPredictiveRule.name ? matchedPredictiveRule.name : '',
                predictiveMatchedRule: matchedPredictiveRule ? 'true' : 'false',
                predictiveResultCount: lastResults.length,
                predictiveTopResultType: lastResults[0] && lastResults[0].type ? lastResults[0].type : ''
              });
            });
          }

          if (!lastResults.length) {
            var fallbackQueries = getPredictiveQueryFallbacks(query, requestQuery);
            if (fallbackQueries.length) {
              return requestPredictiveFallbackResults(fallbackQueries, intent, query).then(function (fallback) {
                if (requestNonce !== predictiveRequestNonce) return;
                if (fallback && fallback.results && fallback.results.length) {
                  lastResults = fallback.results;
                  lastQueries = fallback.queries || lastQueries;
                }
                renderResults();
                saveRecentSearch(query);
                emitThemeAnalytics('coreiq_predictive_query_evaluated', {
                  predictiveQuery: (query || '').trim(),
                  predictiveRequestQuery: requestQuery,
                  predictiveFallbackQuery: fallback && fallback.query ? fallback.query : '',
                  predictiveRuleId: matchedPredictiveRule && matchedPredictiveRule.id ? matchedPredictiveRule.id : '',
                  predictiveRuleName: matchedPredictiveRule && matchedPredictiveRule.name ? matchedPredictiveRule.name : '',
                  predictiveMatchedRule: matchedPredictiveRule ? 'true' : 'false',
                  predictiveResultCount: lastResults.length,
                  predictiveTopResultType: lastResults[0] && lastResults[0].type ? lastResults[0].type : ''
                });
              });
            }
          }

          renderResults();
          saveRecentSearch(query);
          emitThemeAnalytics('coreiq_predictive_query_evaluated', {
            predictiveQuery: (query || '').trim(),
            predictiveRequestQuery: requestQuery,
            predictiveRuleId: matchedPredictiveRule && matchedPredictiveRule.id ? matchedPredictiveRule.id : '',
            predictiveRuleName: matchedPredictiveRule && matchedPredictiveRule.name ? matchedPredictiveRule.name : '',
            predictiveMatchedRule: matchedPredictiveRule ? 'true' : 'false',
            predictiveResultCount: lastResults.length,
            predictiveTopResultType: lastResults[0] && lastResults[0].type ? lastResults[0].type : ''
          });
        })
        .catch(function (error) {
          if (requestNonce !== predictiveRequestNonce) return;
          var recoveryQueries = getPredictiveQueryFallbacks(query, requestQuery);
          requestPredictiveFallbackResults(recoveryQueries, intent, query).then(function (fallback) {
            if (requestNonce !== predictiveRequestNonce) return;
            if (fallback && fallback.results && fallback.results.length) {
              lastResults = fallback.results;
              lastQueries = fallback.queries || [];
              renderResults();
              saveRecentSearch(query);
              emitThemeAnalytics('coreiq_predictive_query_evaluated', {
                predictiveQuery: (query || '').trim(),
                predictiveRequestQuery: requestQuery,
                predictiveFallbackQuery: fallback.query || '',
                predictiveRuleId: matchedPredictiveRule && matchedPredictiveRule.id ? matchedPredictiveRule.id : '',
                predictiveRuleName: matchedPredictiveRule && matchedPredictiveRule.name ? matchedPredictiveRule.name : '',
                predictiveMatchedRule: matchedPredictiveRule ? 'true' : 'false',
                predictiveResultCount: lastResults.length,
                predictiveTopResultType: lastResults[0] && lastResults[0].type ? lastResults[0].type : ''
              });
              return;
            }
            renderPredictiveRequestFailure(error);
          }).catch(function () {
            if (requestNonce !== predictiveRequestNonce) return;
            renderPredictiveRequestFailure(error);
          });

          function renderPredictiveRequestFailure(requestError) {
            var fallbackSearchUrl = isAvailabilityOnlyQuery(query || requestQuery || '')
              ? buildAvailabilitySearchUrl()
              : (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/').replace(/\/?$/, '/') + 'search?q=' + encodeURIComponent(query || requestQuery || '') + '&type=product%2Cpage%2Carticle&options%5Bprefix%5D=last';
            var fallbackSearchLabel = isAvailabilityOnlyQuery(query || requestQuery || '') ? 'View in-stock products' : 'Search for "' + escapeHtml(query || requestQuery || '') + '"';
            if (window.console && typeof window.console.warn === 'function') {
              window.console.warn('[CoreIQ] Predictive search fallback rendered.', {
                status: requestError && requestError.status,
                fields: requestError && requestError.searchFields
              });
            }
            resultsEl.innerHTML = '<div class="ciq-search-error" role="alert">' +
              '<p>Live suggestions are taking a moment.</p>' +
              '<div class="ciq-search-error__actions">' +
                '<a class="ciq-btn ciq-btn--secondary ciq-search-error__link" href="' + escapeHtml(fallbackSearchUrl) + '">' + fallbackSearchLabel + '</a>' +
                '<button type="button" class="ciq-search-retry-btn" data-ciq-search-retry>Retry suggestions</button>' +
              '</div>' +
              '</div>';
            var retryBtn = resultsEl.querySelector('[data-ciq-search-retry]');
            if (retryBtn) {
              retryBtn.addEventListener('click', function () {
                if (input) input.dispatchEvent(new Event('input', { bubbles: true }));
              });
            }
            setPredictiveStatus('Live suggestions could not load. Use the search link or retry suggestions.', false);
            window.requestAnimationFrame(syncSearchPushdownOffset);
          }
        });
    }

    if (input) {
      input.addEventListener('input', function () {
        var query = input.value.trim();
        clearTimeout(searchTimer);
        // Immediately clear stale terminal states while the debounce is pending.
        // Otherwise a previous request failure remains visible over a new query.
        if (resultsEl) {
          var staleState = resultsEl.querySelector('.ciq-search-empty-state, .ciq-search-error');
          if (staleState) {
            resultsEl.innerHTML = '';
            setPredictiveStatus('', false);
          }
        }
        searchTimer = setTimeout(function () {
          fetchPredictiveResults(query);
        }, 180);
      });
    }

    if (resultsEl) {
      resultsEl.addEventListener('click', function (event) {
        var quickAdd = event.target.closest('[data-coreiq-predictive-quick-add]');
        if (!quickAdd) return;
        event.preventDefault();
        event.stopPropagation();
        if (quickAdd.getAttribute('aria-busy') === 'true') return;

        var variantId = quickAdd.getAttribute('data-variant-id');
        if (!variantId) return;
        quickAdd.setAttribute('aria-busy', 'true');
        quickAdd.textContent = 'Adding…';

        window.CiqInventoryGuard.add({ id: variantId, quantity: 1 }, quickAdd)
          .then(function (response) {
            if (!response.ok) throw new Error('Quick add failed');
            return fetch(ciqRoute('cart.js'), { headers: { Accept: 'application/json' } });
          })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            if (typeof updateCartCountBadge === 'function') updateCartCountBadge(cart.item_count || 0);
            quickAdd.textContent = 'Added ✓';
            quickAdd.classList.add('is-added');
          })
          .catch(function () {
            quickAdd.textContent = 'Try again';
          })
          .finally(function () {
            quickAdd.removeAttribute('aria-busy');
          });
      });
    }

    if (menuBridge) {
      menuBridge.hidden = false;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActiveSearchTab(tab, false);
      });

      tab.addEventListener('keydown', function (event) {
        var tabList = Array.prototype.slice.call(tabs);
        var currentIndex = tabList.indexOf(tab);
        var targetIndex = -1;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          targetIndex = (currentIndex + 1) % tabList.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          targetIndex = (currentIndex - 1 + tabList.length) % tabList.length;
        } else if (event.key === 'Home') {
          targetIndex = 0;
        } else if (event.key === 'End') {
          targetIndex = tabList.length - 1;
        }

        if (targetIndex === -1) return;
        event.preventDefault();
        tabList[targetIndex].focus();
        setActiveSearchTab(tabList[targetIndex], false);
      });
    });

    document.addEventListener('ciq:drawer-opened', function (event) {
      if (!event.detail || event.detail.drawerId !== 'predictive-search-drawer') return;
      if (input) {
        focusPredictiveSearchInput(input, event.detail.suppressInitialFocusRing === true);
        input.select();
      }
      setPredictiveStatus('Type to search products, collections, pages, or articles.', false);
      renderRecentlyViewed();
    });

    input.addEventListener('blur', function () {
      input.removeAttribute('data-coreiq-programmatic-focus');
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Tab') {
        input.removeAttribute('data-coreiq-programmatic-focus');
      }
    });


    drawer.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (event.target.closest('[data-coreiq-predictive-quick-add]')) return;
      var productResult = event.target.closest('[data-coreiq-predictive-result][data-coreiq-predictive-type="product"]');
      var productLink = event.target.closest('a[href]');
      if (!productResult || !productLink || !productResult.contains(productLink)) return;
      if ((productLink.target && productLink.target !== '_self') || productLink.hasAttribute('download')) return;

      var productDestination;
      try {
        productDestination = new URL(productLink.href, window.location.href);
      } catch (navigationError) {
        return;
      }
      if (productDestination.origin !== window.location.origin || productDestination.pathname.indexOf('/products/') !== 0) return;

      event.preventDefault();
      if (drawer.getAttribute('data-coreiq-navigation-pending') === 'true') return;
      drawer.setAttribute('data-coreiq-navigation-pending', 'true');
      drawer.setAttribute('aria-busy', 'true');
      drawer.classList.add('is-navigating');
      document.documentElement.classList.add('ciq-pdp-navigation-pending');
      
      closePredictiveSearchForNavigation();
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.setTimeout(function () {
        window.location.assign(productDestination.href);
      }, reducedMotion ? 0 : 300);
    }, true);

    drawer.addEventListener('click', function (e) {
      var searchChip = e.target.closest('[data-coreiq-search-chip-query]');
      if (searchChip && input) {
        e.preventDefault();
        var chipTerm = searchChip.getAttribute('data-coreiq-search-chip-query') || searchChip.textContent || '';
        chipTerm = chipTerm.trim();
        if (!chipTerm) return;
        activeTab = 'all';
        tabs.forEach(function (btn) {
          var isAll = btn.getAttribute('data-coreiq-search-tab') === 'all';
          btn.classList.toggle('is-active', isAll);
          btn.setAttribute('aria-selected', isAll ? 'true' : 'false');
          btn.setAttribute('tabindex', isAll ? '0' : '-1');
        });
        input.value = chipTerm;
        input.focus();
        fetchPredictiveResults(chipTerm);
        return;
      }

      var predictiveRoute = e.target.closest('[data-coreiq-predictive-route]');
      if (predictiveRoute) {
        var routeRuleId = predictiveRoute.getAttribute('data-coreiq-rule-id') || '';
        var routeRuleName = predictiveRoute.getAttribute('data-coreiq-rule-name') || '';
        var routeQuery = predictiveRoute.getAttribute('data-coreiq-query') || (input ? input.value.trim() : '');

        setAssistedAttributionContext({
          assistSurface: 'predictive-search',
          assistTargetType: 'route',
          assistRuleId: routeRuleId,
          assistRuleName: routeRuleName,
          assistQuery: routeQuery,
          assistUrl: predictiveRoute.getAttribute('href') || ''
        });

        emitThemeAnalytics('coreiq_predictive_rule_click', {
          predictiveRuleId: routeRuleId,
          predictiveRuleName: routeRuleName,
          predictiveQuery: routeQuery,
          predictiveCollectionUrl: predictiveRoute.getAttribute('href') || ''
        });
        return;
      }

      var predictiveResult = e.target.closest('[data-coreiq-predictive-result]');
      if (predictiveResult) {
        setAssistedAttributionContext({
          assistSurface: 'predictive-search',
          assistTargetType: predictiveResult.getAttribute('data-coreiq-predictive-type') || '',
          assistRuleId: lastMatchedPredictiveRule && lastMatchedPredictiveRule.id ? lastMatchedPredictiveRule.id : '',
          assistRuleName: lastMatchedPredictiveRule && lastMatchedPredictiveRule.name ? lastMatchedPredictiveRule.name : '',
          assistQuery: input ? input.value.trim() : '',
          assistUrl: predictiveResult.getAttribute('data-coreiq-predictive-url') || ''
        });

        emitThemeAnalytics('coreiq_predictive_result_click', {
          predictiveType: predictiveResult.getAttribute('data-coreiq-predictive-type') || '',
          predictiveTitle: predictiveResult.getAttribute('data-coreiq-predictive-title') || '',
          predictiveUrl: predictiveResult.getAttribute('data-coreiq-predictive-url') || '',
          predictiveQuery: input ? input.value.trim() : '',
          predictiveRuleId: lastMatchedPredictiveRule && lastMatchedPredictiveRule.id ? lastMatchedPredictiveRule.id : '',
          predictiveRuleName: lastMatchedPredictiveRule && lastMatchedPredictiveRule.name ? lastMatchedPredictiveRule.name : ''
        });

        return;
      }

      var recentBtn = e.target.closest('[data-coreiq-recent-item]');
      if (recentBtn && input) {
        var term = recentBtn.getAttribute('data-coreiq-recent-item') || '';
        input.value = term;
        fetchPredictiveResults(term);
        return;
      }

    });

    var predictiveForm = drawer.querySelector('.ciq-search-drawer__form');
    if (predictiveForm) {
      predictiveForm.addEventListener('submit', function () {
        var query = input ? input.value.trim() : '';
        var assistUrl = isAvailabilityOnlyQuery(query)
          ? buildAvailabilitySearchUrl()
          : '/search?q=' + encodeURIComponent(query) + '&type=product%2Cpage%2Carticle&options%5Bprefix%5D=last';
        setAssistedAttributionContext({
          assistSurface: 'predictive-search',
          assistTargetType: 'search-submit',
          assistRuleId: lastMatchedPredictiveRule && lastMatchedPredictiveRule.id ? lastMatchedPredictiveRule.id : '',
          assistRuleName: lastMatchedPredictiveRule && lastMatchedPredictiveRule.name ? lastMatchedPredictiveRule.name : '',
          assistQuery: query,
          assistUrl: assistUrl
        });

        emitThemeAnalytics('coreiq_predictive_search_submit', {
          predictiveQuery: query,
          predictiveRuleId: lastMatchedPredictiveRule && lastMatchedPredictiveRule.id ? lastMatchedPredictiveRule.id : '',
          predictiveRuleName: lastMatchedPredictiveRule && lastMatchedPredictiveRule.name ? lastMatchedPredictiveRule.name : ''
        });
      });
    }

    renderRecentSearches();
    if (tabs.length) {
      setActiveSearchTab(tabs[0], false);
    }
  }

  initPredictiveSearch();
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || event.target.querySelector('#predictive-search-drawer')) {
      initPredictiveSearch();
    }
  });

  ciqIdleInitWhenPresent('[data-coreiq-search-assist]', function () {
  (function initSearchPagePredictiveAssist() {
    var panels = document.querySelectorAll('[data-coreiq-search-assist]');
    if (!panels.length || !window.fetch || typeof URLSearchParams === 'undefined') return;

    var DEFAULT_SEARCH_FIELDS = 'title,product_type,variants.title,variants.sku,variants.barcode,vendor,tag';

    function normalizeAssistText(value) {
      return String(value || '').replace(/\s+/g, ' ').trim();
    }

    function sanitizeAssistSearchFields(fields) {
      var allowedFields = {
        author: true,
        body: true,
        product_type: true,
        tag: true,
        title: true,
        'variants.barcode': true,
        'variants.sku': true,
        'variants.title': true,
        vendor: true
      };
      var normalized = String(fields || DEFAULT_SEARCH_FIELDS)
        .replace(/body_html/g, 'body')
        .split(',')
        .map(function (field) { return field.trim(); })
        .filter(function (field, index, list) {
          return field && allowedFields[field] && list.indexOf(field) === index;
        });
      if (normalized.indexOf('title') === -1) normalized.unshift('title');
      return normalized.join(',');
    }

    function getPredictiveSearchFields(panel) {
      var drawer = document.getElementById('predictive-search-drawer');
      var drawerForm = drawer ? drawer.querySelector('[data-coreiq-search-fields]') : null;
      return sanitizeAssistSearchFields(
        panel.getAttribute('data-coreiq-search-fields') ||
        (drawerForm && drawerForm.getAttribute('data-coreiq-search-fields')) ||
        DEFAULT_SEARCH_FIELDS
      );
    }

    function parsePredictiveRules() {
      var config = document.querySelector('[data-coreiq-predictive-rules]');
      if (!config) return [];
      try {
        var parsed = JSON.parse(config.textContent || '[]');
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }

    function getAssistRuleKeywords(rawValue) {
      return String(rawValue || '')
        .toLowerCase()
        .replace(/[;|]/g, ',')
        .split(',')
        .map(function (value) { return normalizeAssistText(value); })
        .filter(Boolean);
    }

    function findAssistRule(query) {
      var normalizedQuery = normalizeAssistText(query).toLowerCase();
      if (!normalizedQuery) return null;
      var rules = parsePredictiveRules();
      for (var index = 0; index < rules.length; index += 1) {
        var rule = rules[index];
        var keywords = getAssistRuleKeywords(rule && rule.keywords);
        for (var keywordIndex = 0; keywordIndex < keywords.length; keywordIndex += 1) {
          if (normalizedQuery.indexOf(keywords[keywordIndex]) !== -1) {
            return rule;
          }
        }
      }
      return null;
    }

    function addAssistQuery(queries, value) {
      var clean = normalizeAssistText(value);
      if (!clean) return;
      var lower = clean.toLowerCase();
      var exists = queries.some(function (item) { return item.toLowerCase() === lower; });
      if (!exists) queries.push(clean);
    }

    function getAssistQueries(query, panel) {
      var queries = [];
      var matchedRule = findAssistRule(query);
      if (matchedRule && matchedRule.querySeed) {
        addAssistQuery(queries, matchedRule.querySeed);
      }

      addAssistQuery(queries, query);

      if (panel.getAttribute('data-coreiq-typo-expansion') !== 'false') {
        var normalized = normalizeAssistText(query).toLowerCase();
        var terms = normalized.split(/\s+/).filter(Boolean);
        if (terms.length > 1) {
          addAssistQuery(queries, terms.join(''));
        }
        terms.forEach(function (term, index) {
          if (term.length < 3) return;
          var singularPluralTerms = terms.slice();
          singularPluralTerms[index] = term.slice(-1) === 's' ? term.slice(0, -1) : term + 's';
          addAssistQuery(queries, singularPluralTerms.join(' '));
          if (term.indexOf('-') !== -1) {
            var compactTerms = terms.slice();
            compactTerms[index] = term.replace(/-/g, '');
            addAssistQuery(queries, compactTerms.join(' '));
          }
        });
      }

      return queries.slice(0, 5);
    }

    function buildAssistSuggestUrl(queryValue, searchFields) {
      var routesRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      var params = new URLSearchParams();
      params.set('q', queryValue);
      params.set('resources[type]', 'product');
      params.set('resources[limit]', '8');
      params.set('resources[options][fields]', searchFields);
      params.set('resources[options][unavailable_products]', 'last');
      return routesRoot.replace(/\/?$/, '/') + 'search/suggest.json?' + params.toString();
    }

    function normalizeAssistProducts(data) {
      var products = (((data || {}).resources || {}).results || {}).products || [];
      return products.map(function (item) {
        var firstVariant = item.variants && item.variants.length ? item.variants[0] : null;
        var variantTitle = firstVariant && firstVariant.title && String(firstVariant.title).toLowerCase() !== 'default title'
          ? firstVariant.title
          : '';
        return {
          title: item.title || '',
          url: item.url || '#',
          image: item.featured_image ? item.featured_image.url : '',
          vendor: item.vendor || '',
          price: item.price_min || item.price || '',
          available: item.available,
          sizeModifier: variantTitle
        };
      }).filter(function (item) {
        return item.title && item.url;
      });
    }

    function requestAssistProducts(queries, searchFields) {
      var chain = Promise.resolve([]);
      queries.forEach(function (query) {
        chain = chain.then(function (found) {
          if (found.length) return found;
          return fetch(buildAssistSuggestUrl(query, searchFields))
            .then(function (response) {
              if (!response.ok) throw new Error('Search assist request failed');
              return response.json();
            })
            .then(normalizeAssistProducts)
            .catch(function () {
              return [];
            });
        });
      });
      return chain;
    }

    function normalizeAssistUrl(url) {
      var clean = String(url || '').split('#')[0];
      try {
        return new URL(clean, window.location.origin).pathname.replace(/\/$/, '');
      } catch (error) {
        return clean.split('?')[0].replace(/\/$/, '');
      }
    }

    function getNativeResultUrls() {
      var urls = [];
      document.querySelectorAll('[data-coreiq-search-result]').forEach(function (result) {
        var url = result.getAttribute('data-coreiq-search-url') || '';
        var link = result.querySelector('a[href]');
        if (!url && link) url = link.getAttribute('href') || '';
        if (url) urls.push(normalizeAssistUrl(url));
      });
      return urls;
    }

    function formatAssistMoney(value) {
      if (value == null || value === '') return '';
      if (typeof value === 'string') {
        if (value.indexOf('$') !== -1) return value;
        var parsed = parseFloat(value);
        if (isNaN(parsed)) return value;
        return '$' + parsed.toFixed(2);
      }
      if (typeof value === 'number') {
        var normalized = value > 999 ? value / 100 : value;
        return '$' + normalized.toFixed(2);
      }
      return '';
    }

    function buildAssistCard(item, index, query, totalCount) {
      var formattedPrice = formatAssistMoney(item.price);
      var imageHtml = item.image
        ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy">'
        : '<span class="ciq-search-assist-card__placeholder" aria-hidden="true"></span>';
      var vendorHtml = item.vendor ? '<p class="ciq-search-assist-card__vendor">' + escapeHtml(item.vendor) + '</p>' : '';
      var sizeHtml = item.sizeModifier ? '<p class="ciq-search-assist-card__variant">' + escapeHtml(item.sizeModifier) + '</p>' : '';
      var priceHtml = formattedPrice ? '<p class="ciq-search-assist-card__price">' + escapeHtml(formattedPrice) + '</p>' : '';
      return (
        '<a class="ciq-search-assist-card" href="' + escapeHtml(item.url) + '" data-coreiq-search-assist-result data-coreiq-search-query="' + escapeHtml(query) + '" data-coreiq-search-assist-rank="' + (index + 1) + '" data-coreiq-search-assist-count="' + totalCount + '" data-coreiq-search-assist-title="' + escapeHtml(item.title) + '" data-coreiq-search-assist-url="' + escapeHtml(item.url) + '">' +
          '<span class="ciq-search-assist-card__media">' + imageHtml + '</span>' +
          '<span class="ciq-search-assist-card__copy">' +
            vendorHtml +
            '<span class="ciq-search-assist-card__title">' + escapeHtml(item.title) + '</span>' +
            sizeHtml +
            priceHtml +
          '</span>' +
        '</a>'
      );
    }

    panels.forEach(function (panel) {
      if (panel.getAttribute('data-coreiq-search-assist-ready') === 'true') return;
      panel.setAttribute('data-coreiq-search-assist-ready', 'true');

      var query = normalizeAssistText(panel.getAttribute('data-coreiq-search-assist-query') || '');
      var nativeCount = parseInt(panel.getAttribute('data-coreiq-native-results-count') || '0', 10) || 0;
      var resultsEl = panel.querySelector('[data-coreiq-search-assist-results]');
      if (!query || !resultsEl) return;

      var searchFields = getPredictiveSearchFields(panel);
      var queries = getAssistQueries(query, panel);

      requestAssistProducts(queries, searchFields).then(function (products) {
        if (nativeCount > 0) {
          var nativeUrls = getNativeResultUrls();
          products = products.filter(function (product) {
            return nativeUrls.indexOf(normalizeAssistUrl(product.url)) === -1;
          });
        }
        if (!products.length) return;
        var limitedProducts = products.slice(0, 8);
        resultsEl.innerHTML = limitedProducts.map(function (item, index) {
          return buildAssistCard(item, index, query, limitedProducts.length);
        }).join('');
        panel.hidden = false;
        panel.setAttribute('data-coreiq-search-assist-count', String(limitedProducts.length));
        emitThemeAnalytics('coreiq_search_assist_rendered', {
          searchQuery: query,
          searchAssistResultCount: limitedProducts.length,
          searchAssistQueryCount: queries.length
        });
      });
    });

    document.addEventListener('click', function (event) {
      var result = event.target.closest('[data-coreiq-search-assist-result]');
      if (!result) return;
      var query = result.getAttribute('data-coreiq-search-query') || '';
      var url = result.getAttribute('data-coreiq-search-assist-url') || result.getAttribute('href') || '';
      var title = result.getAttribute('data-coreiq-search-assist-title') || '';

      setAssistedAttributionContext({
        assistSurface: 'search-results-predictive-assist',
        assistTargetType: 'product',
        assistRuleId: '',
        assistRuleName: title,
        assistQuery: query,
        assistUrl: url
      });

      emitThemeAnalytics('coreiq_search_assist_click', {
        searchQuery: query,
        searchAssistRank: parseInt(result.getAttribute('data-coreiq-search-assist-rank') || '0', 10) || 0,
        searchAssistResultCount: parseInt(result.getAttribute('data-coreiq-search-assist-count') || '0', 10) || 0,
        searchAssistTitle: title,
        searchAssistUrl: url
      });
    });
  })();
  });

  ciqIdleInitWhenPresent('[data-coreiq-search-results]', function () {
  (function initSearchNativeRelevanceGuard() {
    var containers = document.querySelectorAll('[data-coreiq-search-results]');
    if (!containers.length) return;

    var STOP_WORDS = {
      a: true,
      an: true,
      and: true,
      for: true,
      in: true,
      of: true,
      on: true,
      or: true,
      s: true,
      the: true,
      to: true,
      with: true
    };

    function normalizeSearchValue(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function normalizeToken(token) {
      var clean = normalizeSearchValue(token);
      if (clean === 'womens') return 'women';
      if (clean === 'mens') return 'men';
      return clean;
    }

    function getSearchTokens(value) {
      return normalizeSearchValue(value)
        .split(' ')
        .map(normalizeToken)
        .filter(function (token, index, list) {
          return token && !STOP_WORDS[token] && list.indexOf(token) === index;
        });
    }

    function buildTokenMap(tokens) {
      var map = {};
      tokens.forEach(function (token) {
        map[token] = true;
        if (token.length > 3 && token.slice(-1) === 's') {
          map[token.slice(0, -1)] = true;
        }
      });
      return map;
    }

    function scoreProductTitle(queryTokens, queryText, title) {
      var normalizedTitle = normalizeSearchValue(title);
      var normalizedQuery = normalizeSearchValue(queryText);
      if (!normalizedTitle || !normalizedQuery || !queryTokens.length) return 0;
      if (normalizedTitle === normalizedQuery || normalizedTitle.indexOf(normalizedQuery) !== -1) return 1;

      var titleTokenMap = buildTokenMap(getSearchTokens(normalizedTitle));
      var matched = queryTokens.reduce(function (count, token) {
        var directMatch = titleTokenMap[token];
        var singularMatch = token.length > 3 && token.slice(-1) === 's' && titleTokenMap[token.slice(0, -1)];
        return count + (directMatch || singularMatch ? 1 : 0);
      }, 0);

      return matched / queryTokens.length;
    }

    function getSearchResultTypeCounts(container) {
      var counts = {
        total: 0,
        product: 0,
        page: 0,
        article: 0,
        collection: 0
      };
      Array.prototype.slice.call(container.querySelectorAll('[data-coreiq-search-result]')).forEach(function (result) {
        if (result.hidden) return;
        var type = result.getAttribute('data-coreiq-search-type') || 'result';
        counts.total += 1;
        if (Object.prototype.hasOwnProperty.call(counts, type)) {
          counts[type] += 1;
        }
      });
      return counts;
    }

    function formatSearchTypeCount(count, singular, plural) {
      if (!count) return '';
      return count + ' ' + (count === 1 ? singular : plural);
    }

    function updateSearchResultsLabel(container, query, preferBestMatch) {
      var surface = container.closest('.ciq-search-page') || document;
      var label = surface.querySelector('[data-coreiq-search-toolbar] .ciq-collection-toolbar__results');
      if (!label) return;
      var counts = getSearchResultTypeCounts(container);
      var noun = preferBestMatch
        ? counts.total === 1 ? 'best match' : 'best matches'
        : counts.total === 1 ? 'result' : 'results';
      var parts = [
        counts.total + ' ' + noun + (query ? ' for "' + query + '"' : '')
      ];
      [
        formatSearchTypeCount(counts.product, 'product', 'products'),
        formatSearchTypeCount(counts.page, 'page', 'pages'),
        formatSearchTypeCount(counts.article, 'article', 'articles'),
        formatSearchTypeCount(counts.collection, 'collection', 'collections')
      ].forEach(function (part) {
        if (part) parts.push(part);
      });
      container.setAttribute('data-coreiq-search-results-count', String(counts.total));
      container.setAttribute('data-coreiq-search-product-count', String(counts.product));
      container.setAttribute('data-coreiq-search-page-count', String(counts.page));
      container.setAttribute('data-coreiq-search-article-count', String(counts.article));
      container.setAttribute('data-coreiq-search-collection-count', String(counts.collection));
      label.textContent = parts.join(' | ');
    }

    containers.forEach(function (container) {
      if (container.getAttribute('data-coreiq-search-relevance-ready') === 'true') return;
      container.setAttribute('data-coreiq-search-relevance-ready', 'true');

      var activeFilterCount = parseInt(container.getAttribute('data-coreiq-search-active-filter-count') || '0', 10) || 0;
      if (activeFilterCount > 0) return;

      var query = container.getAttribute('data-coreiq-search-query') || '';
      var queryTokens = getSearchTokens(query);
      var normalizedQuery = normalizeSearchValue(query);
      if (queryTokens.length < 4 || normalizedQuery.length < 18) return;

      var productResults = Array.prototype.slice.call(container.querySelectorAll('[data-coreiq-search-result][data-coreiq-search-type="product"]'));
      if (productResults.length < 3) return;

      var scoredResults = productResults.map(function (result) {
        return {
          result: result,
          score: scoreProductTitle(queryTokens, query, result.getAttribute('data-coreiq-search-title') || '')
        };
      });

      var strongResults = scoredResults.filter(function (item) {
        return item.score >= 0.72;
      });

      if (!strongResults.length || strongResults.length === scoredResults.length) return;

      scoredResults.forEach(function (item) {
        if (item.score >= 0.72) {
          item.result.removeAttribute('hidden');
          item.result.setAttribute('data-coreiq-search-relevance', 'strong');
        } else {
          item.result.hidden = true;
          item.result.setAttribute('data-coreiq-search-relevance', 'weak');
        }
      });

      container.setAttribute('data-coreiq-search-relevance-filtered-count', String(scoredResults.length - strongResults.length));
      updateSearchResultsLabel(container, query, true);

      emitThemeAnalytics('coreiq_search_native_relevance_refined', {
        searchQuery: query,
        searchNativeProductCount: scoredResults.length,
        searchStrongProductCount: strongResults.length,
        searchHiddenProductCount: scoredResults.length - strongResults.length
      });
    });
  })();
  });

  ciqIdleInitWhenPresent('[data-coreiq-search-results][data-coreiq-search-content-fallback]', function () {
  (function initSearchContentFallback() {
    var containers = document.querySelectorAll('[data-coreiq-search-results][data-coreiq-search-content-fallback]');
    if (!containers.length || !window.fetch || !window.URLSearchParams) return;

    function normalizeUrl(url) {
      var value = (url || '').toString();
      if (!value) return '';
      try {
        return new URL(value, window.location.origin).pathname.replace(/\/$/, '');
      } catch (err) {
        return value.replace(/\/$/, '');
      }
    }

    function getImageUrl(item) {
      if (!item) return '';
      if (typeof item.image === 'string') return item.image;
      if (item.image && typeof item.image.url === 'string') return item.image.url;
      if (typeof item.featured_image === 'string') return item.featured_image;
      if (item.featured_image && typeof item.featured_image.url === 'string') return item.featured_image.url;
      return '';
    }

    function stripHtml(value) {
      var div = document.createElement('div');
      div.innerHTML = value || '';
      return (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim();
    }

    function truncate(value, length) {
      var text = stripHtml(value || '');
      if (!text || text.length <= length) return text;
      return text.slice(0, length - 1).replace(/\s+\S*$/, '') + '…';
    }

    function getExistingUrls() {
      var urls = {};
      document.querySelectorAll('[data-coreiq-search-result][data-coreiq-search-url]').forEach(function (card) {
        var url = normalizeUrl(card.getAttribute('data-coreiq-search-url') || '');
        if (url) urls[url] = true;
      });
      return urls;
    }

    function buildSuggestUrl(query) {
      var routesRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      var params = new URLSearchParams();
      params.set('q', query);
      params.set('resources[type]', 'collection,page,article');
      params.set('resources[limit]', '10');
      params.set('resources[options][fields]', 'title,body,author');
      return routesRoot.replace(/\/?$/, '/') + 'search/suggest.json?' + params.toString();
    }

    function getSearchResultTypeCounts(container) {
      var counts = {
        total: 0,
        product: 0,
        page: 0,
        article: 0,
        collection: 0
      };
      Array.prototype.slice.call(container.querySelectorAll('[data-coreiq-search-result]')).forEach(function (result) {
        if (result.hidden) return;
        var type = result.getAttribute('data-coreiq-search-type') || 'result';
        counts.total += 1;
        if (Object.prototype.hasOwnProperty.call(counts, type)) {
          counts[type] += 1;
        }
      });
      return counts;
    }

    function formatSearchTypeCount(count, singular, plural) {
      if (!count) return '';
      return count + ' ' + (count === 1 ? singular : plural);
    }

    function updateSearchResultsLabel(container, query) {
      var surface = container.closest('.ciq-search-page') || document;
      var label = surface.querySelector('[data-coreiq-search-toolbar] .ciq-collection-toolbar__results');
      if (!label) return;
      var counts = getSearchResultTypeCounts(container);
      var strictMode = container.getAttribute('data-coreiq-search-strict-product-query-mode') === 'true';
      var noun = strictMode
        ? counts.total === 1 ? 'best match' : 'best matches'
        : counts.total === 1 ? 'result' : 'results';
      var parts = [
        counts.total + ' ' + noun + (query ? ' for "' + query + '"' : '')
      ];
      [
        formatSearchTypeCount(counts.product, 'product', 'products'),
        formatSearchTypeCount(counts.page, 'page', 'pages'),
        formatSearchTypeCount(counts.article, 'article', 'articles'),
        formatSearchTypeCount(counts.collection, 'collection', 'collections')
      ].forEach(function (part) {
        if (part) parts.push(part);
      });
      container.setAttribute('data-coreiq-search-results-count', String(counts.total));
      container.setAttribute('data-coreiq-search-product-count', String(counts.product));
      container.setAttribute('data-coreiq-search-page-count', String(counts.page));
      container.setAttribute('data-coreiq-search-article-count', String(counts.article));
      container.setAttribute('data-coreiq-search-collection-count', String(counts.collection));
      label.textContent = parts.join(' | ');
    }

    function normalizeItems(results) {
      var normalized = [];
      var collections = results && Array.isArray(results.collections) ? results.collections : [];
      var pages = results && Array.isArray(results.pages) ? results.pages : [];
      var articles = results && Array.isArray(results.articles) ? results.articles : [];

      pages.forEach(function (item) {
        normalized.push({
          type: 'page',
          title: item.title || item.name || '',
          url: item.url || '',
          image: getImageUrl(item),
          excerpt: truncate(item.body || item.content || item.summary || '', 140)
        });
      });

      articles.forEach(function (item) {
        normalized.push({
          type: 'article',
          title: item.title || item.name || '',
          url: item.url || '',
          image: getImageUrl(item),
          excerpt: truncate(item.summary || item.excerpt || item.body || item.content || '', 140)
        });
      });

      collections.forEach(function (item) {
        normalized.push({
          type: 'collection',
          title: item.title || item.name || '',
          url: item.url || '',
          image: getImageUrl(item),
          excerpt: truncate(item.body || item.description || item.summary || '', 140)
        });
      });

      return normalized.filter(function (item) {
        return item.title && item.url;
      });
    }

    function renderCard(item, container, rank, query) {
      var typeLabel = 'Page';
      if (item.type === 'article') {
        typeLabel = container.getAttribute('data-coreiq-search-article-label') || 'Article';
      } else if (item.type === 'collection') {
        typeLabel = container.getAttribute('data-coreiq-search-collection-label') || 'Collection';
      } else {
        typeLabel = container.getAttribute('data-coreiq-search-page-label') || 'Page';
      }
      var mediaHtml = item.image
        ? '<div class="ciq-search-content-card__media"><img src="' + escapeHtml(item.image) + '" alt="" loading="lazy"></div>'
        : '';
      var excerptHtml = item.excerpt
        ? '<p class="ciq-search-content-card__excerpt">' + escapeHtml(item.excerpt) + '</p>'
        : '';

      return '<div class="ciq-search-page__result" data-coreiq-search-result data-coreiq-search-runtime-content="true" data-coreiq-search-query="' + escapeHtml(query) + '" data-coreiq-search-rank="' + rank + '" data-coreiq-search-type="' + escapeHtml(item.type) + '" data-coreiq-search-title="' + escapeHtml(item.title) + '" data-coreiq-search-url="' + escapeHtml(item.url) + '">' +
        '<a href="' + escapeHtml(item.url) + '" class="ciq-search-content-card" data-coreiq-search-content-card>' +
          mediaHtml +
          '<div class="ciq-search-content-card__info">' +
            '<p class="ciq-search-page__result-type">' + escapeHtml(typeLabel) + '</p>' +
            '<h3 class="ciq-search-content-card__title">' + escapeHtml(item.title) + '</h3>' +
            excerptHtml +
          '</div>' +
        '</a>' +
      '</div>';
    }

    containers.forEach(function (container) {
      var query = (container.getAttribute('data-coreiq-search-query') || '').trim();
      if (!query || container.getAttribute('data-coreiq-search-content-loaded') === 'true') return;
      container.setAttribute('data-coreiq-search-content-loaded', 'true');

      fetch(buildSuggestUrl(query), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Search content fallback failed');
          return response.json();
        })
        .then(function (data) {
          var results = data && data.resources && data.resources.results ? data.resources.results : {};
          var existingUrls = getExistingUrls();
          var nativeCount = parseInt(container.getAttribute('data-coreiq-search-results-count') || '0', 10) || 0;
          var items = normalizeItems(results).filter(function (item) {
            var url = normalizeUrl(item.url);
            if (!url || existingUrls[url]) return false;
            existingUrls[url] = true;
            return true;
          });

          if (!items.length) return;

          container.insertAdjacentHTML('beforeend', items.map(function (item, index) {
            return renderCard(item, container, nativeCount + index + 1, query);
          }).join(''));
          container.hidden = false;
          updateSearchResultsLabel(container, query);
          emitThemeAnalytics('coreiq_search_content_fallback_rendered', {
            searchQuery: query,
            searchContentResultCount: items.length
          });
        })
        .catch(function () {
          container.setAttribute('data-coreiq-search-content-error', 'true');
        });
    });
  })();
  });

  (function initSearchResultsAnalytics() {
    var resultsContainers = document.querySelectorAll('[data-coreiq-search-results]');
    if (!resultsContainers.length) return;

    function getResultsMeta(container) {
      return {
        searchQuery: container.getAttribute('data-coreiq-search-query') || '',
        searchResultsCount: parseInt(container.getAttribute('data-coreiq-search-results-count') || '0', 10) || 0
      };
    }

    function emitSearchResultImpression(card) {
      if (!card || card.getAttribute('data-coreiq-search-impression-tracked') === 'true') return;
      var container = card.closest('[data-coreiq-search-results]');
      if (!container) return;

      var meta = getResultsMeta(container);
      card.setAttribute('data-coreiq-search-impression-tracked', 'true');
      emitThemeAnalytics('coreiq_search_result_impression', {
        searchQuery: meta.searchQuery,
        searchResultsCount: meta.searchResultsCount,
        searchResultRank: parseInt(card.getAttribute('data-coreiq-search-rank') || '0', 10) || 0,
        searchResultType: card.getAttribute('data-coreiq-search-type') || '',
        searchResultTitle: card.getAttribute('data-coreiq-search-title') || '',
        searchResultUrl: card.getAttribute('data-coreiq-search-url') || ''
      });
    }

    resultsContainers.forEach(function (container) {
      var meta = getResultsMeta(container);
      emitThemeAnalytics('coreiq_search_results_view', {
        searchQuery: meta.searchQuery,
        searchResultsCount: meta.searchResultsCount,
        hasResults: meta.searchResultsCount > 0 ? 'true' : 'false'
      });

      var resultCards = container.querySelectorAll('[data-coreiq-search-result]');
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            emitSearchResultImpression(entry.target);
            observer.unobserve(entry.target);
          });
        }, {
          threshold: 0.35
        });

        resultCards.forEach(function (card) {
          observer.observe(card);
        });
      } else {
        resultCards.forEach(emitSearchResultImpression);
      }
    });

    document.addEventListener('click', function (event) {
      var resultLink = event.target.closest('[data-coreiq-search-result] a[href]');
      if (!resultLink) return;

      var resultCard = resultLink.closest('[data-coreiq-search-result]');
      var container = resultCard ? resultCard.closest('[data-coreiq-search-results]') : null;
      if (!resultCard || !container) return;

      var meta = getResultsMeta(container);
      var searchResultType = resultCard.getAttribute('data-coreiq-search-type') || '';
      var searchResultTitle = resultCard.getAttribute('data-coreiq-search-title') || '';
      var searchResultUrl = resultCard.getAttribute('data-coreiq-search-url') || resultLink.getAttribute('href') || '';

      setAssistedAttributionContext({
        assistSurface: 'search-results',
        assistTargetType: searchResultType,
        assistRuleId: '',
        assistRuleName: searchResultTitle,
        assistQuery: meta.searchQuery,
        assistUrl: searchResultUrl
      });

      emitThemeAnalytics('coreiq_search_result_click', {
        searchQuery: meta.searchQuery,
        searchResultsCount: meta.searchResultsCount,
        searchResultRank: parseInt(resultCard.getAttribute('data-coreiq-search-rank') || '0', 10) || 0,
        searchResultType: searchResultType,
        searchResultTitle: searchResultTitle,
        searchResultUrl: searchResultUrl
      });
    });

    document.addEventListener('click', function (event) {
      var filterLink = event.target.closest('[data-coreiq-search-filter-value]');
      if (!filterLink) return;

      var container = document.querySelector('[data-coreiq-search-results]');
      var query = container ? container.getAttribute('data-coreiq-search-query') || '' : '';
      var resultsCount = container ? parseInt(container.getAttribute('data-coreiq-search-results-count') || '0', 10) || 0 : 0;

      emitThemeAnalytics('coreiq_search_filter_apply', {
        searchQuery: query,
        searchResultsCount: resultsCount,
        searchFilterName: filterLink.getAttribute('data-coreiq-search-filter-name') || '',
        searchFilterValue: filterLink.getAttribute('data-coreiq-search-filter-label') || ''
      });
    });

    document.addEventListener('change', function (event) {
      var sortSelect = event.target.closest('[data-coreiq-search-sort-form] select[name="sort_by"]');
      if (!sortSelect) return;

      var container = document.querySelector('[data-coreiq-search-results]');
      var query = container ? container.getAttribute('data-coreiq-search-query') || '' : '';
      var resultsCount = container ? parseInt(container.getAttribute('data-coreiq-search-results-count') || '0', 10) || 0 : 0;

      emitThemeAnalytics('coreiq_search_sort_change', {
        searchQuery: query,
        searchResultsCount: resultsCount,
        searchSortValue: sortSelect.value || ''
      });
    });
  })();

  /* â”€â”€ Cart drawer data + interactions â”€â”€ */
  (function initCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    if (drawer.getAttribute('data-coreiq-cart-bound') === 'true') return;
    drawer.setAttribute('data-coreiq-cart-bound', 'true');
    var cartLineActionInFlight = false;

    fetchCartState().catch(function () {
      updateCartCountBadge(0);
    });

    function changeCartLine(target, nextQuantity, options) {
      options = options || {};
      var payload = {
        quantity: Math.max(0, nextQuantity)
      };
      if (target && typeof target === 'object' && Number.isFinite(target.line)) {
        payload.line = target.line;
      } else {
        payload.id = target;
      }

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (!res.ok) {
            var updateError = new Error('Cart update failed');
            updateError.status = res.status;
            return res.json().catch(function () { return {}; }).then(function (payload) {
              updateError.message = payload.description || payload.message || updateError.message;
              throw updateError;
            });
          }
          return res.json();
        })
        .then(function (cart) {
          latestCartState = cart;
          updateCartCountBadge(cart.item_count || 0);
          if (options.render !== false) {
            renderCartDrawer(cart);
          }
          return cart;
        });
    }

    function findCartLineGroup(signature, key) {
      var groups = getRenderableCartItems(latestCartState || {});
      var group = null;
      if (signature) {
        group = groups.find(function (item) {
          return item._ciqCartSignature === signature;
        });
      }
      if (!group && key) {
        group = groups.find(function (item) {
          return item._ciqCartKeys && item._ciqCartKeys.indexOf(key) !== -1;
        });
      }
      return group || null;
    }

    function changeCartLineGroup(group, nextQuantity) {
      if (!group) return Promise.reject(new Error('Cart line not found'));
      var lines = (group._ciqCartLines || []).slice().filter(function (lineNumber) {
        return Number.isFinite(lineNumber) && lineNumber > 0;
      });
      var quantity = Math.max(0, nextQuantity);

      if (!lines.length) {
        return changeCartLine(group.key, quantity);
      }

      if (quantity === 0) {
        return lines.sort(function (a, b) { return b - a; }).reduce(function (sequence, lineNumber, index, sortedLines) {
          return sequence.then(function () {
            return changeCartLine({ line: lineNumber }, 0, { render: index === sortedLines.length - 1 });
          });
        }, Promise.resolve(latestCartState));
      }

      var primaryLine = Math.min.apply(Math, lines);
      var duplicateLines = lines.filter(function (lineNumber) {
        return lineNumber !== primaryLine;
      }).sort(function (a, b) {
        return b - a;
      });

      return duplicateLines.reduce(function (sequence, lineNumber) {
        return sequence.then(function () {
          return changeCartLine({ line: lineNumber }, 0, { render: false });
        });
      }, Promise.resolve(latestCartState)).then(function () {
        return changeCartLine({ line: primaryLine }, quantity);
      });
    }

    function animateCartItemRemoval(removeBtn) {
      return new Promise(function (resolve) {
        var item = removeBtn ? removeBtn.closest('.ciq-cart-drawer__item') : null;
        if (!item || item.classList.contains('is-removing')) {
          resolve();
          return;
        }

        var finished = false;
        var finish = function () {
          if (finished) return;
          finished = true;
          item.removeEventListener('transitionend', onTransitionEnd);
          resolve();
        };
        var onTransitionEnd = function (event) {
          if (event.target !== item) return;
          finish();
        };

        item.addEventListener('transitionend', onTransitionEnd);
        item.classList.add('is-removing');
        window.setTimeout(finish, 320);
      });
    }

    function setCartLineBusyState(key, signature, busy) {
      if (!drawer || (!key && !signature)) return;
      function lineControls(selector) {
        return Array.prototype.filter.call(drawer.querySelectorAll(selector), function (element) {
          return (key && element.getAttribute('data-key') === key) ||
            (signature && element.getAttribute('data-signature') === signature);
        });
      }

      lineControls('[data-coreiq-cart-qty]').forEach(function (button) {
        if (busy) {
          button.setAttribute('disabled', 'disabled');
        } else if (button.getAttribute('data-delta') === '-1') {
          var qtyWrap = button.closest('.ciq-cart-drawer__qty');
          var qtyValueEl = qtyWrap ? qtyWrap.querySelector('[data-coreiq-cart-qty-value]') : null;
          var currentQty = qtyValueEl ? parseInt(qtyValueEl.textContent || '1', 10) : 1;
          if (currentQty <= 1) {
            button.setAttribute('disabled', 'disabled');
          } else {
            button.removeAttribute('disabled');
          }
        } else {
          var plusCurrentQty = parseInt(button.getAttribute('data-inventory-current-quantity') || '0', 10) || 0;
          var plusInventoryLimitValue = button.getAttribute('data-inventory-limit');
          var plusInventoryLimit = plusInventoryLimitValue !== null && plusInventoryLimitValue !== '' ? Number(plusInventoryLimitValue) : NaN;
          if (Number.isFinite(plusInventoryLimit) && plusCurrentQty >= plusInventoryLimit) {
            button.setAttribute('disabled', 'disabled');
            button.setAttribute('title', 'Maximum available quantity is already in your cart');
            button.setAttribute('aria-label', 'Maximum available quantity reached');
          } else {
            button.removeAttribute('disabled');
            button.removeAttribute('title');
            button.setAttribute('aria-label', 'Increase quantity');
          }
        }
      });

      var removeBtn = lineControls('[data-coreiq-cart-remove]')[0];
      if (removeBtn) {
        if (busy) {
          removeBtn.setAttribute('disabled', 'disabled');
        } else {
          removeBtn.removeAttribute('disabled');
        }
      }
    }

    function updateCartNote(note) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ note: note || '' })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart note update failed');
          return res.json();
        })
        .then(function (cart) {
          latestCartState = cart;
          updateCartCountBadge(cart.item_count || 0);
          renderCartDrawer(cart);
        });
    }

    function updateCartAttributes(attributes) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ attributes: attributes || {} })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart attribute update failed');
          return res.json();
        })
        .then(function (cart) {
          latestCartState = cart;
          updateCartCountBadge(cart.item_count || 0);
          renderCartDrawer(cart);
        });
    }

    function syncCartGiftSaveState() {
      var giftWrapInput = drawer.querySelector('[data-coreiq-cart-gift-wrap-input]');
      var giftNoteInput = drawer.querySelector('[data-coreiq-cart-gift-note-input]');
      var giftSaveBtn = drawer.querySelector('[data-coreiq-cart-gift-save]');
      if (!giftSaveBtn || !giftWrapInput || !giftNoteInput) return;
      var savedWrap = giftWrapInput.getAttribute('data-coreiq-saved-gift-wrap') === 'true';
      var savedNote = giftNoteInput.getAttribute('data-coreiq-saved-gift-note');
      if (savedNote === null) {
        savedNote = ((latestCartState && latestCartState.attributes) || {})['Gift note'] || '';
      }
      if (giftWrapInput.checked !== savedWrap || giftNoteInput.value !== savedNote) {
        giftSaveBtn.removeAttribute('disabled');
      } else {
        giftSaveBtn.setAttribute('disabled', 'disabled');
      }
    }

    function openCartDrawer() {
      if (drawer.hasAttribute('open')) {
        setDrawerInteractiveState(drawer, true);
        return;
      }
      drawer.removeAttribute('hidden');
      drawer.classList.add('is-open');
      var cartPanel = drawer.querySelector('.ciq-mobile-drawer__panel');
      if (cartPanel) cartPanel.style.setProperty('transform', 'translateX(0)', 'important');
      setDrawerInteractiveState(drawer, true);
      drawer.setAttribute('open', '');
      document.querySelectorAll('[data-coreiq-drawer-toggle="cart-drawer"]').forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
      });
      // Cart is a non-modal side drawer; do not remove the page scrollbar.
      document.dispatchEvent(new CustomEvent('ciq:drawer-opened', { detail: { id: 'cart-drawer' } }));
    }

    drawer.addEventListener('input', function (e) {
      var textarea = e.target;
      if (textarea && textarea.hasAttribute('data-coreiq-cart-gift-note-input')) {
        syncCartGiftSaveState();
        return;
      }
      if (!textarea || !textarea.hasAttribute('data-coreiq-cart-note-input')) return;
      var saveBtn = drawer.querySelector('[data-coreiq-cart-note-save]');
      if (!saveBtn) return;
      var savedNote = textarea.getAttribute('data-coreiq-saved-note');
      if (savedNote === null) {
        savedNote = (latestCartState && latestCartState.note) || '';
      }
      if (textarea.value !== savedNote) {
        saveBtn.removeAttribute('disabled');
      } else {
        saveBtn.setAttribute('disabled', 'disabled');
      }
    });

    drawer.addEventListener('change', function (e) {
      var giftInput = e.target.closest('[data-coreiq-cart-gift-wrap-input]');
      if (!giftInput) return;
      syncCartGiftSaveState();
    });

    function enhanceCartDetailsPanel(detailsEl, bodySelector, focusSelector) {
      if (!detailsEl) return;
      var summaryEl = detailsEl.querySelector('summary');
      var bodyEl = detailsEl.querySelector(bodySelector);

      function scrollDetailsIntoView() {
        var focusEl = detailsEl.querySelector(focusSelector);
        var scrollContainer = detailsEl.closest('.ciq-mobile-drawer__panel') || detailsEl.closest('.ciq-cart-drawer__inner');

        if (scrollContainer && typeof scrollContainer.scrollTo === 'function') {
          var detailsRect = detailsEl.getBoundingClientRect();
          var containerRect = scrollContainer.getBoundingClientRect();
          var targetTop = scrollContainer.scrollTop + detailsRect.top - containerRect.top - 18;
          scrollContainer.scrollTo({
            top: Math.max(0, targetTop),
            behavior: 'smooth'
          });
        } else if (typeof detailsEl.scrollIntoView === 'function') {
          detailsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        if (focusEl && typeof focusEl.focus === 'function') {
          window.setTimeout(function () {
            focusEl.focus({ preventScroll: true });
          }, 180);
        }
      }

      detailsEl.addEventListener('toggle', function () {
        if (!detailsEl.open) return;
        if (bodyEl) {
          bodyEl.style.animation = 'none';
          void bodyEl.offsetHeight;
          bodyEl.style.animation = '';
        }
        window.setTimeout(function () {
          scrollDetailsIntoView();
        }, 160);
      });

      if (summaryEl) {
        summaryEl.addEventListener('click', function (e) {
          if (!detailsEl.open) return;
          e.preventDefault();
          if (bodyEl) {
            bodyEl.style.animation = 'none';
            void bodyEl.offsetHeight;
            bodyEl.style.animation = 'ciq-note-collapse 220ms ease-in forwards';
            bodyEl.addEventListener('animationend', function onEnd() {
              bodyEl.removeEventListener('animationend', onEnd);
              bodyEl.style.animation = '';
              detailsEl.removeAttribute('open');
            }, { once: true });
          } else {
            detailsEl.removeAttribute('open');
          }
        });
      }
    }

    enhanceCartDetailsPanel(drawer.querySelector('[data-coreiq-cart-note-wrap]'), '.ciq-cart-drawer__note-body', '[data-coreiq-cart-note-input]');
    enhanceCartDetailsPanel(drawer.querySelector('[data-coreiq-cart-gift-wrap]'), '.ciq-cart-drawer__gift-body', '[data-coreiq-cart-gift-note-input]');

    document.addEventListener('coreiq:cart:refresh', function (event) {
      fetchCartState()
        .then(function (cart) {
          renderCartDrawer(cart);
          if (event && event.detail && event.detail.open) {
            openCartDrawer();
          }
          announceCartUpdate(cart.item_count || 0);
        })
        .catch(function () {});
    });

    drawer.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-coreiq-cart-remove]');
      if (removeBtn) {
        if (cartLineActionInFlight) return;
        var key = removeBtn.getAttribute('data-key') || '';
        var signature = removeBtn.getAttribute('data-signature') || '';
        var removeGroup = findCartLineGroup(signature, key);
        if (!removeGroup) return;
        cartLineActionInFlight = true;
        setCartLineBusyState(key, signature, true);
        animateCartItemRemoval(removeBtn)
          .then(function () {
            return changeCartLineGroup(removeGroup, 0);
          })
          .catch(function () {})
          .finally(function () {
            cartLineActionInFlight = false;
            setCartLineBusyState(key, signature, false);
          });
        return;
      }

      var noteSaveBtn = e.target.closest('[data-coreiq-cart-note-save]');
      if (noteSaveBtn) {
        var noteInput = drawer.querySelector('[data-coreiq-cart-note-input]');
        if (!noteInput) return;
        noteSaveBtn.setAttribute('disabled', 'disabled');
        updateCartNote(noteInput.value)
          .then(function () {
            noteInput.setAttribute('data-coreiq-saved-note', noteInput.value);
            noteSaveBtn.textContent = 'Saved';
            var noteStatus = drawer.querySelector('[data-coreiq-cart-note-status]');
            if (noteStatus) noteStatus.textContent = 'Order note saved.';
            setTimeout(function () {
              noteSaveBtn.textContent = 'Save note';
              noteSaveBtn.setAttribute('disabled', 'disabled');
              if (noteStatus) noteStatus.textContent = '';
              /* Keep disabled — re-enables only when user edits the note again */
            }, 900);
          })
          .catch(function () {
            noteSaveBtn.textContent = 'Try again';
            setTimeout(function () {
              noteSaveBtn.textContent = 'Save note';
              noteSaveBtn.removeAttribute('disabled');
            }, 1200);
          });
        return;
      }

      var giftSaveBtn = e.target.closest('[data-coreiq-cart-gift-save]');
      if (giftSaveBtn) {
        var giftWrapInput = drawer.querySelector('[data-coreiq-cart-gift-wrap-input]');
        var giftNoteInput = drawer.querySelector('[data-coreiq-cart-gift-note-input]');
        if (!giftWrapInput || !giftNoteInput) return;
        var nextAttributes = Object.assign({}, (latestCartState && latestCartState.attributes) || {});
        nextAttributes['Gift wrap'] = giftWrapInput.checked ? 'Yes' : '';
        nextAttributes['Gift note'] = giftNoteInput.value || '';
        giftSaveBtn.setAttribute('disabled', 'disabled');
        updateCartAttributes(nextAttributes)
          .then(function () {
            giftWrapInput.setAttribute('data-coreiq-saved-gift-wrap', giftWrapInput.checked ? 'true' : 'false');
            giftNoteInput.setAttribute('data-coreiq-saved-gift-note', giftNoteInput.value || '');
            giftSaveBtn.textContent = 'Saved';
            var giftStatus = drawer.querySelector('[data-coreiq-cart-gift-status]');
            if (giftStatus) giftStatus.textContent = 'Gift options saved.';
            setTimeout(function () {
              giftSaveBtn.textContent = 'Save gift options';
              giftSaveBtn.setAttribute('disabled', 'disabled');
              if (giftStatus) giftStatus.textContent = '';
            }, 900);
          })
          .catch(function () {
            giftSaveBtn.textContent = 'Try again';
            setTimeout(function () {
              giftSaveBtn.textContent = 'Save gift options';
              giftSaveBtn.removeAttribute('disabled');
            }, 1200);
          });
        return;
      }

      var qtyBtn = e.target.closest('[data-coreiq-cart-qty]');
      if (!qtyBtn) return;
      if (cartLineActionInFlight) return;

      var qtyKey = qtyBtn.getAttribute('data-key') || '';
      var qtySignature = qtyBtn.getAttribute('data-signature') || '';
      var delta = parseInt(qtyBtn.getAttribute('data-delta') || '0', 10);
      if ((!qtyKey && !qtySignature) || !delta || !latestCartState || !latestCartState.items) return;

      var lineGroup = findCartLineGroup(qtySignature, qtyKey);
      if (!lineGroup) return;

      cartLineActionInFlight = true;
      setCartLineBusyState(qtyKey, qtySignature, true);
      changeCartLineGroup(lineGroup, (lineGroup.quantity || 0) + delta)
        .catch(function (error) {
          if (delta > 0 && error && error.status === 422) {
            var quantityWrap = qtyBtn.closest('.ciq-cart-drawer__qty');
            var currentQtyNode = quantityWrap ? quantityWrap.querySelector('[data-coreiq-cart-qty-value]') : null;
            var currentQty = currentQtyNode ? parseInt(currentQtyNode.textContent || '0', 10) || 0 : Number(lineGroup.quantity || 0);
            qtyBtn.setAttribute('data-inventory-limit', String(currentQty));
            qtyBtn.setAttribute('data-inventory-current-quantity', String(currentQty));
            qtyBtn.setAttribute('disabled', 'disabled');
            qtyBtn.setAttribute('title', 'Maximum available quantity is already in your cart');
            qtyBtn.setAttribute('aria-label', 'Maximum available quantity reached');
          }
        })
        .finally(function () {
          cartLineActionInFlight = false;
          setCartLineBusyState(qtyKey, qtySignature, false);
        });
    });
  })();

  /* â”€â”€ Product card quick view modal â”€â”€ */
  (function initQuickViewModal() {
    var modal = document.getElementById('ciq-quick-view-modal');
    if (!modal) return;

    var content = modal.querySelector('[data-coreiq-quick-view-content]');
    var closeButton = modal.querySelector('button[data-coreiq-quick-view-close]');
    var panel = modal.querySelector('[data-coreiq-qv-panel]');
    var a11y = window.CoreIQA11y || null;
    var activeTrigger = null;
    var activeQuickViewVariants = [];
    var activeQuickViewRequest = 0;

    function closeModal() {
      if (a11y && typeof a11y.closeDialog === 'function') {
        a11y.closeDialog(modal, {
          returnFocusTo: activeTrigger,
          clearContainer: content,
          afterCloseDelayMs: 360
        });
      } else {
        modal.setAttribute('aria-hidden', 'true');
        unlockBodyScroll();
        setTimeout(function () {
          modal.hidden = true;
          content.innerHTML = '';
        }, 360);
        if (activeTrigger && typeof activeTrigger.focus === 'function') {
          activeTrigger.focus();
        }
      }

      if (activeTrigger && typeof activeTrigger.setAttribute === 'function') {
        activeTrigger.setAttribute('aria-expanded', 'false');
      }
      activeTrigger = null;
      activeQuickViewRequest += 1;
    }

    function openModal(triggerEl) {
      activeTrigger = triggerEl || null;
      if (activeTrigger && typeof activeTrigger.setAttribute === 'function') {
        activeTrigger.setAttribute('aria-expanded', 'true');
      }

      var primaryAction = content.querySelector('[data-coreiq-qv-add]') || closeButton || panel;

      if (a11y && typeof a11y.openDialog === 'function') {
        a11y.openDialog(modal, {
          trigger: activeTrigger,
          initialFocus: primaryAction
        });
      } else {
        modal.hidden = false;
        lockBodyScroll();
        if (primaryAction && typeof primaryAction.focus === 'function') {
          primaryAction.focus();
        }
        // Double-rAF: ensures the browser has committed a layout with the
        // element visible before the attribute change triggers the CSS open
        // transition. The prior setTimeout(10) approach was unreliable.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            modal.setAttribute('aria-hidden', 'false');
          });
        });
      }

      // The browser's default button activation can restore focus to the card
      // after the click handler completes. Reassert dialog focus once the open
      // transition has exposed the panel.
      window.setTimeout(function () {
        if (modal.hidden || modal.getAttribute('aria-hidden') !== 'false') return;
        if (!modal.contains(document.activeElement) && typeof modal.focus === 'function') {
          try { modal.focus({ preventScroll: true }); } catch (err) { modal.focus(); }
        }
      }, 100);
    }

    function getQuickViewOptionNames(variants) {
      var explicitNames = [];
      variants.some(function (variant) {
        if (variant && Array.isArray(variant.option_names) && variant.option_names.length) {
          explicitNames = variant.option_names;
          return true;
        }
        return false;
      });
      if (explicitNames.length) return explicitNames;

      var maxOptions = variants.reduce(function (max, variant) {
        return Math.max(max, Array.isArray(variant && variant.options) ? variant.options.length : 0);
      }, 0);

      return Array.from({ length: maxOptions }).map(function (_, index) {
        return 'Option ' + (index + 1);
      });
    }

    function getQuickViewSelectionsFromModal() {
      var selected = [];
      modal.querySelectorAll('[data-coreiq-qv-option-index]').forEach(function (button) {
        if (!button.classList.contains('is-selected')) return;
        var index = parseInt(button.getAttribute('data-coreiq-qv-option-index') || '0', 10);
        selected[index] = button.getAttribute('data-coreiq-qv-option-value') || '';
      });
      return selected;
    }

    function findQuickViewVariant(variants, selections) {
      if (!Array.isArray(variants) || !variants.length) return null;
      var matches = variants.filter(function (variant) {
        if (!variant || !Array.isArray(variant.options)) return false;
        return selections.every(function (value, index) {
          return !value || String(variant.options[index] || '') === String(value);
        });
      });
      return matches.filter(function (variant) { return variant.available; })[0] || matches[0] || null;
    }

    function buildQuickViewOptionGroups(variants, defaultVariant) {
      if (!variants.length || !defaultVariant || !Array.isArray(defaultVariant.options) || !defaultVariant.options.length) return '';

      var optionNames = getQuickViewOptionNames(variants);
      return optionNames.map(function (name, optionIndex) {
        var values = [];
        variants.forEach(function (variant) {
          var value = variant && Array.isArray(variant.options) ? variant.options[optionIndex] : '';
          if (value && values.indexOf(value) === -1) values.push(value);
        });
        if (!values.length) return '';

        var normalizedName = String(name || '').toLowerCase();
        var isVisual = normalizedName.indexOf('color') !== -1 || normalizedName.indexOf('colour') !== -1;
        var selectedValue = defaultVariant.options[optionIndex] || values[0];
        var buttons = values.map(function (value) {
          var valueVariant = variants.filter(function (variant) {
            return variant && variant.available && Array.isArray(variant.options) && variant.options[optionIndex] === value && (variant.swatch_image || variant.featured_image);
          })[0] || variants.filter(function (variant) {
            return variant && Array.isArray(variant.options) && variant.options[optionIndex] === value && (variant.swatch_image || variant.featured_image);
          })[0] || null;
          var hasPurchasableValue = variants.some(function (variant) {
            return variant && variant.available && Array.isArray(variant.options) && variant.options[optionIndex] === value;
          });
          var selectedClass = value === selectedValue ? ' is-selected' : '';
          var thumbSrc = valueVariant ? (valueVariant.swatch_image || valueVariant.featured_image) : '';
          var thumb = isVisual && thumbSrc
            ? '<span class="ciq-quick-view-body__option-thumb" style="background-image:url(' + escapeHtml(thumbSrc) + ')" aria-hidden="true"></span>'
            : '';
          return '<button type="button" class="ciq-quick-view-body__option' + selectedClass + (hasPurchasableValue ? '' : ' is-unavailable') + '" data-coreiq-qv-option-index="' + optionIndex + '" data-coreiq-qv-option-value="' + escapeHtml(value) + '" data-coreiq-swatch-label="' + escapeHtml(name || 'Option') + ': ' + escapeHtml(value) + '" aria-pressed="' + (value === selectedValue ? 'true' : 'false') + '" aria-label="' + escapeHtml(name || 'Option') + ': ' + escapeHtml(value) + '">' + thumb + '<span>' + escapeHtml(value) + '</span></button>';
        }).join('');

        return '<div class="ciq-quick-view-body__field ciq-quick-view-body__option-group"><span class="ciq-quick-view-body__field-label">' + escapeHtml(name || 'Option') + '</span><div class="ciq-quick-view-body__options">' + buttons + '</div></div>';
      }).join('');
    }

    function updateQuickViewSelectionFromVariant(variant) {
      if (!variant) return;
      var addBtn = modal.querySelector('[data-coreiq-qv-add]');
      var variantSelect = modal.querySelector('[data-coreiq-qv-variant]');
      var priceEl = modal.querySelector('[data-coreiq-qv-price]');
      var mainImage = modal.querySelector('[data-coreiq-qv-main-image]');
      var availabilityEl = modal.querySelector('[data-coreiq-qv-availability]');

      if (variantSelect) {
        variantSelect.value = String(variant.id || '');
      }

      if (addBtn) {
        addBtn.setAttribute('data-variant-id', variant.id || '');
        addBtn.innerHTML = '<span aria-hidden="true">＋</span> ' + (variant.available ? 'Add to cart' : 'Sold out');
        addBtn.toggleAttribute('disabled', !variant.available);
        var trackedInventory = (variant.inventory_tracked === true || Boolean(variant.inventory_management)) && variant.inventory_policy !== 'continue';
        if (trackedInventory && variant.inventory_quantity != null && Number.isFinite(Number(variant.inventory_quantity))) {
          addBtn.setAttribute('data-inventory-tracked', 'true');
          addBtn.setAttribute('data-inventory-limit', String(Math.max(0, Number(variant.inventory_quantity))));
        } else {
          addBtn.removeAttribute('data-inventory-tracked');
          addBtn.removeAttribute('data-inventory-limit');
        }
        var quantityInput = modal.querySelector('[data-coreiq-qv-qty]');
        if (quantityInput) {
          if (trackedInventory && Number.isFinite(Number(variant.inventory_quantity))) {
            var maxQuantity = Math.max(0, Number(variant.inventory_quantity));
            quantityInput.max = String(maxQuantity);
            quantityInput.setAttribute('data-coreiq-qv-stock-limit', String(maxQuantity));
            if (parseInt(quantityInput.value || '1', 10) > maxQuantity && maxQuantity > 0) quantityInput.value = String(maxQuantity);
            if (maxQuantity === 0) quantityInput.value = '1';
          } else {
            quantityInput.removeAttribute('max');
            quantityInput.removeAttribute('data-coreiq-qv-stock-limit');
          }
        }
      }

      if (priceEl && variant.price) {
        priceEl.textContent = variant.price;
      }

      if (availabilityEl) {
        var stock = parseInt(variant.inventory_quantity, 10);
        var lowStock = variant.inventory_tracked === true && variant.inventory_policy === 'deny' && Number.isFinite(stock) && stock > 0 && stock <= 5;
        availabilityEl.classList.toggle('is-low-stock', lowStock);
        availabilityEl.classList.toggle('is-unavailable', !variant.available);
        availabilityEl.textContent = lowStock ? 'Only ' + stock + ' left' : variant.available ? 'Available to ship' : 'Currently unavailable';
      }

      if (mainImage && mainImage.tagName === 'IMG' && variant.featured_image) {
        mainImage.src = variant.featured_image;
      }
      syncQuickViewQuantityControls();
      if ((variant.inventory_tracked === true || Boolean(variant.inventory_management)) && variant.inventory_policy !== 'continue') {
        fetchCartState().then(syncQuickViewQuantityControls).catch(function () {});
      }
    }

    function syncQuickViewQuantityControls() {
      var qtyInput = modal.querySelector('[data-coreiq-qv-qty]');
      var addBtn = modal.querySelector('[data-coreiq-qv-add]');
      if (!qtyInput || !addBtn) return;

      var minusBtn = modal.querySelector('[data-coreiq-qv-qty-step="-1"]');
      var plusBtn = modal.querySelector('[data-coreiq-qv-qty-step="1"]');
      var current = Math.max(1, parseInt(qtyInput.value || '1', 10));
      var stockLimit = parseInt(qtyInput.getAttribute('data-coreiq-qv-stock-limit') || qtyInput.getAttribute('max') || '', 10);
      var hasStockLimit = Number.isFinite(stockLimit);
      var cartQuantity = 0;
      var variantId = String(addBtn.getAttribute('data-variant-id') || '');

      if (hasStockLimit && latestCartState && Array.isArray(latestCartState.items)) {
        cartQuantity = latestCartState.items.reduce(function (sum, item) {
          return String(item && (item.variant_id || item.id) || '') === variantId ? sum + Number(item.quantity || 0) : sum;
        }, 0);
      }

      var remaining = hasStockLimit ? Math.max(0, stockLimit - cartQuantity) : Infinity;
      var maxReached = hasStockLimit && (remaining < 1 || current >= remaining);
      if (hasStockLimit) qtyInput.max = String(Math.max(1, remaining));
      else qtyInput.removeAttribute('max');
      if (minusBtn) {
        minusBtn.disabled = current <= 1;
        minusBtn.setAttribute('aria-disabled', minusBtn.disabled ? 'true' : 'false');
      }
      if (plusBtn) {
        plusBtn.disabled = maxReached;
        plusBtn.setAttribute('aria-disabled', maxReached ? 'true' : 'false');
        if (hasStockLimit) plusBtn.setAttribute('aria-label', 'Increase quantity' + (remaining > 0 ? ', maximum ' + remaining : ', no more available'));
        else plusBtn.setAttribute('aria-label', 'Increase quantity');
      }
      if (hasStockLimit && current > remaining) {
        qtyInput.value = String(Math.max(1, remaining));
        syncQuantityInputWidth(qtyInput);
      }
      if (hasStockLimit && remaining < 1) {
        addBtn.disabled = true;
        addBtn.setAttribute('aria-label', 'No more units available');
      } else if (hasStockLimit && !modal.querySelector('[data-coreiq-qv-availability].is-unavailable')) {
        if (!addBtn.hasAttribute('data-coreiq-qv-pending')) addBtn.disabled = false;
        addBtn.removeAttribute('aria-label');
      }
    }

    function getQuickViewProductMeta(buttonEl) {
      var card = buttonEl.closest('.ciq-product-card, .ciq-mini-card, .ciq-complementary-card, .ciq-wishlist__item, .pc-wishlist__item');
      var script = card ? card.querySelector('[data-coreiq-product-quickview-meta]') : null;
      var dataMeta = {
        productId: buttonEl.getAttribute('data-product-id') || (card ? card.getAttribute('data-coreiq-product-id') || card.getAttribute('data-item-id') : ''),
        productHandle: buttonEl.getAttribute('data-product-handle') || (buttonEl.getAttribute('data-product-url') || '').split('?')[0].split('/').filter(Boolean).pop() || '',
        type: buttonEl.getAttribute('data-product-type') || '',
        genre: buttonEl.getAttribute('data-product-genre') || '',
        franchise: buttonEl.getAttribute('data-product-franchise') || '',
        series: buttonEl.getAttribute('data-product-series') || '',
        character: buttonEl.getAttribute('data-product-character') || '',
        productNumber: buttonEl.getAttribute('data-product-number') || '',
        release: buttonEl.getAttribute('data-product-release') || '',
        condition: buttonEl.getAttribute('data-product-condition') || '',
        material: buttonEl.getAttribute('data-product-material') || '',
        height: buttonEl.getAttribute('data-product-height') || '',
        exclusivity: buttonEl.getAttribute('data-product-exclusivity') || '',
        edition: buttonEl.getAttribute('data-product-edition') || ''
      };
      if (!script) return dataMeta;
      try {
        var meta = JSON.parse(script.textContent || '{}');
        if (!meta.productId && card) meta.productId = card.getAttribute('data-coreiq-product-id') || '';
        Object.keys(dataMeta).forEach(function (key) { if (!meta[key] && dataMeta[key]) meta[key] = dataMeta[key]; });
        return meta;
      } catch (err) {
        return dataMeta;
      }
    }

    function fetchQuickViewProductMeta(buttonEl, currentMeta) {
      currentMeta = currentMeta || {};
      if (currentMeta.franchise || currentMeta.genre || currentMeta.series || currentMeta.character || currentMeta.productNumber || currentMeta.edition) return Promise.resolve(currentMeta);
      var productUrl = buttonEl.getAttribute('data-product-url') || '';
      if (!productUrl || !window.DOMParser) return Promise.resolve(currentMeta);
      var resolvedUrl;
      try { resolvedUrl = new URL(productUrl, window.location.origin); } catch (err) { return Promise.resolve(currentMeta); }
      if (resolvedUrl.origin !== window.location.origin) return Promise.resolve(currentMeta);
      return fetch(resolvedUrl.href, { credentials: 'same-origin', headers: { Accept: 'text/html' } }).then(function (response) {
        if (!response.ok) return currentMeta;
        return response.text();
      }).then(function (html) {
        if (typeof html !== 'string') return currentMeta;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var wishlistButton = parsed.querySelector('[data-coreiq-wishlist-btn][data-product-franchise], [data-coreiq-wishlist-btn][data-product-genre]');
        if (!wishlistButton) return currentMeta;
        var keys = {
          type: 'productType', genre: 'productGenre', franchise: 'productFranchise', series: 'productSeries', character: 'productCharacter',
          productNumber: 'productNumber', release: 'productRelease', condition: 'productCondition', material: 'productMaterial',
          height: 'productHeight', exclusivity: 'productExclusivity', edition: 'productEdition'
        };
        Object.keys(keys).forEach(function (key) {
          var value = wishlistButton.getAttribute('data-' + keys[key].replace(/[A-Z]/g, function (letter) { return '-' + letter.toLowerCase(); }));
          if (value) currentMeta[key] = value;
        });
        return currentMeta;
      }).catch(function () { return currentMeta; });
    }

    function getQuickViewBadges(meta) {
      var tags = (Array.isArray(meta.tags) ? meta.tags : []).map(function (tag) {
        return String(tag || '').toLowerCase().replace(/[-_]+/g, ' ').trim();
      });
      var has = function (pattern) { return tags.some(function (tag) { return pattern.test(tag); }); };
      var condition = String(meta.condition || '').toLowerCase();
      var exclusivity = String(meta.exclusivity || '').toLowerCase();
      var edition = String(meta.edition || '').toLowerCase();
      var badges = [];
      if (has(/^chase$/) || /\bchase\b/.test(condition) || /\bchase\b/.test(edition)) badges.push('Chase');
      if (has(/^vaulted$/) || /vaulted/.test(edition)) badges.push('Vaulted');
      if (has(/^signed$|^autograph$/) || /signed|autograph/.test(edition)) badges.push('Signed');
      if (has(/convention exclusive/) || /convention/.test(exclusivity) || /convention/.test(edition)) badges.push('Convention exclusive');
      else if (has(/funko.*exclusive/) || /funko/.test(exclusivity) || /funko/.test(edition)) badges.push('Funko exclusive');
      else if (/exclusive/.test(exclusivity) || (/exclusive/.test(edition) && !/convention|funko/.test(edition))) badges.push('Exclusive');
      else if (meta.exclusive === true || /^(true|yes)$/i.test(String(meta.exclusive || '')) || has(/^exclusive$/)) badges.push('Exclusive');
      if (has(/limited edition|limited/) || /limited/.test(edition)) badges.push('Limited edition');
      if (/special/.test(edition)) badges.push('Special edition');
      if (/glow/.test(edition)) badges.push('Glow');
      if (/metallic/.test(edition)) badges.push('Metallic');
      if (/flocked/.test(edition)) badges.push('Flocked');
      if (meta.grail === true || /^(true|yes)$/i.test(String(meta.grail || '')) || has(/^grail$/)) badges.push('Grail');
      if (has(/trending/)) badges.push('Trending');
      if (has(/collector favorite|collectors favorite/)) badges.push('Collector favorite');
      if (has(/new arrival|recently added/)) badges.push('New arrival');
      if (has(/most wishlisted/)) badges.push('Most wishlisted');
      return badges;
    }

    function buildQuickViewMarkup(buttonEl, variants, imageSources, meta) {
      imageSources = (imageSources || []).filter(Boolean);
      meta = meta || {};

      var title = buttonEl.getAttribute('data-product-title') || 'Product';
      var price = buttonEl.getAttribute('data-product-price') || '';
      var vendor = buttonEl.getAttribute('data-product-vendor') || '';
      var productUrl = buttonEl.getAttribute('data-product-url') || '#';
      var hasVariants = variants.length > 0;
      var dialogTitleId = 'ciq-qv-title';
      var defaultVariant = hasVariants
        ? variants.filter(function (variant) { return variant && variant.available; })[0] || variants[0]
        : null;
      var defaultVariantId = defaultVariant ? defaultVariant.id : '';
      var defaultVariantTracked = defaultVariant && (defaultVariant.inventory_tracked === true || Boolean(defaultVariant.inventory_management)) && defaultVariant.inventory_policy !== 'continue';
      var defaultInventoryAttrs = defaultVariantTracked && defaultVariant.inventory_quantity != null && Number.isFinite(Number(defaultVariant.inventory_quantity))
        ? ' data-inventory-tracked="true" data-inventory-limit="' + Math.max(0, Number(defaultVariant.inventory_quantity)) + '"'
        : '';
      var hasOnlyDefaultTitleVariant = variants.length === 1 && defaultVariant &&
        String(defaultVariant.title || '').toLowerCase() === 'default title' &&
        (!Array.isArray(defaultVariant.options) || defaultVariant.options.length <= 1 &&
          String(defaultVariant.options[0] || '').toLowerCase() === 'default title');
      var badges = getQuickViewBadges(meta);
      var badgesHtml = badges.length ? '<div class="ciq-quick-view-body__badges" aria-label="Collector highlights">' + badges.map(function (badge) {
        var tone = /grail|exclusive|limited/i.test(badge) ? ' is-gold' : '';
        return '<span class="ciq-quick-view-body__badge' + tone + '">' + escapeHtml(badge) + '</span>';
      }).join('') + '</div>' : '';
      var inventoryQuantity = parseInt(meta.inventoryQuantity, 10);
      var showLowStock = meta.inventoryTracked === true && Number.isFinite(inventoryQuantity) && inventoryQuantity > 0 && inventoryQuantity <= 5;
      var availabilityText = meta.available === false || defaultVariant && defaultVariant.available === false ? 'Currently unavailable' : 'Available to ship';
      var urgencyHtml = '<span class="ciq-quick-view-body__availability' + (showLowStock ? ' is-low-stock' : availabilityText === 'Currently unavailable' ? ' is-unavailable' : '') + '" data-coreiq-qv-availability>' + (showLowStock ? 'Only ' + inventoryQuantity + ' left' : availabilityText) + '</span>';
      var exclusivity = meta.exclusivity || badges.filter(function (badge) { return /exclusive/i.test(badge); })[0] || '';
      var facts = [
        ['Genre', meta.genre],
        ['Franchise', meta.franchise],
        ['Series', meta.series],
        ['Character', meta.character],
        ['Product number', meta.productNumber],
        ['Release year', meta.release],
        ['Condition', meta.condition],
        ['Edition', meta.edition],
        ['Exclusivity', exclusivity],
        ['Material', meta.material],
        ['Height', meta.height],
        ['Type', meta.type]
      ].filter(function (fact) { return fact[1] && String(fact[1]).trim(); });
      var factsHtml = facts.length ? '<dl class="ciq-quick-view-body__facts">' + facts.map(function (fact) {
        return '<div class="ciq-quick-view-body__fact"><dt>' + escapeHtml(fact[0]) + '</dt><dd>' + escapeHtml(fact[1]) + '</dd></div>';
      }).join('') + '</dl>' : '';
      var trustHtml = '<div class="ciq-quick-view-body__trust" aria-label="Collector purchase protections">' +
        '<span><i aria-hidden="true">✓</i>Authentic collectibles</span>' +
        '<span><i aria-hidden="true">✓</i>Collector grade packaging</span>' +
        '<span><i aria-hidden="true">✓</i>Tracked shipping</span>' +
        '<span><i aria-hidden="true">✓</i>Secure checkout</span>' +
        '<span><i aria-hidden="true">✓</i>Collector support</span></div>';
      var collectorNote = meta.collectorNote
        ? '<p class="ciq-quick-view-body__social-proof">' + escapeHtml(meta.collectorNote) + '</p>'
        : badges.some(function (badge) { return /trending|collector favorite/i.test(badge); })
          ? '<p class="ciq-quick-view-body__social-proof">' + escapeHtml(badges.filter(function (badge) { return /trending|collector favorite/i.test(badge); })[0]) + ' in ' + escapeHtml(meta.franchise || 'the collection') + '</p>'
          : '';
      var wishlistId = meta.productId || buttonEl.getAttribute('data-product-id') || '';
      var productImage = imageSources[0] || buttonEl.getAttribute('data-product-image') || '';
      var productHandle = meta.productHandle || buttonEl.getAttribute('data-product-handle') || '';
      var collectionLabel = meta.franchise || meta.series || '';
      var collectionHref = collectionLabel ? '/search?q=' + encodeURIComponent(collectionLabel) + '&type=product' : '';
      var wishlistButtonHtml = wishlistId ? '<button type="button" class="ciq-quick-view-body__wishlist" data-coreiq-wishlist-btn data-product-id="' + escapeHtml(wishlistId) + '" data-product-handle="' + escapeHtml(productHandle) + '" data-product-title="' + escapeHtml(title) + '" data-product-image="' + escapeHtml(productImage) + '" data-product-price="' + escapeHtml(price) + '" data-product-variant-id="' + escapeHtml(defaultVariantId) + '" data-product-type="' + escapeHtml(meta.type || '') + '" data-product-genre="' + escapeHtml(meta.genre || '') + '" data-product-franchise="' + escapeHtml(meta.franchise || '') + '" data-product-series="' + escapeHtml(meta.series || '') + '" data-product-character="' + escapeHtml(meta.character || '') + '" data-product-number="' + escapeHtml(meta.productNumber || '') + '" data-product-release="' + escapeHtml(meta.release || '') + '" data-product-condition="' + escapeHtml(meta.condition || '') + '" data-product-material="' + escapeHtml(meta.material || '') + '" data-product-height="' + escapeHtml(meta.height || '') + '" data-product-exclusivity="' + escapeHtml(meta.exclusivity || '') + '" data-product-edition="' + escapeHtml(meta.edition || '') + '" aria-pressed="false"><span aria-hidden="true">♡</span> Save to wishlist</button>' : '';

      var variantsOptions = hasVariants
        ? variants
            .map(function (variant) {
              var disabled = variant.available ? '' : ' disabled';
              var selected = String(variant.id) === String(defaultVariantId) ? ' selected' : '';
              return '<option value="' + variant.id + '"' + disabled + selected + '>' + variant.title + (variant.available ? '' : ' - Sold out') + '</option>';
            })
            .join('')
        : '<option value="">Unavailable</option>';
      var optionGroups = hasOnlyDefaultTitleVariant ? '' : buildQuickViewOptionGroups(variants, defaultVariant);

      var slides = imageSources
        .map(function (src, idx) {
          var imageMeta = Array.isArray(meta.images) ? meta.images[idx] : null;
          var alt = imageMeta && imageMeta.alt ? imageMeta.alt : title + ' view ' + (idx + 1);
          return '<button type="button" data-coreiq-qv-swipe data-src="' + escapeHtml(src) + '"' + (idx === 0 ? ' class="is-active" aria-current="true"' : ' aria-current="false"') + ' aria-label="Show image ' + (idx + 1) + ' of ' + imageSources.length + ' for ' + escapeHtml(title) + '"><img src="' + escapeHtml(src) + '" alt="' + escapeHtml(alt) + '" loading="lazy"></button>';
        })
        .join('');

      var primaryImage = imageSources[0]
        ? '<img src="' + escapeHtml(imageSources[0]) + '" alt="' + escapeHtml(Array.isArray(meta.images) && meta.images[0] ? meta.images[0].alt || title : title) + '" data-coreiq-qv-main-image>'
        : '<div class="ciq-quick-view-body__media-placeholder" data-coreiq-qv-main-image>Preview unavailable</div>';

      return (
        '<div class="ciq-quick-view-body">' +
        '<div class="ciq-quick-view-body__media-column">' +
        '<div class="ciq-quick-view-body__gallery">' +
        '<div class="ciq-quick-view-body__media-shell">' +
        '<div class="ciq-quick-view-body__media">' + primaryImage + '</div>' +
        '</div>' +
        (slides ? '<div class="ciq-quick-view-body__swipe" aria-label="Product image views">' + slides + '</div>' : '') +
        '</div>' +
        wishlistButtonHtml +
        '</div>' +
        '<div class="ciq-quick-view-body__surface">' +
        '<div class="ciq-quick-view-body__meta">' +
        '<p class="ciq-quick-view-body__eyebrow">' + (collectionHref ? '<a href="' + escapeHtml(collectionHref) + '">' + escapeHtml(collectionLabel) + '</a>' : escapeHtml(vendor || 'PopChaser collectible')) + (meta.series && meta.franchise ? ' <span>·</span> ' + escapeHtml(meta.series) : '') + '</p>' +
        '<h2 class="ciq-quick-view-body__title" id="' + dialogTitleId + '">' + escapeHtml(title) + '</h2>' +
        (meta.character && String(meta.character).toLowerCase() !== title.toLowerCase() ? '<p class="ciq-quick-view-body__subtitle">' + escapeHtml(meta.character) + (meta.type ? ' <span>·</span> ' + escapeHtml(meta.type) : '') + '</p>' : meta.type ? '<p class="ciq-quick-view-body__subtitle">' + escapeHtml(meta.type) + '</p>' : '') +
        badgesHtml +
        '<div class="ciq-quick-view-body__price-row">' +
        (price ? '<p class="ciq-quick-view-body__price" data-coreiq-qv-price>' + escapeHtml(price) + '</p>' : '') +
        urgencyHtml +
        '</div>' +
        collectorNote +
        '</div>' +
        factsHtml +
        trustHtml +
        '<div class="ciq-quick-view-body__form">' +
        '<div class="ciq-quick-view-body__select-wrap ciq-quick-view-body__select-wrap--hidden"><label class="visually-hidden" for="ciq-qv-variant">Selected variant</label><select id="ciq-qv-variant" data-coreiq-qv-variant tabindex="-1" aria-hidden="true">' + variantsOptions + '</select></div>' +
        optionGroups +
        '<div class="ciq-quick-view-body__field">' +
        '<label class="ciq-quick-view-body__field-label" for="ciq-qv-qty">Quantity</label>' +
        '<div class="ciq-quick-view-body__qty-wrap">' +
        '<button type="button" class="ciq-quick-view-body__qty-step" data-coreiq-qv-qty-step="-1" aria-label="Decrease quantity">-</button>' +
        '<input id="ciq-qv-qty" type="number" min="1" value="1"' + (defaultInventoryAttrs ? ' max="' + Math.max(0, Number(defaultVariant.inventory_quantity)) + '" data-coreiq-qv-stock-limit="' + Math.max(0, Number(defaultVariant.inventory_quantity)) + '"' : '') + ' data-coreiq-qv-qty data-coreiq-qty-autosize>' +
        '<button type="button" class="ciq-quick-view-body__qty-step" data-coreiq-qv-qty-step="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="ciq-quick-view-body__actions">' +
        '<button type="button" class="ciq-btn ciq-btn--primary" data-coreiq-qv-add data-variant-id="' + escapeHtml(defaultVariantId) + '"' + defaultInventoryAttrs + (defaultVariantId && availabilityText !== 'Currently unavailable' ? '' : ' disabled') + '><span aria-hidden="true">＋</span> Add to cart</button>' +
        '<a class="ciq-btn ciq-btn--secondary" href="' + escapeHtml(productUrl) + '">View full details</a>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>'
      );
    }

    function getProductJsonUrl(productUrl) {
      if (!productUrl || productUrl === '#') return '';
      var cleanUrl = productUrl.split('?')[0].split('#')[0];
      if (!cleanUrl) return '';
      if (cleanUrl.slice(-3) === '.js') return cleanUrl;
      return cleanUrl.replace(/\/$/, '') + '.js';
    }

    function normalizeProductJsonVariants(productJson, fallbackPrice, purchasableVariantIds) {
      if (!productJson || !Array.isArray(productJson.variants)) return [];
      purchasableVariantIds = Array.isArray(purchasableVariantIds) ? purchasableVariantIds : [];
      return productJson.variants.map(function (variant) {
        var featuredImage = '';
        var variantId = String(variant.id || '');
        var isPurchasable = variant.available !== false || purchasableVariantIds.indexOf(variantId) !== -1;
        if (variant.featured_image) {
          featuredImage = variant.featured_image.src || variant.featured_image;
        }
        return {
          id: variant.id,
          title: variant.title || 'Default',
          available: isPurchasable,
          price: fallbackPrice || '',
          option_names: (productJson.options || []).map(function (option) {
            return option && option.name ? option.name : String(option || '');
          }).filter(Boolean),
          options: variant.options || [],
          inventory_management: variant.inventory_management || null,
          inventory_policy: variant.inventory_policy || null,
          inventory_quantity: variant.inventory_quantity != null ? variant.inventory_quantity : null,
          inventory_tracked: Boolean(variant.inventory_management && variant.inventory_quantity != null),
          featured_image: featuredImage || null,
          swatch_image: featuredImage || null
        };
      });
    }

    function fetchQuickViewVariants(buttonEl) {
      var productUrl = buttonEl.getAttribute('data-product-url') || '';
      var cardEl = buttonEl.closest('.ciq-product-card, .ciq-mini-card, .ciq-complementary-card');
      var purchasableVariantIdsRaw = buttonEl.getAttribute('data-coreiq-purchasable-variant-ids') ||
        (cardEl ? cardEl.getAttribute('data-coreiq-purchasable-variant-ids') : '') ||
        '';
      var purchasableVariantIds = purchasableVariantIdsRaw
        .split(',')
        .map(function (id) { return id.trim(); })
        .filter(Boolean);
      var productJsonUrl = getProductJsonUrl(productUrl);
      if (!productJsonUrl) return Promise.resolve([]);

      return fetch(productJsonUrl, { headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('Quick view product payload unavailable');
          return res.json();
        })
        .then(function (productJson) {
          return normalizeProductJsonVariants(productJson, buttonEl.getAttribute('data-product-price') || '', purchasableVariantIds);
        })
        .catch(function () {
          return [];
        });
    }

    function buildQuickViewFallbackMarkup(buttonEl, imageSources) {
      imageSources = (imageSources || []).filter(Boolean);
      var title = escapeHtml(buttonEl.getAttribute('data-product-title') || 'Product');
      var vendor = escapeHtml(buttonEl.getAttribute('data-product-vendor') || '');
      var price = escapeHtml(buttonEl.getAttribute('data-product-price') || '');
      var productUrl = escapeHtml(buttonEl.getAttribute('data-product-url') || '#');
      var primaryImage = imageSources[0]
        ? '<img src="' + escapeHtml(imageSources[0]) + '" alt="" data-coreiq-qv-main-image>'
        : '<div class="ciq-quick-view-body__media-placeholder" data-coreiq-qv-main-image>Preview unavailable</div>';

      return (
        '<div class="ciq-quick-view-body ciq-quick-view-body--fallback">' +
        '<div class="ciq-quick-view-body__media-column">' +
        '<div class="ciq-quick-view-body__media-shell">' +
        '<div class="ciq-quick-view-body__media">' + primaryImage + '</div>' +
        '</div>' +
        '</div>' +
        '<div class="ciq-quick-view-body__surface">' +
        '<div class="ciq-quick-view-body__meta">' +
        (vendor ? '<p class="ciq-quick-view-body__eyebrow">' + vendor + '</p>' : '<p class="ciq-quick-view-body__eyebrow">Quick view</p>') +
        '<h2 class="ciq-quick-view-body__title" id="ciq-qv-title">' + title + '</h2>' +
        (price ? '<p class="ciq-quick-view-body__price">' + price + '</p>' : '') +
        '<p class="ciq-quick-view-body__helper">Options are available on the product page.</p>' +
        '</div>' +
        '<div class="ciq-quick-view-body__actions">' +
        '<a class="ciq-btn ciq-btn--primary" href="' + productUrl + '">View details</a>' +
        '<button type="button" class="ciq-btn ciq-btn--secondary" data-coreiq-quick-view-close>Close</button>' +
        '</div>' +
        '</div>' +
        '</div>'
      );
    }

    function buildQuickViewLoadingMarkup(buttonEl, imageSources) {
      imageSources = (imageSources || []).filter(Boolean);
      var title = escapeHtml(buttonEl.getAttribute('data-product-title') || 'Product');
      var vendor = escapeHtml(buttonEl.getAttribute('data-product-vendor') || '');
      var price = escapeHtml(buttonEl.getAttribute('data-product-price') || '');
      var primaryImage = imageSources[0]
        ? '<img src="' + escapeHtml(imageSources[0]) + '" alt="" data-coreiq-qv-main-image>'
        : '<div class="ciq-quick-view-body__media-placeholder" data-coreiq-qv-main-image>Preview unavailable</div>';

      return (
        '<div class="ciq-quick-view-body ciq-quick-view-body--loading" aria-busy="true">' +
        '<div class="ciq-quick-view-body__media-column">' +
        '<div class="ciq-quick-view-body__media-shell">' +
        '<div class="ciq-quick-view-body__media">' + primaryImage + '</div>' +
        '</div>' +
        '<div class="ciq-quick-view-body__swipe ciq-quick-view-body__swipe--loading" aria-hidden="true">' +
        '<span></span><span></span>' +
        '</div>' +
        '</div>' +
        '<div class="ciq-quick-view-body__surface">' +
        '<div class="ciq-quick-view-body__meta">' +
        (vendor ? '<p class="ciq-quick-view-body__eyebrow">' + vendor + '</p>' : '<p class="ciq-quick-view-body__eyebrow">Quick view</p>') +
        '<h2 class="ciq-quick-view-body__title" id="ciq-qv-title">' + title + '</h2>' +
        '<div class="ciq-quick-view-body__price-row">' +
        (price ? '<p class="ciq-quick-view-body__price">' + price + '</p>' : '') +
        '<p class="ciq-quick-view-body__helper">Loading options...</p>' +
        '</div>' +
        '</div>' +
        '<div class="ciq-quick-view-body__form ciq-quick-view-body__form--loading" aria-hidden="true">' +
        '<span></span><span></span><span></span>' +
        '</div>' +
        '</div>' +
        '</div>'
      );
    }

    document.addEventListener('click', function (e) {
      var closeTrigger = e.target.closest('[data-coreiq-quick-view-close]');
      if (closeTrigger) {
        closeModal();
        return;
      }

      var quickViewBtn = e.target.closest('[data-coreiq-quick-view]');
      if (!quickViewBtn) return;

      var card = quickViewBtn.closest('.ciq-product-card, .ciq-mini-card, .ciq-complementary-card, .ciq-wishlist__item, .pc-wishlist__item');
      if (!card) return;

      var variantsScript = card.querySelector('[data-coreiq-product-variants]');
      var variants = [];
      if (variantsScript) {
        try {
          variants = JSON.parse(variantsScript.textContent || '[]');
        } catch (err) {
          variants = [];
        }
      }

      var imgs = card.querySelectorAll('.ciq-product-card__media img, .ciq-product-card__secondary-image img, .ciq-mini-card__media img');
      var imageSources = [];
      imgs.forEach(function (img) {
        if (img && img.src && imageSources.indexOf(img.src) === -1) imageSources.push(img.src);
      });

      var productMeta = getQuickViewProductMeta(quickViewBtn);
      if (Array.isArray(productMeta.images) && productMeta.images.length) {
        imageSources = productMeta.images.map(function (image) { return image && image.src; }).filter(Boolean);
      }

      var fallbackImage = quickViewBtn.getAttribute('data-product-image');
      if (!imageSources.length && fallbackImage) imageSources.push(fallbackImage);
      if (!imageSources.length) imageSources.push('');

      modal.setAttribute('aria-labelledby', 'ciq-qv-title');
      if (variants.length) {
        activeQuickViewVariants = variants;
        content.innerHTML = buildQuickViewMarkup(quickViewBtn, variants, imageSources, productMeta);
        updateQuickViewSelectionFromVariant(findQuickViewVariant(activeQuickViewVariants, getQuickViewSelectionsFromModal()));
        document.dispatchEvent(new CustomEvent('ciq:wishlist:updated'));
        initQuantityAutosize(content);
        openModal(quickViewBtn);
        return;
      }

      var requestId = activeQuickViewRequest + 1;
      var loadingShown = false;
      activeQuickViewRequest = requestId;
      var loadingTimer = window.setTimeout(function () {
        if (activeQuickViewRequest !== requestId) return;
        loadingShown = true;
        content.innerHTML = buildQuickViewLoadingMarkup(quickViewBtn, imageSources);
        openModal(quickViewBtn);
      }, 240);

      Promise.all([fetchQuickViewVariants(quickViewBtn), fetchQuickViewProductMeta(quickViewBtn, productMeta)]).then(function (results) {
        var lazyVariants = results[0];
        productMeta = results[1];
        window.clearTimeout(loadingTimer);
        if (activeQuickViewRequest !== requestId) return;
        if (loadingShown && (modal.hidden || activeTrigger !== quickViewBtn)) return;
        if (!lazyVariants.length) {
          content.innerHTML = buildQuickViewFallbackMarkup(quickViewBtn, imageSources);
          if (!loadingShown) openModal(quickViewBtn);
          return;
        }
        activeQuickViewVariants = lazyVariants;
        content.innerHTML = buildQuickViewMarkup(quickViewBtn, lazyVariants, imageSources, productMeta);
        updateQuickViewSelectionFromVariant(findQuickViewVariant(activeQuickViewVariants, getQuickViewSelectionsFromModal()));
        document.dispatchEvent(new CustomEvent('ciq:wishlist:updated'));
        initQuantityAutosize(content);
        if (!loadingShown) openModal(quickViewBtn);
      });
    });

    modal.addEventListener('change', function (e) {
      var variantSelect = e.target.closest('[data-coreiq-qv-variant]');
      if (variantSelect) {
        var addBtn = modal.querySelector('[data-coreiq-qv-add]');
        if (addBtn) addBtn.setAttribute('data-variant-id', variantSelect.value);
      }
      if (e.target.matches('[data-coreiq-qv-qty]')) syncQuickViewQuantityControls();
    });

    modal.addEventListener('input', function (e) {
      if (!e.target.matches('[data-coreiq-qv-qty]')) return;
      syncQuickViewQuantityControls();
      syncQuantityInputWidth(e.target);
    });

    modal.addEventListener('click', function (e) {
      var crossSellBtn = e.target.closest('[data-coreiq-qv-cross-sell-add]');
      if (crossSellBtn) {
        var crossSellVariantId = parseInt(crossSellBtn.getAttribute('data-variant-id') || '0', 10);
        if (!crossSellVariantId || crossSellBtn.disabled) return;
        crossSellBtn.disabled = true;
        crossSellBtn.textContent = 'Adding…';
        window.CiqInventoryGuard.add({ id: crossSellVariantId, quantity: 1 }, crossSellBtn).then(function (response) {
          if (!response.ok) throw new Error('Quick add failed');
          return response.json();
        }).then(function (item) {
          animateAddToCart(crossSellBtn, item);
          crossSellBtn.textContent = 'Added';
          fetchCartState().then(function (cart) {
            updateCartCountBadge(cart.item_count || 0);
            var openCartDrawer = document.getElementById('cart-drawer');
            if (openCartDrawer && openCartDrawer.hasAttribute('open')) renderCartDrawer(cart);
            announceCartUpdate(cart.item_count || 0);
          }).catch(function () {});
        }).catch(function () {
          crossSellBtn.textContent = 'Try again';
          crossSellBtn.disabled = false;
        });
        return;
      }

      var optionBtn = e.target.closest('[data-coreiq-qv-option-value]');
      if (optionBtn) {
        var optionIndex = parseInt(optionBtn.getAttribute('data-coreiq-qv-option-index') || '0', 10);
        var optionValue = optionBtn.getAttribute('data-coreiq-qv-option-value') || '';
        modal.querySelectorAll('[data-coreiq-qv-option-index="' + optionIndex + '"]').forEach(function (button) {
          button.classList.toggle('is-selected', button === optionBtn);
          button.setAttribute('aria-pressed', button === optionBtn ? 'true' : 'false');
        });
        var selections = getQuickViewSelectionsFromModal();
        selections[optionIndex] = optionValue;
        updateQuickViewSelectionFromVariant(findQuickViewVariant(activeQuickViewVariants, selections));
        return;
      }

      var swipeBtn = e.target.closest('[data-coreiq-qv-swipe]');
      if (swipeBtn) {
        var src = swipeBtn.getAttribute('data-src');
        var mainImage = modal.querySelector('[data-coreiq-qv-main-image]');
        if (mainImage && src && mainImage.tagName === 'IMG') {
          mainImage.src = src;
          var thumbImage = swipeBtn.querySelector('img');
          if (thumbImage) mainImage.alt = thumbImage.alt;
          mainImage.classList.remove('is-switching');
          void mainImage.offsetWidth;
          mainImage.classList.add('is-switching');
        }
        modal.querySelectorAll('[data-coreiq-qv-swipe]').forEach(function (thumb) {
          var isActive = thumb === swipeBtn;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }

      var qtyStepBtn = e.target.closest('[data-coreiq-qv-qty-step]');
      if (qtyStepBtn) {
        var qtyInput = modal.querySelector('[data-coreiq-qv-qty]');
        if (!qtyInput) return;
        var step = parseInt(qtyStepBtn.getAttribute('data-coreiq-qv-qty-step') || '0', 10);
        var currentValue = Math.max(1, parseInt(qtyInput.value || '1', 10));
        var nextValue = Math.max(1, currentValue + step);
        var maxQty = parseInt(qtyInput.getAttribute('max') || '', 10);
        if (Number.isFinite(maxQty)) nextValue = Math.min(Math.max(1, maxQty), nextValue);
        qtyInput.value = String(nextValue);
        syncQuantityInputWidth(qtyInput);
        syncQuickViewQuantityControls();
        return;
      }

      var addBtn = e.target.closest('[data-coreiq-qv-add]');
      if (!addBtn) return;

      var variantId = parseInt(addBtn.getAttribute('data-variant-id') || '0', 10);
      var qtyInput = modal.querySelector('[data-coreiq-qv-qty]');
      var quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value || '1', 10)) : 1;
      if (!variantId) return;

      addBtn.textContent = 'Adding...';
      addBtn.setAttribute('disabled', 'disabled');
      addBtn.setAttribute('data-coreiq-qv-pending', 'true');

      window.CiqInventoryGuard.add({ id: variantId, quantity: quantity }, addBtn)
        .then(function (res) {
          if (!res.ok) throw new Error('Quick view add failed');
          return res.json();
        })
          .then(function (item) {
            emitCartAddAnalytics(item, {
              actionSource: 'quick-view',
              variantId: variantId,
              quantity: quantity
            });
          animateAddToCart(addBtn, item);
          fetchCartState().then(function (cart) {
            var openCartDrawer = document.getElementById('cart-drawer');
            if (openCartDrawer && openCartDrawer.hasAttribute('open')) {
              renderCartDrawer(cart);
            }
            announceCartUpdate(cart.item_count || 0);
          }).catch(function () {});
          addBtn.textContent = 'Added';
          setTimeout(closeModal, 500);
        })
        .catch(function () {
          addBtn.textContent = 'Try again';
          addBtn.removeAttribute('data-coreiq-qv-pending');
          addBtn.removeAttribute('disabled');
        });
    });

    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;

      if (e.key === 'Escape') {
        closeModal();
        return;
      }

      if (e.key === 'Tab') {
        if (a11y && typeof a11y.trapTabKey === 'function') {
          a11y.trapTabKey(e, modal);
        }
      }
    });
  })();

  /* â”€â”€ Announcement countdown â”€â”€ */
  function initAnnouncementCountdown() {
    function formatRemaining(ms) {
      var totalSeconds = Math.max(0, Math.floor(ms / 1000));
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      return [hours, minutes, seconds]
        .map(function (value) { return String(value).padStart(2, '0'); })
        .join(':');
    }

    function formatRemainingUnits(ms) {
      var totalSeconds = Math.max(0, Math.floor(ms / 1000));
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      return [
        { value: days, label: 'Days', a11y: 'days' },
        { value: hours, label: 'Hrs', a11y: 'hours' },
        { value: minutes, label: 'Mins', a11y: 'minutes' },
        { value: seconds, label: 'Secs', a11y: 'seconds' }
      ];
    }

    function renderRemainingUnits(timerEl, units) {
      var html = units.map(function (unit) {
        return '<span class="ciq-navigation-countdown__unit"><strong>' + String(unit.value).padStart(2, '0') + '</strong><small>' + unit.label + '</small></span>';
      }).join('');
      var a11yLabel = units.map(function (unit) {
        return unit.value + ' ' + unit.a11y;
      }).join(', ');

      timerEl.innerHTML = html;
      timerEl.setAttribute('aria-label', a11yLabel);
    }

    function tick() {
      var timers = document.querySelectorAll('[data-coreiq-announcement-countdown], [data-coreiq-announcement-countdown]');
      if (!timers.length) return;

      timers.forEach(function (timerWrap) {
        var endValue = timerWrap.getAttribute('data-countdown-end');
        var timerEl = timerWrap.querySelector('.ciq-announcement__countdown-timer');
        var displayStyle = timerWrap.getAttribute('data-countdown-display') || 'compact';
        if (!endValue || !timerEl) return;

        var targetTime = new Date(endValue).getTime();
        if (!targetTime || Number.isNaN(targetTime)) return;

        var remaining = targetTime - Date.now();
        if (remaining <= 0) {
          timerEl.removeAttribute('aria-label');
          timerEl.textContent = timerWrap.getAttribute('data-countdown-complete') || 'Offer ending soon';
          timerWrap.classList.add('is-complete');
          return;
        }

        timerWrap.classList.remove('is-complete');
        if (displayStyle === 'units') {
          renderRemainingUnits(timerEl, formatRemainingUnits(remaining));
        } else {
          timerEl.textContent = formatRemaining(remaining);
          timerEl.removeAttribute('aria-label');
        }
      });
    }

    tick();
    if (!window.__coreiqAnnouncementCountdownInterval) {
      window.__coreiqAnnouncementCountdownInterval = window.setInterval(tick, 1000);
    }
  }

  initAnnouncementCountdown();

  /* â”€â”€ Announcement promo rotator â”€â”€ */
  function initAnnouncementRotator(root) {
    var rotators = (root || document).querySelectorAll('[data-coreiq-announcement-rotator], [data-coreiq-announcement-rotator]');
    if (!rotators.length) return;

    rotators.forEach(function (rotator) {
      if (rotator.__coreiqRotateHideTimer) {
        window.clearTimeout(rotator.__coreiqRotateHideTimer);
        rotator.__coreiqRotateHideTimer = null;
      }

      if (rotator.__coreiqRotateInterval) {
        window.clearInterval(rotator.__coreiqRotateInterval);
        rotator.__coreiqRotateInterval = null;
      }

      var bar = rotator.closest('.ciq-announcement');
      var isEditorPreview = !!(bar && bar.classList.contains('ciq-announcement--editor-preview'));
      var effect = String(rotator.getAttribute('data-coreiq-rotation-effect') || 'fade').trim().toLowerCase();
      var transitionMs = effect === 'none' ? 0 : 260;

      function clearSlideState(slide) {
        if (!slide) return;
        if (slide.__coreiqRotateActivateFrame) {
          window.cancelAnimationFrame(slide.__coreiqRotateActivateFrame);
          slide.__coreiqRotateActivateFrame = null;
        }
        if (slide.__coreiqRotateActivateFrame2) {
          window.cancelAnimationFrame(slide.__coreiqRotateActivateFrame2);
          slide.__coreiqRotateActivateFrame2 = null;
        }
        slide.classList.remove('is-active');
        slide.classList.remove('is-exiting');
        slide.hidden = true;
        slide.setAttribute('aria-hidden', 'true');
      }

      function showSlide(slide) {
        if (!slide) return;
        if (slide.__coreiqRotateActivateFrame) {
          window.cancelAnimationFrame(slide.__coreiqRotateActivateFrame);
          slide.__coreiqRotateActivateFrame = null;
        }
        if (slide.__coreiqRotateActivateFrame2) {
          window.cancelAnimationFrame(slide.__coreiqRotateActivateFrame2);
          slide.__coreiqRotateActivateFrame2 = null;
        }
        slide.hidden = false;
        slide.classList.remove('is-active');
        slide.classList.remove('is-exiting');
        slide.setAttribute('aria-hidden', 'false');

        if (transitionMs === 0) {
          slide.classList.add('is-active');
          return;
        }

        slide.__coreiqRotateActivateFrame = window.requestAnimationFrame(function () {
          slide.__coreiqRotateActivateFrame = null;
          if (!document.body.contains(slide)) return;

          slide.__coreiqRotateActivateFrame2 = window.requestAnimationFrame(function () {
            slide.__coreiqRotateActivateFrame2 = null;
            if (!document.body.contains(slide)) return;
            slide.classList.add('is-active');
          });
        });
      }

      function transitionToSlide(prevSlide, nextSlide) {
        if (!nextSlide) return;

        if (!prevSlide || prevSlide === nextSlide || transitionMs === 0) {
          if (prevSlide && prevSlide !== nextSlide) {
            clearSlideState(prevSlide);
          }
          showSlide(nextSlide);
          return;
        }

        prevSlide.classList.remove('is-active');
        prevSlide.classList.add('is-exiting');
        prevSlide.setAttribute('aria-hidden', 'true');

        showSlide(nextSlide);

        if (rotator.__coreiqRotateHideTimer) {
          window.clearTimeout(rotator.__coreiqRotateHideTimer);
        }

        rotator.__coreiqRotateHideTimer = window.setTimeout(function () {
          clearSlideState(prevSlide);
          rotator.__coreiqRotateHideTimer = null;
        }, transitionMs);
      }

      var allSlides = Array.prototype.slice.call(rotator.querySelectorAll('.ciq-announcement__slide'));
      if (!allSlides.length) return;

      var slides = [];
      if (!isEditorPreview) {
        slides = allSlides.filter(function (slide) {
          return String(slide.getAttribute('data-coreiq-promo-visible') || 'false') === 'true';
        });
      }

      if (!slides.length) {
        slides = allSlides.filter(function (slide) {
          return slide.hidden !== true;
        });
      }

      if (!slides.length) {
        slides = allSlides.slice();
      }

      if (isEditorPreview) {
        var slotted = [];
        var unslotted = [];

        allSlides.forEach(function (slide) {
          var slot = getAnnouncementSlideSlot(slide);
          if (slot) {
            slotted.push(slide);
          } else {
            unslotted.push(slide);
          }
        });

         var editorSlides = allSlides;
        var frames = getAnnouncementPairedFrames(editorSlides);

        if (frames.length === 0) {
          frames = unslotted.map(function (slide) { return [slide]; });
        }

        function hideAllSlides() {
          allSlides.forEach(function (slide) {
            clearSlideState(slide);
          });
        }

        if (frames.length > 0) {
          var frameIndex = 0;

          function showFrame(idx) {
            hideAllSlides();
            var activeFrame = frames[idx] || [];
            activeFrame.forEach(function (slide) {
              slide.hidden = false;
              slide.classList.add('is-active');
              slide.setAttribute('aria-hidden', 'false');
            });
            applyAnnouncementSlideStyle(bar, activeFrame[0] || null);
            syncHeaderStackHeight();
          }

          showFrame(frameIndex);

          if (frames.length > 1) {
            rotator.__coreiqRotateInterval = window.setInterval(function () {
              if (!document.body.contains(rotator)) {
                window.clearInterval(rotator.__coreiqRotateInterval);
                rotator.__coreiqRotateInterval = null;
                return;
              }
              frameIndex = (frameIndex + 1) % frames.length;
              showFrame(frameIndex);
            }, Math.max(3000, parseInt(rotator.getAttribute('data-rotate-ms') || '4000', 10)));
          }
          return;
        }

        slides = editorSlides;
      }

      if (slides.length <= 1) return;

      var rotateMs = parseInt(rotator.getAttribute('data-rotate-ms') || '4000', 10);
      var currentIndex = 0;


      slides.forEach(function (slide, index) {
        if (index === 0) {
          showSlide(slide);
        } else {
          clearSlideState(slide);
        }
      });
      applyAnnouncementSlideStyle(bar, null);
      syncHeaderStackHeight();

      rotator.__coreiqRotateInterval = window.setInterval(function () {
        if (!document.body.contains(rotator)) {
          window.clearInterval(rotator.__coreiqRotateInterval);
          rotator.__coreiqRotateInterval = null;
          return;
        }

        var previousIndex = currentIndex;
        currentIndex = (currentIndex + 1) % slides.length;
        transitionToSlide(slides[previousIndex], slides[currentIndex]);
        applyAnnouncementSlideStyle(bar, null);
        syncHeaderStackHeight();
      }, Math.max(3000, rotateMs));
    });
  }

  function syncCompactHeaderState() {
    var header = document.querySelector('.ciq-header');
    if (!header) return;

    function scheduleCompactStackSync() {
      if (header.__coreiqCompactSyncTimer) {
        window.clearTimeout(header.__coreiqCompactSyncTimer);
        header.__coreiqCompactSyncTimer = null;
      }

      header.__coreiqCompactSyncTimer = window.setTimeout(function () {
        if (!document.body.contains(header)) return;
        syncHeaderStackHeight();
        syncUnderlapHeaderMode();
      }, 220);
    }

    var announcementBar = document.querySelector('.ciq-announcement');
    var announcementStickyEnabled = announcementBar && announcementBar.getAttribute('data-sticky-enabled') === 'true';
    if (typeof header.__coreiqStickyCompactSetting === 'undefined') {
      header.__coreiqStickyCompactSetting = header.getAttribute('data-sticky-compact-enabled') === 'true';
    }
    var compactEnabled = header.__coreiqStickyCompactSetting && !window.matchMedia('(max-width: 989px)').matches;
    var explicitHeaderStickyEnabled = header.getAttribute('data-sticky-enabled') === 'true';
    var stickyActive = header.classList.contains('ciq-header--sticky') || header.classList.contains('ciq-header--fixed');
    var shouldSticky = announcementStickyEnabled || explicitHeaderStickyEnabled;

    if (shouldSticky !== stickyActive) {
      syncHeaderStackHeight();
      scheduleCompactStackSync();
      stickyActive = shouldSticky;
    }

    var scrollY = window.scrollY || window.pageYOffset || 0;
    var wasCompact = header.classList.contains('ciq-header--compact');
    var compactEnterY = 64;
    var compactExitY = 2;
    var shouldCompact = compactEnabled && stickyActive && (wasCompact ? scrollY > compactExitY : scrollY > compactEnterY);

    if (wasCompact !== shouldCompact) {
      if (!shouldCompact) {
        // Expanding (compact -> full): suppress the header __inner transition for this
        // frame so the header jumps to full size instantly, then update --ciq-fixed-stack-height
        // in the same layout pass — eliminating the ~56px gap caused by the 220ms deferred
        // timer firing after the header had already grown visually.
        var headerInner = header.querySelector('.ciq-header__inner');
        if (headerInner) {
          headerInner.style.transition = 'none';
        }
        header.classList.remove('ciq-header--compact');
        // Force layout so the browser commits the full height before we measure.
        void header.offsetHeight;
        syncHeaderStackHeight();
        syncUnderlapHeaderMode();
        // Re-enable transition on the next frame so the compact (shrink) direction
        // still animates smoothly.
        requestAnimationFrame(function () {
          if (headerInner) {
            headerInner.style.transition = '';
          }
        });
      } else {
        var compactHeaderInner = header.querySelector('.ciq-header__inner');
        if (compactHeaderInner) {
          compactHeaderInner.style.transition = 'none';
        }
        header.classList.add('ciq-header--compact');
        void header.offsetHeight;
        syncHeaderStackHeight();
        syncUnderlapHeaderMode();
        requestAnimationFrame(function () {
          if (compactHeaderInner) {
            compactHeaderInner.style.transition = '';
          }
        });
      }
    } else {
      header.classList.toggle('ciq-header--compact', shouldCompact);
    }
  }

  syncCompactHeaderState();
  window.addEventListener('scroll', syncCompactHeaderState, { passive: true });
  window.addEventListener('resize', function () {
    var header = document.querySelector('.ciq-header');
    if (header) header.__coreiqReservedHeaderHeight = null;
    syncCompactHeaderState();
  });
  document.addEventListener('coreiq:sticky-sync', syncCompactHeaderState);

  function syncQuantityInputWidth(input) {
    if (!input) return;
    var valueLength = String(input.value || input.getAttribute('placeholder') || '1').length;
    input.style.setProperty('--ciq-qty-digits', Math.max(1, valueLength));
  }

  function initQuantityAutosize(root) {
    (root || document).querySelectorAll('[data-coreiq-qty-autosize]').forEach(function (input) {
      syncQuantityInputWidth(input);
    });
  }

  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-coreiq-qty-autosize]');
    if (!input) return;
    syncQuantityInputWidth(input);
  });

  initQuantityAutosize(document);
  document.addEventListener('shopify:section:load', function (event) {
    initQuantityAutosize(event.target || document);
  });

  /* â”€â”€ Main product enhancements: gallery, variants, sticky ATC â”€â”€ */
  (function initMainProductEnhancements() {
    var productSection = document.querySelector('[data-coreiq-main-product]');
    if (!productSection) return;
    var a11y = window.CoreIQA11y || null;
    var mediaInteraction = productSection.getAttribute('data-coreiq-media-interaction') || 'expand';
    var galleryPreset = productSection.getAttribute('data-coreiq-gallery-preset') || 'default';
    var galleryVariantMediaMode = productSection.getAttribute('data-coreiq-gallery-variant-media-mode') || 'all';
    var galleryColorGroupOrder = productSection.getAttribute('data-coreiq-gallery-color-group-order') || 'side_by_side';
    var reduceGalleryMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var variantsScript = productSection.querySelector('[data-coreiq-main-product-variants]') || productSection.querySelector('[data-coreiq-product-variants]');
    var variants = [];
    try {
      variants = JSON.parse((variantsScript && variantsScript.textContent) || '[]');
    } catch (e) {
      variants = [];
    }

    var variantSelect = productSection.querySelector('[data-coreiq-variant-select]');
    var productQtyInput = productSection.querySelector('.ciq-main-product__qty');
    var optionButtons = productSection.querySelectorAll('[data-coreiq-option-value]');
    var optionGroups = productSection.querySelectorAll('[data-coreiq-option-group]');
    var addBtn = productSection.querySelector('[data-coreiq-product-add]');
    var dynamicCheckout = productSection.querySelector('[data-coreiq-dynamic-checkout]');
    var priceEl = productSection.querySelector('[data-coreiq-product-price]');
    var unitPriceEl = productSection.querySelector('[data-coreiq-product-unit-price]');
    var compareEl = productSection.querySelector('[data-coreiq-product-compare]');
    var badgeEl = productSection.querySelector('[data-coreiq-product-badge]');
    var inventoryEl = productSection.querySelector('[data-coreiq-product-inventory]');
    var urgencyEl = productSection.querySelector('[data-coreiq-urgency]');
    var sellingPlanGroup = productSection.querySelector('[data-coreiq-selling-plan-group]');
    var sellingPlanOneTimeLabel = sellingPlanGroup ? (sellingPlanGroup.getAttribute('data-coreiq-one-time-purchase') || 'One-time purchase') : 'One-time purchase';
    var fitConfidenceSection = productSection.querySelector('[data-coreiq-fit-confidence]');
    var fitNoteEl = fitConfidenceSection ? fitConfidenceSection.querySelector('[data-coreiq-fit-note]') : null;
    var fitNoteSource = fitConfidenceSection ? (fitConfidenceSection.getAttribute('data-fit-note-source') || 'product') : 'product';
    var productFitNote = fitConfidenceSection ? (fitConfidenceSection.getAttribute('data-product-fit-note') || '') : '';
    var productModelDetails = fitConfidenceSection ? (fitConfidenceSection.getAttribute('data-product-model-details') || '') : '';
    var productFabricFeel = fitConfidenceSection ? (fitConfidenceSection.getAttribute('data-product-fabric-feel') || '') : '';
    var fitGridEl = fitConfidenceSection ? fitConfidenceSection.querySelector('[data-coreiq-fit-grid]') : null;
    var modelDetailsEl = fitConfidenceSection ? fitConfidenceSection.querySelector('[data-coreiq-model-details]') : null;
    var modelDetailsTextEl = fitConfidenceSection ? fitConfidenceSection.querySelector('[data-coreiq-model-details-text]') : null;
    var fabricFeelEl = fitConfidenceSection ? fitConfidenceSection.querySelector('[data-coreiq-fabric-feel]') : null;
    var fabricFeelTextEl = fitConfidenceSection ? fitConfidenceSection.querySelector('[data-coreiq-fabric-feel-text]') : null;
    var pickupWrap = productSection.querySelector('[data-coreiq-product-pickup]');
    var pickupTitle = productSection.querySelector('[data-coreiq-product-pickup-title]');
    var pickupText = productSection.querySelector('[data-coreiq-product-pickup-text]');
    var backInStockWrap = productSection.querySelector('[data-coreiq-back-in-stock]');
    var backInStockBody = productSection.querySelector('[data-coreiq-back-in-stock-body]');
    var backInStockTags = productSection.querySelector('[data-coreiq-back-in-stock-tags]');
    var backInStockVariantTitle = productSection.querySelector('[data-coreiq-back-in-stock-variant-title]');
    var backInStockVariantId = productSection.querySelector('[data-coreiq-back-in-stock-variant-id]');
    var backInStockSku = productSection.querySelector('[data-coreiq-back-in-stock-sku]');
    var backInStockUrl = productSection.querySelector('[data-coreiq-back-in-stock-url]');
    var backInStockStatus = productSection.querySelector('[data-coreiq-back-in-stock-status]');
    var backInStockNativeForm = productSection.querySelector('[data-coreiq-back-in-stock-native-form]');
    var productDataFields = productSection.querySelectorAll('[data-coreiq-pdp-data-field]');
    var preorderNotice = productSection.querySelector('[data-coreiq-preorder-notice]');
    var preorderMessage = productSection.querySelector('[data-coreiq-preorder-message]');
    var preorderDate = productSection.querySelector('[data-coreiq-preorder-date]');
    var preorderDefaultMessage = preorderNotice ? (preorderNotice.getAttribute('data-coreiq-preorder-default-message') || 'Pre-order available.') : 'Pre-order available.';
    var preorderDatePrefix = preorderNotice ? (preorderNotice.getAttribute('data-coreiq-preorder-date-prefix') || 'Estimated arrival') : 'Estimated arrival';
    var preorderCtaLabel = preorderNotice ? (preorderNotice.getAttribute('data-coreiq-preorder-cta-label') || 'Pre-order') : 'Pre-order';
    var stickyAtc = productSection.querySelector('[data-coreiq-sticky-atc]');
    var stickyImage = productSection.querySelector('[data-coreiq-sticky-image]');
    var stickyPrice = productSection.querySelector('[data-coreiq-sticky-price]');
    var stickyVariant = productSection.querySelector('[data-coreiq-sticky-variant]');
    var stickyConfirm = productSection.querySelector('[data-coreiq-sticky-confirm]');
    var stickyInventoryMessage = productSection.querySelector('[data-coreiq-sticky-inventory-message]');
    var stickyAddBtn = productSection.querySelector('[data-coreiq-sticky-add]');
    var stickyDismissBtn = productSection.querySelector('[data-coreiq-sticky-dismiss]');
    var stickyAtcDismissed = false;
    var variantUrlSyncTimer = null;
    var productForm = productSection.querySelector('[data-coreiq-product-form]');
    var productInfo = productSection.querySelector('.ciq-main-product__info');
    var backInStockSubmittedVariantId = '';
    var galleryItems = productSection.querySelectorAll('[data-coreiq-gallery-media-item]');
    var thumbs = productSection.querySelectorAll('[data-coreiq-gallery-thumb]');
    var galleryFocusBridge = productSection.querySelector('[data-coreiq-gallery-focus-bridge]');
    var galleryPrevBtn = productSection.querySelector('[data-coreiq-gallery-prev]');
    var galleryNextBtn = productSection.querySelector('[data-coreiq-gallery-next]');
    var galleryCounter = productSection.querySelector('[data-coreiq-gallery-counter]');
    var cinematicPreviews = productSection.querySelectorAll('[data-coreiq-cinematic-preview]');
    var mediaModal = productSection.querySelector('[data-coreiq-media-modal]');
    var mediaModalPanel = productSection.querySelector('[data-coreiq-media-modal-panel]');
    var mediaModalItems = productSection.querySelectorAll('[data-coreiq-modal-media-item]');
    var mediaModalThumbs = productSection.querySelectorAll('[data-coreiq-modal-thumb]');
    var expandButtons = productSection.querySelectorAll('[data-coreiq-gallery-expand]');
    var activeMediaId = '';
    var gallery = productSection.querySelector('[data-coreiq-product-gallery]');

    function syncLayeredGalleryAspectRatio() {
      if (galleryPreset !== 'layered' || !gallery) return;
      var images = [];
      Array.prototype.forEach.call(galleryItems, function (item) {
        var image = item.querySelector('img');
        if (!image) return;
        images.push(image);
        if (!image.complete) image.addEventListener('load', syncLayeredGalleryAspectRatio, { once: true });
      });
      var tallestRatio = 0;
      images.forEach(function (image) {
        if (!image.naturalWidth || !image.naturalHeight) return;
        var ratio = image.naturalWidth / image.naturalHeight;
        if (ratio > 0 && (!tallestRatio || ratio < tallestRatio)) tallestRatio = ratio;
      });
      if (tallestRatio) gallery.style.setProperty('--ciq-gallery-media-ratio', tallestRatio);
    }

    function getStableMediaOrder(mediaId) {
      var value = String(mediaId || '');
      var hash = 0;
      for (var i = 0; i < value.length; i++) {
        hash = ((hash << 5) - hash) + value.charCodeAt(i);
        hash |= 0;
      }
      return Math.abs(hash % 1000);
    }

    function syncGalleryColorGroupOrder() {
      var controls = Array.prototype.slice.call(thumbs).concat(Array.prototype.slice.call(mediaModalThumbs));
      controls.forEach(function (item, index) {
        if (galleryColorGroupOrder === 'random') {
          item.style.order = getStableMediaOrder(item.getAttribute('data-media-id')) + index;
        } else {
          item.style.removeProperty('order');
        }
      });
    }

    function animateActiveGalleryMedia(mediaId, previousMediaId) {
      if (reduceGalleryMotion || !mediaId || String(mediaId) === String(previousMediaId || '')) return;
      var activeItem = Array.prototype.find.call(galleryItems, function (item) {
        return String(item.getAttribute('data-media-id') || '') === String(mediaId) && !item.hidden;
      });
      if (!activeItem) return;
      activeItem.classList.remove('is-gallery-entering');
      activeItem.offsetWidth;
      activeItem.classList.add('is-gallery-entering');
    }

    function syncMediaCollection(items, mediaId, toggleHidden) {
      items.forEach(function (item) {
        var isActive = String(item.getAttribute('data-media-id') || '') === String(mediaId);
        item.classList.toggle('is-active', isActive);
        if (item.matches && item.matches('[data-coreiq-gallery-thumb], [data-coreiq-modal-thumb]')) {
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          item.removeAttribute('aria-current');
        }
        if (toggleHidden || (item.matches && item.matches('[data-coreiq-gallery-media-item]'))) {
          item.hidden = !isActive;
        }
      });
    }

    function syncGalleryCounter(mediaId) {
      if (!galleryCounter) return;
      var visibleThumbs = getVisibleThumbs();
      var index = visibleThumbs.findIndex(function (thumb) {
        return String(thumb.getAttribute('data-media-id') || '') === String(mediaId || '');
      });
      if (index < 0) index = 0;
      galleryCounter.textContent = (index + 1) + ' / ' + visibleThumbs.length;
    }

    function syncCinematicPreviews(mediaId) {
      if (!cinematicPreviews.length) return;
      var visibleThumbs = getVisibleThumbs();
      if (visibleThumbs.length < 2) {
        cinematicPreviews.forEach(function (preview) { preview.hidden = true; });
        return;
      }
      var activeIndex = visibleThumbs.findIndex(function (thumb) {
        return String(thumb.getAttribute('data-media-id') || '') === String(mediaId || '');
      });
      if (activeIndex < 0) activeIndex = 0;

      cinematicPreviews.forEach(function (preview, index) {
        var offset = index === 0 ? -1 : 1;
        var sourceThumb = visibleThumbs[(activeIndex + offset + visibleThumbs.length) % visibleThumbs.length];
        var sourceMediaId = sourceThumb ? sourceThumb.getAttribute('data-media-id') : '';
        var sourceMediaItem = Array.prototype.find.call(galleryItems, function (item) {
          return String(item.getAttribute('data-media-id') || '') === String(sourceMediaId || '');
        });
        var sourceImage = (sourceMediaItem && sourceMediaItem.querySelector('img')) || (sourceThumb && sourceThumb.querySelector('img'));
        var targetImage = preview.querySelector('img');
        if (!sourceImage || !targetImage) {
          preview.hidden = true;
          preview.removeAttribute('data-media-id');
          return;
        }
        var imageSrc = sourceImage.currentSrc || sourceImage.src || '';
        if (imageSrc) targetImage.src = imageSrc;
        var sourceSet = sourceImage.getAttribute('srcset');
        if (sourceSet) targetImage.setAttribute('srcset', sourceSet);
        else targetImage.removeAttribute('srcset');
        preview.setAttribute('data-media-id', sourceMediaId);
        preview.setAttribute('aria-label', 'View ' + (index === 0 ? 'previous' : 'next') + ' product media');
        preview.hidden = false;
      });
    }

    function activateMediaById(mediaId) {
      if (!mediaId) return;
      var previousMediaId = activeMediaId;
      activeMediaId = String(mediaId);

      syncMediaCollection(galleryItems, mediaId, galleryVariantMediaMode === 'active_option');
      syncMediaCollection(thumbs, mediaId, false);
      syncMediaCollection(mediaModalItems, mediaId, true);
      syncMediaCollection(mediaModalThumbs, mediaId, false);
      syncGalleryNav(mediaId);
      syncGalleryCounter(mediaId);
      syncCinematicPreviews(mediaId);
      syncLayeredGalleryAspectRatio();
      animateActiveGalleryMedia(mediaId, previousMediaId);
    }

    // Expanded-media navigation must not change the page gallery. Keeping the
    // modal state local also guarantees that only one modal item is visible
    // after switching between media with different dimensions.
    function activateModalMediaById(mediaId) {
      if (!mediaId) return null;
      var target = Array.prototype.find.call(mediaModalItems, function (item) {
        return String(item.getAttribute('data-media-id') || '') === String(mediaId);
      });
      if (!target) return null;

      mediaModalItems.forEach(function (item) {
        var isTarget = item === target;
        item.classList.toggle('is-active', isTarget);
        item.classList.remove('is-zoomed', 'is-panning');
        item.hidden = !isTarget;
        item.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
        item.scrollLeft = 0;
        item.scrollTop = 0;
        item.style.setProperty('display', isTarget ? 'block' : 'none', 'important');
        item.style.setProperty('visibility', isTarget ? 'visible' : 'hidden', 'important');
        item.style.setProperty('opacity', isTarget ? '1' : '0', 'important');

        var image = item.querySelector('img');
        if (image) {
          image.style.setProperty('display', isTarget ? 'block' : 'none', 'important');
          image.style.setProperty('visibility', isTarget ? 'visible' : 'hidden', 'important');
          image.style.setProperty('opacity', isTarget ? '1' : '0', 'important');
        }
      });
      syncMediaCollection(mediaModalThumbs, mediaId, false);
      syncModalZoomControl(target);
      return target;
    }

    function syncModalZoomControl(item) {
      var button = mediaModal && mediaModal.querySelector('[data-coreiq-modal-zoom]');
      if (!button) return;
      var zoomed = !!(item && item.classList.contains('is-zoomed'));
      button.hidden = !item || !item.querySelector('[data-coreiq-media-pan-image]');
      button.setAttribute('aria-pressed', zoomed ? 'true' : 'false');
      button.textContent = zoomed ? 'Fit image' : 'Zoom in';
    }

    function toggleModalZoom(item) {
      if (!item) return;
      var zoomed = item.classList.toggle('is-zoomed');
      item.scrollLeft = 0;
      item.scrollTop = 0;
      syncModalZoomControl(item);
      if (zoomed) window.requestAnimationFrame(function () {
        item.scrollLeft = Math.max(0, (item.scrollWidth - item.clientWidth) / 2);
        item.scrollTop = Math.max(0, (item.scrollHeight - item.clientHeight) / 2);
      });
    }

    function normalizeMediaPath(url) {
      if (!url || typeof URL === 'undefined') return '';
      try {
        return new URL(url, window.location.origin).pathname;
      } catch (e) {
        return '';
      }
    }

    function normalizeMediaToken(url) {
      var path = normalizeMediaPath(url);
      if (!path) return '';
      var fileName = path.split('/').pop() || '';
      try {
        fileName = decodeURIComponent(fileName);
      } catch (e) {
        // Keep the original filename if it cannot be decoded.
      }
      return fileName.toLowerCase().replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|\d+x|x\d+)(?=\.)/, '');
    }

    function mediaUrlsFromImage(image) {
      if (!image) return [];
      var urls = [];
      if (image.currentSrc) urls.push(image.currentSrc);
      if (image.src) urls.push(image.src);
      var srcset = image.getAttribute('srcset') || '';
      if (srcset) {
        srcset.split(',').forEach(function (candidate) {
          var url = candidate.trim().split(/\s+/)[0];
          if (url) urls.push(url);
        });
      }
      return urls;
    }

    function findMediaIdByImageUrl(imageUrl) {
      var targetPath = normalizeMediaPath(imageUrl);
      var targetToken = normalizeMediaToken(imageUrl);
      if (!targetPath && !targetToken) return '';

      var items = Array.prototype.slice.call(galleryItems);
      var match = items.find(function (item) {
        var mediaId = item.getAttribute('data-media-id');
        if (!mediaId) return false;
        var images = item.querySelectorAll('img');
        return Array.prototype.some.call(images, function (image) {
          return mediaUrlsFromImage(image).some(function (url) {
            var currentPath = normalizeMediaPath(url);
            var currentToken = normalizeMediaToken(url);
            return (targetPath && currentPath === targetPath) || (targetToken && currentToken === targetToken);
          });
        });
      });

      return match ? match.getAttribute('data-media-id') : '';
    }

    function updateActiveGalleryImageFromVariant(imageUrl) {
      if (!imageUrl) return false;
      var activeItem = Array.prototype.find.call(galleryItems, function (item) {
        return item.classList.contains('is-active') || !item.hidden;
      }) || galleryItems[0];
      var activeImage = activeItem ? activeItem.querySelector('img') : null;
      if (!activeImage) return false;
      activeImage.src = imageUrl;
      activeImage.removeAttribute('srcset');
      syncLayeredGalleryAspectRatio();
      return true;
    }

    function activateVariantMedia(variant) {
      if (!variant) return;
      if (variant.featured_media_id) {
        activateMediaById(variant.featured_media_id);
        return;
      }
      if (variant.featured_image) {
        var mediaId = findMediaIdByImageUrl(variant.featured_image);
        if (mediaId) {
          activateMediaById(mediaId);
          return;
        }
        updateActiveGalleryImageFromVariant(variant.featured_image);
      }
    }

    function findVariantById(id) {
      if (!id || !variants.length) return null;
      var variantId = String(id);
      return variants.find(function (item) {
        return String(item.id) === variantId;
      }) || null;
    }

    function updateVariantUrl(variant) {
      if (!variant || !variant.id || !window.history || !window.location || typeof URL === 'undefined') return;
      try {
        var nextUrl = new URL(window.location.href);
        var variantId = String(variant.id);
        if (nextUrl.searchParams.get('variant') === variantId) return;
        nextUrl.searchParams.set('variant', variantId);
        window.history.replaceState(window.history.state || {}, '', nextUrl.pathname + nextUrl.search + nextUrl.hash);
        productSection.setAttribute('data-coreiq-current-variant-id', variantId);
      } catch (e) {
        // Ignore older browsers or malformed current URLs.
      }
    }

    function syncVariantUrlFromCurrentSelection() {
      var variant = getSelectedVariant();
      if (!variant && variantSelect) {
        variant = findVariantById(variantSelect.value);
      }
      updateVariantUrl(variant);
    }

    function scheduleVariantUrlSync() {
      window.clearTimeout(variantUrlSyncTimer);
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(syncVariantUrlFromCurrentSelection);
      } else {
        syncVariantUrlFromCurrentSelection();
      }
      variantUrlSyncTimer = window.setTimeout(syncVariantUrlFromCurrentSelection, 80);
    }

    function getVisibleThumbs() {
      return Array.prototype.filter.call(thumbs, function (thumb) {
        return !thumb.hidden && thumb.getAttribute('aria-hidden') !== 'true';
      });
    }

    function syncGalleryNav(mediaId) {
      if (!thumbs.length || (!galleryPrevBtn && !galleryNextBtn)) return;
      var navThumbs = getVisibleThumbs();
      if (!navThumbs.length) navThumbs = Array.prototype.slice.call(thumbs);
      var activeIndex = -1;
      navThumbs.forEach(function (thumb, index) {
        if (String(thumb.getAttribute('data-media-id') || '') === String(mediaId)) {
          activeIndex = index;
        }
      });
      if (activeIndex < 0) activeIndex = 0;
      if (galleryPrevBtn) galleryPrevBtn.disabled = activeIndex === 0;
      if (galleryNextBtn) galleryNextBtn.disabled = activeIndex >= navThumbs.length - 1;
    }

    function focusFirstProductInfoControl() {
      if (!productInfo) return;
      var focusable = Array.prototype.filter.call(productInfo.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'), function (el) {
        if (el.hasAttribute('hidden') || el.getAttribute('aria-hidden') === 'true') return false;
        if (el.classList && el.classList.contains('visually-hidden')) return false;
        var rect = el.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0;
      })[0];
      if (focusable && typeof focusable.focus === 'function') {
        focusable.focus();
      }
    }

    function openMediaModal(trigger, mediaId) {
      if (!mediaModal) return;
      var requestedMediaId = mediaId || activeMediaId;
      var modalTarget = activateModalMediaById(requestedMediaId);
      if (!modalTarget) modalTarget = mediaModalItems[0];
      if (modalTarget) requestedMediaId = modalTarget.getAttribute('data-media-id') || requestedMediaId;
      if (requestedMediaId) modalTarget = activateModalMediaById(requestedMediaId) || modalTarget;

      // Variant filtering can leave the modal collection hidden until the
      // dialog opens. Always ensure the requested media is the visible item.
      if (modalTarget) {
        var modalImage = modalTarget.querySelector('img');
        var sourceItem = Array.prototype.find.call(galleryItems, function (item) {
          return String(item.getAttribute('data-media-id') || '') === String(requestedMediaId || '');
        });
        var sourceImage = sourceItem ? sourceItem.querySelector('img') : null;
        if (modalImage && sourceImage) {
          var sourceUrl = sourceImage.currentSrc || sourceImage.src || '';
          if (sourceUrl && !modalImage.getAttribute('src')) {
            modalImage.src = sourceUrl;
            modalImage.removeAttribute('srcset');
          }
          modalImage.style.display = 'block';
          modalImage.style.visibility = 'visible';
          modalImage.style.opacity = '1';
        }
      }

      expandButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', 'true');
      });

      // The dialog must escape the product gallery/layout stacking context.
      // Otherwise the overlay can cover the viewport while the panel remains
      // clipped below it, leaving an apparently empty expanded-media state.
      if (mediaModal.parentElement !== document.body) {
        document.body.appendChild(mediaModal);
      }
      document.documentElement.classList.add('ciq-media-lightbox-open');

      if (a11y) {
        a11y.openDialog(mediaModal, {
          trigger: trigger || null,
          initialFocus: mediaModalPanel || mediaModal,
          lockBody: true
        });
      } else {
        mediaModal.hidden = false;
        mediaModal.removeAttribute('inert');
      }

      // The modal is progressively revealed by the accessibility helper. A
      // variant/media sync can otherwise leave the active item carrying the
      // native `hidden` attribute for one frame, resulting in an empty
      // lightbox. Re-assert the selected item after the dialog is visible.
      var revealModalMedia = function () {
        if (!mediaModal) return;
        var selectedThumb = Array.prototype.find.call(mediaModalThumbs, function (thumb) {
          return thumb.classList.contains('is-active');
        });
        var selectedMediaId = selectedThumb ? selectedThumb.getAttribute('data-media-id') : requestedMediaId;
        activateModalMediaById(selectedMediaId);
      };
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(revealModalMedia);
      });
    }

    function setStickyAddLabel(text) {
      if (!stickyAddBtn) return;
      var label = stickyAddBtn.querySelector('[data-coreiq-sticky-add-label]');
      if (label) {
        label.textContent = text;
      } else {
        stickyAddBtn.textContent = text;
      }
      stickyAddBtn.setAttribute('aria-label', text);
    }

    function setStickyAddedState(isAdded) {
      if (stickyAtc) {
        stickyAtc.classList.toggle('is-added', Boolean(isAdded));
      }
      if (stickyAddBtn) {
        stickyAddBtn.classList.toggle('is-added', Boolean(isAdded));
      }
    }

    function closeMediaModal() {
      if (!mediaModal) return;

      mediaModalItems.forEach(function (item) {
        item.classList.remove('is-zoomed', 'is-panning');
        item.scrollLeft = 0;
        item.scrollTop = 0;
      });

      expandButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });

      if (a11y) {
        a11y.closeDialog(mediaModal, {
          lockBody: true
        });
      } else {
        mediaModal.hidden = true;
        mediaModal.setAttribute('inert', '');
      }
      document.documentElement.classList.remove('ciq-media-lightbox-open');
    }

    function getSelectedVariant() {
      if (!variantSelect || !variants.length) return null;
      var id = parseInt(variantSelect.value, 10);
      return variants.find(function (item) {
        return parseInt(item.id, 10) === id;
      }) || null;
    }

    function getVariantColorOptionValue(variant) {
      if (!variant || !Array.isArray(variant.options)) return '';
      var names = Array.isArray(variant.option_names) ? variant.option_names : [];
      var colorIndex = -1;

      names.some(function (name, index) {
        var normalized = String(name || '').toLowerCase();
        if (normalized.indexOf('color') !== -1 || normalized.indexOf('colour') !== -1) {
          colorIndex = index;
          return true;
        }
        return false;
      });

      if (colorIndex < 0 && optionGroups.length) {
        optionGroups.forEach(function (group, index) {
          if (colorIndex > -1) return;
          var label = (group.getAttribute('data-coreiq-option-group') || '').toLowerCase();
          if (label.indexOf('color') !== -1 || label.indexOf('colour') !== -1) {
            colorIndex = index;
          }
        });
      }

      return colorIndex > -1 ? String(variant.options[colorIndex] || '') : '';
    }

    function mediaMatchesActiveOption(item, activeOptionValue) {
      if (!item) return false;
      if (galleryVariantMediaMode !== 'active_option') return true;
      if (!activeOptionValue) return true;
      var mediaOptionValues = item.getAttribute('data-coreiq-media-option-values') || item.getAttribute('data-coreiq-media-option-value') || '';
      if (!mediaOptionValues) return false;
      var normalizedActiveOption = String(activeOptionValue || '').trim().toLowerCase();
      return mediaOptionValues.split('||').some(function (mediaOptionValue) {
        return String(mediaOptionValue || '').trim().toLowerCase() === normalizedActiveOption;
      });
    }

    function hasMediaForActiveOption(activeOptionValue) {
      if (galleryVariantMediaMode !== 'active_option') return true;
      if (!activeOptionValue) return true;
      return Array.prototype.some.call(galleryItems, function (item) {
        return mediaMatchesActiveOption(item, activeOptionValue);
      });
    }

    function applyVariantMediaFilter(variant) {
      if (galleryVariantMediaMode !== 'active_option') return;
      syncGalleryColorGroupOrder();
      var activeOptionValue = getVariantColorOptionValue(variant);
      var hasTaggedMediaForActiveOption = hasMediaForActiveOption(activeOptionValue);
      var mediaControls = Array.prototype.slice.call(galleryItems)
        .concat(Array.prototype.slice.call(thumbs))
        .concat(Array.prototype.slice.call(mediaModalItems))
        .concat(Array.prototype.slice.call(mediaModalThumbs));

      var selectedMediaId = variant && variant.featured_media_id ? String(variant.featured_media_id) : '';
      var visibleMediaIds = [];

      mediaControls.forEach(function (item) {
        var mediaId = item.getAttribute('data-media-id') || '';
        var isAllowed = hasTaggedMediaForActiveOption ? mediaMatchesActiveOption(item, activeOptionValue) : true;
        if (!isAllowed && selectedMediaId && String(mediaId) === selectedMediaId) {
          isAllowed = true;
        }
        if (isAllowed && mediaId && visibleMediaIds.indexOf(String(mediaId)) === -1) {
          visibleMediaIds.push(String(mediaId));
        }
        item.hidden = !isAllowed;
        item.setAttribute('aria-hidden', isAllowed ? 'false' : 'true');
        if (!isAllowed) {
          item.classList.remove('is-active');
          if (item.matches && item.matches('[data-coreiq-gallery-thumb], [data-coreiq-modal-thumb]')) {
            item.setAttribute('aria-pressed', 'false');
          }
        }
      });

      galleryItems.forEach(function (item) {
        var mediaId = item.getAttribute('data-media-id') || '';
        var showMainMedia = selectedMediaId
          ? visibleMediaIds.indexOf(String(mediaId)) !== -1 && String(mediaId) === selectedMediaId
          : !item.hidden && item.classList.contains('is-active');
        item.hidden = !showMainMedia;
        item.setAttribute('aria-hidden', showMainMedia ? 'false' : 'true');
      });

      mediaModalItems.forEach(function (item) {
        var mediaId = item.getAttribute('data-media-id') || '';
        var showModalMedia = selectedMediaId
          ? visibleMediaIds.indexOf(String(mediaId)) !== -1 && String(mediaId) === selectedMediaId
          : !item.hidden && item.classList.contains('is-active');
        item.hidden = !showModalMedia;
        item.setAttribute('aria-hidden', showModalMedia ? 'false' : 'true');
      });

      if (!visibleMediaIds.length && selectedMediaId) {
        mediaControls.forEach(function (item) {
          var isSelectedMedia = String(item.getAttribute('data-media-id') || '') === selectedMediaId;
          item.hidden = !isSelectedMedia;
          item.setAttribute('aria-hidden', isSelectedMedia ? 'false' : 'true');
        });
      }

      if (selectedMediaId) {
        var selectedMediaItem = Array.prototype.find.call(galleryItems, function (item) {
          return !item.hidden && String(item.getAttribute('data-media-id') || '') === selectedMediaId;
        });
        if (selectedMediaItem) {
          activateMediaById(selectedMediaId);
          return;
        }
      }

      var activeItem = Array.prototype.find.call(galleryItems, function (item) {
        return !item.hidden && item.classList.contains('is-active');
      });
      if (activeItem) {
        syncGalleryNav(activeItem.getAttribute('data-media-id'));
        return;
      }

      var firstVisible = Array.prototype.find.call(galleryItems, function (item) {
        return !item.hidden;
      });
      if (firstVisible) {
        activateMediaById(firstVisible.getAttribute('data-media-id'));
      }
    }

    function getSelectedOptionsFromButtons() {
      var selected = [];
      optionGroups.forEach(function (group) {
        var selectedButton = group.querySelector('[data-coreiq-option-value].is-selected');
        selected.push(selectedButton ? selectedButton.getAttribute('data-coreiq-option-choice') || '' : '');
      });
      return selected;
    }

    function syncOptionButtonsFromVariant(variant) {
      if (!variant || !Array.isArray(variant.options) || !optionButtons.length) return;

      optionButtons.forEach(function (button) {
        var index = parseInt(button.getAttribute('data-coreiq-option-index') || '-1', 10);
        var value = button.getAttribute('data-coreiq-option-choice') || '';
        var isSelected = index > -1 && variant.options[index] === value;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

    }

    function isVariantAvailable(variant) {
      return !!(variant && (variant.available === true || variant.available === 'true'));
    }

    function isPreorderBackorderVariant(variant) {
      if (!variant) return false;
      if (variant.preorder_backorder_native === true || variant.preorder_backorder_native === 'true') return true;
      var qty = parseInt(variant.inventory_quantity || 0, 10);
      var eta = String(variant.preorder_backorder_eta || variant.preorder_backorder_eta_formatted || '').trim();
      if (!!variant.inventory_management && variant.inventory_policy === 'continue' && qty <= 0) return true;
      if (!isVariantAvailable(variant) && eta) return true;
      return false;
    }

    function isBackInStockAlertVariant(variant) {
      return !!(variant && !isVariantAvailable(variant) && !isPreorderBackorderVariant(variant) && (variant.back_in_stock_enabled === true || variant.back_in_stock_enabled === 'true'));
    }

    function isPurchasableVariant(variant) {
      return !!(variant && (isVariantAvailable(variant) || isPreorderBackorderVariant(variant)));
    }

    function normalizeBackInStockTagToken(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function setBackInStockStatus(message, type) {
      if (!backInStockWrap || !backInStockStatus) return;
      var statusType = type || 'success';
      backInStockStatus.textContent = message || '';
      backInStockStatus.hidden = !message;
      backInStockWrap.classList.toggle('is-submitted', statusType === 'success' && !!message);
      backInStockWrap.classList.toggle('is-error', statusType === 'error' && !!message);
    }

    function resetBackInStockSubmitState() {
      if (!backInStockWrap) return;
      backInStockWrap.classList.remove('is-submitting');
      backInStockWrap.classList.remove('is-submitted');
      backInStockWrap.classList.remove('is-error');
      if (backInStockStatus) {
        backInStockStatus.hidden = true;
        backInStockStatus.textContent = '';
      }
    }

    function updateBackInStockAlert(variant) {
      if (!backInStockWrap) return;
      var isSoldOut = isBackInStockAlertVariant(variant);
      backInStockWrap.hidden = !isSoldOut;
      if (!isSoldOut || !variant) {
        backInStockSubmittedVariantId = '';
        resetBackInStockSubmitState();
        return;
      }

      if (backInStockSubmittedVariantId && String(backInStockSubmittedVariantId) !== String(variant.id || '')) {
        backInStockSubmittedVariantId = '';
        resetBackInStockSubmitState();
      }

      var productTitle = backInStockWrap.getAttribute('data-product-title') || document.title || 'Product';
      var productHandle = normalizeBackInStockTagToken(backInStockWrap.getAttribute('data-product-handle') || productTitle);
      var productUrl = backInStockWrap.getAttribute('data-product-url') || window.location.href.split('?')[0];
      var variantTitle = variant.title && variant.title !== 'Default Title' ? variant.title : productTitle;
      var body = 'Back-in-stock request for ' + productTitle + '. Variant: ' + variantTitle + '. Variant ID: ' + variant.id;
      if (variant.sku) {
        body += '. SKU: ' + variant.sku;
      }
      var productVariantUrl = productUrl + '?variant=' + variant.id;
      body += '. Product URL: ' + productVariantUrl;

      if (backInStockTags) {
        var tags = ['back-in-stock', 'product-alert', 'bis-product-' + productHandle, 'bis-variant-' + variant.id];
        var skuToken = normalizeBackInStockTagToken(variant.sku || '');
        if (skuToken) tags.push('bis-sku-' + skuToken);
        backInStockTags.value = tags.join(', ');
      }
      if (backInStockBody) backInStockBody.value = body;
      if (backInStockVariantTitle) backInStockVariantTitle.value = variantTitle;
      if (backInStockVariantId) backInStockVariantId.value = variant.id || '';
      if (backInStockSku) backInStockSku.value = variant.sku || '';
      if (backInStockUrl) backInStockUrl.value = productVariantUrl;
    }

    function initBackInStockSubmit() {
      if (!backInStockNativeForm || !backInStockWrap) return;

      var nativeSuccess = backInStockNativeForm.querySelector('.ciq-main-product__back-in-stock-success');
      var nativeError = backInStockNativeForm.querySelector('.ciq-main-product__back-in-stock-error');
      if (nativeSuccess) {
        setBackInStockStatus(nativeSuccess.textContent || '', 'success');
      } else if (nativeError) {
        setBackInStockStatus(nativeError.textContent || '', 'error');
      }

      if (typeof fetch !== 'function' || typeof FormData === 'undefined') return;

      backInStockNativeForm.addEventListener('submit', function (event) {
        var emailInput = backInStockWrap.querySelector('input[type="email"]');
        if (emailInput && typeof emailInput.reportValidity === 'function' && !emailInput.reportValidity()) return;
        event.preventDefault();

        var variant = getSelectedVariant();
        var variantId = variant && variant.id ? String(variant.id) : (backInStockVariantId ? String(backInStockVariantId.value || '') : '');
        var submitButton = backInStockWrap.querySelector('button[type="submit"]');
        var successMessage = backInStockNativeForm.getAttribute('data-coreiq-back-in-stock-success-message') || (backInStockStatus ? backInStockStatus.textContent : '') || "Thanks. We'll email you when it is back in stock.";

        backInStockWrap.classList.add('is-submitting');
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
        }

        var payload = new FormData(backInStockNativeForm);
        backInStockWrap.querySelectorAll('input[name], textarea[name], select[name]').forEach(function (field) {
          if (!field.name) return;
          if (typeof payload.has === 'function' && payload.has(field.name)) return;
          payload.append(field.name, field.value || '');
        });

        fetch(backInStockNativeForm.action || window.location.href, {
          method: (backInStockNativeForm.method || 'post').toUpperCase(),
          body: payload,
          credentials: 'same-origin',
          headers: {
            Accept: 'text/html'
          }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Back-in-stock request failed');
            backInStockSubmittedVariantId = variantId;
            setBackInStockStatus(successMessage, 'success');
            if (emailInput) emailInput.value = '';
          })
          .catch(function () {
            setBackInStockStatus('We could not save that alert. Please try again.', 'error');
          })
          .finally(function () {
            backInStockWrap.classList.remove('is-submitting');
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.removeAttribute('aria-busy');
            }
          });
      });
    }

    function updateProductDataFields(variant) {
      if (!productDataFields.length || !variant || !variant.id) return;

      productDataFields.forEach(function (field) {
        var source = field.getAttribute('data-coreiq-pdp-data-source') || '';
        if (source !== 'variant_field' && source !== 'variant_metafield') return;

        var valueEl = field.querySelector('[data-coreiq-pdp-data-value]');
        var variantsScript = field.querySelector('[data-coreiq-pdp-data-variants]');
        if (!valueEl || !variantsScript) return;

        var variantValues = {};
        try {
          variantValues = JSON.parse(variantsScript.textContent || '{}') || {};
        } catch (e) {
          variantValues = {};
        }

        var variantId = String(variant.id);
        var nextValue = Object.prototype.hasOwnProperty.call(variantValues, variantId) ? variantValues[variantId] : '';
        if (nextValue == null) nextValue = '';
        valueEl.textContent = nextValue;
        syncProductDataFieldVisibility(field, nextValue);
      });
    }

    function normalizeProductDataValue(value) {
      var normalized = String(value == null ? '' : value)
        .replace(/\u00a0/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

      return normalized;
    }

    function syncProductDataFieldVisibility(field, value) {
      if (!field) return;
      var valueEl = field.querySelector('[data-coreiq-pdp-data-value]');
      var hideWhenEmpty = field.getAttribute('data-coreiq-pdp-data-hide-empty') === 'true';
      var normalized = normalizeProductDataValue(value != null ? value : (valueEl ? valueEl.textContent : ''));
      var hasValue = normalized.length > 0;
      var shouldHide = hideWhenEmpty && !hasValue;

      field.hidden = shouldHide;
      field.classList.toggle('is-empty', !hasValue);
      field.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
    }

    function syncInitialProductDataFields() {
      if (!productDataFields.length) return;

      productDataFields.forEach(function (field) {
        var source = field.getAttribute('data-coreiq-pdp-data-source') || '';
        if (source === 'variant_field' || source === 'variant_metafield') return;
        syncProductDataFieldVisibility(field);
      });
    }

    function updateOptionAvailability() {
      if (!optionButtons.length || !optionGroups.length) return;

      optionButtons.forEach(function (button) {
        var index = parseInt(button.getAttribute('data-coreiq-option-index') || '-1', 10);
        var choice = button.getAttribute('data-coreiq-option-choice') || '';
        var fallbackState = button.getAttribute('data-coreiq-option-fallback') || '';
        if (index < 0 || !choice) return;

        var hasAvailableValue = variants.some(function (variant) {
          if (!isVariantAvailable(variant) || isPreorderBackorderVariant(variant) || !Array.isArray(variant.options)) return false;
          return variant.options[index] === choice;
        });

        var hasPreorderValue = variants.some(function (variant) {
          if (!isPreorderBackorderVariant(variant) || !Array.isArray(variant.options)) return false;
          return variant.options[index] === choice;
        });

        var hasBackInStockValue = variants.some(function (variant) {
          if (!isBackInStockAlertVariant(variant) || !Array.isArray(variant.options)) return false;
          return variant.options[index] === choice;
        });

        if (!hasAvailableValue && fallbackState === 'available') {
          hasAvailableValue = true;
        }
        if (!hasPreorderValue && fallbackState === 'preorder') {
          hasPreorderValue = true;
        }
        if (!hasBackInStockValue && fallbackState === 'back_in_stock') {
          hasBackInStockValue = true;
        }

        button.classList.toggle('is-unavailable', !hasAvailableValue && !hasPreorderValue && !hasBackInStockValue);
        button.classList.toggle('is-preorder-option', !hasAvailableValue && hasPreorderValue);
        button.classList.toggle('is-back-in-stock-option', !hasAvailableValue && !hasPreorderValue && hasBackInStockValue);
        button.setAttribute('data-coreiq-option-availability', hasAvailableValue ? 'available' : (hasPreorderValue ? 'preorder' : (hasBackInStockValue ? 'back_in_stock' : 'unavailable')));
        if (!hasAvailableValue) {
          if (hasPreorderValue) {
            button.removeAttribute('aria-disabled');
            button.removeAttribute('disabled');
            button.setAttribute('data-coreiq-option-status', preorderCtaLabel);
          } else if (hasBackInStockValue) {
            button.removeAttribute('aria-disabled');
            button.removeAttribute('disabled');
            button.setAttribute('data-coreiq-option-status', 'Notify me');
          } else {
            button.setAttribute('aria-disabled', 'true');
            button.setAttribute('disabled', 'disabled');
            button.removeAttribute('data-coreiq-option-status');
          }
        } else {
          button.removeAttribute('aria-disabled');
          button.removeAttribute('disabled');
          button.removeAttribute('data-coreiq-option-status');
        }
      });
    }

    function syncVariantSelectFromButtons(changedButton) {
      if (!variantSelect || !variants.length || !optionGroups.length) return false;
      var selectedOptions = getSelectedOptionsFromButtons();
      var matchedVariant = variants.find(function (variant) {
        if (!Array.isArray(variant.options)) return false;
        return variant.options.every(function (value, index) {
          return selectedOptions[index] === value;
        });
      });

      if (!matchedVariant && changedButton) {
        var changedIndex = parseInt(changedButton.getAttribute('data-coreiq-option-index') || '-1', 10);
        var changedChoice = changedButton.getAttribute('data-coreiq-option-choice') || '';
        var bestScore = -1;
        variants.forEach(function (variant) {
          if (!Array.isArray(variant.options) || variant.options[changedIndex] !== changedChoice) return;
          var score = isPurchasableVariant(variant) ? 100 : (isBackInStockAlertVariant(variant) ? 80 : 10);
          variant.options.forEach(function (value, index) {
            if (index !== changedIndex && selectedOptions[index] === value) score += 1000;
          });
          if (score > bestScore) {
            bestScore = score;
            matchedVariant = variant;
          }
        });
      }

      if (!matchedVariant) return false;
      variantSelect.value = String(matchedVariant.id);
      syncVariantUi();
      return true;
    }

    function getSelectedSellingPlanInput() {
      if (!sellingPlanGroup) return null;
      return sellingPlanGroup.querySelector('[data-coreiq-selling-plan-input]:checked');
    }

    function updateSellingPlanPrice() {
      if (!priceEl) return;
      var selectedInput = getSelectedSellingPlanInput();
      var planPrice = selectedInput ? selectedInput.getAttribute('data-price') : '';
      if (!planPrice) planPrice = (getSelectedVariant() || {}).price || '';
      if (planPrice) {
        priceEl.textContent = planPrice;
        if (stickyPrice) stickyPrice.textContent = planPrice;
      }
    }

    function buildSellingPlanOptionHtml(value, price, priceCents, label, isChecked) {
      return '<label class="ciq-main-product__selling-plan-option' + (isChecked ? ' is-selected' : '') + '">' +
        '<input type="radio" name="selling_plan" value="' + value + '" class="ciq-main-product__selling-plan-input" data-coreiq-selling-plan-input' +
        ' data-price="' + (price || '') + '" data-price-cents="' + (priceCents || '') + '"' + (isChecked ? ' checked' : '') + '>' +
        '<span class="ciq-main-product__selling-plan-info">' +
        '<span class="ciq-main-product__selling-plan-title">' + (label || '') + '</span>' +
        '</span>' +
        '<span class="ciq-main-product__selling-plan-price">' + (price || '') + '</span>' +
        '</label>';
    }

    function syncSellingPlanForVariant(variant) {
      if (!sellingPlanGroup) return;
      var optionsContainer = sellingPlanGroup.querySelector('[data-coreiq-selling-plan-options]');
      var allocations = Array.isArray(variant && variant.selling_plan_allocations) ? variant.selling_plan_allocations : [];
      if (!optionsContainer || !allocations.length) {
        sellingPlanGroup.hidden = true;
        return;
      }

      var previousValue = '';
      var previousInput = getSelectedSellingPlanInput();
      if (previousInput) previousValue = previousInput.value;
      var isAvailable = function (value) {
        return value === '' || allocations.some(function (plan) { return String(plan.id) === value; });
      };
      var nextValue = isAvailable(previousValue) ? previousValue : '';

      var html = buildSellingPlanOptionHtml('', variant.price, String(variant.price_cents || ''), sellingPlanOneTimeLabel, nextValue === '');
      allocations.forEach(function (plan) {
        var planPrice = plan.per_delivery_price || plan.price || '';
        var planPriceCents = plan.per_delivery_price_cents != null ? String(plan.per_delivery_price_cents) : (plan.price_cents != null ? String(plan.price_cents) : '');
        html += buildSellingPlanOptionHtml(plan.id, planPrice, planPriceCents, plan.name || '', nextValue === String(plan.id));
      });

      optionsContainer.innerHTML = html;
      sellingPlanGroup.hidden = false;
      updateSellingPlanPrice();
    }

    function syncVariantUi() {
      var variant = getSelectedVariant();
      if (!variant) return;

      if (productQtyInput) {
        var trackedInventory = Boolean(variant.inventory_management);
        if (trackedInventory && variant.inventory_quantity != null && Number.isFinite(Number(variant.inventory_quantity))) {
          var maxAvailable = Math.max(0, Number(variant.inventory_quantity));
          productQtyInput.max = String(maxAvailable);
          if (parseInt(productQtyInput.value || '1', 10) > maxAvailable) productQtyInput.value = String(Math.max(1, maxAvailable));
        } else {
          productQtyInput.removeAttribute('max');
        }
      }

      if (priceEl) priceEl.textContent = variant.price || '';
      if (stickyPrice) stickyPrice.textContent = variant.price || '';
      if (unitPriceEl) {
        var unitPriceText = variant.unit_price && variant.unit_price_reference
          ? variant.unit_price + ' / ' + variant.unit_price_reference
          : '';
        unitPriceEl.textContent = unitPriceText;
        unitPriceEl.hidden = !unitPriceText;
        if (unitPriceText) {
          unitPriceEl.removeAttribute('aria-hidden');
        } else {
          unitPriceEl.setAttribute('aria-hidden', 'true');
        }
      }
      var stickyThumbImg = stickyImage || (stickyAtc ? stickyAtc.querySelector('.ciq-sticky-atc__thumb img') : null);
      if (stickyThumbImg && variant.featured_image) {
        stickyThumbImg.src = variant.featured_image;
        // Variant URLs are already Shopify CDN-sized; remove the initial product srcset
        // so the browser cannot retain the previous variant image candidate.
        stickyThumbImg.removeAttribute('srcset');
      }
      if (stickyVariant) {
        stickyVariant.textContent = variant.title && variant.title !== 'Default Title' ? variant.title : '';
        stickyVariant.hidden = !stickyVariant.textContent || !stickyAtc || !stickyAtc.classList.contains('ciq-sticky-atc--detailed');
      }
      var stickyLabel = productSection.querySelector('[data-ciq-sticky-variant-label]');
      if (stickyLabel) {
        var stickyLabelText = variant.title && variant.title !== 'Default Title'
          ? String(variant.title).replace(/\s*\/\s*/g, ' · ')
          : '';
        stickyLabel.textContent = stickyLabelText;
        stickyLabel.hidden = !stickyLabelText;
      }

      var variantOnSale = variant.has_compare === true;
      if (typeof variant.price_cents === 'number' && typeof variant.compare_at_price_cents === 'number') {
        variantOnSale = variant.compare_at_price_cents > variant.price_cents;
      }

      if (compareEl) {
        if (variantOnSale) {
          compareEl.hidden = false;
          compareEl.removeAttribute('aria-hidden');
          compareEl.innerHTML = '<s>' + (variant.compare_at_price || '') + '</s>';
        } else {
          compareEl.hidden = true;
          compareEl.setAttribute('aria-hidden', 'true');
          compareEl.innerHTML = '';
        }
      }

      if (badgeEl) {
        var discountPercent = 0;
        if (variantOnSale && Number(variant.compare_at_price_cents) > 0 && Number(variant.price_cents) >= 0) {
          discountPercent = Math.floor(((Number(variant.compare_at_price_cents) - Number(variant.price_cents)) / Number(variant.compare_at_price_cents)) * 100);
        }
        badgeEl.textContent = discountPercent + '% off';
        badgeEl.setAttribute('aria-label', discountPercent + '% off');
        badgeEl.hidden = !variantOnSale;
        badgeEl.setAttribute('aria-hidden', badgeEl.hidden ? 'true' : 'false');
      }

      if (inventoryEl) {
        var lowStockThreshold = parseInt(inventoryEl.getAttribute('data-low-stock-threshold') || '5', 10);
        var lowStock = isVariantAvailable(variant) && !!variant.inventory_management && variant.inventory_policy === 'deny' && variant.inventory_quantity > 0 && variant.inventory_quantity <= lowStockThreshold;
        inventoryEl.hidden = !lowStock;
        if (lowStock) {
          inventoryEl.textContent = 'Only ' + variant.inventory_quantity + ' left in stock';
        }
      }

      if (urgencyEl) {
        var urgencyThreshold = parseInt(urgencyEl.getAttribute('data-coreiq-urgency-threshold') || '5', 10);
        var urgencyCritical = parseInt(urgencyEl.getAttribute('data-coreiq-urgency-critical') || '2', 10);
        var urgencyQty = variant.inventory_quantity || 0;
        var urgencyActive = isVariantAvailable(variant) && !!variant.inventory_management && variant.inventory_policy === 'deny' && urgencyQty > 0 && urgencyQty <= urgencyThreshold;
        urgencyEl.hidden = !urgencyActive;
        if (urgencyActive) {
          var urgencyMsg = (urgencyEl.getAttribute('data-coreiq-urgency-msg') || 'Only {count} left').replace('{count}', urgencyQty);
          urgencyEl.textContent = urgencyMsg;
          urgencyEl.classList.toggle('ciq-urgency--critical', urgencyQty <= urgencyCritical);
        }
      }

      if (fitNoteEl) {
        var resolvedFitNote = '';
        if (fitNoteSource === 'variant') {
          resolvedFitNote = (variant.fit_note && variant.fit_note.trim())
            ? variant.fit_note
            : productFitNote;
        } else {
          resolvedFitNote = productFitNote;
        }
        fitNoteEl.textContent = resolvedFitNote;
        fitNoteEl.hidden = !resolvedFitNote;
      }

      if (modelDetailsEl && modelDetailsTextEl) {
        var resolvedModel = (variant.model_details && variant.model_details.trim())
          ? variant.model_details : productModelDetails;
        modelDetailsTextEl.textContent = resolvedModel;
        modelDetailsEl.hidden = !resolvedModel;
      }

      if (fabricFeelEl && fabricFeelTextEl) {
        var resolvedFabric = (variant.fabric_feel && variant.fabric_feel.trim())
          ? variant.fabric_feel : productFabricFeel;
        fabricFeelTextEl.textContent = resolvedFabric;
        fabricFeelEl.hidden = !resolvedFabric;
      }

      if (fitGridEl && modelDetailsEl && fabricFeelEl) {
        fitGridEl.hidden = modelDetailsEl.hidden && fabricFeelEl.hidden;
      }

      if (pickupWrap) {
        var hasPickup = !!variant.pickup_available && (!!variant.pickup_location || !!variant.pickup_time);
        pickupWrap.hidden = !hasPickup;
        if (hasPickup) {
          if (pickupTitle) {
            pickupTitle.innerHTML = '<strong>Pickup available</strong> at ' + (variant.pickup_location || 'selected location');
          }
          if (pickupText) {
            pickupText.textContent = variant.pickup_time ? 'Ready for pickup: ' + variant.pickup_time : 'Ready for pickup today';
          }
        } else {
          if (pickupTitle) {
            pickupTitle.innerHTML = '<strong>Check availability</strong> at nearby stores';
          }
          if (pickupText) {
            pickupText.textContent = '';
          }
        }
      }

      updateBackInStockAlert(variant);
      updateProductDataFields(variant);

      if (preorderNotice) {
        var preorderActive = isPreorderBackorderVariant(variant);
        var preorderMessageText = preorderDefaultMessage;
        var preorderDateText = (variant.preorder_backorder_eta_formatted || variant.preorder_backorder_eta || '').trim();
        var hasPreorderContent = preorderMessageText || preorderDateText;
        preorderNotice.hidden = !preorderActive || !hasPreorderContent;
        if (preorderMessage) {
          preorderMessage.textContent = preorderMessageText || 'Pre-order available.';
          preorderMessage.hidden = !preorderActive || !preorderMessage.textContent.trim();
        }
        if (preorderDate) {
          preorderDate.textContent = preorderDateText ? preorderDatePrefix + ': ' + preorderDateText : '';
          preorderDate.hidden = !preorderActive || !preorderDateText;
        }
      }

      if (addBtn) {
        var allowPreorderVariant = isPreorderBackorderVariant(variant);
        var availableVariant = isVariantAvailable(variant);
        addBtn.disabled = !availableVariant && !allowPreorderVariant;
        addBtn.textContent = allowPreorderVariant ? preorderCtaLabel : (availableVariant ? 'Add to cart' : 'Sold out');
        addBtn.setAttribute('data-coreiq-sold-out-state', availableVariant || allowPreorderVariant ? 'false' : 'true');
      }

      if (dynamicCheckout) {
        var hideDynamicCheckout = !isVariantAvailable(variant) || isPreorderBackorderVariant(variant);
        dynamicCheckout.hidden = hideDynamicCheckout;
        dynamicCheckout.setAttribute('aria-hidden', hideDynamicCheckout ? 'true' : 'false');
      }

      if (stickyAddBtn) {
        var allowStickyPreorder = isPreorderBackorderVariant(variant);
        var stickyAvailableVariant = isVariantAvailable(variant);
        stickyAddBtn.disabled = !stickyAvailableVariant && !allowStickyPreorder;
        setStickyAddLabel(allowStickyPreorder ? preorderCtaLabel : (stickyAvailableVariant ? 'Add to cart' : 'Sold out'));
        stickyAddBtn.setAttribute('data-coreiq-sold-out-state', stickyAvailableVariant || allowStickyPreorder ? 'false' : 'true');
      }

      syncSellingPlanForVariant(variant);
      syncOptionButtonsFromVariant(variant);
      updateOptionAvailability();
      updateVariantUrl(variant);

      activateVariantMedia(variant);
      applyVariantMediaFilter(variant);
    }

    if (variantSelect && variantSelect.tagName === 'SELECT') {
      variantSelect.addEventListener('change', function () {
        syncVariantUi();
        scheduleVariantUrlSync();
      });
      variantSelect.addEventListener('input', function () {
        syncVariantUi();
        scheduleVariantUrlSync();
      });
    }

    if (sellingPlanGroup) {
      sellingPlanGroup.addEventListener('change', function (event) {
        if (event.target && event.target.matches && event.target.matches('[data-coreiq-selling-plan-input]')) {
          sellingPlanGroup.querySelectorAll('.ciq-main-product__selling-plan-option').forEach(function (label) {
            label.classList.toggle('is-selected', !!(label.querySelector('[data-coreiq-selling-plan-input]:checked')));
          });
          updateSellingPlanPrice();
        }
      });
    }

    optionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.hasAttribute('disabled')) return;
        var groupName = button.getAttribute('data-coreiq-option-name') || '';
        optionButtons.forEach(function (peer) {
          if ((peer.getAttribute('data-coreiq-option-name') || '') !== groupName) return;
          peer.classList.remove('is-selected');
          peer.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        if (!syncVariantSelectFromButtons(button)) {
          syncOptionButtonsFromVariant(getSelectedVariant());
          updateOptionAvailability();
        }
        scheduleVariantUrlSync();
      });
    });

    productSection.addEventListener('change', function (event) {
      var control = event.target.closest('[name="id"], [data-coreiq-variant-select], [data-coreiq-option-value]');
      if (!control || !productSection.contains(control)) return;
      scheduleVariantUrlSync();
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaId = thumb.getAttribute('data-media-id');
        activateMediaById(mediaId);
      });

    });
    cinematicPreviews.forEach(function (preview) {
      preview.addEventListener('click', function () {
        var mediaId = preview.getAttribute('data-media-id');
        if (mediaId) activateMediaById(mediaId);
      });
    });
    if (thumbs.length) {
      var currentThumb = Array.prototype.find.call(thumbs, function (thumb) {
        return thumb.classList.contains('is-active') || thumb.getAttribute('aria-pressed') === 'true';
      }) || thumbs[0];
      activateMediaById(currentThumb.getAttribute('data-media-id'));
    }

    var galleryMain = productSection.querySelector('[data-coreiq-gallery-main]');
    if (galleryMain && thumbs.length) {
      var swipeStartX = 0;
      var swipeStartY = 0;
      var galleryWheelLocked = false;
      galleryMain.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'touch') return;
        swipeStartX = event.clientX;
        swipeStartY = event.clientY;
      }, { passive: true });
      galleryMain.addEventListener('pointerup', function (event) {
        if (event.pointerType !== 'touch' || !swipeStartX) return;
        var deltaX = event.clientX - swipeStartX;
        var deltaY = event.clientY - swipeStartY;
        swipeStartX = 0;
        if (Math.abs(deltaX) < 48 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        var navThumbs = getVisibleThumbs();
        var activeIndex = navThumbs.findIndex(function (thumb) {
          return thumb.classList.contains('is-active');
        });
        if (activeIndex < 0) activeIndex = 0;
        var nextIndex = deltaX < 0 ? activeIndex + 1 : activeIndex - 1;
        if (navThumbs[nextIndex]) activateMediaById(navThumbs[nextIndex].getAttribute('data-media-id'));
      }, { passive: true });
      galleryMain.addEventListener('wheel', function (event) {
        if (window.matchMedia('(max-width: 989px)').matches || galleryPreset !== 'cinematic') return;
        var navThumbs = getVisibleThumbs();
        if (navThumbs.length < 2) return;
        event.preventDefault();
        if (galleryWheelLocked || Math.abs(event.deltaY) < 14 || Math.abs(event.deltaY) < Math.abs(event.deltaX)) return;
        var activeIndex = navThumbs.findIndex(function (thumb) {
          return thumb.classList.contains('is-active');
        });
        if (activeIndex < 0) activeIndex = 0;
        var nextIndex = event.deltaY > 0
          ? (activeIndex + 1) % navThumbs.length
          : (activeIndex - 1 + navThumbs.length) % navThumbs.length;
        galleryWheelLocked = true;
        activateMediaById(navThumbs[nextIndex].getAttribute('data-media-id'));
        window.setTimeout(function () { galleryWheelLocked = false; }, 260);
      }, { passive: false });
    }
    syncGalleryColorGroupOrder();
    applyVariantMediaFilter(getSelectedVariant());
    syncCinematicPreviews(activeMediaId);
    if (galleryFocusBridge) {
      galleryFocusBridge.addEventListener('focus', function () {
        window.requestAnimationFrame(focusFirstProductInfoControl);
      });
    }

    mediaModalItems.forEach(function (item) {
      var panImage = item.querySelector('[data-coreiq-media-pan-image]');
      if (!panImage) return;
      var isPanning = false;
      var startX = 0;
      var startY = 0;
      var startScrollLeft = 0;
      var startScrollTop = 0;
      var didPan = false;

      item.addEventListener('pointerdown', function (event) {
        if (event.button !== undefined && event.button !== 0) return;
        if (!item.classList.contains('is-zoomed')) return;
        if (item.scrollWidth <= item.clientWidth && item.scrollHeight <= item.clientHeight) return;
        isPanning = true;
        startX = event.clientX;
        startY = event.clientY;
        startScrollLeft = item.scrollLeft;
        startScrollTop = item.scrollTop;
        didPan = false;
        item.classList.add('is-panning');
        if (typeof item.setPointerCapture === 'function') item.setPointerCapture(event.pointerId);
        event.preventDefault();
      });

      item.addEventListener('pointermove', function (event) {
        if (!isPanning) return;
        if (Math.abs(event.clientX - startX) > 4 || Math.abs(event.clientY - startY) > 4) didPan = true;
        item.scrollLeft = startScrollLeft - (event.clientX - startX);
        item.scrollTop = startScrollTop - (event.clientY - startY);
        event.preventDefault();
      });

      function stopPanning(event) {
        if (!isPanning) return;
        isPanning = false;
        item.classList.remove('is-panning');
        if (event && typeof item.releasePointerCapture === 'function') {
          try { item.releasePointerCapture(event.pointerId); } catch (error) {}
        }
      }

      item.addEventListener('pointerup', stopPanning);
      item.addEventListener('pointercancel', stopPanning);
      item.addEventListener('lostpointercapture', stopPanning);
      panImage.addEventListener('click', function (event) {
        if (didPan) {
          didPan = false;
          return;
        }
        toggleModalZoom(item);
      });
    });

    mediaModalThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaId = thumb.getAttribute('data-media-id');
        activateModalMediaById(mediaId);
      });
    });

    expandButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        openMediaModal(button, button.getAttribute('data-media-id') || activeMediaId);
      });
    });

    if (mediaModal) {
      mediaModal.addEventListener('click', function (e) {
        if (e.target.closest('[data-coreiq-modal-zoom]')) {
          toggleModalZoom(mediaModal.querySelector('[data-coreiq-modal-media-item].is-active'));
          return;
        }
        var closeTarget = e.target.closest('[data-coreiq-media-modal-close]');
        if (closeTarget) {
          closeMediaModal();
        }
      });

      mediaModal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          closeMediaModal();
          return;
        }

        if (a11y) {
          a11y.trapTabKey(e, mediaModal);
        }
      });
    }

    function addCurrentVariantToCart(sourceEl) {
      var variantInput = variantSelect || (productForm && productForm.querySelector('[name="id"]'));
      if (!variantInput) return;
      var variantId = parseInt(variantInput.value, 10);
      if (!Number.isFinite(variantId) || variantId <= 0) return;
      var qtyInput = productSection.querySelector('.ciq-main-product__qty');
      var requestedQuantity = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
      var quantity = Number.isFinite(requestedQuantity) ? Math.max(1, requestedQuantity) : 1;
      var animationSource = sourceEl || addBtn || productForm || productSection;
      var isStickyAddSource = !!(stickyAddBtn && animationSource === stickyAddBtn);
      var requestButton = isStickyAddSource ? stickyAddBtn : addBtn;
      if (requestButton && requestButton.dataset.ciqAdding === 'true') return;
      if (isStickyAddSource && stickyInventoryMessage) {
        window.clearTimeout(stickyInventoryMessage.__ciqDismissTimer);
        window.clearTimeout(stickyInventoryMessage.__ciqHideTimer);
        stickyInventoryMessage.classList.remove('is-visible');
        stickyInventoryMessage.textContent = '';
        stickyInventoryMessage.hidden = true;
      }

      if (requestButton) {
        requestButton.dataset.ciqAdding = 'true';
        requestButton.disabled = true;
        requestButton.setAttribute('aria-busy', 'true');
        if (isStickyAddSource) setStickyAddLabel('Adding…');
      }

      var payload = { id: variantId, quantity: quantity };
      var selectedSellingPlan = getSelectedSellingPlanInput();
      if (selectedSellingPlan && selectedSellingPlan.value) payload.selling_plan = selectedSellingPlan.value;

      window.CiqInventoryGuard.add(payload, animationSource)
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) throw new Error(body && (body.description || body.message) || 'This item could not be added. Please try again.');
            return body;
          });
        })
          .then(function (item) {
            var inventoryMessage = productSection.querySelector('[data-coreiq-inventory-message]');
            if (inventoryMessage) {
              inventoryMessage.textContent = '';
              inventoryMessage.hidden = true;
            }
            if (stickyInventoryMessage) {
              window.clearTimeout(stickyInventoryMessage.__ciqDismissTimer);
              window.clearTimeout(stickyInventoryMessage.__ciqHideTimer);
              stickyInventoryMessage.classList.remove('is-visible');
              stickyInventoryMessage.textContent = '';
              stickyInventoryMessage.hidden = true;
            }
            emitCartAddAnalytics(item, {
              actionSource: 'product-page',
              variantId: variantId,
              quantity: quantity
            });
          animateAddToCart(animationSource, item);
          fetchCartState().then(function (cart) {
            var openCartDrawer = document.getElementById('cart-drawer');
            if (openCartDrawer && openCartDrawer.hasAttribute('open')) {
              renderCartDrawer(cart);
            }
            announceCartUpdate(cart.item_count || 0);
          }).catch(function () {});
          if (isStickyAddSource) {
            window.clearTimeout(stickyAtc && stickyAtc.__ciqStickyAddedTimer);
            setStickyAddLabel('Added');
            setStickyAddedState(true);
            if (stickyConfirm) {
              var selectedVariant = getSelectedVariant();
              var variantLabel = selectedVariant && selectedVariant.title && selectedVariant.title !== 'Default Title' ? selectedVariant.title : 'selected option';
              stickyConfirm.textContent = 'Added ' + quantity + ' x ' + variantLabel + ' to cart';
              stickyConfirm.hidden = false;
              stickyConfirm.classList.add('is-visible');
            }
            var stickyAddedTimer = setTimeout(function () {
              var resetVariant = getSelectedVariant();
              var resetAvailable = !resetVariant || isVariantAvailable(resetVariant);
              var resetPreorder = Boolean(resetVariant && isPreorderBackorderVariant(resetVariant));
              setStickyAddLabel(resetPreorder ? preorderCtaLabel : (resetAvailable ? 'Add to cart' : 'Sold out'));
              setStickyAddedState(false);
              if (stickyConfirm) {
                stickyConfirm.classList.remove('is-visible');
                setTimeout(function () {
                  stickyConfirm.hidden = true;
                }, 220);
              }
            }, 2200);
            if (stickyAtc) stickyAtc.__ciqStickyAddedTimer = stickyAddedTimer;
          }
        })
        .catch(function (error) {
          var message = error && error.message ? error.message : 'This item could not be added. Please try again.';
          if (stickyConfirm && isStickyAddSource) {
            stickyConfirm.textContent = message;
            stickyConfirm.hidden = false;
            stickyConfirm.classList.add('is-visible');
          }
          if (stickyInventoryMessage && isStickyAddSource) {
            window.clearTimeout(stickyInventoryMessage.__ciqDismissTimer);
            window.clearTimeout(stickyInventoryMessage.__ciqHideTimer);
            stickyInventoryMessage.textContent = message;
            stickyInventoryMessage.hidden = false;
            requestAnimationFrame(function () { stickyInventoryMessage.classList.add('is-visible'); });
            stickyInventoryMessage.__ciqDismissTimer = window.setTimeout(function () {
              stickyInventoryMessage.classList.remove('is-visible');
              stickyInventoryMessage.__ciqHideTimer = window.setTimeout(function () {
                stickyInventoryMessage.hidden = true;
              }, 220);
            }, 3000);
          }
          var inventoryMessage = productSection.querySelector('[data-coreiq-inventory-message]');
          if (inventoryMessage) {
            inventoryMessage.textContent = message;
            inventoryMessage.hidden = false;
          }
          document.querySelectorAll('[data-coreiq-cart-status]').forEach(function (statusEl) {
            statusEl.textContent = message;
          });
        })
        .finally(function () {
          if (!requestButton) return;
          delete requestButton.dataset.ciqAdding;
          requestButton.removeAttribute('aria-busy');
          var selectedVariant = getSelectedVariant();
          var available = selectedVariant && isVariantAvailable(selectedVariant);
          var preorder = selectedVariant && isPreorderBackorderVariant(selectedVariant);
          requestButton.disabled = !available && !preorder;
          if (isStickyAddSource && !requestButton.classList.contains('is-added')) {
            setStickyAddLabel(preorder ? preorderCtaLabel : (available ? 'Add to cart' : 'Sold out'));
          }
        });
    }

    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        addCurrentVariantToCart(stickyAddBtn);
      });
    }

    if (stickyDismissBtn && stickyAtc) {
      stickyDismissBtn.addEventListener('click', function () {
        stickyAtcDismissed = true;
        stickyAtc.classList.remove('is-visible');
        document.body.classList.remove('ciq-has-sticky-atc');
        document.body.classList.remove('ciq-has-sticky-atc-pollheim');
        document.documentElement.style.setProperty('--ciq-sticky-footer-offset', '0px');
      });
    }

    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();
        addCurrentVariantToCart(e.submitter || addBtn || productForm);
      });
    }

    initBackInStockSubmit();

    if (stickyAtc && productForm) {
      function isCartDrawerActive() {
        var cartDrawer = document.getElementById('cart-drawer');
        return Boolean(cartDrawer && (
          cartDrawer.hasAttribute('open') ||
          cartDrawer.getAttribute('aria-hidden') === 'false' ||
          cartDrawer.classList.contains('is-open')
        ));
      }

      function isElementVisibleInViewport(el, minimumRatio) {
        if (!el || typeof el.getBoundingClientRect !== 'function') return false;
        var rect = el.getBoundingClientRect();
        if (!rect.width || !rect.height) return false;
        var style = window.getComputedStyle ? window.getComputedStyle(el) : null;
        if (style && (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0')) return false;
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        var visibleWidth = Math.max(0, Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0));
        var visibleHeight = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
        if (!visibleWidth || !visibleHeight) return false;
        var visibleRatio = (visibleWidth * visibleHeight) / (rect.width * rect.height);
        return visibleRatio >= (minimumRatio || 0.25);
      }

      function isPrimaryCtaVisible() {
        if (addBtn && isElementVisibleInViewport(addBtn, 0.28)) return true;
        var ctaRow = addBtn && addBtn.closest ? addBtn.closest('.ciq-main-product__cta-row') : null;
        if (ctaRow && isElementVisibleInViewport(ctaRow, 0.32)) return true;
        if (!addBtn && productForm && isElementVisibleInViewport(productForm, 0.18)) return true;
        return false;
      }

      function syncStickyVisibility() {
        var triggerEl = addBtn || productForm;
        var triggerRect = triggerEl.getBoundingClientRect();
        var productText = (productSection.textContent || '').toLowerCase();
        var isAuctionProduct = /live\s+auction|auction\s+item|opening\s+bid|current\s+bid/.test(productText);
        var isPollheim = stickyAtc.classList.contains('ciq-sticky-atc--pollheim');
        var isLuxuryMinimalSticky = isPollheim && document.body && document.body.getAttribute('data-ciq-theme-design-preset') === 'luxury_minimal';
        var isTriggerVisible = isLuxuryMinimalSticky ? isPrimaryCtaVisible() : (triggerRect.top < window.innerHeight && triggerRect.bottom > 0);
        var shouldShow = !isAuctionProduct && !stickyAtcDismissed && !isTriggerVisible && !isCartDrawerActive();
        stickyAtc.hidden = isAuctionProduct;
        var footer = document.querySelector('.ciq-footer');
        var footerOffset = 0;
        if (shouldShow && footer) {
          var footerRect = footer.getBoundingClientRect();
          var baseBottom = isLuxuryMinimalSticky ? Math.max(44, Math.min(window.innerHeight * 0.06, 92)) : (isPollheim ? Math.max(14, Math.min(window.innerWidth * 0.04, 32)) : Math.max(12, Math.min(window.innerWidth * 0.015, 20)));
          var desiredBottom = window.innerHeight - baseBottom;
          if (footerRect.top < desiredBottom) {
            shouldShow = false;
          }
        }
        if (isLuxuryMinimalSticky) {
          stickyAtc.setAttribute('data-coreiq-primary-cta-visible', isTriggerVisible ? 'true' : 'false');
        } else {
          stickyAtc.removeAttribute('data-coreiq-primary-cta-visible');
        }
        stickyAtc.classList.toggle('is-visible', shouldShow);
        document.body.classList.toggle('ciq-has-sticky-atc', shouldShow);
        document.body.classList.toggle('ciq-has-sticky-atc-pollheim', shouldShow && isPollheim);
        document.documentElement.style.setProperty('--ciq-sticky-footer-offset', shouldShow ? footerOffset + 'px' : '0px');
        document.documentElement.style.setProperty('--ciq-sticky-atc-height', shouldShow ? Math.ceil(stickyAtc.offsetHeight || 0) + 'px' : '0px');
      }

      window.addEventListener('scroll', syncStickyVisibility, { passive: true });
      window.addEventListener('resize', syncStickyVisibility, { passive: true });
      document.addEventListener('ciq:drawer-opened', syncStickyVisibility);
      document.addEventListener('ciq:drawer-closed', syncStickyVisibility);
      window.addEventListener('pageshow', syncStickyVisibility);
      var stickyCartDrawer = document.getElementById('cart-drawer');
      if (stickyCartDrawer && typeof MutationObserver === 'function') {
        new MutationObserver(syncStickyVisibility).observe(stickyCartDrawer, {
          attributes: true,
          attributeFilter: ['open', 'aria-hidden', 'class']
        });
      }
      syncStickyVisibility();
      window.requestAnimationFrame(syncStickyVisibility);
    }

    syncInitialProductDataFields();
    syncVariantUi();
    updateOptionAvailability();
  })();

  function renderRecentlyViewedRails() {
    var rails = document.querySelectorAll('[data-coreiq-recently-viewed]');
    if (!rails.length) return;

    function hideRecentlyViewedRail(rail, grid) {
      if (grid) {
        grid.innerHTML = '';
        grid.hidden = true;
      }
      rail.classList.remove('is-ready');
      rail.hidden = true;
    }

    function resetRecentlyViewedGridStart(grid) {
      if (!grid) return;
      grid.setAttribute('data-coreiq-scroll-position', 'start');
      if (typeof grid.scrollTo === 'function') {
        grid.scrollTo({ left: 0, behavior: 'auto' });
      } else {
        grid.scrollLeft = 0;
      }
    }

    function showRecentlyViewedRail(rail, grid, items) {
      var cardsHtml = (items || []).map(function (item) {
        return buildRecentlyViewedCard(item, rail.classList.contains('ciq-cart-page__recently-viewed'));
      }).filter(Boolean).join('');
      if (!cardsHtml) {
        hideRecentlyViewedRail(rail, grid);
        return;
      }

      grid.innerHTML = cardsHtml;
      document.dispatchEvent(new CustomEvent('ciq:wishlist:updated'));
      grid.hidden = false;
      rail.hidden = false;
      rail.classList.add('is-ready');
      grid.removeAttribute('data-coreiq-initial-scroll-normalized');
      resetRecentlyViewedGridStart(grid);
      if (typeof initCarouselPan === 'function') {
        initCarouselPan(rail);
      }
      window.requestAnimationFrame(function () {
        resetRecentlyViewedGridStart(grid);
      });
      window.setTimeout(function () {
        resetRecentlyViewedGridStart(grid);
      }, 120);
    }

    rails.forEach(function (rail) {
      rail.classList.remove('is-ready');
      rail.hidden = true;

      var currentHandle = rail.getAttribute('data-current-product-handle') || '';
      var currentItem = null;
      if (currentHandle) {
        currentItem = {
          handle: currentHandle,
          url: rail.getAttribute('data-current-product-url') || '',
          title: rail.getAttribute('data-current-product-title') || '',
          price: rail.getAttribute('data-current-product-price') || '',
          image: rail.getAttribute('data-current-product-image') || '',
          vendor: rail.getAttribute('data-current-product-vendor') || '',
          variantId: rail.getAttribute('data-current-product-variant-id') || '',
          variantTitle: rail.getAttribute('data-current-product-variant-title') || '',
          available: rail.getAttribute('data-current-product-available') === 'true',
          purchasable: rail.getAttribute('data-current-product-purchasable') === 'true'
        };
        saveRecentlyViewedProduct(currentItem);
      }

      var grid = rail.querySelector('[data-coreiq-recently-viewed-grid]');
      if (!grid) return;
      grid.hidden = true;

      var limit = parseInt(rail.getAttribute('data-recently-viewed-limit') || '4', 10);
      var storedItems = getRecentlyViewedProducts();
      var displayCandidates = storedItems.filter(function (item) {
        return item && item.handle && item.handle !== currentHandle;
      });

      if (!displayCandidates.length) {
        if (currentItem) {
          showRecentlyViewedRail(rail, grid, [currentItem]);
        } else {
          hideRecentlyViewedRail(rail, grid);
        }
        return;
      }

      validateRecentlyViewedProducts(displayCandidates, limit).then(function (validatedItems) {
        saveRecentlyViewedProducts((currentItem ? [currentItem] : []).concat(validatedItems || []).slice(0, 12));
        var items = validatedItems.filter(function (item) {
          return item && item.handle && item.handle !== currentHandle;
        }).slice(0, Math.max(1, limit));

        if (!items.length) {
          if (currentItem) {
            showRecentlyViewedRail(rail, grid, [currentItem]);
          } else {
            hideRecentlyViewedRail(rail, grid);
          }
          return;
        }

        showRecentlyViewedRail(rail, grid, items);
      }).catch(function () {
        var fallbackItems = displayCandidates.filter(function (item) {
          return item && (item.purchasable === true || item.purchasable === 'true' || item.available === true);
        }).slice(0, Math.max(1, limit));
        saveRecentlyViewedProducts((currentItem ? [currentItem] : []).concat(fallbackItems).slice(0, 12));

        if (!fallbackItems.length) {
          if (currentItem) {
            showRecentlyViewedRail(rail, grid, [currentItem]);
          } else {
            hideRecentlyViewedRail(rail, grid);
          }
          return;
        }

        showRecentlyViewedRail(rail, grid, fallbackItems);
      });
    });
  }

  /* -- Recently viewed products (deferred) -- */
  ciqIdleInitWhenPresent('[data-coreiq-recently-viewed]', function () {
  (function initRecentlyViewed() {
    renderRecentlyViewedRails();
  })();
  }); // end ciqIdleInit recently-viewed

  /* -- Product card swatches (deferred) -- */
  ciqIdleInitWhenPresent('[data-coreiq-card-swatches]', function () {
  (function initProductCardSwatches() {
    var cards = Array.prototype.map.call(
      document.querySelectorAll('[data-coreiq-card-swatches]'),
      function (swatchGroup) { return swatchGroup.closest('.ciq-product-card'); }
    ).filter(Boolean);
    if (!cards.length) return;
    var supportsHoverPreview = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function getPrimaryImage(card) {
      return card ? card.querySelector('[data-coreiq-card-primary-image]') : null;
    }

    function ensureOriginalImage(img) {
      if (!img || img.dataset.ciqOriginalImageReady === 'true') return;
      img.dataset.ciqOriginalSrc = img.getAttribute('src') || '';
      img.dataset.ciqOriginalSrcset = img.getAttribute('srcset') || '';
      img.dataset.ciqOriginalSizes = img.getAttribute('sizes') || '';
      img.dataset.ciqOriginalImageReady = 'true';
    }

    function applyImage(img, src, srcset) {
      if (!img || !src) return;
      ensureOriginalImage(img);
      img.setAttribute('src', src);
      if (srcset) {
        img.setAttribute('srcset', srcset);
      }
    }

    function restoreImage(card) {
      var img = getPrimaryImage(card);
      if (!img || img.dataset.ciqOriginalImageReady !== 'true') return;
      img.setAttribute('src', img.dataset.ciqOriginalSrc || '');
      img.setAttribute('srcset', img.dataset.ciqOriginalSrcset || '');
      if (img.dataset.ciqOriginalSizes) {
        img.setAttribute('sizes', img.dataset.ciqOriginalSizes);
      }
      card.classList.remove('is-swatch-preview');
    }

    function clearPreviewState(card) {
      if (!card) return;
      card.querySelectorAll('[data-coreiq-card-swatch].is-preview').forEach(function (item) {
        item.classList.remove('is-preview');
      });
    }

    function setActiveSwatch(card, swatch) {
      if (!card || !swatch) return;
      card.querySelectorAll('[data-coreiq-card-swatch]').forEach(function (item) {
        var isActive = item === swatch;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function previewSwatch(card, swatch) {
      if (!card || !swatch) return;
      var img = getPrimaryImage(card);
      if (!img) return;
      clearPreviewState(card);
      swatch.classList.add('is-preview');
      applyImage(
        img,
        swatch.getAttribute('data-coreiq-card-swatch-image') || '',
        swatch.getAttribute('data-coreiq-card-swatch-srcset') || ''
      );
      card.classList.add('is-swatch-preview');
    }

    document.addEventListener('mouseover', function (event) {
      if (!supportsHoverPreview) return;
      var swatch = event.target.closest('[data-coreiq-card-swatch]');
      if (!swatch) return;
      previewSwatch(swatch.closest('.ciq-product-card'), swatch);
    });

    document.addEventListener('focusin', function (event) {
      var swatch = event.target.closest('[data-coreiq-card-swatch]');
      if (!swatch) return;
      previewSwatch(swatch.closest('.ciq-product-card'), swatch);
    });

    document.addEventListener('click', function (event) {
      var swatch = event.target.closest('[data-coreiq-card-swatch]');
      if (!swatch) return;
      var card = swatch.closest('.ciq-product-card');
      if (!card) return;

      event.preventDefault();
      setActiveSwatch(card, swatch);
      previewSwatch(card, swatch);

      var selectedVariantId = swatch.getAttribute('data-coreiq-card-swatch-variant-id') || '';
      var directVariantInput = card.querySelector('.ciq-product-card__static-atc-form input[name="id"], .ciq-product-card__quick-add-form input[name="id"]');
      if (selectedVariantId && directVariantInput) {
        directVariantInput.value = selectedVariantId;
      }

      var atcBtn = card.querySelector('.ciq-product-card__static-atc');
      if (atcBtn && !atcBtn.classList.contains('ciq-product-card__static-atc--expand')) {
        if (!atcBtn.hasAttribute('data-ciq-original-label')) {
          atcBtn.setAttribute('data-ciq-original-label', atcBtn.textContent.trim());
          atcBtn.setAttribute('data-ciq-original-disabled', String(atcBtn.disabled));
        }
        var swatchAvailable = swatch.getAttribute('data-coreiq-card-swatch-available') !== 'false';
        var swatchPreorder = swatch.getAttribute('data-coreiq-card-swatch-preorder') === 'true';
        var swatchPreorderLabel = swatch.getAttribute('data-coreiq-card-swatch-preorder-label') || 'Pre-order';
        if (swatchAvailable) {
          atcBtn.disabled = false;
          atcBtn.classList.remove('ciq-product-card__static-atc--disabled');
          atcBtn.classList.toggle('ciq-product-card__static-atc--preorder', swatchPreorder);
          atcBtn.textContent = swatchPreorder ? swatchPreorderLabel : (atcBtn.getAttribute('data-ciq-original-label') || atcBtn.textContent);
        } else {
          atcBtn.disabled = true;
          atcBtn.classList.remove('ciq-product-card__static-atc--preorder');
          atcBtn.classList.add('ciq-product-card__static-atc--disabled');
          atcBtn.textContent = 'Sold out';
        }
      }
    });

    cards.forEach(function (card) {
      var swatches = card.querySelectorAll('[data-coreiq-card-swatch]');
      if (!swatches.length) return;

      var img = getPrimaryImage(card);
      ensureOriginalImage(img);
      var activeOnLoad = card.querySelector('[data-coreiq-card-swatch].is-active') || card.querySelector('[data-coreiq-card-swatch-default]') || swatches[0];
      if (activeOnLoad) {
        setActiveSwatch(card, activeOnLoad);
      }

      card.addEventListener('mouseleave', function () {
        clearPreviewState(card);
        var active = card.querySelector('[data-coreiq-card-swatch].is-active');
        if (active) {
          previewSwatch(card, active);
          clearPreviewState(card);
          return;
        }
        restoreImage(card);
      });

      card.addEventListener('focusout', function (event) {
        if (card.contains(event.relatedTarget)) return;
        clearPreviewState(card);
        var active = card.querySelector('[data-coreiq-card-swatch].is-active');
        if (active) {
          previewSwatch(card, active);
          clearPreviewState(card);
          return;
        }
        restoreImage(card);
      });
    });
  })();
  }); // end ciqIdleInit product-card-swatches

  /* â”€â”€ Recovery surface analytics â”€â”€ */
  (function initRecoveryAnalytics() {
    if (window.Shopify && window.Shopify.designMode) return;

    var recoveryEls = document.querySelectorAll('[data-coreiq-recovery-state], [data-coreiq-recovery-rail]');
    if (!recoveryEls.length) return;

    function getRecoveryText(el) {
      return (el && (el.getAttribute('data-coreiq-recovery-label') || el.textContent || '') || '').trim();
    }

    function getRecoveryMeta(el) {
      var recoveryParent = el && el.closest
        ? el.closest('[data-coreiq-recovery-state], [data-coreiq-recovery-rail]')
        : null;
      var source = recoveryParent || el;

      return {
        recoverySurface: source && (source.getAttribute('data-coreiq-recovery-state') || source.getAttribute('data-coreiq-recovery-rail')) || '',
        recoveryRuleId: source && source.getAttribute('data-coreiq-recovery-rule-id') || '',
        recoveryRuleName: source && source.getAttribute('data-coreiq-recovery-rule-name') || '',
        recoveryQuery: source && source.getAttribute('data-coreiq-recovery-query') || ''
      };
    }

    function trackImpression(el, type) {
      if (!el || el.dataset.ciqRecoverySeen === 'true') return;

      el.dataset.ciqRecoverySeen = 'true';
      var recoveryMeta = getRecoveryMeta(el);
      emitThemeAnalytics('coreiq_recovery_impression', Object.assign({}, recoveryMeta, {
        recoveryType: type,
      }));

      if (recoveryMeta.recoverySurface === 'search-no-results' && !recoveryMeta.recoveryRuleId) {
        emitThemeAnalytics('coreiq_recovery_unmatched_impression', Object.assign({}, recoveryMeta, {
          recoveryType: type
        }));
      }
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var element = entry.target;
          var type = element.hasAttribute('data-coreiq-recovery-state') ? 'state' : 'rail';
          trackImpression(element, type);
          observer.unobserve(element);
        });
      }, { threshold: 0.35 });

      recoveryEls.forEach(function (el) {
        observer.observe(el);
      });
    } else {
      recoveryEls.forEach(function (el) {
        var type = el.hasAttribute('data-coreiq-recovery-state') ? 'state' : 'rail';
        trackImpression(el, type);
      });
    }

    document.addEventListener('click', function (event) {
      var primaryLink = event.target.closest('[data-coreiq-recovery-primary]');
      if (primaryLink) {
        var primaryMeta = getRecoveryMeta(primaryLink);
        setAssistedAttributionContext({
          assistSurface: primaryMeta.recoverySurface || '',
          assistTargetType: 'primary',
          assistRuleId: primaryMeta.recoveryRuleId || '',
          assistRuleName: primaryMeta.recoveryRuleName || '',
          assistQuery: primaryMeta.recoveryQuery || '',
          assistUrl: primaryLink.getAttribute('href') || ''
        });
        emitThemeAnalytics('coreiq_recovery_click', Object.assign({}, primaryMeta, {
          recoverySurface: primaryLink.getAttribute('data-coreiq-recovery-surface') || primaryMeta.recoverySurface || '',
          recoveryTargetType: 'primary',
          recoveryLabel: getRecoveryText(primaryLink),
          recoveryUrl: primaryLink.getAttribute('href') || ''
        }));
        return;
      }

      var shortcutLink = event.target.closest('[data-coreiq-recovery-shortcut]');
      if (shortcutLink) {
        var shortcutMeta = getRecoveryMeta(shortcutLink);
        setAssistedAttributionContext({
          assistSurface: shortcutMeta.recoverySurface || '',
          assistTargetType: 'shortcut',
          assistRuleId: shortcutMeta.recoveryRuleId || '',
          assistRuleName: shortcutMeta.recoveryRuleName || '',
          assistQuery: shortcutMeta.recoveryQuery || '',
          assistUrl: shortcutLink.getAttribute('href') || ''
        });
        emitThemeAnalytics('coreiq_recovery_click', Object.assign({}, shortcutMeta, {
          recoverySurface: shortcutLink.getAttribute('data-coreiq-recovery-surface') || shortcutMeta.recoverySurface || '',
          recoveryTargetType: 'shortcut',
          recoveryLabel: getRecoveryText(shortcutLink),
          recoveryUrl: shortcutLink.getAttribute('href') || ''
        }));
        return;
      }

      var collectionLink = event.target.closest('[data-coreiq-recovery-collection-link]');
      if (collectionLink) {
        var collectionMeta = getRecoveryMeta(collectionLink);
        setAssistedAttributionContext({
          assistSurface: collectionMeta.recoverySurface || '',
          assistTargetType: 'collection',
          assistRuleId: collectionMeta.recoveryRuleId || '',
          assistRuleName: collectionMeta.recoveryRuleName || '',
          assistQuery: collectionMeta.recoveryQuery || '',
          assistUrl: collectionLink.getAttribute('href') || ''
        });
        emitThemeAnalytics('coreiq_recovery_click', Object.assign({}, collectionMeta, {
          recoverySurface: collectionLink.getAttribute('data-coreiq-recovery-surface') || collectionMeta.recoverySurface || '',
          recoveryTargetType: 'collection',
          recoveryLabel: getRecoveryText(collectionLink),
          recoveryUrl: collectionLink.getAttribute('href') || ''
        }));
        return;
      }

      var productCard = event.target.closest('[data-coreiq-recovery-product-card]');
      if (!productCard) return;

      var productLink = event.target.closest('a[href]');
      var quickViewTrigger = event.target.closest('[data-coreiq-quick-view-trigger]');
      if (!productLink && !quickViewTrigger) return;

      var productMeta = getRecoveryMeta(productCard);
      setAssistedAttributionContext({
        assistSurface: productMeta.recoverySurface || '',
        assistTargetType: quickViewTrigger ? 'quick-view' : 'product',
        assistRuleId: productMeta.recoveryRuleId || '',
        assistRuleName: productMeta.recoveryRuleName || '',
        assistQuery: productMeta.recoveryQuery || '',
        assistUrl: productLink ? productLink.getAttribute('href') || '' : productCard.getAttribute('data-coreiq-recovery-product-url') || ''
      });

      emitThemeAnalytics('coreiq_recovery_click', Object.assign({}, productMeta, {
        recoverySurface: productCard.getAttribute('data-coreiq-recovery-surface') || productMeta.recoverySurface || '',
        recoveryTargetType: quickViewTrigger ? 'quick-view' : 'product',
        recoveryLabel: productCard.getAttribute('data-coreiq-recovery-product-title') || '',
        recoveryUrl: productLink ? productLink.getAttribute('href') || '' : productCard.getAttribute('data-coreiq-recovery-product-url') || ''
      }));
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-coreiq-recovery-search-form]');
      if (!form) return;

      var queryInput = form.querySelector('input[name="q"]');
      emitThemeAnalytics('coreiq_recovery_search_submit', Object.assign({}, getRecoveryMeta(form), {
        recoverySurface: form.getAttribute('data-coreiq-recovery-surface') || getRecoveryMeta(form).recoverySurface || '',
        recoveryTargetType: 'search-submit',
        recoveryLabel: queryInput ? (queryInput.value || '').trim() : ''
      }));
    });
  })();

  /* -- Quick add modal (variant selection) -- */
  var ciqQaBackdropEl = null;

  function ciqGetOrCreateBackdrop() {
    if (!ciqQaBackdropEl) {
      ciqQaBackdropEl = document.createElement('div');
      ciqQaBackdropEl.className = 'ciq-qa-modal-backdrop';
      document.body.appendChild(ciqQaBackdropEl);
      ciqQaBackdropEl.addEventListener('click', function () { ciqCloseAllQaModals(); });
    }
    return ciqQaBackdropEl;
  }

  function ciqCloseQaTray(openTray, shouldReturnFocus) {
    if (!openTray) return;
    openTray.classList.remove('is-open');
    openTray.setAttribute('aria-hidden', 'true');
    var card = openTray.closest('.ciq-product-card');
    var trigger = openTray.__ciqQaTrigger || (card ? card.querySelector('[data-coreiq-qa-trigger]') : null);
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.classList.remove('is-open');
    }
    var returnFocusTo = openTray.__ciqQaTrigger || trigger || null;
    openTray.__ciqQaTrigger = null;
    // Collection integrations can place cards in transformed or clipped
    // containers. A fixed dialog inside that container is no longer viewport
    // fixed, which leaves only the global backdrop visible. Restore the tray
    // to its original spot once it is closed.
    if (openTray.__ciqQaPlaceholder && openTray.__ciqQaPlaceholder.parentNode) {
      openTray.__ciqQaPlaceholder.parentNode.replaceChild(openTray, openTray.__ciqQaPlaceholder);
    }
    openTray.__ciqQaPlaceholder = null;
    if (shouldReturnFocus && returnFocusTo && document.contains(returnFocusTo) && typeof returnFocusTo.focus === 'function') {
      returnFocusTo.focus();
    }
  }

  function ciqFocusQaTray(tray) {
    if (!tray) return;
    var a11y = window.CoreIQA11y || null;
    var focusables = a11y && typeof a11y.getFocusable === 'function' ? a11y.getFocusable(tray) : [];
    var focusTarget = focusables[0] || tray;
    if (focusTarget && typeof focusTarget.focus === 'function') {
      focusTarget.focus();
    }
  }

  function ciqPortalQaTray(tray) {
    if (!tray || tray.parentNode === document.body) return;
    var placeholder = document.createComment('ciq-qa-tray-placeholder');
    tray.parentNode.insertBefore(placeholder, tray);
    tray.__ciqQaPlaceholder = placeholder;
    document.body.appendChild(tray);
  }

  function ciqCloseAllQaModals(options) {
    options = options || {};
    document.querySelectorAll('[data-coreiq-qa-tray].is-open').forEach(function (openTray) {
      ciqCloseQaTray(openTray, options.returnFocus !== false);
    });
    if (ciqQaBackdropEl) ciqQaBackdropEl.classList.remove('is-open');
    document.body.classList.remove('ciq-modal-open');
  }

  document.addEventListener('click', function (e) {
    // Close button inside modal header
    if (e.target.closest('.ciq-product-card__qa-modal-close')) {
      ciqCloseAllQaModals();
      return;
    }

    var trigger = e.target.closest('[data-coreiq-qa-trigger]');
    if (trigger) {
      var card = trigger.closest('.ciq-product-card');
      if (!card) return;
      var tray = card.querySelector('[data-coreiq-qa-tray]');
      if (!tray) return;

      // A card with one purchasable variant already has a complete quick-add
      // form in its tray. Do not put customers through a modal just to submit
      // that one variant: use the shared AJAX form handler directly. Products
      // with option controls still open the chooser below, while quick view
      // remains on its separate data-coreiq-quick-view path.
      var directQuickAddForm = tray.querySelector('[data-coreiq-quick-add-form]');
      var hasVariantChoices = tray.querySelector('[data-coreiq-qa-option]');
      if (directQuickAddForm && !hasVariantChoices) {
        if (typeof directQuickAddForm.requestSubmit === 'function') {
          directQuickAddForm.requestSubmit();
        } else {
          directQuickAddForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
        return;
      }

      var isOpen = trigger.getAttribute('aria-expanded') === 'true';

      // Close other open modals first
      document.querySelectorAll('[data-coreiq-qa-tray].is-open').forEach(function (openTray) {
        if (openTray !== tray) {
          ciqCloseQaTray(openTray, false);
        }
      });

      if (!isOpen) {
        // Inject modal header with product title + close button (once per card)
        if (!tray.querySelector('.ciq-product-card__qa-modal-header')) {
          var titleEl = card.querySelector('.ciq-product-card__title');
          var titleText = titleEl ? titleEl.textContent.trim() : '';
          var header = document.createElement('div');
          header.className = 'ciq-product-card__qa-modal-header';
          var titleNode = document.createElement('h3');
          titleNode.className = 'ciq-product-card__qa-modal-title';
          titleNode.textContent = titleText;
          var closeNode = document.createElement('button');
          closeNode.type = 'button';
          closeNode.className = 'ciq-product-card__qa-modal-close';
          closeNode.setAttribute('aria-label', 'Close');
          closeNode.innerHTML = '&times;';
          header.appendChild(titleNode);
          header.appendChild(closeNode);
          tray.insertBefore(header, tray.firstChild);
        }
        tray.__ciqQaTrigger = trigger;
        ciqPortalQaTray(tray);
        tray.classList.add('is-open');
        tray.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        trigger.classList.add('is-open');
        var backdrop = ciqGetOrCreateBackdrop();
        requestAnimationFrame(function () { backdrop.classList.add('is-open'); });
        document.body.classList.add('ciq-modal-open');
        window.requestAnimationFrame(function () { ciqFocusQaTray(tray); });
      } else {
        ciqCloseAllQaModals();
      }
      return;
    }

    // Dismiss on click outside the tray
    if (!e.target.closest('[data-coreiq-qa-tray]') && !e.target.closest('.ciq-qa-modal-backdrop')) {
      ciqCloseAllQaModals();
    }
  });

  document.addEventListener('keydown', function (e) {
    var openQaTray = document.querySelector('[data-coreiq-qa-tray].is-open');
    if (!openQaTray) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      ciqCloseAllQaModals();
      return;
    }

    if (e.key === 'Tab') {
      var a11y = window.CoreIQA11y || null;
      if (a11y && typeof a11y.trapTabKey === 'function') {
        a11y.trapTabKey(e, openQaTray);
      }
    }
  });

  /* Variant swatch selection within tray */
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-coreiq-qa-option]');
    if (!swatch) return;
    var tray = swatch.closest('[data-coreiq-qa-tray]');
    if (!tray) return;

    var optionName = swatch.getAttribute('data-coreiq-qa-option');
    // Deselect siblings in same group
    tray.querySelectorAll('[data-coreiq-qa-option="' + optionName + '"]').forEach(function (s) {
      s.classList.remove('is-selected');
    });
    swatch.classList.add('is-selected');

    // Find matching variant and update hidden id input
    var variantsScript = tray.querySelector('[data-coreiq-qa-product-variants]');
    if (!variantsScript) return;
    var variants = [];
    try { variants = JSON.parse(variantsScript.textContent || '[]'); } catch (_) { return; }

    var selectedOptions = {};
    tray.querySelectorAll('[data-coreiq-qa-option]').forEach(function (s) {
      if (s.classList.contains('is-selected')) {
        selectedOptions[s.getAttribute('data-coreiq-qa-option')] = s.getAttribute('data-coreiq-qa-value');
      }
    });

    var match = variants.find(function (v) {
      return v.options.every(function (opt, idx) {
        var optGroups = tray.querySelectorAll('[data-coreiq-qa-option]');
        var groupNames = [];
        optGroups.forEach(function (el) {
          var n = el.getAttribute('data-coreiq-qa-option');
          if (groupNames.indexOf(n) === -1) groupNames.push(n);
        });
        var name = groupNames[idx];
        return !name || selectedOptions[name] === opt;
      });
    });

    if (match) {
      var idInput = tray.querySelector('[data-coreiq-qa-variant-id]');
      if (idInput) idInput.value = match.id;
      var priceEl = tray.querySelector('[data-coreiq-qa-price]');
      if (priceEl && match.price) priceEl.textContent = match.price;
      var atcBtn = tray.querySelector('[data-coreiq-quick-add-btn]');
      if (atcBtn) {
        atcBtn.disabled = !match.available;
        var tracked = match.inventory_tracked === true;
        var form = tray.querySelector('[data-coreiq-quick-add-form]');
        if (form) {
          form.setAttribute('data-inventory-tracked', tracked ? 'true' : 'false');
          if (tracked && Number.isFinite(Number(match.inventory_quantity))) form.setAttribute('data-inventory-limit', String(Math.max(0, Number(match.inventory_quantity))));
          else form.removeAttribute('data-inventory-limit');
        }
        var labelEl = atcBtn.querySelector('[data-coreiq-quick-add-label]');
        if (labelEl) labelEl.textContent = match.available ? 'Add to cart' : 'Sold out';
      }

      var card = tray.closest('.ciq-product-card');
      var primaryImg = card ? card.querySelector('[data-coreiq-card-primary-image]') : null;
      if (primaryImg && match.featured_image) {
        primaryImg.setAttribute('src', match.featured_image);
      }
    }
  });

  /* â”€â”€ Quick add to cart (AJAX) â”€â”€ */
  document.addEventListener('submit', function (e) {
    var quickAddForm = e.target.closest('[data-coreiq-quick-add-form]');
    if (!quickAddForm) return;

    e.preventDefault();
    if (quickAddForm.dataset.ciqAdding === 'true') return;

    var submitBtn = quickAddForm.querySelector('[data-coreiq-quick-add-btn]');
    var labelEl = quickAddForm.querySelector('[data-coreiq-quick-add-label]');
    var variantInput = quickAddForm.querySelector('input[name="id"]');
    var quantityInput = quickAddForm.querySelector('input[name="quantity"]');
    if (!submitBtn || !variantInput) return;
    var variantId = parseInt(variantInput.value, 10);
    if (!Number.isFinite(variantId) || variantId <= 0) return;
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    if (!Number.isFinite(quantity) || quantity <= 0) quantity = 1;

    quickAddForm.dataset.ciqAdding = 'true';
    submitBtn.disabled = true;
    var initialLabel = labelEl ? labelEl.textContent : 'Quick add';
    submitBtn.classList.add('is-loading');
    submitBtn.setAttribute('aria-busy', 'true');
    if (labelEl) labelEl.textContent = 'Adding...';

    window.CiqInventoryGuard.add({ id: variantId, quantity: quantity }, quickAddForm)
      .then(function (response) {
        if (!response.ok) throw new Error('Quick add failed');
        return response.json();
      })
      .then(function (item) {
        emitCartAddAnalytics(item, {
          actionSource: 'quick-add',
          variantId: variantId,
          quantity: quantity
        });
        animateAddToCart(submitBtn, item);
        fetchCartState().then(function (cart) {
          var openCartDrawer = document.getElementById('cart-drawer');
          if (openCartDrawer && openCartDrawer.hasAttribute('open')) {
            renderCartDrawer(cart);
          }
          announceCartUpdate(cart.item_count || 0);
          refreshCartPageSection().catch(function () {});
        }).catch(function () {});
        submitBtn.classList.remove('is-loading');
        submitBtn.classList.add('is-added');
        submitBtn.removeAttribute('aria-busy');
        if (labelEl) labelEl.textContent = 'Added';

        var tray = quickAddForm.closest('[data-coreiq-qa-tray]');
        var trayConfirm = tray ? tray.querySelector('[data-coreiq-qa-confirm]') : null;
        if (trayConfirm) {
          var itemVariant = item && item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
          trayConfirm.textContent = itemVariant ? 'Added ' + itemVariant + ' to cart' : 'Added to cart';
          trayConfirm.hidden = false;
          trayConfirm.classList.add('is-visible');
        }

        setTimeout(function () {
          if (tray) {
            ciqCloseAllQaModals();
          }
          submitBtn.classList.remove('is-added');
          if (labelEl) labelEl.textContent = initialLabel;
          if (trayConfirm) {
            trayConfirm.classList.remove('is-visible');
            trayConfirm.hidden = true;
          }
          delete quickAddForm.dataset.ciqAdding;
          submitBtn.disabled = false;
        }, 1400);
      })
      .catch(function (error) {
        submitBtn.classList.remove('is-loading');
        submitBtn.removeAttribute('aria-busy');
        delete quickAddForm.dataset.ciqAdding;
        submitBtn.disabled = false;
        if (labelEl) labelEl.textContent = 'Try again';

        setTimeout(function () {
          if (labelEl) labelEl.textContent = initialLabel;
        }, 1400);
      });
  });

  document.addEventListener('click', function (e) {
    var checkoutLink = e.target.closest('a[href*="/checkout"]');
    if (!checkoutLink) return;

    var assistedContext = getAssistedAttributionContext();
    if (!assistedContext) return;

    emitThemeAnalytics('coreiq_assisted_checkout_start', Object.assign({}, assistedContext, {
      checkoutUrl: checkoutLink.getAttribute('href') || ''
    }));
  });

})();


/* Shared deferred-init helpers for the legacy modules below. Keep these
   outside the primary IIFE so later modules can safely use them too. */
function ciqIdleInitWhenPresent(selector, fn) {
  if (!selector || !document.querySelector(selector) || typeof fn !== 'function') return;
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(function () { fn(); }, { timeout: 2000 });
  } else {
    window.setTimeout(function () { fn(); }, 200);
  }
}

function ciqHasDom(selector) {
  return Boolean(selector && document.querySelector(selector));
}


  /* â”€â”€ Recovery Carousel Navigation â”€â”€ */
  (function initCarouselNavigation() {
    document.addEventListener('click', function(e) {
      var navBtn = e.target.closest('[data-coreiq-recovery-scroll], [data-coreiq-carousel-scroll]');
      if (!navBtn) return;
      var track = navBtn._ciqTrack || navBtn.closest('.ciq-recovery-rail__viewport')?.querySelector('.ciq-recovery-rail__track');
      if (!track) return;
      var direction = parseInt(navBtn.getAttribute('data-coreiq-carousel-scroll') || navBtn.getAttribute('data-coreiq-recovery-scroll'), 10);
      var step = Math.max(240, Math.round(track.clientWidth * 0.82));
      track.scrollBy({ left: step * direction, behavior: 'smooth' });
    });
  })();

  /* â”€â”€ Recovery Carousel Grab & Pan â”€â”€ */
  function initCarouselPan() {
    var tracks = document.querySelectorAll('.ciq-recovery-rail__track');
    tracks.forEach(function(track) {
      if(!track || track.dataset.panBound) return;
      track.dataset.panBound = "true";

      var isDown = false;
      var startX;
      var scrollLeft;
      var dragged = false;

      // Prevent native ghost-dragging of links and images
      track.addEventListener('dragstart', function(e) {
        e.preventDefault();
      });

      track.addEventListener('mousedown', function(e) {
        isDown = true;
        dragged = false;
        track.style.cursor = 'grabbing';
        track.style.scrollSnapType = 'none'; // Disable snap while dragging
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
      });

      track.addEventListener('mouseleave', function() {
        if(!isDown) return;
        isDown = false;
        track.style.cursor = '';
        setTimeout(function(){ track.style.scrollSnapType = ''; }, 50);
      });

      track.addEventListener('mouseup', function(e) {
        if(!isDown) return;
        isDown = false;
        track.style.cursor = '';
        setTimeout(function(){ track.style.scrollSnapType = ''; }, 50);
      });

      track.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault(); // Prevent text selection
        var x = e.pageX - track.offsetLeft;
        var walk = (x - startX) * 2;
        if (Math.abs(walk) > 5) dragged = true;
        track.scrollLeft = scrollLeft - walk;
      });

      // Intercept click capture phase so we can kill clicks if they dragged
      track.addEventListener('click', function(e) {
        if(dragged) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    });
  }

  function updateDragPanState(track) {
    if (!track) return false;
    enforceRecentlyViewedFreePan(track);
    var isScrollable = track.scrollWidth > track.clientWidth + 2;
    if (track.classList.contains('is-scrollable') !== isScrollable) {
      track.classList.toggle('is-scrollable', isScrollable);
    }
    var scrollableValue = isScrollable ? 'true' : 'false';
    if (track.getAttribute('data-coreiq-drag-scrollable') !== scrollableValue) {
      track.setAttribute('data-coreiq-drag-scrollable', scrollableValue);
    }
    if (!isScrollable) {
      if (track.classList.contains('is-dragging')) track.classList.remove('is-dragging');
      if (track.hasAttribute('data-coreiq-scroll-position')) track.removeAttribute('data-coreiq-scroll-position');
    } else {
      var maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
      var currentScrollLeft = Math.max(0, Math.min(track.scrollLeft, maxScrollLeft));
      var edgeThreshold = 4;
      var scrollPosition = 'middle';
      if (currentScrollLeft <= edgeThreshold) {
        scrollPosition = 'start';
      } else if (currentScrollLeft >= maxScrollLeft - edgeThreshold) {
        scrollPosition = 'end';
      }
      if (track.getAttribute('data-coreiq-scroll-position') !== scrollPosition) {
        track.setAttribute('data-coreiq-scroll-position', scrollPosition);
      }
    }
    updateCarouselNavigation(track, isScrollable);
    return isScrollable;
  }

  function getCarouselNavigationHost(track) {
    return track && track.parentElement;
  }

  function ensureCarouselNavigation(track) {
    if (!track || track.matches('.pop-chaser-trending__track')) return null;
    if (track.matches('.ciq-recovery-rail__track')) {
      return track.closest('.ciq-recovery-rail__viewport');
    }
    var host = getCarouselNavigationHost(track);
    if (!host) return null;
    var nav = host.querySelector(':scope > [data-coreiq-carousel-nav]');
    if (!nav) {
      nav = document.createElement('div');
      nav.className = 'ciq-carousel-nav';
      nav.setAttribute('data-coreiq-carousel-nav', '');
      nav.setAttribute('role', 'group');
      nav.setAttribute('aria-label', 'Carousel navigation');
      nav.innerHTML = '<button type="button" class="ciq-carousel-nav__button ciq-carousel-nav__button--prev" data-coreiq-carousel-scroll="-1" aria-label="Scroll to previous items"><span aria-hidden="true">←</span></button><button type="button" class="ciq-carousel-nav__button ciq-carousel-nav__button--next" data-coreiq-carousel-scroll="1" aria-label="Scroll to more items"><span aria-hidden="true">→</span></button>';
      host.appendChild(nav);
    }
    nav.querySelectorAll('[data-coreiq-carousel-scroll]').forEach(function (button) { button._ciqTrack = track; });
    host.classList.add('ciq-carousel-nav-host');
    return nav;
  }

  function updateCarouselNavigation(track, isScrollable) {
    if (!track) return;
    var nav = ensureCarouselNavigation(track);
    if (!nav) return;
    var isRecoveryRail = track.matches('.ciq-recovery-rail__track');
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    var current = Math.max(0, Math.min(track.scrollLeft, maxScroll));
    var edge = 4;
    var shouldHideNav = !isScrollable;
    if (!isRecoveryRail && nav.hidden !== shouldHideNav) nav.hidden = shouldHideNav;
    var previous = nav.querySelector('[data-coreiq-carousel-scroll="-1"], [data-coreiq-recovery-scroll="-1"]');
    var next = nav.querySelector('[data-coreiq-carousel-scroll="1"], [data-coreiq-recovery-scroll="1"]');
    if (previous) {
      var previousUnavailable = !isScrollable || current <= edge;
      if (previous.hidden !== previousUnavailable) previous.hidden = previousUnavailable;
      if (previous.disabled !== previousUnavailable) previous.disabled = previousUnavailable;
    }
    if (next) {
      var nextUnavailable = !isScrollable || current >= maxScroll - edge;
      if (next.hidden !== nextUnavailable) next.hidden = nextUnavailable;
      if (next.disabled !== nextUnavailable) next.disabled = nextUnavailable;
    }
    if (!isRecoveryRail) {
      var host = getCarouselNavigationHost(track);
      if (host) {
        var navY = (track.offsetTop + track.offsetHeight / 2) + 'px';
        if (host.style.getPropertyValue('--ciq-carousel-nav-y') !== navY) {
          host.style.setProperty('--ciq-carousel-nav-y', navY);
        }
      }
    }
  }

  function observeCarouselTrack(track) {
    if (!track || track.getAttribute('data-coreiq-nav-observed') === 'true') return;
    track.setAttribute('data-coreiq-nav-observed', 'true');
    var refreshFrame = 0;
    var refresh = function () {
      if (refreshFrame) return;
      refreshFrame = window.requestAnimationFrame(function () {
        refreshFrame = 0;
        updateDragPanState(track);
      });
    };
    if (typeof window.ResizeObserver === 'function') {
      var resizeObserver = new ResizeObserver(refresh);
      resizeObserver.observe(track);
      track._ciqCarouselResizeObserver = resizeObserver;
    }
    if (typeof window.MutationObserver === 'function') {
      var mutationObserver = new MutationObserver(function (records) {
        var hasExternalChange = records.some(function (record) {
          // updateDragPanState owns the track's state classes. Ignore its own
          // class writes so refreshing cannot trigger another refresh cycle.
          return !(record.type === 'attributes' && record.target === track && record.attributeName === 'class');
        });
        if (hasExternalChange) refresh();
      });
      mutationObserver.observe(track, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class'] });
      track._ciqCarouselMutationObserver = mutationObserver;
    }
  }

  function isRecentlyViewedPanTrack(track) {
    return Boolean(track && (
      track.matches('[data-coreiq-recently-viewed-grid]') ||
      (track.closest('[data-coreiq-recently-viewed]') && track.classList.contains('ciq-merch-rail__grid'))
    ));
  }

  function enforceRecentlyViewedFreePan(track) {
    if (!isRecentlyViewedPanTrack(track)) return;
    track.setAttribute('data-coreiq-free-pan', 'true');
    track.style.scrollSnapType = 'none';
    track.style.scrollPaddingInline = '0px';
    Array.prototype.forEach.call(track.children || [], function (child) {
      child.style.scrollSnapAlign = 'none';
      child.style.scrollSnapStop = 'normal';
    });
  }

  function normalizeInitialRailScroll(track) {
    if (!track || track.getAttribute('data-coreiq-initial-scroll-normalized') === 'true') return;
    track.setAttribute('data-coreiq-initial-scroll-normalized', 'true');
    window.requestAnimationFrame(function () {
      var shouldNormalize = isRecentlyViewedPanTrack(track) || !window.matchMedia || window.matchMedia('(max-width: 749px)').matches;
      if (shouldNormalize && track.scrollLeft > 0) {
        if (typeof track.scrollTo === 'function') {
          track.scrollTo({ left: 0, behavior: 'auto' });
        } else {
          track.scrollLeft = 0;
        }
      }
      updateDragPanState(track);
    });
  }

  function enableProductRailPan(track) {
    if (!track || track.getAttribute('data-coreiq-pan-bound') === 'true') return;
    track.setAttribute('data-coreiq-pan-bound', 'true');
    var freePan = isRecentlyViewedPanTrack(track);
    enforceRecentlyViewedFreePan(track);

    var isDown = false;
    var startX = 0;
    var startScrollLeft = 0;
    var moved = false;
    var suppressClickUntil = 0;
    var previousScrollBehavior = '';
    var scrollFrame = null;
    var queuePanStateUpdate = function () {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(function () {
        scrollFrame = null;
        updateDragPanState(track);
      });
    };

    updateDragPanState(track);
    normalizeInitialRailScroll(track);
    window.setTimeout(function () { updateDragPanState(track); }, 120);

    track.addEventListener('scroll', queuePanStateUpdate, { passive: true });

    track.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    track.addEventListener('pointerdown', function (event) {
      if (event.button !== undefined && event.button !== 0) return;
      if (track.getAttribute('data-coreiq-drag-scrollable') !== 'true') return;
      if (event.target.closest('button, input, select, textarea, summary, label, [role="button"], .ciq-mini-card__media[href], .ciq-mini-card__title a, .ciq-mini-card__cta, .ciq-product-card__media-link, .ciq-product-card__title a, .ciq-product-card__static-atc, .ciq-complementary-card__media')) {
        moved = false;
        suppressClickUntil = 0;
        return;
      }
      isDown = true;
      moved = false;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      previousScrollBehavior = track.style.scrollBehavior || '';
      track.style.scrollBehavior = 'auto';
      if (freePan) {
        enforceRecentlyViewedFreePan(track);
      }
      track.classList.add('is-dragging');
      if (typeof track.setPointerCapture === 'function') {
        track.setPointerCapture(event.pointerId);
      }
    });

    track.addEventListener('pointermove', function (event) {
      if (!isDown) return;
      var delta = event.clientX - startX;
      if (Math.abs(delta) > 4) {
        moved = true;
        if (event.cancelable) event.preventDefault();
      }
      track.scrollLeft = startScrollLeft - delta;
      queuePanStateUpdate();
    });

    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (eventName) {
      track.addEventListener(eventName, function (event) {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
        if (freePan) {
          enforceRecentlyViewedFreePan(track);
        } else {
          track.style.scrollBehavior = previousScrollBehavior;
        }
        if (moved) {
          suppressClickUntil = Date.now() + 180;
          window.setTimeout(function () {
            moved = false;
          }, 220);
        }
        if (event && typeof track.releasePointerCapture === 'function') {
          try { track.releasePointerCapture(event.pointerId); } catch (err) {}
        }
        updateDragPanState(track);
      });
    });

    track.addEventListener('click', function (event) {
      if (event.target.closest('.ciq-mini-card__media[href], .ciq-mini-card__title a, .ciq-mini-card__cta, .ciq-product-card__media-link, .ciq-product-card__title a, .ciq-product-card__static-atc, .ciq-complementary-card__media')) {
        moved = false;
        suppressClickUntil = 0;
        return;
      }
      if (!moved && Date.now() > suppressClickUntil) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }, true);
  }

  function getProductPanRails(root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(PRODUCT_PAN_RAIL_SELECTOR));
  }

  var PRODUCT_PAN_RAIL_SELECTOR = [
      '.ciq-recovery-rail__track',
      '.ciq-header__nav-promos--feature',
      '[data-coreiq-recently-viewed-grid]',
      '.ciq-section-featured-collection--carousel .ciq-featured-collection__grid',
      '.ciq-carousel-mode-carousel .ciq-merch-rail:not(.ciq-main-product__recommendations--grid) .ciq-merch-rail__grid',
      '.ciq-main-product__recommendations--carousel .ciq-merch-rail__grid',
      '.ciq-carousel-mode-carousel .ciq-main-product__complementary:not(.ciq-main-product__complementary--grid) .ciq-main-product__complementary-list',
      '.ciq-main-product__complementary--carousel .ciq-main-product__complementary-list',
      '.ciq-cart-drawer__upsell-list--carousel',
      '.ciq-cart-page__recently-viewed .ciq-merch-rail__grid',
      '.ciq-cart-page__empty-collection .ciq-merch-rail__grid',
      '.pc-cart-product-rail'
    ].join(',');

  initCarouselPan = function (root) {
    var scope = root && root.target ? root.target : root;
    getProductPanRails(scope).forEach(function (track) {
      enableProductRailPan(track);
      ensureCarouselNavigation(track);
      observeCarouselTrack(track);
      updateDragPanState(track);
    });
  };

  // Hook into DOM ready and Shopify Theme Editor loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      ciqIdleInitWhenPresent(PRODUCT_PAN_RAIL_SELECTOR, initCarouselPan);
    });
  } else {
    ciqIdleInitWhenPresent(PRODUCT_PAN_RAIL_SELECTOR, initCarouselPan);
  }
  document.addEventListener('shopify:section:load', function (event) {
    if (getProductPanRails(event && event.target ? event.target : document).length) {
      initCarouselPan(event);
    }
  });
  window.addEventListener('resize', function () {
    if (ciqHasDom(PRODUCT_PAN_RAIL_SELECTOR)) initCarouselPan();
  }, { passive: true });

/* ============================================
   CoreIQ â€” Scroll Reveal & Ripple (Tier 2)
   ============================================ */

/**
 * Scroll Reveal Animation
 * Triggers .ciq-scroll-reveal elements when visible in viewport.
 * Progressive enhancement â€” no JS required if CSS animation not needed.
 */
(function () {
  'use strict';

  var initScrollReveal = function () {
    if (!('IntersectionObserver' in window)) return;

    var reveals = document.querySelectorAll('.ciq-scroll-reveal');
    if (!reveals.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    reveals.forEach(function (el) { observer.observe(el); });
  };

  function queueScrollReveal() {
    ciqIdleInitWhenPresent('.ciq-scroll-reveal', initScrollReveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueScrollReveal);
  } else {
    queueScrollReveal();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var scope = event && event.target ? event.target : document;
    if (!scope.querySelector || !scope.querySelector('.ciq-scroll-reveal')) return;
    initScrollReveal();
  });

  /* ── Guided size recommender micro-flow ── */
  (function initSizeRecommender() {
    var roots = document.querySelectorAll('[data-coreiq-size-recommender]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var openBtn = root.querySelector('[data-coreiq-size-recommender-open]');
      var closeBtn = root.querySelector('[data-coreiq-size-recommender-close]');
      var calcBtn = root.querySelector('[data-coreiq-size-recommender-calc]');
      var modal = root.querySelector('[data-coreiq-size-recommender-modal]');
      var result = root.querySelector('[data-coreiq-size-recommender-result]');
      var heightInput = root.querySelector('[data-coreiq-size-height]');
      var buildInput = root.querySelector('[data-coreiq-size-build]');
      var fitInput = root.querySelector('[data-coreiq-size-fit]');
      var unitInput = root.querySelector('[data-coreiq-size-unit]');
      var bustInput = root.querySelector('[data-coreiq-size-bust]');
      var waistInput = root.querySelector('[data-coreiq-size-waist]');
      var hipInput = root.querySelector('[data-coreiq-size-hip]');
      var riseInput = root.querySelector('[data-coreiq-size-rise]');
      var inseamInput = root.querySelector('[data-coreiq-size-inseam]');
      var notice = root.querySelector('[data-coreiq-size-recommender-notice]');
      var panel = root.querySelector('[data-coreiq-size-recommender-panel]');
      var resolved = root.querySelector('[data-coreiq-size-recommender-resolved]');
      var resolvedState = root.querySelector('[data-coreiq-size-recommender-resolved-state]');
      var resolvedSize = root.querySelector('[data-coreiq-size-recommender-resolved-size]');
      var resolvedMessage = root.querySelector('[data-coreiq-size-recommender-resolved-message]');
      var unavailableModal = root.querySelector('[data-coreiq-size-recommender-unavailable]');
      var unavailableCloseButtons = root.querySelectorAll('[data-coreiq-size-recommender-unavailable-close]');
      var recoPrefix = root.getAttribute('data-coreiq-size-recommender-reco') || 'Recommended size';
      var successMessageTemplate = root.getAttribute('data-coreiq-size-recommender-success') || 'Based on your input, we recommend size {size} and have preselected it for you.';
      var unavailableMessageTemplate = root.getAttribute('data-coreiq-size-recommender-unavailable') || 'Based on your input, we recommend size {size}, but it is currently out of stock.';
      var productRoot = root.closest('[data-coreiq-main-product]');
      var disabled = root.getAttribute('data-coreiq-size-recommender-disabled') === 'true';
      var MODAL_EXIT_MS = 220;
      var sizeModalTrigger = null;
      var cachedSizeProfile;

      function setSizeModalExpanded(isOpen) {
        if (openBtn) {
          openBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }
      }

      function focusSizeDialog(modalEl) {
        if (!modalEl) return;
        var a11y = window.CoreIQA11y || null;
        var focusables = a11y && typeof a11y.getFocusable === 'function' ? a11y.getFocusable(modalEl) : [];
        var target = focusables[0] || modalEl.querySelector('[role="dialog"]') || modalEl;
        if (target && typeof target.focus === 'function') {
          if (!target.hasAttribute('tabindex') && target.getAttribute('role') === 'dialog') {
            target.setAttribute('tabindex', '-1');
          }
          target.focus();
        }
      }

      function returnSizeFocus() {
        if (sizeModalTrigger && document.contains(sizeModalTrigger) && typeof sizeModalTrigger.focus === 'function') {
          sizeModalTrigger.focus();
        }
        sizeModalTrigger = null;
      }

      function resetResolvedState() {
        if (panel) {
          panel.classList.remove('is-resolving');
          panel.removeAttribute('data-coreiq-size-state');
        }
        if (resolved) {
          resolved.hidden = true;
          resolved.removeAttribute('data-tone');
        }
        if (resolvedState) resolvedState.textContent = '';
        if (resolvedSize) resolvedSize.textContent = '';
        if (resolvedMessage) resolvedMessage.textContent = '';
        if (notice) {
          notice.hidden = true;
          notice.textContent = '';
          notice.removeAttribute('data-tone');
        }
        if (calcBtn) {
          calcBtn.disabled = false;
          calcBtn.removeAttribute('aria-busy');
        }
      }

      function openSizeModal(trigger) {
        if (!modal) return;
        sizeModalTrigger = trigger || document.activeElement || openBtn || null;
        resetResolvedState();
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        setSizeModalExpanded(true);
        window.requestAnimationFrame(function () {
          modal.classList.add('is-open');
          focusSizeDialog(modal);
        });
      }

      function closeSizeModal(options) {
        if (!modal || modal.hidden) return;
        options = options || {};
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        setSizeModalExpanded(false);
        window.setTimeout(function () {
          modal.hidden = true;
          resetResolvedState();
          if (options.returnFocus !== false) returnSizeFocus();
        }, MODAL_EXIT_MS);
      }

      function openUnavailableModal() {
        if (!unavailableModal) return;
        unavailableModal.hidden = false;
        unavailableModal.setAttribute('aria-hidden', 'false');
        window.requestAnimationFrame(function () {
          unavailableModal.classList.add('is-open');
          focusSizeDialog(unavailableModal);
        });
      }

      function closeUnavailableModal(options) {
        if (!unavailableModal || unavailableModal.hidden) return;
        options = options || {};
        unavailableModal.classList.remove('is-open');
        unavailableModal.setAttribute('aria-hidden', 'true');
        window.setTimeout(function () {
          unavailableModal.hidden = true;
          if (options.returnFocus !== false) returnSizeFocus();
        }, MODAL_EXIT_MS);
      }

      function getVariantPayload() {
        if (!productRoot) return [];
        var variantsScript = productRoot.querySelector('[data-coreiq-main-product-variants]') || productRoot.querySelector('[data-coreiq-product-variants]');
        if (!variantsScript) return [];
        try {
          return JSON.parse(variantsScript.textContent || '[]');
        } catch (e) {
          return [];
        }
      }

      function getSizeProfile() {
        if (cachedSizeProfile !== undefined) return cachedSizeProfile;
        var profileScript = root.querySelector('[data-coreiq-size-profile]');
        if (!profileScript) {
          cachedSizeProfile = null;
          return cachedSizeProfile;
        }
        try {
          var parsed = JSON.parse(profileScript.textContent || '{}');
          if (typeof parsed === 'string') parsed = JSON.parse(parsed);
          cachedSizeProfile = parsed && typeof parsed === 'object' ? parsed : null;
        } catch (e) {
          cachedSizeProfile = null;
        }
        return cachedSizeProfile;
      }

      function extractSizeToken(variant) {
        if (!variant) return '';
        var commonOrder = ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
        var values = [];

        if (Array.isArray(variant.options)) {
          values = variant.options.map(function (value) {
            return String(value || '').toUpperCase().trim();
          });
        }
        values.push(String(variant.title || '').toUpperCase().trim());

        for (var i = 0; i < commonOrder.length; i += 1) {
          var token = commonOrder[i];
          var matched = values.some(function (value) {
            return value === token || value.indexOf(token + ' /') === 0 || value.indexOf('/ ' + token) !== -1 || value.indexOf(' ' + token + ' ') !== -1;
          });
          if (matched) return token;
        }

        return '';
      }

      function getVariantLabels(variants, availableOnly) {
        if (!Array.isArray(variants) || !variants.length) return [];
        var seen = {};
        var labels = [];

        variants.forEach(function (variant) {
          if (!variant) return;
          if (availableOnly && !variant.available) return;
          var token = extractSizeToken(variant);
          if (!token || seen[token]) return;
          seen[token] = true;
          labels.push(token);
        });

        return labels;
      }

      function resolveSizeOrder(labels) {
        var commonOrder = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
        var available = commonOrder.filter(function (size) {
          return labels.some(function (label) {
            return label === size || label.indexOf(size + ' /') === 0 || label.indexOf('/ ' + size) !== -1 || label.indexOf(' ' + size + ' ') !== -1;
          });
        });
        return available.length ? available : ['S', 'M', 'L'];
      }

      function clampIndex(index, max) {
        if (index < 0) return 0;
        if (index > max) return max;
        return index;
      }

      function normalizeOptionToken(value) {
        return String(value || '')
          .replace(/\u00a0/g, ' ')
          .replace(/\s+/g, ' ')
          .trim()
          .toUpperCase();
      }

      function dispatchNativeChange(control) {
        if (!control) return;
        var event;
        if (typeof Event === 'function') {
          event = new Event('change', { bubbles: true });
        } else {
          event = document.createEvent('Event');
          event.initEvent('change', true, true);
        }
        control.dispatchEvent(event);
      }

      function getProductOptionGroups() {
        if (!productRoot) return [];
        return Array.prototype.slice.call(productRoot.querySelectorAll('[data-coreiq-option-group]'));
      }

      function getProductSizeOptionIndex() {
        var groups = getProductOptionGroups();
        var sizeGroup = groups.find(function (group) {
          return String(group.getAttribute('data-coreiq-option-group') || '').toLowerCase().indexOf('size') !== -1;
        });

        if (!sizeGroup) return -1;
        return parseInt(sizeGroup.getAttribute('data-coreiq-option-index') || '-1', 10);
      }

      function getSelectedProductOptions() {
        var selected = [];
        getProductOptionGroups().forEach(function (group) {
          var index = parseInt(group.getAttribute('data-coreiq-option-index') || '-1', 10);
          var button = group.querySelector('[data-coreiq-option-value].is-selected');
          if (index > -1 && button) {
            selected[index] = button.getAttribute('data-coreiq-option-choice') || '';
          }
        });
        return selected;
      }

      function variantMatchesCurrentNonSizeOptions(variant, selectedOptions, sizeIndex) {
        if (!variant || !Array.isArray(variant.options)) return false;
        return selectedOptions.every(function (value, index) {
          if (!value || index === sizeIndex) return true;
          return variant.options[index] === value;
        });
      }

      function findRecommendedVariant(variants, recommended) {
        if (!Array.isArray(variants) || !variants.length) return null;
        var sizeIndex = getProductSizeOptionIndex();
        var selectedOptions = getSelectedProductOptions();
        var candidates = variants.filter(function (variant) {
          return extractSizeToken(variant) === recommended;
        });

        if (!candidates.length) return null;

        var matchingCurrentOptions = candidates.filter(function (variant) {
          return variantMatchesCurrentNonSizeOptions(variant, selectedOptions, sizeIndex);
        });
        if (matchingCurrentOptions.length) {
          return matchingCurrentOptions.find(function (variant) { return variant.available; }) || matchingCurrentOptions[0];
        }

        return candidates.find(function (variant) { return variant.available; }) || candidates[0];
      }

      function syncVisibleSizeOption(recommended) {
        if (!productRoot) return false;
        var sizeIndex = getProductSizeOptionIndex();
        var selector = '[data-coreiq-option-value]';
        if (sizeIndex > -1) {
          selector += '[data-coreiq-option-index="' + sizeIndex + '"]';
        }

        var target = Array.prototype.find.call(productRoot.querySelectorAll(selector), function (button) {
          return normalizeOptionToken(button.getAttribute('data-coreiq-option-choice')) === normalizeOptionToken(recommended);
        });

        if (!target || target.hasAttribute('disabled') || target.getAttribute('aria-disabled') === 'true') return false;
        target.click();
        return true;
      }

      function setRecommendationResult(message, state) {
        if (!result) return;
        result.textContent = message;
        result.hidden = false;
        result.setAttribute('data-coreiq-size-recommender-state', state || 'idle');
        result.classList.remove('is-applied');
        window.requestAnimationFrame(function () {
          result.classList.add('is-applied');
        });
        window.setTimeout(function () {
          result.classList.remove('is-applied');
        }, 900);
      }

      function showSizeNotice(message, tone) {
        if (!notice) return;
        notice.textContent = message;
        notice.hidden = false;
        notice.setAttribute('data-tone', tone || 'success');
      }

      function formatSizeMessage(template, size) {
        var message = String(template || '');
        if (!message) return '';
        return message
          .replace(/\{size\}/gi, size)
          .replace(/\[\[size\]\]/gi, size)
          .replace(/%size%/gi, size);
      }

      function showResolvedSizePanel(size, message, tone) {
        if (panel) {
          panel.setAttribute('data-coreiq-size-state', tone || 'success');
          panel.classList.add('is-resolving');
        }
        if (notice) {
          notice.hidden = true;
          notice.textContent = '';
        }
        if (!resolved) {
          showSizeNotice(message, tone);
          return;
        }

        resolved.hidden = false;
        resolved.setAttribute('data-tone', tone || 'success');
        if (resolvedState) {
          resolvedState.textContent = tone === 'warning' ? 'Size unavailable' : 'Size selected';
        }
        if (resolvedSize) {
          resolvedSize.textContent = tone === 'warning' ? 'Size ' + size + ' is not available' : 'Size ' + size;
        }
        if (resolvedMessage) {
          resolvedMessage.textContent = message;
        }

        window.requestAnimationFrame(function () {
          if (resolved && typeof resolved.focus === 'function') resolved.focus();
        });
      }

      function completeSizeFlow(size, message, tone, callback) {
        showResolvedSizePanel(size, message, tone);
        if (calcBtn) {
          calcBtn.disabled = true;
          calcBtn.setAttribute('aria-busy', 'true');
        }
        window.setTimeout(function () {
          if (calcBtn) {
            calcBtn.disabled = false;
            calcBtn.removeAttribute('aria-busy');
          }
          if (typeof callback === 'function') callback();
        }, tone === 'warning' ? 2200 : 1800);
      }

      function getMeasuredValue(input, unit, profileUnit) {
        var value = input ? parseFloat(input.value) : NaN;
        if (!Number.isFinite(value) || value <= 0) return null;
        if (unit === profileUnit) return value;
        return profileUnit === 'cm' ? value * 2.54 : value / 2.54;
      }

      function rangeDistance(value, range) {
        if (value === null || range === null || range === undefined) return null;
        var bounds = Array.isArray(range) ? range : [range, range];
        var min = parseFloat(bounds[0]);
        var max = parseFloat(bounds[1] === undefined ? bounds[0] : bounds[1]);
        if (!Number.isFinite(min) || !Number.isFinite(max)) return null;
        if (value < min) return min - value;
        if (value > max) return value - max;
        return 0;
      }

      function getProfileRecommendation(profile, measurements, fit) {
        if (!profile || !Array.isArray(profile.sizes) || !profile.sizes.length) return null;
        var category = String(profile.category || 'tops').toLowerCase();
        var keys = category === 'bottoms' ? ['waist', 'hip', 'inseam'] : category === 'footwear' ? ['foot', 'length'] : category === 'accessories' ? ['wrist', 'circumference'] : category === 'dresses' ? ['bust', 'waist', 'hip'] : ['bust', 'waist'];
        var best = null;
        profile.sizes.forEach(function (entry, index) {
          if (!entry || !entry.size) return;
          var score = 0;
          var measured = 0;
          keys.forEach(function (key) {
            var value = measurements[key];
            var distance = rangeDistance(value, entry[key] !== undefined ? entry[key] : (key === 'bust' ? entry.chest : null));
            if (distance !== null) { score += distance; measured += 1; }
          });
          if (!measured) return;
          if (fit === 'fitted' && index > 0) score += 0.25;
          if (fit === 'relaxed' && index < profile.sizes.length - 1) score += 0.25;
          if (!best || score < best.score) best = { size: String(entry.size).toUpperCase(), score: score };
        });
        return best;
      }

      function calculateRecommendation() {
        if (disabled) return;
        var variants = getVariantPayload();
        var labels = getVariantLabels(variants, false);
        var sizeOrder = resolveSizeOrder(labels);
        var baseIndex = sizeOrder.indexOf('M');
        if (baseIndex < 0) baseIndex = Math.floor(sizeOrder.length / 2);

        var height = heightInput ? heightInput.value : 'regular';
        var build = buildInput ? buildInput.value : 'regular';
        var fit = fitInput ? fitInput.value : 'regular';
        var profile = getSizeProfile();
        var profileUnit = profile && profile.unit === 'cm' ? 'cm' : 'in';
        var inputUnit = unitInput ? unitInput.value : 'in';
        var measurements = {
          bust: getMeasuredValue(bustInput, inputUnit, profileUnit),
          chest: getMeasuredValue(bustInput, inputUnit, profileUnit),
          waist: getMeasuredValue(waistInput, inputUnit, profileUnit),
          hip: getMeasuredValue(hipInput, inputUnit, profileUnit),
          inseam: getMeasuredValue(inseamInput, inputUnit, profileUnit),
          rise: riseInput ? riseInput.value : 'any'
        };
        var profileMatch = getProfileRecommendation(profile, measurements, fit);
        var explanation = profileMatch ? 'We suggest ' + profileMatch.size + ' based on this product\'s ' + (profile.cut || profile.fit || 'measured') + ' fit.' : 'Guided estimate — product measurement data is not available.';
        var offset = 0;
        if (!profileMatch) {
          if (height === 'petite') offset -= 1;
          if (height === 'tall') offset += 1;
          if (build === 'slim') offset -= 1;
          if (build === 'athletic' || build === 'curvy') offset += 1;
          if (fit === 'fitted') offset -= 1;
          if (fit === 'relaxed') offset += 1;
        }
        var finalIndex = profileMatch ? sizeOrder.indexOf(profileMatch.size) : clampIndex(baseIndex + offset, sizeOrder.length - 1);
        if (finalIndex < 0) finalIndex = clampIndex(baseIndex + offset, sizeOrder.length - 1);
        var recommended = sizeOrder[finalIndex];
        var applied = false;
        var recommendedAvailable = false;
        var recommendedVariant = findRecommendedVariant(variants, recommended);

        if (productRoot) {
          var variantSelect = productRoot.querySelector('[data-coreiq-variant-select]');
          if (variantSelect && recommendedVariant && recommendedVariant.available && recommendedVariant.id) {
            applied = syncVisibleSizeOption(recommended);
            if (!applied) {
              variantSelect.value = String(recommendedVariant.id);
              dispatchNativeChange(variantSelect);
              applied = true;
            }
            recommendedAvailable = applied;
          }
        }

        if (recommendedAvailable) {
          var successMessage = formatSizeMessage(successMessageTemplate, recommended) + ' ' + explanation;
          setRecommendationResult(recoPrefix + ': ' + recommended + ' selected', 'applied');
          completeSizeFlow(recommended, successMessage, 'success', function () {
            closeSizeModal();
          });
          return;
        }

        var unavailableMessage = formatSizeMessage(unavailableMessageTemplate, recommended) + ' ' + explanation;
        setRecommendationResult(recoPrefix + ': ' + recommended + ' is out of stock', 'unavailable');
        completeSizeFlow(recommended, unavailableMessage, 'warning', function () {
          closeSizeModal();
        });
      }

      if (openBtn && modal && !disabled) {
        openBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          openSizeModal(openBtn);
        });
      }

      if (disabled && openBtn) {
        openBtn.hidden = true;
      }

      if (closeBtn && modal) {
        closeBtn.addEventListener('click', function () {
          closeSizeModal();
        });
      }

      if (calcBtn) {
        calcBtn.addEventListener('click', calculateRecommendation);
      }

      if (modal) {
        modal.addEventListener('click', function (e) {
          if (e.target === modal) closeSizeModal();
        });
      }

      unavailableCloseButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          closeUnavailableModal();
        });
      });

      if (unavailableModal) {
        unavailableModal.addEventListener('click', function (e) {
          if (e.target === unavailableModal) closeUnavailableModal();
        });
      }

      document.addEventListener('keydown', function (e) {
        var activeModal = null;
        if (modal && !modal.hidden) activeModal = modal;
        if (unavailableModal && !unavailableModal.hidden) activeModal = unavailableModal;
        if (!activeModal) return;

        if (e.key === 'Escape') {
          e.preventDefault();
          if (activeModal === unavailableModal) {
            closeUnavailableModal();
          } else {
            closeSizeModal();
          }
          return;
        }

        if (e.key === 'Tab') {
          var a11y = window.CoreIQA11y || null;
          if (a11y && typeof a11y.trapTabKey === 'function') {
            a11y.trapTabKey(e, activeModal);
          }
        }
      });
    });
  })();

  /* ── Find My Size delegated fallback ── */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-coreiq-size-recommender-open]');
    if (trigger) {
      var scope = trigger.closest('[data-coreiq-size-recommender]');
      var modal = scope ? scope.querySelector('[data-coreiq-size-recommender-modal]') : null;
      if (modal && modal.hidden) {
        event.preventDefault();
        event.stopPropagation();
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        window.requestAnimationFrame(function () {
          modal.classList.add('is-open');
          var panel = modal.querySelector('[data-coreiq-size-recommender-panel]');
          if (panel && typeof panel.focus === 'function') {
            if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
            panel.focus();
          }
        });
        trigger.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    var closeTrigger = event.target.closest('[data-coreiq-size-recommender-close]');
    if (closeTrigger) {
      var closeModal = closeTrigger.closest('[data-coreiq-size-recommender-modal]');
      if (closeModal) {
        event.preventDefault();
        closeModal.classList.remove('is-open');
        closeModal.setAttribute('aria-hidden', 'true');
        window.setTimeout(function () { closeModal.hidden = true; }, 220);
      }
    }
  });

  /* ── Advanced Collection Filter + Sort ── */
  function initCollectionFilters(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll ? scope.querySelectorAll('[data-coreiq-filterable-grid]') : [];
    sections.forEach(function (grid) {
      if (grid.getAttribute('data-coreiq-filter-ready') === 'true') return;
      grid.setAttribute('data-coreiq-filter-ready', 'true');
      var container = grid.closest('.ciq-section') || grid.parentElement;
      var filterBar = container ? container.querySelector('[data-coreiq-filter-bar]') : null;
      var filterGroupsEl = filterBar ? filterBar.querySelector('[data-coreiq-filter-groups]') : null;
      var clearBtn = filterBar ? filterBar.querySelector('[data-coreiq-filter-clear]') : null;
      var clearCount = clearBtn ? clearBtn.querySelector('[data-coreiq-filter-clear-count]') : null;
      var activeBar = container ? container.querySelector('[data-coreiq-filter-active-bar]') : null;
      var activeText = container ? container.querySelector('[data-coreiq-filter-active-text]') : null;
      var activeChips = container ? container.querySelector('[data-coreiq-filter-active-chips]') : null;
      var emptyState = container ? container.querySelector('[data-coreiq-filter-empty]') : null;
      var sortSelect = container ? container.querySelector('[data-coreiq-sort]') : null;
      var filterStorageId = filterBar ? filterBar.getAttribute('data-coreiq-filter-id') : '';
      var storageKey = filterStorageId ? 'ciq-filters-' + filterStorageId : '';
      var refineTimer = null;

      var items = Array.from(grid.querySelectorAll('.ciq-filter-item'));
      if (!items.length) return;

      /* Build unique value maps from data attrs */
      var typeSet = {}, vendorSet = {}, tagSet = {};
      items.forEach(function (item) {
        var t = item.getAttribute('data-filter-type') || '';
        var v = item.getAttribute('data-filter-vendor') || '';
        var tgs = item.getAttribute('data-filter-tags') || '';
        if (t) typeSet[t] = true;
        if (v) vendorSet[v] = true;
        if (tgs) tgs.split(',').forEach(function (tag) {
          var trimmed = tag.trim();
          if (trimmed) tagSet[trimmed] = true;
        });
      });

      var types = Object.keys(typeSet).sort();
      var vendors = Object.keys(vendorSet).sort();
      var tags = Object.keys(tagSet).sort();

      /* Active filters state */
      var activeFilters = { type: [], vendor: [], tag: [], available: false };

      if (storageKey) {
        try {
          var storedState = JSON.parse(localStorage.getItem(storageKey) || '{}');
          if (storedState && typeof storedState === 'object') {
            activeFilters.type = Array.isArray(storedState.type) ? storedState.type : [];
            activeFilters.vendor = Array.isArray(storedState.vendor) ? storedState.vendor : [];
            activeFilters.tag = Array.isArray(storedState.tag) ? storedState.tag : [];
            activeFilters.available = Boolean(storedState.available);
          }
        } catch (e) {}
      }

      function saveFilterState() {
        if (!storageKey) return;
        try {
          localStorage.setItem(storageKey, JSON.stringify(activeFilters));
        } catch (e) {}
      }

      /* Build filter group element */
      function buildFilterGroup(label, values, dimension) {
        if (!values.length) return null;
        var group = document.createElement('div');
        group.className = 'ciq-filter-group';
        group.setAttribute('data-filter-dimension', dimension);
        var groupLabel = document.createElement('span');
        groupLabel.className = 'ciq-filter-group__label';
        groupLabel.textContent = label;
        group.appendChild(groupLabel);
        var chips = document.createElement('div');
        chips.className = 'ciq-filter-group__chips';
        values.forEach(function (val) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'ciq-filter-chip';
          var count = items.filter(function (item) {
            if (dimension === 'type') return (item.getAttribute('data-filter-type') || '') === val;
            if (dimension === 'vendor') return (item.getAttribute('data-filter-vendor') || '') === val;
            if (dimension === 'tag') return (item.getAttribute('data-filter-tags') || '').split(',').map(function (t) { return t.trim(); }).indexOf(val) > -1;
            return false;
          }).length;
          btn.innerHTML = escapeHtml(val) + ' <span class="ciq-filter-chip__count">(' + count + ')</span>';
          btn.setAttribute('data-filter-value', val);
          btn.setAttribute('data-filter-dim', dimension);
          btn.setAttribute('aria-pressed', 'false');
          btn.addEventListener('click', function () {
            toggleFilter(dimension, val);
          });
          chips.appendChild(btn);
        });
        group.appendChild(chips);
        return group;
      }

      /* Add availability filter option */
      function buildAvailabilityGroup() {
        var group = document.createElement('div');
        group.className = 'ciq-filter-group';
        group.setAttribute('data-filter-dimension', 'available');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ciq-filter-chip';
        btn.textContent = 'In stock only';
        btn.setAttribute('data-filter-dim', 'available');
        btn.setAttribute('aria-pressed', 'false');
        btn.addEventListener('click', function () {
          activeFilters.available = !activeFilters.available;
          applyFilters();
        });
        group.appendChild(btn);
        return group;
      }

      /* Render filter groups */
      if (filterGroupsEl) {
        if (types.length > 1) {
          var tg = buildFilterGroup('Type', types, 'type');
          if (tg) filterGroupsEl.appendChild(tg);
        }
        if (vendors.length > 1) {
          var vg = buildFilterGroup('Brand', vendors, 'vendor');
          if (vg) filterGroupsEl.appendChild(vg);
        }
        if (tags.length) {
          var tagsToShow = tags.slice(0, 12);
          var tgr = buildFilterGroup('Tags', tagsToShow, 'tag');
          if (tgr) filterGroupsEl.appendChild(tgr);
        }
        /* availability group */
        filterGroupsEl.appendChild(buildAvailabilityGroup());
      }

      function toggleFilter(dimension, value) {
        var arr = activeFilters[dimension];
        if (!Array.isArray(arr)) return;
        var idx = arr.indexOf(value);
        if (idx > -1) {
          arr.splice(idx, 1);
        } else {
          arr.push(value);
        }
        applyFilters();
      }

      function applyFilters() {
        grid.classList.add('is-refining');
        if (refineTimer) window.clearTimeout(refineTimer);
        var totalActive = activeFilters.type.length + activeFilters.vendor.length + activeFilters.tag.length + (activeFilters.available ? 1 : 0);
        saveFilterState();

        /* Update chip pressed states */
        if (filterGroupsEl) {
          filterGroupsEl.querySelectorAll('[data-filter-chip]').forEach(function (chip) {});
          filterGroupsEl.querySelectorAll('[data-filter-dim]').forEach(function (btn) {
            var dim = btn.getAttribute('data-filter-dim');
            var val = btn.getAttribute('data-filter-value');
            if (dim === 'available') {
              btn.setAttribute('aria-pressed', activeFilters.available ? 'true' : 'false');
              btn.classList.toggle('is-active', activeFilters.available);
            } else {
              var isActive = Array.isArray(activeFilters[dim]) && activeFilters[dim].indexOf(val) > -1;
              btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
              btn.classList.toggle('is-active', isActive);
            }
          });
        }

        /* Show/hide clear button */
        if (clearBtn) {
          clearBtn.hidden = totalActive === 0;
          if (clearCount) clearCount.textContent = totalActive > 0 ? '(' + totalActive + ')' : '';
        }

        /* Filter items */
        var visibleCount = 0;
        items.forEach(function (item) {
          var itemType = item.getAttribute('data-filter-type') || '';
          var itemVendor = item.getAttribute('data-filter-vendor') || '';
          var itemTags = (item.getAttribute('data-filter-tags') || '').split(',').map(function (t) { return t.trim(); });
          var itemAvailable = item.getAttribute('data-filter-available') === 'true';

          var show = true;
          if (activeFilters.type.length && activeFilters.type.indexOf(itemType) === -1) show = false;
          if (activeFilters.vendor.length && activeFilters.vendor.indexOf(itemVendor) === -1) show = false;
          if (activeFilters.tag.length) {
            var hasTag = activeFilters.tag.some(function (tag) { return itemTags.indexOf(tag) > -1; });
            if (!hasTag) show = false;
          }
          if (activeFilters.available && !itemAvailable) show = false;

          item.hidden = !show;
          if (show) visibleCount++;
        });

        /* Active bar summary */
        if (activeBar) {
          if (totalActive > 0) {
            if (activeText) {
              activeText.textContent = 'Showing ' + visibleCount + ' product' + (visibleCount !== 1 ? 's' : '');
            }

            if (activeChips) {
              var entries = [];
              activeFilters.type.forEach(function (value) { entries.push({ dim: 'type', value: value }); });
              activeFilters.vendor.forEach(function (value) { entries.push({ dim: 'vendor', value: value }); });
              activeFilters.tag.forEach(function (value) { entries.push({ dim: 'tag', value: value }); });
              if (activeFilters.available) entries.push({ dim: 'available', value: 'In stock only' });

              activeChips.innerHTML = entries.map(function (entry) {
                return '<button type="button" class="ciq-filter-chip ciq-filter-chip--active" data-coreiq-active-filter-remove data-coreiq-active-filter-dim="' + entry.dim + '" data-coreiq-active-filter-value="' + escapeHtml(entry.value) + '">' + escapeHtml(entry.value) + ' ×</button>';
              }).join('');
            }
            activeBar.style.display = 'block';
          } else {
            if (activeText) activeText.textContent = '';
            if (activeChips) activeChips.innerHTML = '';
            activeBar.style.display = 'none';
          }
        }

        if (emptyState) {
          emptyState.hidden = visibleCount !== 0;
        }

        /* Sort still applied after filter */
        sortItems();
        refineTimer = window.setTimeout(function () {
          grid.classList.remove('is-refining');
        }, 150);
      }

      /* Clear all filters */
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          activeFilters = { type: [], vendor: [], tag: [], available: false };
          applyFilters();
        });
      }

      /* Sort logic */
      var originalOrder = items.slice();

      function sortItems() {
        if (!sortSelect) return;
        var sortVal = sortSelect.value;
        var sorted = items.filter(function (item) { return !item.hidden; });
        var hidden = items.filter(function (item) { return item.hidden; });

        sorted.sort(function (a, b) {
          if (sortVal === 'newest') {
            return 0; /* Shopify doesn't expose created_at in data attr by default; keep order */
          } else if (sortVal === 'price-asc') {
            return parseInt(a.getAttribute('data-filter-price') || 0, 10) - parseInt(b.getAttribute('data-filter-price') || 0, 10);
          } else if (sortVal === 'price-desc') {
            return parseInt(b.getAttribute('data-filter-price') || 0, 10) - parseInt(a.getAttribute('data-filter-price') || 0, 10);
          } else if (sortVal === 'title-asc') {
            var ta = a.querySelector('.ciq-product-card__title') ? a.querySelector('.ciq-product-card__title').textContent.trim() : '';
            var tb = b.querySelector('.ciq-product-card__title') ? b.querySelector('.ciq-product-card__title').textContent.trim() : '';
            return ta.localeCompare(tb);
          }
          return 0;
        });

        sorted.concat(hidden).forEach(function (item) {
          grid.appendChild(item);
        });
      }

      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          sortItems();
        });
      }

      if (activeChips) {
        activeChips.addEventListener('click', function (event) {
          var removeBtn = event.target.closest('[data-coreiq-active-filter-remove]');
          if (!removeBtn) return;
          var dim = removeBtn.getAttribute('data-coreiq-active-filter-dim');
          var value = removeBtn.getAttribute('data-coreiq-active-filter-value');
          if (dim === 'available') {
            activeFilters.available = false;
          } else {
            var arr = activeFilters[dim] || [];
            activeFilters[dim] = arr.filter(function (item) { return item !== value; });
          }
          applyFilters();
        });
      }

      applyFilters();
    });
  }

  function queueCollectionFilters() {
    ciqIdleInitWhenPresent('[data-coreiq-filterable-grid]', function () {
      initCollectionFilters(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueCollectionFilters);
  } else {
    queueCollectionFilters();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var scope = event && event.target ? event.target : document;
    if (!scope.querySelector || !scope.querySelector('[data-coreiq-filterable-grid]')) return;
    initCollectionFilters(scope);
  });

  /* ── Store locator: search + static directions panel ── */
  (function initStoreLocator() {
    var roots = document.querySelectorAll('[data-coreiq-store-locator]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var searchInput = root.querySelector('[data-coreiq-store-search]');
      var clearSearchBtn = root.querySelector('[data-coreiq-store-clear-search]');
      var resultsCountEl = root.querySelector('[data-coreiq-store-results-count]');
      var emptyEl = root.querySelector('[data-coreiq-store-empty]');
      var cards = Array.from(root.querySelectorAll('[data-coreiq-store-card]'));

      function activateCard(cardEl) {
        cards.forEach(function (card) {
          card.classList.toggle('is-active', card === cardEl);
        });
      }

      function applySearchFilter() {
        var query = searchInput ? String(searchInput.value || '').trim().toLowerCase() : '';
        var visibleCount = 0;

        cards.forEach(function (card, index) {
          var haystack = [
            card.getAttribute('data-store-name') || '',
            card.getAttribute('data-store-city') || '',
            card.getAttribute('data-store-state') || '',
            card.getAttribute('data-store-postal') || ''
          ]
            .join(' ')
            .toLowerCase();

          var isVisible = !query || haystack.indexOf(query) !== -1;
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        if (resultsCountEl) {
          var label = root.getAttribute('data-coreiq-results-label') || 'stores';
          resultsCountEl.textContent = visibleCount + ' ' + label + (query ? ' found' : '');
        }

        if (emptyEl) {
          emptyEl.hidden = visibleCount !== 0;
        }

        if (clearSearchBtn) {
          clearSearchBtn.hidden = !query;
        }
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function (event) {
          if (event.target.closest('a, button')) return;
          activateCard(card);
        });
      });

      if (searchInput) {
        searchInput.addEventListener('input', applySearchFilter);
      }

      if (clearSearchBtn && searchInput) {
        clearSearchBtn.addEventListener('click', function () {
          searchInput.value = '';
          applySearchFilter();
          searchInput.focus();
        });
      }

      applySearchFilter();
    });
  })();

  /* ── Synonym notice public API ── */
  window.ciqShowSynonymNotice = function (originalQuery, expandedTerms) {
    var el = document.querySelector('[data-coreiq-synonym-notice]');
    if (!el) return;
    el.textContent = 'Also showing results for: ' + expandedTerms.join(', ');
    el.classList.remove('visually-hidden');
  };

  /* -- Complementary products (PDP "Frequently bought together") -- */
  (function initComplementaryProducts() {
    var wrap = document.querySelector('[data-coreiq-complementary]');
    if (!wrap) return;
    var dragLists = [];

    function updateDragScrollState(list) {
      if (!list) return false;
      var isScrollable = list.scrollWidth > list.clientWidth + 2;
      list.classList.toggle('is-scrollable', isScrollable);
      list.setAttribute('data-coreiq-drag-scrollable', isScrollable ? 'true' : 'false');
      if (!isScrollable) {
        list.classList.remove('is-dragging');
      }
      return isScrollable;
    }

    function enableDragScroll(list) {
      if (!list || list.getAttribute('data-coreiq-drag-scroll-ready') === 'true') return;
      list.setAttribute('data-coreiq-drag-scroll-ready', 'true');
      dragLists.push(list);

      var isDown = false;
      var startX = 0;
      var startScrollLeft = 0;
      var moved = false;

      updateDragScrollState(list);
      window.setTimeout(function () { updateDragScrollState(list); }, 80);

      list.addEventListener('pointerdown', function (event) {
        if (event.button !== undefined && event.button !== 0) return;
        if (list.getAttribute('data-coreiq-drag-scrollable') !== 'true') return;
        if (event.target.closest('button, input, select, textarea, summary, label, [role="button"]')) return;
        isDown = true;
        moved = false;
        startX = event.clientX;
        startScrollLeft = list.scrollLeft;
        list.classList.add('is-dragging');
        if (typeof list.setPointerCapture === 'function') {
          list.setPointerCapture(event.pointerId);
        }
      });

      list.addEventListener('pointermove', function (event) {
        if (!isDown) return;
        var delta = event.clientX - startX;
        if (Math.abs(delta) > 4) moved = true;
        list.scrollLeft = startScrollLeft - delta;
      });

      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (eventName) {
        list.addEventListener(eventName, function (event) {
          if (!isDown) return;
          isDown = false;
          list.classList.remove('is-dragging');
          if (event && typeof list.releasePointerCapture === 'function') {
            try { list.releasePointerCapture(event.pointerId); } catch (err) {}
          }
        });
      });

      list.addEventListener('click', function (event) {
        if (!moved) return;
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }, true);
    }

    document.querySelectorAll('.ciq-main-product__complementary-list').forEach(enableDragScroll);

    if (typeof ResizeObserver === 'function') {
      var dragResizeObserver = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          updateDragScrollState(entry.target);
        });
      });
      dragLists.forEach(function (list) { dragResizeObserver.observe(list); });
    } else {
      window.addEventListener('resize', function () {
        dragLists.forEach(updateDragScrollState);
      });
    }

    var productId = wrap.getAttribute('data-product-id');
    var limit = parseInt(wrap.getAttribute('data-limit') || '3', 10);
    var allowUnavailable = wrap.getAttribute('data-allow-unavailable') === 'true';
    var list = wrap.querySelector('[data-coreiq-complementary-list]');
    function setComplementaryState(state) {
      wrap.setAttribute('data-coreiq-complementary-state', state);
      wrap.hidden = state !== 'ready';
      wrap.style.display = state === 'ready' ? '' : 'none';
      wrap.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
    }

    setComplementaryState('loading');
    if (!productId || !list) {
      setComplementaryState('empty');
      return;
    }

    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=' + limit + '&intent=complementary', {
      headers: { Accept: 'application/json' }
    })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(); })
      .then(function (data) {
        var products = ((data && data.products) || []).filter(function (product) {
          return allowUnavailable || (product && product.available !== false);
        });
        var cards = products.map(function (p) {
          if (!p) return '';
          var img = p.featured_image ? '<img src="' + escapeHtml(p.featured_image) + '" alt="" loading="lazy">' : '';
          var price = p.price_min ? formatCurrency(p.price_min, null) : '';
          var variantId = p.variants && p.variants[0] ? p.variants[0].id : '';
          var available = p.available !== false;
          var variantsJson = (p.variants || []).map(function (variant) {
            return {
              id: variant.id,
              title: variant.title || 'Default Title',
              available: variant.available !== false,
              price: variant.price ? formatCurrency(variant.price, null) : price
            };
          });
          var variantsPayload = JSON.stringify(variantsJson).replace(/</g, '\\u003c');
          if (!variantId) return '';
          return (
            '<div class="ciq-complementary-card">' +
            '<button type="button" class="ciq-complementary-card__quick-view" data-coreiq-quick-view aria-haspopup="dialog" aria-controls="ciq-quick-view-modal" aria-expanded="false" data-product-context="product-card" data-product-url="' + escapeHtml(p.url || '/products/' + p.handle) + '" data-product-title="' + escapeHtml(p.title || '') + '" data-product-price="' + escapeHtml(price) + '" data-product-vendor="' + escapeHtml(p.vendor || '') + '" data-product-image="' + escapeHtml(p.featured_image || '') + '" aria-label="Quick look ' + escapeHtml(p.title || 'product') + '">' +
            '<span class="visually-hidden">Quick look</span>' +
            getQuickLookIconMarkup() +
            '</button>' +
            '<a href="' + escapeHtml(p.url || '/products/' + p.handle) + '" class="ciq-complementary-card__media">' + img + '</a>' +
            '<div class="ciq-complementary-card__info">' +
            (p.vendor ? '<p class="ciq-complementary-card__vendor"><a href="/search?q=' + encodeURIComponent(p.vendor) + '&type=product%2Cpage%2Carticle&options%5Bprefix%5D=last" class="ciq-complementary-card__vendor-link">' + escapeHtml(p.vendor) + '</a></p>' : '') +
            '<h3 class="ciq-complementary-card__title"><a href="' + escapeHtml(p.url || '/products/' + p.handle) + '">' + escapeHtml(p.title || '') + '</a></h3>' +
            '<p class="ciq-complementary-card__price">' + escapeHtml(price) + '</p>' +
            '</div>' +
            (available && variantId
              ? '<form method="post" action="/cart/add" class="ciq-complementary-card__form" data-coreiq-quick-add-form><input type="hidden" name="id" value="' + variantId + '"><input type="hidden" name="quantity" value="1"><button type="submit" class="ciq-btn ciq-btn--secondary" data-coreiq-quick-add-btn><span data-coreiq-quick-add-label>Add</span></button></form>'
              : '<button type="button" class="ciq-btn" disabled>Sold out</button>') +
            '<script type="application/json" data-coreiq-product-variants>' + variantsPayload + '</script>' +
            '</div>'
          );
        }).filter(function (card) { return Boolean(card); });
        if (!cards.length) {
          list.innerHTML = '';
          setComplementaryState('empty');
          return;
        }
        list.innerHTML = cards.join('');
        enableDragScroll(list);
        updateDragScrollState(list);
        if (!list.childElementCount) {
          setComplementaryState('empty');
          return;
        }
        setComplementaryState('ready');
      })
      .catch(function () {
        list.innerHTML = '';
        setComplementaryState('error');
      });
  })();

  /* -- Theme editor admin helpers -- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-coreiq-open-admin-url]');
    if (!trigger) return;

    var url = trigger.getAttribute('data-coreiq-open-admin-url') || '';
    if (!url) return;

    e.preventDefault();
    var adminWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (adminWindow && typeof adminWindow.focus === 'function') {
      adminWindow.focus();
    }
  });

  /* -- Footer newsletter AJAX submission -- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-coreiq-newsletter-form]');
    if (!form) return;
    e.preventDefault();

    var emailInput = form.querySelector('input[type="email"]');
    var msg = form.querySelector('[data-coreiq-newsletter-msg]');
    var btn = form.querySelector('button[type="submit"]');
    var successText = form.getAttribute('data-success-msg') || 'Thanks for subscribing!';
    var klaviyoList = form.getAttribute('data-klaviyo-list') || '';
    var email = emailInput ? emailInput.value.trim() : '';

    if (!email || !emailInput.validity.valid) {
      emailInput.focus();
      return;
    }

    if (btn) { btn.disabled = true; btn.textContent = '…'; }

    if (klaviyoList) {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(window.Klaviyo && window.Klaviyo.apiKey || ''), {
        method: 'POST',
        headers: { 'content-type': 'application/json', revision: '2023-12-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { list_id: klaviyoList, email: email } } })
      }).then(function () { showNewsletterSuccess(); }).catch(function () { showNewsletterSuccess(); });
    } else {
      var body = new URLSearchParams();
      body.set('form_type', 'customer');
      body.set('utf8', '✓');
      body.set('contact[email]', email);
      body.set('contact[tags]', 'newsletter');
      fetch('/contact', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' }, body: body.toString() })
        .then(function () { showNewsletterSuccess(); })
        .catch(function () { showNewsletterSuccess(); });
    }

    function showNewsletterSuccess() {
      form.setAttribute('data-submitting', 'true');
      window.setTimeout(function () {
        form.querySelector('.ciq-footer__newsletter-row').hidden = true;
        if (msg) { msg.textContent = successText; msg.hidden = false; msg.style.animation = 'ciq-newsletter-fade-in 300ms ease forwards'; }
        form.removeAttribute('data-submitting');
      }, 150);
    }
  });

  /* -- Grid Density Toggle -- */
  document.addEventListener('click', function (e) {
    var densityBtn = e.target.closest('.ciq-grid-density-btn');
    if (!densityBtn) return;

    var grid = densityBtn.closest('[data-coreiq-collection-grid]');
    if (!grid) return;

    var targetDensity = densityBtn.getAttribute('data-grid-density');
    if (!targetDensity) return;

    // Update grid class
    grid.classList.remove('ciq-grid--2', 'ciq-grid--3', 'ciq-grid--4');
    grid.classList.add('ciq-grid--' + targetDensity);

    // Update button states
    var allBtns = grid.parentElement.querySelectorAll('.ciq-grid-density-btn');
    allBtns.forEach(function (btn) {
      btn.setAttribute('aria-pressed', 'false');
    });
    densityBtn.setAttribute('aria-pressed', 'true');

    // Store preference in localStorage
    try {
      localStorage.setItem('ciq-grid-density', targetDensity);
    } catch (err) {
      // localStorage not available
    }
  });

  // Restore grid density preference on page load
  (function () {
    try {
      var savedDensity = localStorage.getItem('ciq-grid-density');
      if (savedDensity) {
        var grid = document.querySelector('[data-coreiq-collection-grid][data-enable-density-toggle="true"]');
        if (grid) {
          var densityBtn = grid.parentElement.querySelector('.ciq-grid-density-btn[data-grid-density="' + savedDensity + '"]');
          if (densityBtn) {
            densityBtn.click();
          }
        }
      }
    } catch (err) {
      // localStorage not available
    }
  })();

}());

/* Shared text entrance motion. Kept isolated from section-specific scripts so
   dynamically rendered sections and Shopify editor updates remain safe. */
(function () {
  'use strict';
  var body = document.body;
  if (!body || body.dataset.coreiqTextMotionReady === 'true') return;
  body.dataset.coreiqTextMotionReady = 'true';
  document.documentElement.classList.add('ciq-text-motion-ready');
  var rootSettings = document.documentElement.dataset;
  var globalMotion = body.dataset.coreiqTextMotion || rootSettings.coreiqTextMotion || 'rise';
  var motionEnabled = rootSettings.coreiqMotionEnabled !== 'false';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Do not scan every text node or observe DOM mutations when motion is off. */
  if (!motionEnabled || globalMotion === 'none' || reduced) return;
  var duration = body.dataset.ciqMotionDuration || rootSettings.ciqMotionDuration || '180ms';
  var stagger = Number(body.dataset.ciqMotionStagger || rootSettings.ciqMotionStagger || 45);
  var selector = 'h1,h2,h3,h4,h5,p,li,dt,dd,.ciq-rte,.ciq-eyebrow,.ciq-kicker,.ciq-section__eyebrow,.ciq-section__heading,.ciq-section__subheading';
  var excluded = '.ciq-header,.ciq-mega-panel,.ciq-cart-drawer,.ciq-mobile-drawer,.ciq-editor-overlay,.shopify-section-group-header-group,.shopify-section-group-footer-group,header,footer,.header,.footer,.ciq-main-product,[data-coreiq-section-type="main-product"],.product-card,[class*="product-card"],[data-coreiq-no-motion]';
  var observer;
  var mark = function (section, force, subtree) {
    if (!section || section.matches(excluded)) return;
    /* Shopify wraps section markup in an outer .shopify-section. When the
       inner section exposes an override, let that section own its copy so
       the wrapper cannot preempt it with the global setting. */
    if (section.matches('.shopify-section') && section.querySelector('[data-coreiq-text-motion-override]')) return;
    var scope = subtree && subtree.nodeType === 1 ? subtree : section;
    var items = Array.prototype.slice.call(scope.matches && scope.matches(selector) ? [scope].concat(Array.prototype.slice.call(scope.querySelectorAll(selector))) : scope.querySelectorAll(selector)).filter(function (item) {
      if (item.closest(excluded)) return false;
      if (!force && item.closest('[data-coreiq-text-motion]')) return false;
      return item.textContent.trim().length > 0;
    });
    items.forEach(function (item, index) {
      var itemSection = item.closest('[data-coreiq-text-motion-override]') || section;
      var override = itemSection.dataset.coreiqTextMotionOverride;
      var motion = override && override !== 'global' ? override : globalMotion;
      if (!motionEnabled || motion === 'none') motion = 'none';
      item.dataset.coreiqTextMotion = motion;
      item.style.setProperty('--ciq-motion-duration', duration);
      item.style.setProperty('--ciq-text-delay', Math.min(index * stagger, 360) + 'ms');
      /* Visibility is one-way. Editor rescans and section mutations must not
         reset an already revealed element and replay the entrance animation. */
      if (!observer) item.classList.add('is-visible');
      else {
        observer.observe(item);
        /* Reveal copy already in the viewport immediately. */
        var rect = item.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) item.classList.add('is-visible');
      }
    });
  };
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  }
  var sectionSelector = '.shopify-section,[data-coreiq-section-type],[data-coreiq-text-motion-override]';
  var scan = function (root) {
    if (!root || root.nodeType === 9) {
      document.querySelectorAll(sectionSelector).forEach(function (section) { mark(section); });
      return;
    }
    if (root.nodeType !== 1) return;
    var owner = root.closest(sectionSelector);
    if (!owner) return;
    /* Process only inserted content. Rescanning the full owner section for
       every Shopify/search insertion multiplies work as the page updates. */
    mark(owner, false, root);
  };
  scan(document);
  if ('MutationObserver' in window) {
    var pendingScanRoots = [];
    var scanFrame = 0;
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes' && record.target.matches && record.target.matches('[data-coreiq-text-motion-override]')) {
          mark(record.target, true);
          return;
        }
        Array.prototype.forEach.call(record.addedNodes, function (node) {
          if (node.nodeType !== 1) return;
          /* Batch additions, keeping only outermost inserted roots. */
          var contains = function (parent, child) { return parent === child || Boolean(parent && parent.contains && parent.contains(child)); };
          if (pendingScanRoots.some(function (pending) { return contains(pending, node); })) return;
          pendingScanRoots = pendingScanRoots.filter(function (pending) { return !contains(node, pending); });
          pendingScanRoots.push(node);
        });
      });
      if (pendingScanRoots.length && !scanFrame) {
        scanFrame = window.requestAnimationFrame(function () {
          var roots = pendingScanRoots;
          pendingScanRoots = [];
          scanFrame = 0;
          roots.forEach(scan);
        });
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-coreiq-text-motion-override'] });
  }
}());


/* Give PDPs opened from predictive search a brief, reduced-motion-aware arrival cue. */
(function () {
  var handoffKey = 'ciq-search-pdp-enter';
  try {
    var startedAt = Number(window.sessionStorage.getItem(handoffKey) || 0);
    if (startedAt && Date.now() - startedAt < 10000) {
      window.sessionStorage.removeItem(handoffKey);
      document.documentElement.classList.add('ciq-search-pdp-enter');
      window.setTimeout(function () {
        document.documentElement.classList.remove('ciq-search-pdp-enter');
      }, 700);
    } else if (startedAt) {
      window.sessionStorage.removeItem(handoffKey);
    }
  } catch (handoffReadError) {}

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var target = event.target;
    var result = target && target.closest ? target.closest('[data-coreiq-predictive-result][data-coreiq-predictive-type=\"product\"]') : null;
    var link = result && target.closest ? target.closest('a[href]') : null;
    if (!link || (link.target && link.target !== '_self') || link.hasAttribute('download')) return;
    try {
      var destination = new URL(link.href, window.location.href);
      if (destination.origin === window.location.origin && destination.pathname.indexOf('/products/') === 0) {
        window.sessionStorage.setItem(handoffKey, String(Date.now()));
      }
    } catch (handoffWriteError) {}
  }, true);
})();
